{
  "level": "bs06",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:bs06",
    "objects": "AREAS.E3:bs06.e3",
    "mesh": "TREES.E3:bs06.e3"
  },
  "spawn_point": {
    "position": [
      -2915.5640313616486,
      -4642.876327458009,
      1013.8216552734375
    ],
    "facing_rad": 0.0,
    "look_point": [
      -2915.5640313616486,
      -4542.876327458009,
      1013.8216552734375
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -4007.749267578125,
      -5045.98291015625,
      989.8216552734375
    ],
    "bbox_max": [
      -1964.791748046875,
      -3619.7685546875,
      1402.623779296875
    ],
    "vertex_count": 1347,
    "vertices": [
      [
        -3220.548828125,
        -4367.96875,
        1052.4244384765625
      ],
      [
        -3237.634765625,
        -4367.96875,
        1045.7977294921875
      ],
      [
        -3374.21240234375,
        -4319.2314453125,
        1052.623779296875
      ],
      [
        -3380.1875,
        -4319.2314453125,
        1052.623779296875
      ],
      [
        -3344.14453125,
        -4264.63525390625,
        1052.623779296875
      ],
      [
        -3346.71630859375,
        -4260.1806640625,
        1052.623779296875
      ],
      [
        -3342.380126953125,
        -4264.0966796875,
        1052.623779296875
      ],
      [
        -3344.14453125,
        -4264.63525390625,
        1052.623779296875
      ],
      [
        -3292.968017578125,
        -4336.92236328125,
        1052.623779296875
      ],
      [
        -3289.980224609375,
        -4342.0966796875,
        1052.623779296875
      ],
      [
        -3355.28369140625,
        -4338.1806640625,
        1052.623779296875
      ],
      [
        -3357.855712890625,
        -4342.63525390625,
        1052.623779296875
      ],
      [
        -3356.632080078125,
        -4336.92236328125,
        1052.623779296875
      ],
      [
        -3355.28369140625,
        -4338.1806640625,
        1052.623779296875
      ],
      [
        -3291.74462890625,
        -4342.63525390625,
        1052.623779296875
      ],
      [
        -3294.31640625,
        -4338.1806640625,
        1052.623779296875
      ],
      [
        -3289.980224609375,
        -4342.0966796875,
        1052.623779296875
      ],
      [
        -3291.74462890625,
        -4342.63525390625,
        1052.623779296875
      ],
      [
        -3203.56298828125,
        -4367.96875,
        1045.7977294921875
      ],
      [
        -3220.548828125,
        -4367.96875,
        1052.4244384765625
      ],
      [
        -2654.999755859375,
        -4362.7685546875,
        1023.0237426757812
      ],
      [
        -2679.999755859375,
        -4367.96875,
        1030.623779296875
      ],
      [
        -2654.999755859375,
        -4362.7685546875,
        1023.0237426757812
      ],
      [
        -2654.999755859375,
        -4367.96875,
        1023.0237426757812
      ],
      [
        -3237.634765625,
        -4367.96875,
        1045.7977294921875
      ],
      [
        -3244.62939453125,
        -4367.96875,
        1029.7994384765625
      ],
      [
        -3244.62939453125,
        -4367.96875,
        1029.7994384765625
      ],
      [
        -3237.634765625,
        -4367.96875,
        1013.8012084960938
      ],
      [
        -3237.634765625,
        -4367.96875,
        1013.8012084960938
      ],
      [
        -3225.7265625,
        -4367.96875,
        1003.7753295898438
      ],
      [
        -3180.0,
        -4367.96875,
        1034.7977294921875
      ],
      [
        -3203.56298828125,
        -4367.96875,
        1045.7977294921875
      ],
      [
        -3180.0,
        -4367.96875,
        1013.8012084960938
      ],
      [
        -3203.56298828125,
        -4367.96875,
        1013.8012084960938
      ],
      [
        -3180.0,
        -4367.96875,
        1034.7977294921875
      ],
      [
        -2654.999755859375,
        -4372.7685546875,
        1023.0237426757812
      ],
      [
        -2654.999755859375,
        -4372.7685546875,
        1023.0237426757812
      ],
      [
        -2717.499755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      [
        -2719.999755859375,
        -4719.7685546875,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4680.4384765625,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4680.4384765625,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4680.4384765625,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4680.4384765625,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      [
        -2719.999755859375,
        -4684.7685546875,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4680.4384765625,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4680.4384765625,
        1052.623779296875
      ],
      [
        -2709.999755859375,
        -4684.7685546875,
        1052.623779296875
      ],
      [
        -2709.999755859375,
        -4684.7685546875,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      [
        -2719.999755859375,
        -4684.7685546875,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4680.4384765625,
        1052.623779296875
      ],
      [
        -2729.999755859375,
        -4684.7685546875,
        1052.623779296875
      ],
      [
        -2739.999755859375,
        -4684.7685546875,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4680.4384765625,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      [
        -2739.999755859375,
        -4684.7685546875,
        1052.623779296875
      ],
      [
        -2729.999755859375,
        -4684.7685546875,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      [
        -2709.999755859375,
        -4719.7685546875,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      [
        -2709.999755859375,
        -4719.7685546875,
        1052.623779296875
      ],
      [
        -2719.999755859375,
        -4719.7685546875,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      [
        -2719.999755859375,
        -4644.7685546875,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      [
        -2709.999755859375,
        -4644.7685546875,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      [
        -2709.999755859375,
        -4644.7685546875,
        1052.623779296875
      ],
      [
        -2719.999755859375,
        -4644.7685546875,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      [
        -2729.999755859375,
        -4644.7685546875,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      [
        -2739.999755859375,
        -4644.7685546875,
        1052.623779296875
      ],
      [
        -2739.999755859375,
        -4644.7685546875,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      [
        -2729.999755859375,
        -4644.7685546875,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4750.4384765625,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4750.4384765625,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4750.4384765625,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4750.4384765625,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      [
        -2719.999755859375,
        -4754.7685546875,
        1052.623779296875
      ],
      [
        -2719.999755859375,
        -4754.7685546875,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4750.4384765625,
        1052.623779296875
      ],
      [
        -2709.999755859375,
        -4754.7685546875,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4750.4384765625,
        1052.623779296875
      ],
      [
        -2709.999755859375,
        -4754.7685546875,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      [
        -2739.999755859375,
        -4754.7685546875,
        1052.623779296875
      ],
      [
        -2729.999755859375,
        -4754.7685546875,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      [
        -2739.999755859375,
        -4754.7685546875,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4750.4384765625,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4750.4384765625,
        1052.623779296875
      ],
      [
        -2729.999755859375,
        -4754.7685546875,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      [
        -2729.999755859375,
        -4719.7685546875,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      [
        -2739.999755859375,
        -4719.7685546875,
        1052.623779296875
      ],
      [
        -2739.999755859375,
        -4719.7685546875,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      [
        -2729.999755859375,
        -4719.7685546875,
        1052.623779296875
      ],
      [
        -2719.999755859375,
        -4794.7685546875,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4790.4384765625,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4790.4384765625,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4790.4384765625,
        1052.623779296875
      ],
      [
        -2717.499755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      [
        -2719.999755859375,
        -4794.7685546875,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4790.4384765625,
        1052.623779296875
      ],
      [
        -2709.999755859375,
        -4794.7685546875,
        1052.623779296875
      ],
      [
        -2709.999755859375,
        -4794.7685546875,
        1052.623779296875
      ],
      [
        -2712.499755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4790.4384765625,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4790.4384765625,
        1052.623779296875
      ],
      [
        -2739.999755859375,
        -4794.7685546875,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4790.4384765625,
        1052.623779296875
      ],
      [
        -2737.499755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      [
        -2739.999755859375,
        -4794.7685546875,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4790.4384765625,
        1052.623779296875
      ],
      [
        -2729.999755859375,
        -4794.7685546875,
        1052.623779296875
      ],
      [
        -2729.999755859375,
        -4794.7685546875,
        1052.623779296875
      ],
      [
        -2732.499755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      [
        -3180.0,
        -4389.7685546875,
        1034.7977294921875
      ],
      [
        -3203.56298828125,
        -4389.7685546875,
        1045.7977294921875
      ],
      [
        -3220.548828125,
        -4389.7685546875,
        1052.4244384765625
      ],
      [
        -3237.634765625,
        -4389.7685546875,
        1045.7977294921875
      ],
      [
        -3203.56298828125,
        -4389.7685546875,
        1045.7977294921875
      ],
      [
        -3220.548828125,
        -4389.7685546875,
        1052.4244384765625
      ],
      [
        -3237.634765625,
        -4389.7685546875,
        1045.7977294921875
      ],
      [
        -3244.62939453125,
        -4389.7685546875,
        1029.7994384765625
      ],
      [
        -3244.62939453125,
        -4389.7685546875,
        1029.7994384765625
      ],
      [
        -3237.634765625,
        -4389.7685546875,
        1013.8012084960938
      ],
      [
        -3237.634765625,
        -4389.7685546875,
        1013.8012084960938
      ],
      [
        -3230.191162109375,
        -4367.96875,
        1007.5341186523438
      ],
      [
        -3230.191162109375,
        -4389.7685546875,
        1007.5341186523438
      ],
      [
        -3180.0,
        -4377.96875,
        1024.8221435546875
      ],
      [
        -3180.0,
        -4389.7685546875,
        1030.7569580078125
      ],
      [
        -3180.0,
        -4389.7685546875,
        1024.8221435546875
      ],
      [
        -3180.0,
        -4389.7685546875,
        1034.7977294921875
      ],
      [
        -3180.0,
        -4389.7685546875,
        1030.7569580078125
      ],
      [
        -3180.0,
        -4377.96875,
        1024.8221435546875
      ],
      [
        -3180.0,
        -4377.96875,
        1013.8012084960938
      ],
      [
        -3180.0,
        -4389.7685546875,
        1013.8012084960938
      ],
      [
        -3203.56298828125,
        -4389.7685546875,
        1013.8012084960938
      ],
      [
        -3203.56298828125,
        -4377.96875,
        1013.8012084960938
      ],
      [
        -3225.7265625,
        -4377.96875,
        1003.7753295898438
      ],
      [
        -3225.7265625,
        -4389.7685546875,
        1003.7753295898438
      ],
      [
        -3230.191162109375,
        -4377.96875,
        1007.5341186523438
      ],
      [
        -3180.0,
        -4389.7685546875,
        1013.8012084960938
      ],
      [
        -3092.50048828125,
        -4539.7685546875,
        1052.623779296875
      ],
      [
        -3021.00048828125,
        -4539.7685546875,
        1052.623779296875
      ],
      [
        -3203.56298828125,
        -4539.7685546875,
        1031.8438720703125
      ],
      [
        -3203.56298828125,
        -4409.7685546875,
        1044.843994140625
      ],
      [
        -3220.548828125,
        -4409.7685546875,
        1051.470703125
      ],
      [
        -3220.548828125,
        -4539.7685546875,
        1038.4705810546875
      ],
      [
        -3102.499755859375,
        -4539.7685546875,
        1052.623779296875
      ],
      [
        -3102.499755859375,
        -4525.01611328125,
        1052.623779296875
      ],
      [
        -3092.50146484375,
        -4525.01611328125,
        1052.623779296875
      ],
      [
        -3092.50048828125,
        -4539.7685546875,
        1052.623779296875
      ],
      [
        -3102.499755859375,
        -4525.01611328125,
        1052.623779296875
      ],
      [
        -3092.50146484375,
        -4525.01611328125,
        1052.623779296875
      ],
      [
        -3220.548828125,
        -4539.7685546875,
        1038.4705810546875
      ],
      [
        -3220.548828125,
        -4409.7685546875,
        1051.470703125
      ],
      [
        -3237.634765625,
        -4409.7685546875,
        1044.843994140625
      ],
      [
        -3237.634765625,
        -4539.7685546875,
        1031.8438720703125
      ],
      [
        -3237.634765625,
        -4539.7685546875,
        1031.8438720703125
      ],
      [
        -3237.634765625,
        -4409.7685546875,
        1044.843994140625
      ],
      [
        -3244.62939453125,
        -4409.7685546875,
        1028.845703125
      ],
      [
        -3244.62939453125,
        -4539.7685546875,
        1015.845703125
      ],
      [
        -3244.62939453125,
        -4539.7685546875,
        1015.845703125
      ],
      [
        -3244.62939453125,
        -4409.7685546875,
        1028.845703125
      ],
      [
        -3237.634765625,
        -4409.7685546875,
        1012.8474731445312
      ],
      [
        -3237.634765625,
        -4539.7685546875,
        999.8474731445312
      ],
      [
        -3237.634765625,
        -4539.7685546875,
        999.8474731445312
      ],
      [
        -3237.634765625,
        -4409.7685546875,
        1012.8474731445312
      ],
      [
        -3225.7265625,
        -4409.7685546875,
        1002.8215942382812
      ],
      [
        -3225.7265625,
        -4539.7685546875,
        989.8216552734375
      ],
      [
        -3021.00048828125,
        -4589.7685546875,
        1052.623779296875
      ],
      [
        -3102.499755859375,
        -4589.7685546875,
        1052.623779296875
      ],
      [
        -3102.499755859375,
        -4539.7685546875,
        1052.623779296875
      ],
      [
        -3102.499755859375,
        -4589.7685546875,
        1052.623779296875
      ],
      [
        -3021.00048828125,
        -4555.0,
        1052.623779296875
      ],
      [
        -3021.00048828125,
        -4560.0,
        1052.623779296875
      ],
      [
        -3021.00048828125,
        -4570.0,
        1052.623779296875
      ],
      [
        -3021.00048828125,
        -4575.0,
        1052.623779296875
      ],
      [
        -3021.00048828125,
        -4589.7685546875,
        1052.623779296875
      ],
      [
        -3021.00048828125,
        -4585.0,
        1052.623779296875
      ],
      [
        -3021.00048828125,
        -4539.7685546875,
        1052.623779296875
      ],
      [
        -3021.00048828125,
        -4545.0,
        1052.623779296875
      ],
      [
        -3021.00048828125,
        -4585.0,
        1052.623779296875
      ],
      [
        -3021.00048828125,
        -4575.0,
        1052.623779296875
      ],
      [
        -3021.00048828125,
        -4570.0,
        1052.623779296875
      ],
      [
        -3021.00048828125,
        -4560.0,
        1052.623779296875
      ],
      [
        -3021.00048828125,
        -4555.0,
        1052.623779296875
      ],
      [
        -3021.00048828125,
        -4545.0,
        1052.623779296875
      ],
      [
        -3073.46435546875,
        -4561.46435546875,
        1052.623779296875
      ],
      [
        -3072.0,
        -4565.0,
        1052.623779296875
      ],
      [
        -3077.0,
        -4560.0,
        1052.623779296875
      ],
      [
        -3073.46435546875,
        -4561.46435546875,
        1052.623779296875
      ],
      [
        -3080.53564453125,
        -4561.46435546875,
        1052.623779296875
      ],
      [
        -3077.0,
        -4560.0,
        1052.623779296875
      ],
      [
        -3082.0,
        -4565.0,
        1052.623779296875
      ],
      [
        -3080.53564453125,
        -4561.46435546875,
        1052.623779296875
      ],
      [
        -3080.53564453125,
        -4568.53564453125,
        1052.623779296875
      ],
      [
        -3082.0,
        -4565.0,
        1052.623779296875
      ],
      [
        -3077.0,
        -4570.0,
        1052.623779296875
      ],
      [
        -3080.53564453125,
        -4568.53564453125,
        1052.623779296875
      ],
      [
        -3073.46435546875,
        -4568.53564453125,
        1052.623779296875
      ],
      [
        -3077.0,
        -4570.0,
        1052.623779296875
      ],
      [
        -3072.0,
        -4565.0,
        1052.623779296875
      ],
      [
        -3073.46435546875,
        -4568.53564453125,
        1052.623779296875
      ],
      [
        -3046.46435546875,
        -4561.46435546875,
        1052.623779296875
      ],
      [
        -3045.0,
        -4565.0,
        1052.623779296875
      ],
      [
        -3050.0,
        -4560.0,
        1052.623779296875
      ],
      [
        -3046.46435546875,
        -4561.46435546875,
        1052.623779296875
      ],
      [
        -3053.53564453125,
        -4561.46435546875,
        1052.623779296875
      ],
      [
        -3050.0,
        -4560.0,
        1052.623779296875
      ],
      [
        -3055.0,
        -4565.0,
        1052.623779296875
      ],
      [
        -3053.53564453125,
        -4561.46435546875,
        1052.623779296875
      ],
      [
        -3053.53564453125,
        -4568.53564453125,
        1052.623779296875
      ],
      [
        -3055.0,
        -4565.0,
        1052.623779296875
      ],
      [
        -3050.0,
        -4570.0,
        1052.623779296875
      ],
      [
        -3053.53564453125,
        -4568.53564453125,
        1052.623779296875
      ],
      [
        -3046.46435546875,
        -4568.53564453125,
        1052.623779296875
      ],
      [
        -3050.0,
        -4570.0,
        1052.623779296875
      ],
      [
        -3045.0,
        -4565.0,
        1052.623779296875
      ],
      [
        -3046.46435546875,
        -4568.53564453125,
        1052.623779296875
      ],
      [
        -3188.19580078125,
        -4400.2314453125,
        1038.623779296875
      ],
      [
        -3200.3818359375,
        -4400.2314453125,
        1038.623779296875
      ],
      [
        -3240.771240234375,
        -4400.2314453125,
        1038.623779296875
      ],
      [
        -3240.354248046875,
        -4409.7685546875,
        1038.623779296875
      ],
      [
        -3240.771240234375,
        -4400.2314453125,
        1038.623779296875
      ],
      [
        -3240.771240234375,
        -4389.7685546875,
        1038.623779296875
      ],
      [
        -3188.19580078125,
        -4389.7685546875,
        1038.623779296875
      ],
      [
        -3188.19580078125,
        -4400.2314453125,
        1038.623779296875
      ],
      [
        -3321.8125,
        -4397.2314453125,
        1052.623779296875
      ],
      [
        -3327.78759765625,
        -4397.2314453125,
        1052.623779296875
      ],
      [
        -3322.228271484375,
        -4395.43408203125,
        1052.623779296875
      ],
      [
        -3321.8125,
        -4397.2314453125,
        1052.623779296875
      ],
      [
        -2423.8173828125,
        -4774.30712890625,
        1052.623779296875
      ],
      [
        -2417.461181640625,
        -4767.951171875,
        1052.623779296875
      ],
      [
        -2414.220458984375,
        -4783.90380859375,
        1052.623779296875
      ],
      [
        -2423.8173828125,
        -4774.30712890625,
        1052.623779296875
      ],
      [
        -2452.134765625,
        -4777.5478515625,
        1052.623779296875
      ],
      [
        -2442.538330078125,
        -4767.951171875,
        1052.623779296875
      ],
      [
        -2423.8173828125,
        -4745.22998046875,
        1052.623779296875
      ],
      [
        -2414.220703125,
        -4735.63330078125,
        1052.623779296875
      ],
      [
        -2442.538330078125,
        -4751.5859375,
        1052.623779296875
      ],
      [
        -2452.134765625,
        -4741.9892578125,
        1052.623779296875
      ],
      [
        -2452.134765625,
        -4741.9892578125,
        1052.623779296875
      ],
      [
        -2445.77880859375,
        -4735.6337890625,
        1052.623779296875
      ],
      [
        -2639.999755859375,
        -4404.7685546875,
        1052.623779296875
      ],
      [
        -2596.999755859375,
        -4404.7685546875,
        1052.623779296875
      ],
      [
        -2639.999755859375,
        -4404.7685546875,
        1052.623779296875
      ],
      [
        -2639.999755859375,
        -4404.7685546875,
        1042.5999755859375
      ],
      [
        -2639.999755859375,
        -4404.7685546875,
        1039.0382080078125
      ],
      [
        -2609.999755859375,
        -4404.7685546875,
        1039.0328369140625
      ],
      [
        -2639.999755859375,
        -4404.7685546875,
        1039.0328369140625
      ],
      [
        -2654.999755859375,
        -4404.7685546875,
        1039.0328369140625
      ],
      [
        -2596.999755859375,
        -4382.55810546875,
        1042.5999755859375
      ],
      [
        -2596.999755859375,
        -4404.7685546875,
        1042.5999755859375
      ],
      [
        -2596.999755859375,
        -4404.7685546875,
        1047.5999755859375
      ],
      [
        -2596.999755859375,
        -4389.84765625,
        1047.5999755859375
      ],
      [
        -2570.999755859375,
        -4509.7685546875,
        1042.5999755859375
      ],
      [
        -2509.999755859375,
        -4509.7685546875,
        1042.5999755859375
      ],
      [
        -2537.592529296875,
        -4394.5380859375,
        1042.5999755859375
      ],
      [
        -2558.22998046875,
        -4415.17578125,
        1042.5999755859375
      ],
      [
        -2508.40673828125,
        -4394.5380859375,
        1042.5999755859375
      ],
      [
        -2537.592529296875,
        -4394.5380859375,
        1042.5999755859375
      ],
      [
        -2570.999755859375,
        -4509.7685546875,
        1047.5999755859375
      ],
      [
        -2509.999755859375,
        -4509.7685546875,
        1047.5999755859375
      ],
      [
        -2537.28466796875,
        -4395.28125,
        1047.5999755859375
      ],
      [
        -2557.487060546875,
        -4415.4833984375,
        1047.5999755859375
      ],
      [
        -2508.714599609375,
        -4395.28125,
        1047.5999755859375
      ],
      [
        -2537.28466796875,
        -4395.28125,
        1047.5999755859375
      ],
      [
        -2570.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      [
        -2509.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      [
        -2536.975341796875,
        -4396.02783203125,
        1052.623779296875
      ],
      [
        -2556.740478515625,
        -4415.79248046875,
        1052.623779296875
      ],
      [
        -2509.02392578125,
        -4396.02783203125,
        1052.623779296875
      ],
      [
        -2536.975341796875,
        -4396.02783203125,
        1052.623779296875
      ],
      [
        -3667.999755859375,
        -4647.33837890625,
        1032.5999755859375
      ],
      [
        -3667.999755859375,
        -4651.576171875,
        1032.5999755859375
      ],
      [
        -3675.999755859375,
        -4647.33837890625,
        1032.5999755859375
      ],
      [
        -3667.999755859375,
        -4647.33837890625,
        1032.5999755859375
      ],
      [
        -3624.999755859375,
        -4641.01611328125,
        1032.5999755859375
      ],
      [
        -3632.999755859375,
        -4641.01611328125,
        1032.5999755859375
      ],
      [
        -3624.999755859375,
        -4637.44140625,
        1032.5999755859375
      ],
      [
        -3624.999755859375,
        -4641.01611328125,
        1032.5999755859375
      ],
      [
        -3675.999755859375,
        -4652.44384765625,
        1038.623779296875
      ],
      [
        -3667.999755859375,
        -4652.44384765625,
        1038.623779296875
      ],
      [
        -3667.999755859375,
        -4652.44384765625,
        1038.623779296875
      ],
      [
        -3667.999755859375,
        -4656.68115234375,
        1038.623779296875
      ],
      [
        -3624.999755859375,
        -4645.32275390625,
        1038.623779296875
      ],
      [
        -3632.999755859375,
        -4645.32275390625,
        1038.623779296875
      ],
      [
        -3624.999755859375,
        -4641.748046875,
        1038.623779296875
      ],
      [
        -3624.999755859375,
        -4645.32275390625,
        1038.623779296875
      ],
      [
        -3675.999755859375,
        -4664.30908203125,
        1052.623779296875
      ],
      [
        -3667.999755859375,
        -4664.30908203125,
        1052.623779296875
      ],
      [
        -3667.999755859375,
        -4664.30908203125,
        1052.623779296875
      ],
      [
        -3667.999755859375,
        -4668.54638671875,
        1052.623779296875
      ],
      [
        -3624.999755859375,
        -4655.33154296875,
        1052.623779296875
      ],
      [
        -3632.999755859375,
        -4655.33154296875,
        1052.623779296875
      ],
      [
        -3624.999755859375,
        -4651.7568359375,
        1052.623779296875
      ],
      [
        -3624.999755859375,
        -4655.33154296875,
        1052.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1082.623779296875
      ],
      [
        -2651.219482421875,
        -3984.21875,
        1187.623779296875
      ],
      [
        -2354.91015625,
        -4155.29296875,
        1082.623779296875
      ],
      [
        -2354.909423828125,
        -4155.2939453125,
        1185.623779296875
      ],
      [
        -2354.943603515625,
        -4155.27392578125,
        1052.623779296875
      ],
      [
        -2354.943603515625,
        -4155.27392578125,
        1082.623779296875
      ],
      [
        -2654.341064453125,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -2654.341064453125,
        -4249.7685546875,
        1152.623779296875
      ],
      [
        -2346.291259765625,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -2346.291259765625,
        -4249.7685546875,
        1226.623779296875
      ],
      [
        -2295.551025390625,
        -4249.7685546875,
        1187.623779296875
      ],
      [
        -2295.551025390625,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -2344.81982421875,
        -4166.49951171875,
        1082.623779296875
      ],
      [
        -2344.81982421875,
        -4166.49951171875,
        1185.623779296875
      ],
      [
        -2344.835693359375,
        -4166.5009765625,
        1052.623779296875
      ],
      [
        -2344.835693359375,
        -4166.5009765625,
        1082.623779296875
      ],
      [
        -2366.2392578125,
        -4168.896484375,
        1085.0360107421875
      ],
      [
        -2344.835693359375,
        -4166.5009765625,
        1087.623779296875
      ],
      [
        -2344.835693359375,
        -4166.5009765625,
        1082.623779296875
      ],
      [
        -2366.2392578125,
        -4168.896484375,
        1082.623779296875
      ],
      [
        -2366.2392578125,
        -4168.896484375,
        1085.0360107421875
      ],
      [
        -2366.2392578125,
        -4168.896484375,
        1082.623779296875
      ],
      [
        -2654.341064453125,
        -4249.7685546875,
        1072.623779296875
      ],
      [
        -2642.794189453125,
        -4249.7685546875,
        1072.623779296875
      ],
      [
        -2642.794189453125,
        -4249.7685546875,
        1072.623779296875
      ],
      [
        -2631.2470703125,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1082.623779296875
      ],
      [
        -3046.499755859375,
        -3927.351806640625,
        1187.623779296875
      ],
      [
        -3600.0,
        -4069.7685546875,
        1302.623779296875
      ],
      [
        -3170.86669921875,
        -3902.59228515625,
        1302.623779296875
      ],
      [
        -3188.277587890625,
        -3976.673095703125,
        1133.5926513671875
      ],
      [
        -3063.126220703125,
        -3857.455078125,
        1165.0567626953125
      ],
      [
        -3066.32861328125,
        -3883.4814453125,
        1098.453857421875
      ],
      [
        -3163.276611328125,
        -3965.8662109375,
        1102.623779296875
      ],
      [
        -3188.277587890625,
        -3976.673095703125,
        1133.5926513671875
      ],
      [
        -3066.32861328125,
        -3883.4814453125,
        1098.4541015625
      ],
      [
        -3068.5068359375,
        -3889.566650390625,
        1086.4215087890625
      ],
      [
        -3502.938720703125,
        -4189.7685546875,
        1302.623779296875
      ],
      [
        -3439.048583984375,
        -4197.71923828125,
        1121.623779296875
      ],
      [
        -3435.49072265625,
        -4201.27734375,
        1102.62255859375
      ],
      [
        -3435.49072265625,
        -4201.27734375,
        1052.623779296875
      ],
      [
        -3426.12841796875,
        -4210.6396484375,
        1052.623779296875
      ],
      [
        -3699.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      [
        -3699.999755859375,
        -4206.7998046875,
        1102.623779296875
      ],
      [
        -3699.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      [
        -3699.999755859375,
        -4249.7685546875,
        1102.623779296875
      ],
      [
        -3699.999755859375,
        -4249.7685546875,
        1102.623779296875
      ],
      [
        -3744.02880859375,
        -4249.7685546875,
        1278.7403564453125
      ],
      [
        -3746.760498046875,
        -4249.7685546875,
        1278.740234375
      ],
      [
        -3754.28271484375,
        -4249.7685546875,
        1302.623779296875
      ],
      [
        -3744.02880859375,
        -4249.7685546875,
        1278.740234375
      ],
      [
        -3746.760498046875,
        -4249.7685546875,
        1278.7403564453125
      ],
      [
        -2920.0,
        -4919.7685546875,
        1102.623779296875
      ],
      [
        -2920.0,
        -4919.7685546875,
        1052.623779296875
      ],
      [
        -2920.0,
        -4942.994140625,
        1195.5255126953125
      ],
      [
        -2920.0,
        -4919.7685546875,
        1102.623779296875
      ],
      [
        -2920.0,
        -4942.994140625,
        1195.5255126953125
      ],
      [
        -2920.0,
        -4981.9541015625,
        1302.623779296875
      ],
      [
        -2724.999755859375,
        -4919.7685546875,
        1232.623779296875
      ],
      [
        -2749.999755859375,
        -4919.7685546875,
        1232.623779296875
      ],
      [
        -2375.5595703125,
        -4696.50634765625,
        1159.5906982421875
      ],
      [
        -2375.614013671875,
        -4696.45263671875,
        1159.5908203125
      ],
      [
        -2363.673828125,
        -4708.23046875,
        1159.5906982421875
      ],
      [
        -2375.5595703125,
        -4696.50634765625,
        1159.5906982421875
      ],
      [
        -2378.821533203125,
        -4693.28857421875,
        1159.596923828125
      ],
      [
        -2378.821533203125,
        -4693.28857421875,
        1159.596923828125
      ],
      [
        -2523.17236328125,
        -4693.47509765625,
        1072.623779296875
      ],
      [
        -2528.104248046875,
        -4675.56005859375,
        1072.623779296875
      ],
      [
        -2528.118408203125,
        -4675.5087890625,
        1072.623779296875
      ],
      [
        -2514.890380859375,
        -4662.4599609375,
        1072.623779296875
      ],
      [
        -2528.118408203125,
        -4675.5087890625,
        1072.623779296875
      ],
      [
        -2514.85205078125,
        -4662.42236328125,
        1072.623779296875
      ],
      [
        -2496.559326171875,
        -4667.32421875,
        1072.623779296875
      ],
      [
        -2514.85205078125,
        -4662.42236328125,
        1072.623779296875
      ],
      [
        -2484.43994140625,
        -4696.50634765625,
        1159.5906982421875
      ],
      [
        -2496.32568359375,
        -4708.23046875,
        1159.5906982421875
      ],
      [
        -2528.118408203125,
        -4844.0283203125,
        1072.623779296875
      ],
      [
        -2523.186767578125,
        -4826.1142578125,
        1072.623779296875
      ],
      [
        -2523.17236328125,
        -4826.06201171875,
        1072.623779296875
      ],
      [
        -2504.931640625,
        -4821.173828125,
        1072.623779296875
      ],
      [
        -2523.17236328125,
        -4826.06201171875,
        1072.623779296875
      ],
      [
        -2504.879150390625,
        -4821.16015625,
        1072.623779296875
      ],
      [
        -2491.61279296875,
        -4834.24658203125,
        1072.623779296875
      ],
      [
        -2504.879150390625,
        -4821.16015625,
        1072.623779296875
      ],
      [
        -2504.9052734375,
        -4821.1669921875,
        1072.623779296875
      ],
      [
        -2504.9052734375,
        -4821.1669921875,
        1072.623779296875
      ],
      [
        -2484.440185546875,
        -4823.03125,
        1159.5906982421875
      ],
      [
        -2493.60302734375,
        -4813.99267578125,
        1159.5906982421875
      ],
      [
        -2484.440185546875,
        -4823.03125,
        1159.5906982421875
      ],
      [
        -2481.17822265625,
        -4826.24853515625,
        1159.5968017578125
      ],
      [
        -2496.32568359375,
        -4811.306640625,
        1159.5906982421875
      ],
      [
        -2496.32568359375,
        -4811.306640625,
        1159.5906982421875
      ],
      [
        -2463.123046875,
        -4724.6455078125,
        1192.623779296875
      ],
      [
        -2463.123046875,
        -4741.5439453125,
        1192.623779296875
      ],
      [
        -2446.74609375,
        -4724.64599609375,
        1192.623779296875
      ],
      [
        -2446.74609375,
        -4724.64599609375,
        1192.623779296875
      ],
      [
        -2413.039794921875,
        -4724.64599609375,
        1192.623779296875
      ],
      [
        -2463.123046875,
        -4777.9931640625,
        1192.623779296875
      ],
      [
        -2463.123046875,
        -4741.5439453125,
        1192.623779296875
      ],
      [
        -2386.349853515625,
        -4724.64599609375,
        1192.623779296875
      ],
      [
        -2389.768798828125,
        -4721.35205078125,
        1212.623779296875
      ],
      [
        -2399.380126953125,
        -4712.0927734375,
        1192.623779296875
      ],
      [
        -2400.089111328125,
        -4711.40966796875,
        1212.623779296875
      ],
      [
        -2407.14111328125,
        -4720.8974609375,
        1177.623779296875
      ],
      [
        -2378.547607421875,
        -4693.55908203125,
        1159.596435546875
      ],
      [
        -2442.53857421875,
        -4738.87353515625,
        1067.623779296875
      ],
      [
        -2458.6767578125,
        -4715.91455078125,
        1165.623779296875
      ],
      [
        -2463.123046875,
        -4714.5048828125,
        1192.623779296875
      ],
      [
        -2460.619384765625,
        -4712.0927734375,
        1192.623779296875
      ],
      [
        -2459.91064453125,
        -4711.41015625,
        1212.623779296875
      ],
      [
        -2466.416748046875,
        -4717.677734375,
        1212.623779296875
      ],
      [
        -2458.6767578125,
        -4715.91455078125,
        1165.623779296875
      ],
      [
        -2458.87841796875,
        -4715.650390625,
        1166.846923828125
      ],
      [
        -2463.123046875,
        -4716.3994140625,
        1192.623779296875
      ],
      [
        -2459.89501953125,
        -4713.31298828125,
        1192.623779296875
      ],
      [
        -2460.871826171875,
        -4712.3359375,
        1192.623779296875
      ],
      [
        -2463.123046875,
        -4714.5048828125,
        1192.623779296875
      ],
      [
        -2459.89501953125,
        -4713.31298828125,
        1192.623779296875
      ],
      [
        -2463.123046875,
        -4716.3994140625,
        1192.623779296875
      ],
      [
        -2448.56201171875,
        -4724.64599609375,
        1192.623779296875
      ],
      [
        -2459.641845703125,
        -4713.07080078125,
        1192.623779296875
      ],
      [
        -2460.619384765625,
        -4712.0927734375,
        1192.623779296875
      ],
      [
        -2459.641845703125,
        -4713.07080078125,
        1192.623779296875
      ],
      [
        -2448.06591796875,
        -4724.64599609375,
        1192.623779296875
      ],
      [
        -2452.15087890625,
        -4721.60107421875,
        1177.6793212890625
      ],
      [
        -2458.87841796875,
        -4715.650390625,
        1166.846923828125
      ],
      [
        -2452.859130859375,
        -4720.89697265625,
        1177.623779296875
      ],
      [
        -2458.89453125,
        -4715.60546875,
        1166.9442138671875
      ],
      [
        -2450.75732421875,
        -4703.9345703125,
        1177.96044921875
      ],
      [
        -2452.15087890625,
        -4703.9345703125,
        1181.2305908203125
      ],
      [
        -2394.729248046875,
        -4704.62060546875,
        1177.623779296875
      ],
      [
        -2403.511474609375,
        -4717.71484375,
        1171.20263671875
      ],
      [
        -2452.15087890625,
        -4703.9345703125,
        1181.2305908203125
      ],
      [
        -2460.653076171875,
        -4710.67578125,
        1177.623779296875
      ],
      [
        -2460.02099609375,
        -4712.447265625,
        1173.7857666015625
      ],
      [
        -2456.488037109375,
        -4717.71533203125,
        1171.2025146484375
      ],
      [
        -2469.093994140625,
        -4786.8505859375,
        1177.623779296875
      ],
      [
        -2494.296630859375,
        -4813.30810546875,
        1159.5906982421875
      ],
      [
        -2475.95654296875,
        -4726.8681640625,
        1192.623779296875
      ],
      [
        -2476.665771484375,
        -4727.5517578125,
        1212.623779296875
      ],
      [
        -2475.034912109375,
        -4727.78955078125,
        1192.623779296875
      ],
      [
        -2475.95654296875,
        -4726.8681640625,
        1192.623779296875
      ],
      [
        -2475.034912109375,
        -4727.78955078125,
        1192.623779296875
      ],
      [
        -2463.123046875,
        -4739.70166015625,
        1192.623779296875
      ],
      [
        -2451.613037109375,
        -4741.4677734375,
        1052.623779296875
      ],
      [
        -2446.300537109375,
        -4736.1552734375,
        1052.623779296875
      ],
      [
        -2466.974365234375,
        -4734.83251953125,
        1178.0010986328125
      ],
      [
        -2458.89453125,
        -4715.60546875,
        1166.9442138671875
      ],
      [
        -2494.296875,
        -4706.22900390625,
        1159.5906982421875
      ],
      [
        -2484.2236328125,
        -4734.83251953125,
        1181.6800537109375
      ],
      [
        -2484.2236328125,
        -4736.2177734375,
        1178.6890869140625
      ],
      [
        -2470.88134765625,
        -4789.03857421875,
        1171.865478515625
      ],
      [
        -2482.140625,
        -4794.93603515625,
        1177.623779296875
      ],
      [
        -2484.2236328125,
        -4734.83251953125,
        1181.6800537109375
      ],
      [
        -2729.999755859375,
        -4856.7685546875,
        1082.623779296875
      ],
      [
        -2729.999755859375,
        -4856.7685546875,
        1082.623779296875
      ],
      [
        -2729.999755859375,
        -4877.7685546875,
        1072.623779296875
      ],
      [
        -2729.999755859375,
        -4877.7685546875,
        1082.623779296875
      ],
      [
        -2729.999755859375,
        -4869.7685546875,
        1072.623779296875
      ],
      [
        -2729.999755859375,
        -4869.7685546875,
        1082.623779296875
      ],
      [
        -2732.999755859375,
        -4877.7685546875,
        1078.623779296875
      ],
      [
        -2732.999755859375,
        -4869.7685546875,
        1078.623779296875
      ],
      [
        -2732.999755859375,
        -4869.7685546875,
        1078.623779296875
      ],
      [
        -2729.999755859375,
        -4869.7685546875,
        1078.623779296875
      ],
      [
        -2729.999755859375,
        -4877.7685546875,
        1078.623779296875
      ],
      [
        -2732.999755859375,
        -4877.7685546875,
        1078.623779296875
      ],
      [
        -2729.999755859375,
        -4864.7685546875,
        1087.6239013671875
      ],
      [
        -2729.999755859375,
        -4859.76806640625,
        1082.623779296875
      ],
      [
        -2746.999755859375,
        -4809.7685546875,
        1096.845947265625
      ],
      [
        -2737.499755859375,
        -4809.7685546875,
        1092.623779296875
      ],
      [
        -2737.499755859375,
        -4811.7685546875,
        1092.623779296875
      ],
      [
        -2737.499755859375,
        -4864.7685546875,
        1092.623779296875
      ],
      [
        -2737.5,
        -4799.7685546875,
        1092.623779296875
      ],
      [
        -2746.999755859375,
        -4799.7685546875,
        1096.845947265625
      ],
      [
        -2746.999755859375,
        -4809.7685546875,
        1096.845947265625
      ],
      [
        -2746.999755859375,
        -4799.7685546875,
        1096.845947265625
      ],
      [
        -2741.999755859375,
        -4799.7685546875,
        1094.623779296875
      ],
      [
        -2741.999755859375,
        -4809.7685546875,
        1094.623779296875
      ],
      [
        -2746.999755859375,
        -4859.76806640625,
        1082.623779296875
      ],
      [
        -2746.999755859375,
        -4864.7685546875,
        1087.6239013671875
      ],
      [
        -2741.999755859375,
        -4864.7685546875,
        1087.6239013671875
      ],
      [
        -2741.999755859375,
        -4863.2685546875,
        1086.1239013671875
      ],
      [
        -2741.999755859375,
        -4864.7685546875,
        1087.6239013671875
      ],
      [
        -2741.999755859375,
        -4864.7685546875,
        1087.6239013671875
      ],
      [
        -2746.999755859375,
        -4864.7685546875,
        1087.6239013671875
      ],
      [
        -2742.999755859375,
        -4863.2685546875,
        1086.1239013671875
      ],
      [
        -2742.999755859375,
        -4864.7685546875,
        1087.6239013671875
      ],
      [
        -2741.999755859375,
        -4863.2685546875,
        1086.1239013671875
      ],
      [
        -2742.999755859375,
        -4863.2685546875,
        1086.1239013671875
      ],
      [
        -2734.999755859375,
        -4864.7685546875,
        1087.6239013671875
      ],
      [
        -2729.999755859375,
        -4864.7685546875,
        1087.6239013671875
      ],
      [
        -2734.999755859375,
        -4864.7685546875,
        1087.6239013671875
      ],
      [
        -2734.999755859375,
        -4863.2685546875,
        1086.1239013671875
      ],
      [
        -2734.999755859375,
        -4864.7685546875,
        1087.6239013671875
      ],
      [
        -2733.999755859375,
        -4864.7685546875,
        1087.6239013671875
      ],
      [
        -2733.999755859375,
        -4863.2685546875,
        1086.1239013671875
      ],
      [
        -2733.999755859375,
        -4863.2685546875,
        1086.1239013671875
      ],
      [
        -2734.999755859375,
        -4863.2685546875,
        1086.1239013671875
      ],
      [
        -2731.999755859375,
        -4879.7685546875,
        1085.123779296875
      ],
      [
        -2731.999755859375,
        -4877.7685546875,
        1085.123779296875
      ],
      [
        -2731.999755859375,
        -4878.7685546875,
        1086.623779296875
      ],
      [
        -2731.999755859375,
        -4879.7685546875,
        1085.123779296875
      ],
      [
        -2731.999755859375,
        -4877.7685546875,
        1085.123779296875
      ],
      [
        -2731.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      [
        -2731.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      [
        -2731.999755859375,
        -4878.7685546875,
        1086.623779296875
      ],
      [
        -2724.999755859375,
        -4879.7685546875,
        1085.123779296875
      ],
      [
        -2721.999755859375,
        -4879.7685546875,
        1085.123779296875
      ],
      [
        -2721.999755859375,
        -4877.7685546875,
        1085.123779296875
      ],
      [
        -2724.999755859375,
        -4877.7685546875,
        1085.123779296875
      ],
      [
        -2724.999755859375,
        -4878.7685546875,
        1086.623779296875
      ],
      [
        -2721.999755859375,
        -4878.7685546875,
        1086.623779296875
      ],
      [
        -2721.999755859375,
        -4879.7685546875,
        1085.123779296875
      ],
      [
        -2724.999755859375,
        -4879.7685546875,
        1085.123779296875
      ],
      [
        -2724.999755859375,
        -4877.7685546875,
        1085.123779296875
      ],
      [
        -2721.999755859375,
        -4877.7685546875,
        1085.123779296875
      ],
      [
        -2721.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      [
        -2724.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      [
        -2724.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      [
        -2721.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      [
        -2721.999755859375,
        -4878.7685546875,
        1086.623779296875
      ],
      [
        -2724.999755859375,
        -4878.7685546875,
        1086.623779296875
      ],
      [
        -2711.999755859375,
        -4872.7685546875,
        1095.623779296875
      ],
      [
        -2714.999755859375,
        -4872.7685546875,
        1095.623779296875
      ],
      [
        -2839.999755859375,
        -4869.7685546875,
        1230.4019775390625
      ],
      [
        -2839.999755859375,
        -4718.13916015625,
        1230.4019775390625
      ],
      [
        -2799.999755859375,
        -4719.2421875,
        1231.90625
      ],
      [
        -2799.999755859375,
        -4869.7685546875,
        1231.90625
      ],
      [
        -2839.999755859375,
        -4718.13916015625,
        1230.4019775390625
      ],
      [
        -2799.999755859375,
        -4719.2421875,
        1231.90625
      ],
      [
        -2799.999755859375,
        -4869.7685546875,
        1231.90625
      ],
      [
        -2839.999755859375,
        -4869.7685546875,
        1230.4019775390625
      ],
      [
        -2879.999755859375,
        -4609.7685546875,
        1052.623779296875
      ],
      [
        -2879.999755859375,
        -4609.7685546875,
        1072.623779296875
      ],
      [
        -2920.0,
        -4850.7685546875,
        1082.623779296875
      ],
      [
        -2920.0,
        -4850.7685546875,
        1152.623779296875
      ],
      [
        -2920.0,
        -4850.7685546875,
        1152.623779296875
      ],
      [
        -2920.0,
        -4852.89501953125,
        1179.3675537109375
      ],
      [
        -2920.0,
        -4856.3642578125,
        1227.393310546875
      ],
      [
        -2920.0,
        -4852.89501953125,
        1179.3675537109375
      ],
      [
        -2879.999755859375,
        -4609.7685546875,
        1072.623779296875
      ],
      [
        -2899.999755859375,
        -4609.7685546875,
        1112.623779296875
      ],
      [
        -2920.0,
        -4850.7685546875,
        1082.623779296875
      ],
      [
        -2920.0,
        -4835.04296875,
        1082.623779296875
      ],
      [
        -2920.0,
        -4835.04296875,
        1082.623779296875
      ],
      [
        -2920.0,
        -4830.03662109375,
        1082.623779296875
      ],
      [
        -2920.0,
        -4821.984375,
        1052.623779296875
      ],
      [
        -2920.0,
        -4821.984375,
        1082.623779296875
      ],
      [
        -2920.0,
        -4821.984375,
        1082.623779296875
      ],
      [
        -2920.0,
        -4857.9619140625,
        1255.3924560546875
      ],
      [
        -2920.0,
        -4909.00634765625,
        1255.3924560546875
      ],
      [
        -2920.0,
        -4856.3642578125,
        1227.393310546875
      ],
      [
        -2920.0,
        -4857.9619140625,
        1255.3924560546875
      ],
      [
        -2303.999755859375,
        -4605.7685546875,
        1085.623779296875
      ],
      [
        -2303.999755859375,
        -4609.7685546875,
        1085.623779296875
      ],
      [
        -2879.999755859375,
        -4605.7685546875,
        1072.623779296875
      ],
      [
        -2899.999755859375,
        -4605.7685546875,
        1112.623779296875
      ],
      [
        -2879.999755859375,
        -4605.7685546875,
        1052.623779296875
      ],
      [
        -2879.999755859375,
        -4605.7685546875,
        1072.623779296875
      ],
      [
        -2780.7998046875,
        -4605.7685546875,
        1074.923828125
      ],
      [
        -2776.19970703125,
        -4605.7685546875,
        1074.923828125
      ],
      [
        -2776.19970703125,
        -4605.7685546875,
        1079.423828125
      ],
      [
        -2776.19970703125,
        -4605.7685546875,
        1074.923828125
      ],
      [
        -2780.7998046875,
        -4605.7685546875,
        1074.923828125
      ],
      [
        -2780.7998046875,
        -4605.7685546875,
        1079.423828125
      ],
      [
        -2780.7998046875,
        -4605.7685546875,
        1079.423828125
      ],
      [
        -2776.19970703125,
        -4605.7685546875,
        1079.423828125
      ],
      [
        -2389.999755859375,
        -4319.7685546875,
        1077.623779296875
      ],
      [
        -2389.999755859375,
        -4569.7998046875,
        1077.623779296875
      ],
      [
        -2214.77978515625,
        -4559.7685546875,
        1077.623779296875
      ],
      [
        -2264.67724609375,
        -4319.7685546875,
        1187.623779296875
      ],
      [
        -2260.266845703125,
        -4329.7685546875,
        1187.623779296875
      ],
      [
        -2260.266845703125,
        -4329.7685546875,
        1052.623779296875
      ],
      [
        -2264.67724609375,
        -4319.7685546875,
        1052.623779296875
      ],
      [
        -2260.266845703125,
        -4329.7685546875,
        1077.623779296875
      ],
      [
        -2224.77978515625,
        -4410.228515625,
        1077.623779296875
      ],
      [
        -2214.77978515625,
        -4432.9013671875,
        1077.623779296875
      ],
      [
        -2224.77978515625,
        -4410.228515625,
        1052.623779296875
      ],
      [
        -2224.77978515625,
        -4410.228515625,
        1077.623779296875
      ],
      [
        -2224.77978515625,
        -4410.228515625,
        1187.623779296875
      ],
      [
        -2224.77978515625,
        -4541.6123046875,
        1072.623779296875
      ],
      [
        -2257.211669921875,
        -4548.52197265625,
        1072.623779296875
      ],
      [
        -2354.0,
        -4480.0,
        1085.2237548828125
      ],
      [
        -2350.0,
        -4485.71435546875,
        1087.7666015625
      ],
      [
        -2350.0,
        -4485.71435546875,
        1087.7666015625
      ],
      [
        -2354.0,
        -4480.0,
        1085.2237548828125
      ],
      [
        -2389.999755859375,
        -4447.27294921875,
        1072.623779296875
      ],
      [
        -2270.0,
        -4420.0,
        1068.623779296875
      ],
      [
        -2246.28076171875,
        -4408.14013671875,
        1070.9957275390625
      ],
      [
        -2270.0,
        -4420.0,
        1068.623779296875
      ],
      [
        -2350.0,
        -4356.23193359375,
        1081.37744140625
      ],
      [
        -2357.999755859375,
        -4360.0,
        1080.6239013671875
      ],
      [
        -2350.0,
        -4356.23193359375,
        1081.37744140625
      ],
      [
        -2321.97216796875,
        -4350.95166015625,
        1082.4334716796875
      ],
      [
        -2246.28076171875,
        -4408.14013671875,
        1070.9957275390625
      ],
      [
        -2238.910400390625,
        -4402.97021484375,
        1072.623779296875
      ],
      [
        -2383.043212890625,
        -4446.95654296875,
        1075.05859375
      ],
      [
        -2386.6806640625,
        -4450.29052734375,
        1073.7855224609375
      ],
      [
        -2383.043212890625,
        -4446.95654296875,
        1075.05859375
      ],
      [
        -2232.88427734375,
        -4435.9033203125,
        1071.18994140625
      ],
      [
        -2270.0,
        -4425.45458984375,
        1067.532958984375
      ],
      [
        -2259.171142578125,
        -4425.45458984375,
        1067.5328369140625
      ],
      [
        -2270.0,
        -4425.45458984375,
        1067.532958984375
      ],
      [
        -2280.90869140625,
        -4425.45458984375,
        1067.532958984375
      ],
      [
        -2280.849853515625,
        -4283.1005859375,
        1187.623779296875
      ],
      [
        -2269.969970703125,
        -4307.7685546875,
        1187.623779296875
      ],
      [
        -2269.969970703125,
        -4307.7685546875,
        1052.623779296875
      ],
      [
        -2280.849853515625,
        -4283.1005859375,
        1052.623779296875
      ],
      [
        -2301.203125,
        -4292.16162109375,
        1104.3970947265625
      ],
      [
        -2301.203125,
        -4292.16162109375,
        1116.3970947265625
      ],
      [
        -2307.839599609375,
        -4295.1162109375,
        1117.6470947265625
      ],
      [
        -2301.203125,
        -4292.16162109375,
        1116.3970947265625
      ],
      [
        -2339.999755859375,
        -4314.7685546875,
        1075.123779296875
      ],
      [
        -2359.999755859375,
        -4319.7685546875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4569.7998046875,
        1064.623779296875
      ],
      [
        -2654.999755859375,
        -4569.7998046875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4250.8173828125,
        1052.623779296875
      ],
      [
        -2654.999755859375,
        -4250.8173828125,
        1152.623779296875
      ],
      [
        -2629.999755859375,
        -4449.7685546875,
        1102.0
      ],
      [
        -2639.999755859375,
        -4569.7998046875,
        1067.623779296875
      ],
      [
        -2639.999755859375,
        -4569.7998046875,
        1064.623779296875
      ],
      [
        -2619.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      [
        -2616.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      [
        -2619.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      [
        -2616.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      [
        -2619.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      [
        -2619.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      [
        -2596.999755859375,
        -4395.837890625,
        1052.623779296875
      ],
      [
        -2596.999755859375,
        -4395.837890625,
        1055.623779296875
      ],
      [
        -2596.999755859375,
        -4395.837890625,
        1055.623779296875
      ],
      [
        -2654.999755859375,
        -4569.7998046875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4529.7685546875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4529.7685546875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4509.7685546875,
        1067.623779296875
      ],
      [
        -2639.999755859375,
        -4509.7685546875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4569.7998046875,
        1064.623779296875
      ],
      [
        -2654.999755859375,
        -4529.7685546875,
        1064.623779296875
      ],
      [
        -2654.999755859375,
        -4529.7685546875,
        1064.623779296875
      ],
      [
        -2639.999755859375,
        -4509.7685546875,
        1064.623779296875
      ],
      [
        -2654.999755859375,
        -4509.7685546875,
        1064.623779296875
      ],
      [
        -2654.999755859375,
        -4446.7685546875,
        1064.623779296875
      ],
      [
        -2654.999755859375,
        -4446.7685546875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4446.7685546875,
        1064.623779296875
      ],
      [
        -2654.999755859375,
        -4446.7685546875,
        1067.623779296875
      ],
      [
        -2536.48291015625,
        -4397.216796875,
        1060.623779296875
      ],
      [
        -2555.551513671875,
        -4416.28515625,
        1060.623779296875
      ],
      [
        -2509.516357421875,
        -4397.216796875,
        1060.623779296875
      ],
      [
        -2536.48291015625,
        -4397.216796875,
        1060.623779296875
      ],
      [
        -2578.01416015625,
        -4404.7685546875,
        1055.623779296875
      ],
      [
        -2572.66552734375,
        -4401.677734375,
        1055.623779296875
      ],
      [
        -2559.999755859375,
        -4506.7685546875,
        1072.623779296875
      ],
      [
        -2559.999755859375,
        -4471.568359375,
        1072.623779296875
      ],
      [
        -2559.999755859375,
        -4414.4423828125,
        1072.5
      ],
      [
        -2559.999755859375,
        -4409.68896484375,
        1072.5
      ],
      [
        -2559.999755859375,
        -4409.68896484375,
        1072.5
      ],
      [
        -2559.999755859375,
        -4414.4423828125,
        1071.197021484375
      ],
      [
        -2535.968017578125,
        -4398.4599609375,
        1068.990966796875
      ],
      [
        -2554.30810546875,
        -4416.80029296875,
        1068.9908447265625
      ],
      [
        -2510.03125,
        -4398.4599609375,
        1068.990966796875
      ],
      [
        -2535.968017578125,
        -4398.4599609375,
        1068.990966796875
      ],
      [
        -2555.33984375,
        -4416.37255859375,
        1062.0474853515625
      ],
      [
        -2553.7685546875,
        -4417.0234375,
        1072.623779296875
      ],
      [
        -2553.7685546875,
        -4442.513671875,
        1072.623779296875
      ],
      [
        -2535.744384765625,
        -4398.99951171875,
        1072.623779296875
      ],
      [
        -2553.7685546875,
        -4417.0234375,
        1072.623779296875
      ],
      [
        -2553.7685546875,
        -4442.513671875,
        1072.623779296875
      ],
      [
        -2535.74462890625,
        -4460.53759765625,
        1072.623779296875
      ],
      [
        -2510.2548828125,
        -4398.99951171875,
        1072.623779296875
      ],
      [
        -2535.744384765625,
        -4398.99951171875,
        1072.623779296875
      ],
      [
        -2518.0,
        -4460.53759765625,
        1072.623779296875
      ],
      [
        -2518.0,
        -4450.0,
        1072.623779296875
      ],
      [
        -2518.0,
        -4460.53759765625,
        1072.623779296875
      ],
      [
        -2510.2548828125,
        -4460.53759765625,
        1072.623779296875
      ],
      [
        -2535.74462890625,
        -4460.53759765625,
        1072.623779296875
      ],
      [
        -2526.199951171875,
        -4460.53759765625,
        1072.623779296875
      ],
      [
        -2589.999755859375,
        -4509.7685546875,
        1075.623779296875
      ],
      [
        -2589.999755859375,
        -4506.7685546875,
        1075.623779296875
      ],
      [
        -2519.9892578125,
        -4422.5,
        1094.623779296875
      ],
      [
        -2526.010986328125,
        -4422.5,
        1094.623779296875
      ],
      [
        -2526.0107421875,
        -4422.5,
        1094.623779296875
      ],
      [
        -2519.989013671875,
        -4422.5,
        1094.623779296875
      ],
      [
        -2519.989013671875,
        -4422.5,
        1086.623779296875
      ],
      [
        -2526.0107421875,
        -4422.5,
        1086.623779296875
      ],
      [
        -2516.0,
        -4426.869140625,
        1094.623779296875
      ],
      [
        -2516.0,
        -4426.869140625,
        1094.623779296875
      ],
      [
        -2516.0,
        -4426.869140625,
        1086.623779296875
      ],
      [
        -2516.0,
        -4432.66796875,
        1094.623779296875
      ],
      [
        -2516.0,
        -4432.66796875,
        1094.623779296875
      ],
      [
        -2516.0,
        -4432.66796875,
        1086.623779296875
      ],
      [
        -2528.5,
        -4427.49072265625,
        1094.623779296875
      ],
      [
        -2520.832763671875,
        -4435.0,
        1094.623779296875
      ],
      [
        -2520.832763671875,
        -4435.0,
        1094.623779296875
      ],
      [
        -2520.832763671875,
        -4435.0,
        1086.623779296875
      ],
      [
        -2528.5,
        -4432.04638671875,
        1094.623779296875
      ],
      [
        -2525.16650390625,
        -4435.0,
        1094.623779296875
      ],
      [
        -2556.13671875,
        -4509.7685546875,
        1075.623779296875
      ],
      [
        -2540.313720703125,
        -4471.568359375,
        1075.623779296875
      ],
      [
        -2553.32958984375,
        -4442.33154296875,
        1075.623779296875
      ],
      [
        -2535.562744140625,
        -4460.0986328125,
        1075.623779296875
      ],
      [
        -2525.16650390625,
        -4435.0,
        1094.623779296875
      ],
      [
        -2525.16650390625,
        -4435.0,
        1086.623779296875
      ],
      [
        -2518.0,
        -4460.0986328125,
        1075.623779296875
      ],
      [
        -2518.0,
        -4450.0,
        1075.623779296875
      ],
      [
        -2518.0,
        -4460.0986328125,
        1075.623779296875
      ],
      [
        -2510.436767578125,
        -4460.0986328125,
        1075.623779296875
      ],
      [
        -2535.562744140625,
        -4460.0986328125,
        1075.623779296875
      ],
      [
        -2526.199951171875,
        -4460.0986328125,
        1075.623779296875
      ],
      [
        -2799.999755859375,
        -4344.7998046875,
        1065.123779296875
      ],
      [
        -2799.999755859375,
        -4344.7998046875,
        1065.123779296875
      ],
      [
        -2799.999755859375,
        -4344.7998046875,
        1052.623779296875
      ],
      [
        -2833.39990234375,
        -4372.7685546875,
        1065.123779296875
      ],
      [
        -2833.39990234375,
        -4372.7685546875,
        1052.623779296875
      ],
      [
        -2799.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      [
        -2823.362548828125,
        -4372.7685546875,
        1082.623779296875
      ],
      [
        -2823.362548828125,
        -4372.7685546875,
        1082.623779296875
      ],
      [
        -2833.39990234375,
        -4372.7685546875,
        1065.123779296875
      ],
      [
        -2799.999755859375,
        -4355.0,
        1065.123779296875
      ],
      [
        -2799.999755859375,
        -4355.0,
        1063.0
      ],
      [
        -2799.999755859375,
        -4355.0,
        1063.0
      ],
      [
        -2799.999755859375,
        -4344.7998046875,
        1063.0
      ],
      [
        -2833.39990234375,
        -4355.0,
        1063.0
      ],
      [
        -2799.999755859375,
        -4344.7998046875,
        1065.123779296875
      ],
      [
        -2799.999755859375,
        -4355.0,
        1065.123779296875
      ],
      [
        -2833.39990234375,
        -4355.0,
        1065.123779296875
      ],
      [
        -2823.39990234375,
        -4372.7685546875,
        1065.123779296875
      ],
      [
        -2823.39990234375,
        -4372.7685546875,
        1063.0
      ],
      [
        -2833.39990234375,
        -4372.7685546875,
        1065.123779296875
      ],
      [
        -2823.39990234375,
        -4372.7685546875,
        1065.123779296875
      ],
      [
        -2823.39990234375,
        -4372.7685546875,
        1063.0
      ],
      [
        -2833.39990234375,
        -4372.7685546875,
        1063.0
      ],
      [
        -2867.999755859375,
        -4319.7685546875,
        1098.1436767578125
      ],
      [
        -2867.999755859375,
        -4372.7685546875,
        1098.1436767578125
      ],
      [
        -2739.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      [
        -2777.362548828125,
        -4372.7685546875,
        1092.623779296875
      ],
      [
        -2799.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      [
        -2795.0,
        -4319.7685546875,
        1075.9237060546875
      ],
      [
        -2795.0,
        -4330.0,
        1075.9237060546875
      ],
      [
        -2749.472900390625,
        -4319.7685546875,
        1085.0452880859375
      ],
      [
        -2749.472900390625,
        -4330.0,
        1085.0452880859375
      ],
      [
        -2747.39990234375,
        -4372.7685546875,
        1052.623779296875
      ],
      [
        -2747.39990234375,
        -4372.7685546875,
        1065.123779296875
      ],
      [
        -2757.362548828125,
        -4372.7685546875,
        1082.623779296875
      ],
      [
        -2777.362548828125,
        -4372.7685546875,
        1092.623779296875
      ],
      [
        -2747.39990234375,
        -4372.7685546875,
        1065.123779296875
      ],
      [
        -2757.362548828125,
        -4372.7685546875,
        1082.623779296875
      ],
      [
        -2747.39990234375,
        -4355.0,
        1063.0
      ],
      [
        -2747.39990234375,
        -4355.0,
        1065.123779296875
      ],
      [
        -2757.362548828125,
        -4372.7685546875,
        1063.0
      ],
      [
        -2757.362548828125,
        -4372.7685546875,
        1065.123779296875
      ],
      [
        -2747.39990234375,
        -4372.7685546875,
        1063.0
      ],
      [
        -2757.362548828125,
        -4372.7685546875,
        1063.0
      ],
      [
        -2757.362548828125,
        -4372.7685546875,
        1065.123779296875
      ],
      [
        -2747.39990234375,
        -4372.7685546875,
        1065.123779296875
      ],
      [
        -2795.0,
        -4372.7685546875,
        1056.5999755859375
      ],
      [
        -2795.0,
        -4372.7685546875,
        1058.7249755859375
      ],
      [
        -2785.0,
        -4372.7685546875,
        1056.5999755859375
      ],
      [
        -2785.0,
        -4372.7685546875,
        1057.5440673828125
      ],
      [
        -2785.0,
        -4372.7685546875,
        1056.5999755859375
      ],
      [
        -2795.0,
        -4372.7685546875,
        1056.5999755859375
      ],
      [
        -2795.0,
        -4372.7685546875,
        1058.7249755859375
      ],
      [
        -2785.0,
        -4372.7685546875,
        1058.7249755859375
      ],
      [
        -2785.0,
        -4372.7685546875,
        1058.7249755859375
      ],
      [
        -2763.0,
        -4330.0,
        1092.623779296875
      ],
      [
        -2763.0,
        -4330.0,
        1097.623779296875
      ],
      [
        -2739.999755859375,
        -4319.7685546875,
        1056.0
      ],
      [
        -2736.0,
        -4319.7685546875,
        1056.0
      ],
      [
        -2736.0,
        -4319.7685546875,
        1056.0
      ],
      [
        -2736.0,
        -4319.7685546875,
        1052.623779296875
      ],
      [
        -2919.999755859375,
        -4306.16796875,
        1052.623779296875
      ],
      [
        -2919.999755859375,
        -4306.16796875,
        1152.623779296875
      ],
      [
        -2869.999755859375,
        -4306.16796875,
        1067.823486328125
      ],
      [
        -2739.999755859375,
        -4306.16796875,
        1067.823486328125
      ],
      [
        -2750.961181640625,
        -4306.16796875,
        1067.823486328125
      ],
      [
        -2695.4853515625,
        -4291.30322265625,
        1060.39111328125
      ],
      [
        -2679.95068359375,
        -4275.7685546875,
        1052.623779296875
      ],
      [
        -2695.4853515625,
        -4291.30322265625,
        1060.39111328125
      ],
      [
        -2869.999755859375,
        -4306.16796875,
        1052.623779296875
      ],
      [
        -2869.999755859375,
        -4306.16796875,
        1067.823486328125
      ],
      [
        -2739.999755859375,
        -4303.23046875,
        1066.3548583984375
      ],
      [
        -2739.999755859375,
        -4303.23046875,
        1052.623779296875
      ],
      [
        -2739.999755859375,
        -4306.16796875,
        1067.823486328125
      ],
      [
        -2739.999755859375,
        -4306.16796875,
        1052.623779296875
      ],
      [
        -2909.999755859375,
        -4444.7685546875,
        1092.623779296875
      ],
      [
        -2919.999755859375,
        -4559.7685546875,
        1072.623779296875
      ],
      [
        -2919.999755859375,
        -4444.7685546875,
        1072.623779296875
      ],
      [
        -2909.999755859375,
        -4444.7685546875,
        1092.623779296875
      ],
      [
        -2919.999755859375,
        -4444.7685546875,
        1092.623779296875
      ],
      [
        -2739.999755859375,
        -4454.7998046875,
        1092.623779296875
      ],
      [
        -2739.999755859375,
        -4454.7998046875,
        1052.623779296875
      ],
      [
        -2869.999755859375,
        -4454.7998046875,
        1052.623779296875
      ],
      [
        -2869.999755859375,
        -4454.7998046875,
        1068.6842041015625
      ],
      [
        -2869.999755859375,
        -4454.7998046875,
        1074.623779296875
      ],
      [
        -2869.999755859375,
        -4454.7998046875,
        1068.6842041015625
      ],
      [
        -2884.999755859375,
        -4454.7998046875,
        1092.623779296875
      ],
      [
        -2884.999755859375,
        -4454.7998046875,
        1074.623779296875
      ],
      [
        -2869.999755859375,
        -4454.7998046875,
        1074.623779296875
      ],
      [
        -2884.999755859375,
        -4454.7998046875,
        1074.623779296875
      ],
      [
        -2654.999755859375,
        -4479.7685546875,
        1064.623779296875
      ],
      [
        -2654.999755859375,
        -4454.7998046875,
        1064.623779296875
      ],
      [
        -2660.0,
        -4454.7998046875,
        1064.623779296875
      ],
      [
        -2660.0,
        -4479.7685546875,
        1064.623779296875
      ],
      [
        -2660.0,
        -4479.7685546875,
        1067.623779296875
      ],
      [
        -2660.0,
        -4454.7998046875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4454.7998046875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4479.7685546875,
        1067.623779296875
      ],
      [
        -2660.0,
        -4454.7998046875,
        1067.623779296875
      ],
      [
        -2660.0,
        -4479.7685546875,
        1067.623779296875
      ],
      [
        -2660.0,
        -4479.7685546875,
        1064.623779296875
      ],
      [
        -2660.0,
        -4454.7998046875,
        1064.623779296875
      ],
      [
        -2747.39990234375,
        -4444.60009765625,
        1065.123779296875
      ],
      [
        -2833.39990234375,
        -4444.60009765625,
        1065.123779296875
      ],
      [
        -2747.39990234375,
        -4444.60009765625,
        1063.0
      ],
      [
        -2833.39990234375,
        -4444.60009765625,
        1063.0
      ],
      [
        -2884.999755859375,
        -4497.7685546875,
        1092.623779296875
      ],
      [
        -2864.999755859375,
        -4497.7685546875,
        1092.623779296875
      ],
      [
        -2764.999755859375,
        -4509.7685546875,
        1074.623779296875
      ],
      [
        -2764.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      [
        -2660.0,
        -4559.7685546875,
        1067.623779296875
      ],
      [
        -2660.0,
        -4559.7685546875,
        1064.623779296875
      ],
      [
        -2654.999755859375,
        -4559.7685546875,
        1064.623779296875
      ],
      [
        -2660.0,
        -4559.7685546875,
        1064.623779296875
      ],
      [
        -2660.0,
        -4559.7685546875,
        1067.623779296875
      ],
      [
        -2654.999755859375,
        -4559.7685546875,
        1067.623779296875
      ],
      [
        -2749.999755859375,
        -4559.7685546875,
        1072.623779296875
      ],
      [
        -2779.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      [
        -2776.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      [
        -2779.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      [
        -2776.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      [
        -2776.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      [
        -2776.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      [
        -2779.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      [
        -2779.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      [
        -2879.999755859375,
        -4589.7685546875,
        1072.623779296875
      ],
      [
        -2899.999755859375,
        -4589.7685546875,
        1112.623779296875
      ],
      [
        -2879.999755859375,
        -4589.7685546875,
        1052.623779296875
      ],
      [
        -2879.999755859375,
        -4589.7685546875,
        1072.623779296875
      ],
      [
        -3699.999755859375,
        -4260.35546875,
        1102.623779296875
      ],
      [
        -3729.92431640625,
        -4249.7685546875,
        1222.32177734375
      ],
      [
        -3699.999755859375,
        -4260.80517578125,
        1102.623779296875
      ],
      [
        -3733.5146484375,
        -4249.7685546875,
        1236.6832275390625
      ],
      [
        -3319.999755859375,
        -4741.146484375,
        1052.623779296875
      ],
      [
        -3319.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      [
        -3339.772216796875,
        -4739.541015625,
        1181.713134765625
      ],
      [
        -3580.227294921875,
        -4739.541015625,
        1181.713134765625
      ],
      [
        -3319.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      [
        -3339.772216796875,
        -4739.541015625,
        1181.713134765625
      ],
      [
        -3116.600341796875,
        -4740.53759765625,
        1101.623779296875
      ],
      [
        -3111.6005859375,
        -4740.6494140625,
        1092.623779296875
      ],
      [
        -3116.600341796875,
        -4740.53759765625,
        1101.623779296875
      ],
      [
        -3111.6005859375,
        -4740.6494140625,
        1092.623779296875
      ],
      [
        -3087.100341796875,
        -4740.6494140625,
        1092.623779296875
      ],
      [
        -3082.100341796875,
        -4740.53759765625,
        1101.623779296875
      ],
      [
        -3111.6005859375,
        -4740.6494140625,
        1092.623779296875
      ],
      [
        -3087.100341796875,
        -4740.6494140625,
        1092.623779296875
      ],
      [
        -3000.410888671875,
        -4741.14697265625,
        1052.623779296875
      ],
      [
        -3001.35986328125,
        -4740.77392578125,
        1082.623779296875
      ],
      [
        -3003.574462890625,
        -4739.90283203125,
        1152.623779296875
      ],
      [
        -3001.35986328125,
        -4740.77392578125,
        1082.623779296875
      ],
      [
        -2968.059326171875,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -2968.409423828125,
        -4741.146484375,
        1052.623779296875
      ],
      [
        -2955.91162109375,
        -4741.146484375,
        1052.623779296875
      ],
      [
        -2956.077392578125,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -2956.077392578125,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -2968.059326171875,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -3199.588623046875,
        -4741.14697265625,
        1052.623779296875
      ],
      [
        -3198.6396484375,
        -4740.77392578125,
        1082.623779296875
      ],
      [
        -3196.425048828125,
        -4739.90283203125,
        1152.623779296875
      ],
      [
        -3198.6396484375,
        -4740.77392578125,
        1082.623779296875
      ],
      [
        -3231.590087890625,
        -4741.146484375,
        1052.623779296875
      ],
      [
        -3231.940185546875,
        -4740.7734375,
        1082.623779296875
      ],
      [
        -3624.999755859375,
        -4741.07763671875,
        1058.1834716796875
      ],
      [
        -3624.999755859375,
        -4679.7998046875,
        1059.3406982421875
      ],
      [
        -3624.999755859375,
        -4679.7998046875,
        1054.3406982421875
      ],
      [
        -3624.999755859375,
        -4741.1396484375,
        1053.1822509765625
      ],
      [
        -3667.999755859375,
        -4741.05810546875,
        1059.7738037109375
      ],
      [
        -3667.999755859375,
        -4679.7998046875,
        1059.7738037109375
      ],
      [
        -3667.999755859375,
        -4679.7998046875,
        1054.7738037109375
      ],
      [
        -3667.999755859375,
        -4741.1201171875,
        1054.7738037109375
      ],
      [
        -3632.999755859375,
        -4741.07763671875,
        1058.1834716796875
      ],
      [
        -3632.999755859375,
        -4679.7998046875,
        1059.3406982421875
      ],
      [
        -3624.999755859375,
        -4679.7998046875,
        1059.3406982421875
      ],
      [
        -3624.999755859375,
        -4741.07763671875,
        1058.1834716796875
      ],
      [
        -3347.17578125,
        -4746.9443359375,
        1211.3271484375
      ],
      [
        -3574.965576171875,
        -4744.802734375,
        1202.759765625
      ],
      [
        -3347.175537109375,
        -4946.9443359375,
        1211.3270263671875
      ],
      [
        -3347.17578125,
        -4746.9443359375,
        1211.3271484375
      ],
      [
        -3319.999755859375,
        -4850.7685546875,
        1102.6241455078125
      ],
      [
        -3332.493896484375,
        -4850.7685546875,
        1152.5999755859375
      ],
      [
        -3319.999755859375,
        -4947.19970703125,
        1212.34912109375
      ],
      [
        -3347.175537109375,
        -4946.9443359375,
        1211.3270263671875
      ],
      [
        -3087.100341796875,
        -4939.7685546875,
        1092.623779296875
      ],
      [
        -3087.1005859375,
        -4965.7685546875,
        1092.623779296875
      ],
      [
        -3137.9208984375,
        -5025.11279296875,
        1140.0
      ],
      [
        -3060.780029296875,
        -5025.11279296875,
        1140.0
      ],
      [
        -3053.76708984375,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3144.93408203125,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3143.625732421875,
        -4965.7685546875,
        1150.268798828125
      ],
      [
        -3140.769775390625,
        -4965.7685546875,
        1145.1282958984375
      ],
      [
        -3144.93408203125,
        -4965.7685546875,
        1152.623779296875
      ],
      [
        -3143.625732421875,
        -4965.7685546875,
        1150.268798828125
      ],
      [
        -3054.07763671875,
        -4965.7685546875,
        1152.0648193359375
      ],
      [
        -3083.009033203125,
        -4965.7685546875,
        1099.98828125
      ],
      [
        -3116.016845703125,
        -4965.7685546875,
        1100.57275390625
      ],
      [
        -3140.769775390625,
        -4965.7685546875,
        1145.1282958984375
      ],
      [
        -3083.0087890625,
        -4965.7685546875,
        1099.98828125
      ],
      [
        -3116.0166015625,
        -4965.7685546875,
        1100.5728759765625
      ],
      [
        -3111.6005859375,
        -4965.7685546875,
        1092.623779296875
      ],
      [
        -3087.100341796875,
        -4965.7685546875,
        1092.623779296875
      ],
      [
        -3119.999755859375,
        -4939.7685546875,
        1107.7423095703125
      ],
      [
        -3116.6005859375,
        -4939.7685546875,
        1101.623779296875
      ],
      [
        -3082.105224609375,
        -4939.7685546875,
        1101.614990234375
      ],
      [
        -3079.999755859375,
        -4939.7685546875,
        1105.4046630859375
      ],
      [
        -3082.100341796875,
        -4939.7685546875,
        1101.623779296875
      ],
      [
        -3116.6005859375,
        -4939.7685546875,
        1101.623779296875
      ],
      [
        -3111.6005859375,
        -4939.7685546875,
        1092.623779296875
      ],
      [
        -3087.100341796875,
        -4939.7685546875,
        1092.623779296875
      ],
      [
        -3053.76708984375,
        -4965.52783203125,
        1152.623779296875
      ],
      [
        -3054.07763671875,
        -4965.7685546875,
        1152.064697265625
      ],
      [
        -3077.07080078125,
        -4932.697265625,
        1110.6771240234375
      ],
      [
        -3079.999755859375,
        -4939.7685546875,
        1105.4046630859375
      ],
      [
        -3069.999755859375,
        -4929.7685546875,
        1123.4049072265625
      ],
      [
        -3077.07080078125,
        -4932.697265625,
        1110.6771240234375
      ],
      [
        -3064.878173828125,
        -4931.8896484375,
        1132.623779296875
      ],
      [
        -3069.999755859375,
        -4929.7685546875,
        1123.4049072265625
      ],
      [
        -3119.999755859375,
        -4939.7685546875,
        1107.742431640625
      ],
      [
        -3122.9287109375,
        -4932.697265625,
        1113.014404296875
      ],
      [
        -3122.9287109375,
        -4932.697265625,
        1113.014404296875
      ],
      [
        -3129.999755859375,
        -4929.7685546875,
        1125.7420654296875
      ],
      [
        -3129.999755859375,
        -4929.7685546875,
        1125.7420654296875
      ],
      [
        -3133.822998046875,
        -4931.35205078125,
        1132.623779296875
      ],
      [
        -3229.37255859375,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3169.794189453125,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3169.794189453125,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3229.37255859375,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3286.183349609375,
        -4919.7685546875,
        1102.623779296875
      ],
      [
        -3290.5458984375,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3319.999755859375,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3229.37255859375,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3275.381591796875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3275.381591796875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3184.8525390625,
        -4935.62158203125,
        1092.623779296875
      ],
      [
        -3145.921875,
        -4965.7685546875,
        1092.623779296875
      ],
      [
        -3319.999755859375,
        -4850.7685546875,
        1092.623779296875
      ],
      [
        -3314.499755859375,
        -4850.7685546875,
        1092.623779296875
      ],
      [
        -3294.4287109375,
        -4850.7685546875,
        1098.123779296875
      ],
      [
        -3294.42822265625,
        -4850.7685546875,
        1152.623779296875
      ],
      [
        -3169.794189453125,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3210.865234375,
        -4896.6904296875,
        1092.623779296875
      ],
      [
        -3184.8525390625,
        -4935.62158203125,
        1092.623779296875
      ],
      [
        -3184.8525390625,
        -4765.91552734375,
        1092.623779296875
      ],
      [
        -3210.865234375,
        -4804.8466796875,
        1092.623779296875
      ],
      [
        -3222.96435546875,
        -4750.33740234375,
        1092.623779296875
      ],
      [
        -3198.3232421875,
        -4740.6494140625,
        1092.623779296875
      ],
      [
        -3213.019775390625,
        -4808.0712890625,
        1095.0
      ],
      [
        -3219.147216796875,
        -4817.24169921875,
        1095.0
      ],
      [
        -3264.823974609375,
        -4787.7001953125,
        1095.0
      ],
      [
        -3262.144287109375,
        -4787.7001953125,
        1095.0
      ],
      [
        -3262.144287109375,
        -4787.7001953125,
        1095.0
      ],
      [
        -3252.736083984375,
        -4787.7001953125,
        1095.0
      ],
      [
        -3219.147216796875,
        -4817.24169921875,
        1095.0
      ],
      [
        -3246.87841796875,
        -4801.26220703125,
        1092.623779296875
      ],
      [
        -3219.147216796875,
        -4817.24169921875,
        1092.623779296875
      ],
      [
        -3264.823974609375,
        -4787.7001953125,
        1092.623779296875
      ],
      [
        -3253.999755859375,
        -4787.7001953125,
        1092.623779296875
      ],
      [
        -3253.0908203125,
        -4786.7001953125,
        1092.623779296875
      ],
      [
        -3253.999755859375,
        -4786.7001953125,
        1092.623779296875
      ],
      [
        -3219.999755859375,
        -4850.7685546875,
        1092.623779296875
      ],
      [
        -3210.865234375,
        -4896.6904296875,
        1092.623779296875
      ],
      [
        -3210.865234375,
        -4804.8466796875,
        1092.623779296875
      ],
      [
        -3211.66259765625,
        -4808.85498046875,
        1092.623779296875
      ],
      [
        -3219.999755859375,
        -4850.7685546875,
        1092.623779296875
      ],
      [
        -3213.928955078125,
        -4820.24853515625,
        1092.623779296875
      ],
      [
        -3213.928955078125,
        -4820.24853515625,
        1092.623779296875
      ],
      [
        -3129.2607421875,
        -4965.7685546875,
        1092.623779296875
      ],
      [
        -3145.921875,
        -4965.7685546875,
        1092.623779296875
      ],
      [
        -3129.2607421875,
        -4965.7685546875,
        1092.623779296875
      ],
      [
        -3137.07080078125,
        -4932.697265625,
        1092.623779296875
      ],
      [
        -3139.999755859375,
        -4939.7685546875,
        1092.623779296875
      ],
      [
        -3129.999755859375,
        -4929.7685546875,
        1092.623779296875
      ],
      [
        -3137.07080078125,
        -4932.697265625,
        1092.623779296875
      ],
      [
        -3122.9287109375,
        -4932.697265625,
        1092.623779296875
      ],
      [
        -3129.999755859375,
        -4929.7685546875,
        1092.623779296875
      ],
      [
        -3119.999755859375,
        -4939.7685546875,
        1092.623779296875
      ],
      [
        -3122.9287109375,
        -4932.697265625,
        1092.623779296875
      ],
      [
        -3144.960693359375,
        -4784.3359375,
        1092.623779296875
      ],
      [
        -3144.960693359375,
        -4784.3359375,
        1092.623779296875
      ],
      [
        -3164.42626953125,
        -4797.34228515625,
        1092.623779296875
      ],
      [
        -3219.147216796875,
        -4817.24169921875,
        1092.623779296875
      ],
      [
        -3219.147216796875,
        -4817.24169921875,
        1082.623779296875
      ],
      [
        -3092.656005859375,
        -4965.7685546875,
        1082.623779296875
      ],
      [
        -3092.656005859375,
        -4965.7685546875,
        1082.623779296875
      ],
      [
        -3109.32275390625,
        -4965.7685546875,
        1052.623779296875
      ],
      [
        -3102.194580078125,
        -4859.7685546875,
        1065.4539794921875
      ],
      [
        -3100.907958984375,
        -4872.13232421875,
        1067.76953125
      ],
      [
        -3104.51708984375,
        -4870.9296875,
        1061.2734375
      ],
      [
        -3104.51708984375,
        -4879.7685546875,
        1061.2734375
      ],
      [
        -3102.194580078125,
        -4859.7685546875,
        1065.4539794921875
      ],
      [
        -3104.516845703125,
        -4859.7685546875,
        1061.2734375
      ],
      [
        -3115.3525390625,
        -4897.552734375,
        1066.4066162109375
      ],
      [
        -3103.38330078125,
        -4893.56298828125,
        1063.314453125
      ],
      [
        -3103.720947265625,
        -4879.7685546875,
        1062.7064208984375
      ],
      [
        -3112.388427734375,
        -4879.7685546875,
        1064.801025390625
      ],
      [
        -3100.572265625,
        -4892.6259765625,
        1068.3741455078125
      ],
      [
        -3104.185791015625,
        -4893.83056640625,
        1069.8497314453125
      ],
      [
        -3104.185791015625,
        -4879.7685546875,
        1067.7403564453125
      ],
      [
        -3101.4658203125,
        -4879.7685546875,
        1066.7657470703125
      ],
      [
        -3112.388427734375,
        -4879.7685546875,
        1064.801025390625
      ],
      [
        -3103.720947265625,
        -4879.7685546875,
        1062.7064208984375
      ],
      [
        -3101.4658203125,
        -4879.7685546875,
        1066.7657470703125
      ],
      [
        -3104.185791015625,
        -4879.7685546875,
        1067.7403564453125
      ],
      [
        -3104.185791015625,
        -4893.83056640625,
        1069.8497314453125
      ],
      [
        -3100.572265625,
        -4892.6259765625,
        1068.3741455078125
      ],
      [
        -3100.572265625,
        -4899.7685546875,
        1068.3741455078125
      ],
      [
        -3105.34765625,
        -4899.7685546875,
        1070.3240966796875
      ],
      [
        -3115.8916015625,
        -4899.7685546875,
        1066.5457763671875
      ],
      [
        -3103.38330078125,
        -4899.7685546875,
        1063.314453125
      ],
      [
        -3103.38330078125,
        -4893.56298828125,
        1063.314453125
      ],
      [
        -3115.3525390625,
        -4897.552734375,
        1066.4066162109375
      ],
      [
        -3104.875,
        -4859.7685546875,
        1060.62890625
      ],
      [
        -3098.21142578125,
        -4769.7685546875,
        1072.623779296875
      ],
      [
        -3106.102294921875,
        -4894.46923828125,
        1070.63232421875
      ],
      [
        -3105.496826171875,
        -4879.7685546875,
        1068.210205078125
      ],
      [
        -3106.102294921875,
        -4894.46923828125,
        1070.63232421875
      ],
      [
        -3106.10205078125,
        -4899.7685546875,
        1070.6322021484375
      ],
      [
        -3105.28125,
        -4879.7685546875,
        1067.3477783203125
      ],
      [
        -3105.496826171875,
        -4879.7685546875,
        1068.210205078125
      ],
      [
        -3098.21142578125,
        -4769.7685546875,
        1072.623779296875
      ],
      [
        -3103.996826171875,
        -4769.7685546875,
        1062.2100830078125
      ],
      [
        -3158.268798828125,
        -4856.10205078125,
        1074.1480712890625
      ],
      [
        -3160.296630859375,
        -4855.63134765625,
        1074.5291748046875
      ],
      [
        -3150.283935546875,
        -4868.052734375,
        1077.010009765625
      ],
      [
        -3137.30712890625,
        -4876.7236328125,
        1069.59814453125
      ],
      [
        -3110.458251953125,
        -4879.7685546875,
        1065.4927978515625
      ],
      [
        -3121.999755859375,
        -4879.7685546875,
        1067.14453125
      ],
      [
        -3158.954833984375,
        -4855.07568359375,
        1076.4903564453125
      ],
      [
        -3158.954833984375,
        -4855.07568359375,
        1074.4185791015625
      ],
      [
        -3158.268798828125,
        -4856.10205078125,
        1074.1480712890625
      ],
      [
        -3150.283935546875,
        -4868.052734375,
        1077.010009765625
      ],
      [
        -3137.30712890625,
        -4876.7236328125,
        1069.59814453125
      ],
      [
        -3129.5654296875,
        -4878.263671875,
        1068.1536865234375
      ],
      [
        -3121.999755859375,
        -4879.7685546875,
        1067.14453125
      ],
      [
        -3160.285888671875,
        -4848.3837890625,
        1075.7105712890625
      ],
      [
        -3158.954833984375,
        -4855.07568359375,
        1074.4185791015625
      ],
      [
        -3158.954833984375,
        -4855.07568359375,
        1076.4903564453125
      ],
      [
        -3158.954833984375,
        -4855.07568359375,
        1078.74072265625
      ],
      [
        -3150.283935546875,
        -4868.052734375,
        1078.2279052734375
      ],
      [
        -3150.283935546875,
        -4868.052734375,
        1078.2279052734375
      ],
      [
        -3161.999755859375,
        -4839.7685546875,
        1077.64697265625
      ],
      [
        -3158.954833984375,
        -4855.07568359375,
        1078.74072265625
      ],
      [
        -3162.180419921875,
        -4838.8603515625,
        1077.58203125
      ],
      [
        -3162.8212890625,
        -4838.54638671875,
        1077.6964111328125
      ],
      [
        -3161.85107421875,
        -4839.021484375,
        1077.5233154296875
      ],
      [
        -3161.85107421875,
        -4839.021484375,
        1077.5233154296875
      ],
      [
        -3161.999755859375,
        -4839.7685546875,
        1077.64697265625
      ],
      [
        -3167.051025390625,
        -4864.76513671875,
        1083.610595703125
      ],
      [
        -3166.463134765625,
        -4879.146484375,
        1083.7283935546875
      ],
      [
        -3161.5869140625,
        -4837.6923828125,
        1084.7890625
      ],
      [
        -3158.954833984375,
        -4824.46142578125,
        1085.788818359375
      ],
      [
        -3167.28173828125,
        -4858.52490234375,
        1083.564453125
      ],
      [
        -3167.051025390625,
        -4864.76513671875,
        1083.610595703125
      ],
      [
        -3164.702880859375,
        -4865.2255859375,
        1082.999755859375
      ],
      [
        -3162.061279296875,
        -4879.830078125,
        1082.579833984375
      ],
      [
        -3165.979248046875,
        -4857.9853515625,
        1083.2120361328125
      ],
      [
        -3164.702880859375,
        -4865.2255859375,
        1082.999755859375
      ],
      [
        -3162.061279296875,
        -4879.830078125,
        1082.579833984375
      ],
      [
        -3161.68212890625,
        -4881.64111328125,
        1082.5341796875
      ],
      [
        -3161.999755859375,
        -4839.7685546875,
        1081.439208984375
      ],
      [
        -3158.954833984375,
        -4855.07568359375,
        1081.093505859375
      ],
      [
        -3158.954833984375,
        -4855.07568359375,
        1081.093505859375
      ],
      [
        -3159.099365234375,
        -4825.1875,
        1080.291015625
      ],
      [
        -3161.999755859375,
        -4839.7685546875,
        1081.439208984375
      ],
      [
        -3138.03271484375,
        -4801.0615234375,
        1089.561279296875
      ],
      [
        -3158.77392578125,
        -4855.98486328125,
        1074.2430419921875
      ],
      [
        -3106.600341796875,
        -4789.7685546875,
        1069.885009765625
      ],
      [
        -3106.600341796875,
        -4769.7685546875,
        1071.7528076171875
      ],
      [
        -3106.600341796875,
        -4769.7685546875,
        1071.7528076171875
      ],
      [
        -3106.37109375,
        -4769.7685546875,
        1071.7066650390625
      ],
      [
        -3110.53564453125,
        -4879.7685546875,
        1065.465087890625
      ],
      [
        -3112.425048828125,
        -4879.98828125,
        1064.82080078125
      ],
      [
        -3112.48291015625,
        -4879.7685546875,
        1064.8238525390625
      ],
      [
        -3112.48291015625,
        -4879.7685546875,
        1064.8238525390625
      ],
      [
        -3112.377685546875,
        -4879.7685546875,
        1064.804931640625
      ],
      [
        -3106.600341796875,
        -4789.7685546875,
        1057.5238037109375
      ],
      [
        -3106.600341796875,
        -4769.7685546875,
        1057.5238037109375
      ],
      [
        -3106.600341796875,
        -4769.7685546875,
        1057.5238037109375
      ],
      [
        -3030.205322265625,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -2970.626953125,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -2970.626953125,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -3030.205322265625,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -2929.999755859375,
        -4919.7685546875,
        1062.337158203125
      ],
      [
        -2920.0,
        -4919.7685546875,
        1087.22900390625
      ],
      [
        -2924.617919921875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -2970.626953125,
        -4980.90283203125,
        1152.623779296875
      ],
      [
        -2924.617919921875,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -2920.0,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3030.205322265625,
        -5028.2685546875,
        1152.623779296875
      ],
      [
        -3001.92333984375,
        -4740.5517578125,
        1152.623779296875
      ],
      [
        -3001.92333984375,
        -4740.55224609375,
        1100.4375
      ],
      [
        -3087.1005859375,
        -4956.91162109375,
        1092.623779296875
      ],
      [
        -3076.568115234375,
        -4899.7685546875,
        1056.38720703125
      ],
      [
        -3082.07958984375,
        -4886.4619140625,
        1057.81103515625
      ],
      [
        -3082.07958984375,
        -4886.4619140625,
        1060.822998046875
      ],
      [
        -3076.568115234375,
        -4899.7685546875,
        1058.572509765625
      ],
      [
        -3082.07958984375,
        -4886.4619140625,
        1060.822998046875
      ],
      [
        -3084.85205078125,
        -4879.7685546875,
        1060.8125
      ],
      [
        -3084.85205078125,
        -4879.7685546875,
        1058.52734375
      ],
      [
        -3084.85205078125,
        -4879.7685546875,
        1060.8125
      ],
      [
        -3103.383056640625,
        -4879.7685546875,
        1063.314453125
      ],
      [
        -3095.234619140625,
        -4874.02392578125,
        1063.67138671875
      ],
      [
        -3099.999755859375,
        -4872.435546875,
        1062.4404296875
      ],
      [
        -3099.999755859375,
        -4879.7685546875,
        1062.4404296875
      ],
      [
        -3093.83740234375,
        -4879.7685546875,
        1064.0323486328125
      ],
      [
        -3102.855712890625,
        -4859.7685546875,
        1064.263916015625
      ],
      [
        -3103.383056640625,
        -4859.7685546875,
        1063.314453125
      ],
      [
        -3099.999755859375,
        -4859.7685546875,
        1062.4404296875
      ],
      [
        -3098.7021484375,
        -4859.7685546875,
        1062.775634765625
      ],
      [
        -3098.733154296875,
        -4859.7685546875,
        1062.11328125
      ],
      [
        -3097.61083984375,
        -4859.7685546875,
        1062.384521484375
      ],
      [
        -3097.521484375,
        -4859.7685546875,
        1067.1285400390625
      ],
      [
        -3099.99951171875,
        -4872.43505859375,
        1068.1405029296875
      ],
      [
        -3097.521484375,
        -4859.7685546875,
        1067.1285400390625
      ],
      [
        -3093.13623046875,
        -4859.7685546875,
        1063.4658203125
      ],
      [
        -3093.13623046875,
        -4859.7685546875,
        1065.337890625
      ],
      [
        -3091.44970703125,
        -4875.28564453125,
        1064.649169921875
      ],
      [
        -3091.44970703125,
        -4879.7685546875,
        1064.649169921875
      ],
      [
        -3093.135986328125,
        -4859.7685546875,
        1068.699951171875
      ],
      [
        -3085.949951171875,
        -4877.11865234375,
        1073.87744140625
      ],
      [
        -3085.949951171875,
        -4877.11865234375,
        1066.0699462890625
      ],
      [
        -3084.852294921875,
        -4879.7685546875,
        1066.353515625
      ],
      [
        -3093.135986328125,
        -4859.7685546875,
        1068.699951171875
      ],
      [
        -3082.07958984375,
        -4886.4619140625,
        1057.81103515625
      ],
      [
        -3084.85205078125,
        -4879.7685546875,
        1058.146484375
      ],
      [
        -3084.85205078125,
        -4879.7685546875,
        1058.146484375
      ],
      [
        -3104.210693359375,
        -4859.7685546875,
        1061.8248291015625
      ],
      [
        -3102.068603515625,
        -4859.7685546875,
        1061.30712890625
      ],
      [
        -3102.068603515625,
        -4871.74609375,
        1061.906005859375
      ],
      [
        -3101.266357421875,
        -4879.7685546875,
        1062.11328125
      ],
      [
        -3104.51708984375,
        -4859.7685546875,
        1061.2734375
      ],
      [
        -3103.26611328125,
        -4859.7685546875,
        1061.5965576171875
      ],
      [
        -3106.600341796875,
        -4779.76904296875,
        1052.623779296875
      ],
      [
        -3106.600341796875,
        -4777.31884765625,
        1057.5238037109375
      ],
      [
        -3093.076171875,
        -4859.7685546875,
        1068.7213134765625
      ],
      [
        -3093.135986328125,
        -4859.7685546875,
        1068.482421875
      ],
      [
        -3093.076171875,
        -4859.7685546875,
        1068.7213134765625
      ],
      [
        -3093.069580078125,
        -4859.9287109375,
        1068.7476806640625
      ],
      [
        -3097.100341796875,
        -4769.7685546875,
        1052.623779296875
      ],
      [
        -3039.69970703125,
        -4835.6328125,
        1074.5296630859375
      ],
      [
        -3041.732177734375,
        -4836.1044921875,
        1074.147705078125
      ],
      [
        -3062.6923828125,
        -4856.7236328125,
        1069.5980224609375
      ],
      [
        -3049.715576171875,
        -4848.052734375,
        1077.010009765625
      ],
      [
        -3049.715576171875,
        -4848.052734375,
        1077.010009765625
      ],
      [
        -3041.732177734375,
        -4836.1044921875,
        1074.147705078125
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1074.4188232421875
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1076.4903564453125
      ],
      [
        -3070.636962890625,
        -4858.3037109375,
        1068.1158447265625
      ],
      [
        -3062.6923828125,
        -4856.7236328125,
        1069.59814453125
      ],
      [
        -3093.13623046875,
        -4859.7685546875,
        1064.03125
      ],
      [
        -3084.100341796875,
        -4859.7685546875,
        1065.6495361328125
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1076.4903564453125
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1074.4188232421875
      ],
      [
        -3039.713623046875,
        -4828.38427734375,
        1075.7105712890625
      ],
      [
        -3049.715576171875,
        -4848.052734375,
        1078.227783203125
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1078.74072265625
      ],
      [
        -3049.715576171875,
        -4848.052734375,
        1078.227783203125
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1078.74072265625
      ],
      [
        -3037.999755859375,
        -4819.7685546875,
        1077.646728515625
      ],
      [
        -3037.178955078125,
        -4818.54736328125,
        1077.6961669921875
      ],
      [
        -3037.819091796875,
        -4818.86083984375,
        1077.5819091796875
      ],
      [
        -3038.148193359375,
        -4819.02197265625,
        1077.523193359375
      ],
      [
        -3037.999755859375,
        -4819.7685546875,
        1077.646728515625
      ],
      [
        -3038.148193359375,
        -4819.02197265625,
        1077.523193359375
      ],
      [
        -3041.044677734375,
        -4804.46142578125,
        1085.788818359375
      ],
      [
        -3049.715576171875,
        -4791.484375,
        1087.5196533203125
      ],
      [
        -3041.044677734375,
        -4804.46142578125,
        1085.788818359375
      ],
      [
        -3038.41259765625,
        -4817.6923828125,
        1084.7890625
      ],
      [
        -3086.18994140625,
        -4759.7685546875,
        1094.262451171875
      ],
      [
        -3086.283935546875,
        -4779.7685546875,
        1092.623779296875
      ],
      [
        -3086.517333984375,
        -4759.7685546875,
        1093.67333984375
      ],
      [
        -3038.317138671875,
        -4861.64111328125,
        1082.5341796875
      ],
      [
        -3037.93798828125,
        -4859.830078125,
        1082.5799560546875
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1081.0933837890625
      ],
      [
        -3037.999755859375,
        -4819.7685546875,
        1081.4393310546875
      ],
      [
        -3041.044677734375,
        -4835.07568359375,
        1081.0933837890625
      ],
      [
        -3037.999755859375,
        -4819.7685546875,
        1081.4393310546875
      ],
      [
        -3040.900146484375,
        -4805.18798828125,
        1080.2908935546875
      ],
      [
        -3061.96728515625,
        -4781.06298828125,
        1089.561279296875
      ],
      [
        -3087.100341796875,
        -4773.181640625,
        1092.623779296875
      ],
      [
        -3083.5576171875,
        -4773.18701171875,
        1092.623779296875
      ],
      [
        -3041.22607421875,
        -4835.98681640625,
        1074.2427978515625
      ],
      [
        -3092.100341796875,
        -4769.7685546875,
        1070.1458740234375
      ],
      [
        -3092.100341796875,
        -4789.7685546875,
        1068.2783203125
      ],
      [
        -3092.752685546875,
        -4769.7685546875,
        1070.0147705078125
      ],
      [
        -3092.100341796875,
        -4769.7685546875,
        1070.1458740234375
      ],
      [
        -3084.85205078125,
        -4879.7685546875,
        1058.52734375
      ],
      [
        -3175.480712890625,
        -5044.55859375,
        1217.7845458984375
      ],
      [
        -3024.021728515625,
        -5045.98291015625,
        1223.48095703125
      ],
      [
        -3024.021728515625,
        -5045.98291015625,
        1223.48095703125
      ],
      [
        -2958.201416015625,
        -4994.4453125,
        1225.95654296875
      ],
      [
        -2958.201416015625,
        -4994.4453125,
        1225.95654296875
      ],
      [
        -3024.021728515625,
        -5045.98291015625,
        1223.4810791015625
      ],
      [
        -3240.002197265625,
        -4992.48828125,
        1215.35791015625
      ],
      [
        -3175.480712890625,
        -5044.55859375,
        1217.7845458984375
      ],
      [
        -3175.480712890625,
        -5044.55859375,
        1217.7845458984375
      ],
      [
        -3240.002197265625,
        -4992.48828125,
        1215.35791015625
      ],
      [
        -3295.838623046875,
        -4947.42724609375,
        1213.2578125
      ],
      [
        -3290.547119140625,
        -4932.2685546875,
        1152.623779296875
      ],
      [
        -3240.002197265625,
        -4992.48828125,
        1215.35791015625
      ],
      [
        -3281.96435546875,
        -4947.5576171875,
        1213.7796630859375
      ],
      [
        -3281.96435546875,
        -4947.5576171875,
        1213.7796630859375
      ],
      [
        -2920.0,
        -4954.5869140625,
        1227.393310546875
      ],
      [
        -2958.201416015625,
        -4994.4453125,
        1225.95654296875
      ],
      [
        -2985.0,
        -4965.7685546875,
        1152.623779296875
      ],
      [
        -2987.251708984375,
        -4976.64208984375,
        1166.2159423828125
      ],
      [
        -3255.81689453125,
        -4912.5498046875,
        1214.7630615234375
      ],
      [
        -3255.81689453125,
        -4854.98095703125,
        1214.7630615234375
      ],
      [
        -3292.71533203125,
        -4855.599609375,
        1213.3753662109375
      ],
      [
        -3302.565185546875,
        -4855.56982421875,
        1213.0048828125
      ],
      [
        -3255.81689453125,
        -4854.98095703125,
        1214.7630615234375
      ],
      [
        -3292.71533203125,
        -4855.599609375,
        1213.3753662109375
      ],
      [
        -3303.63720703125,
        -4969.7685546875,
        1302.623779296875
      ],
      [
        -3295.838623046875,
        -4947.42724609375,
        1213.2578125
      ],
      [
        -3369.999755859375,
        -4917.0087890625,
        1302.623779296875
      ],
      [
        -3360.86962890625,
        -4912.603515625,
        1266.10302734375
      ],
      [
        -3347.175537109375,
        -4916.06201171875,
        1211.3270263671875
      ],
      [
        -3369.999755859375,
        -4910.2978515625,
        1302.623779296875
      ],
      [
        -2978.129638671875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -2959.9150390625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -2951.49462890625,
        -4860.02587890625,
        1302.6241455078125
      ],
      [
        -2951.49462890625,
        -4906.9423828125,
        1302.6241455078125
      ],
      [
        -2951.49462890625,
        -4860.02587890625,
        1302.6241455078125
      ],
      [
        -2959.9150390625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4906.7421875,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -2978.129638671875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -3005.45556640625,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3014.40673828125,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3005.45556640625,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3351.867919921875,
        -4751.63671875,
        1230.0960693359375
      ],
      [
        -3566.1171875,
        -4753.6513671875,
        1238.15380859375
      ],
      [
        -3351.867919921875,
        -4751.63671875,
        1230.0960693359375
      ],
      [
        -3351.867919921875,
        -4914.876953125,
        1230.0960693359375
      ],
      [
        -3240.08447265625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -3248.5048828125,
        -4860.02587890625,
        1302.6241455078125
      ],
      [
        -3221.869873046875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -3240.08447265625,
        -4859.85693359375,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4906.7421875,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3194.5439453125,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3221.869873046875,
        -4859.599609375,
        1302.6241455078125
      ],
      [
        -3185.5927734375,
        -4859.455078125,
        1302.6241455078125
      ],
      [
        -3194.5439453125,
        -4859.287109375,
        1302.6241455078125
      ],
      [
        -3070.100341796875,
        -4629.7685546875,
        1052.623779296875
      ],
      [
        -3128.60009765625,
        -4629.7685546875,
        1052.623779296875
      ],
      [
        -3070.100341796875,
        -4539.7685546875,
        1060.0
      ],
      [
        -3070.100341796875,
        -4589.7685546875,
        1060.0
      ],
      [
        -3070.100341796875,
        -4589.7685546875,
        1060.0
      ],
      [
        -3070.100341796875,
        -4589.7685546875,
        1052.623779296875
      ],
      [
        -3070.100341796875,
        -4539.7685546875,
        1060.0
      ],
      [
        -3070.100341796875,
        -4539.7685546875,
        1052.623779296875
      ],
      [
        -3020.100830078125,
        -4306.16796875,
        1052.623779296875
      ],
      [
        -3020.09716796875,
        -4306.16796875,
        1152.623779296875
      ],
      [
        -3383.487060546875,
        -4285.408203125,
        1077.5
      ],
      [
        -3331.087158203125,
        -4363.408203125,
        1077.5
      ],
      [
        -3321.69580078125,
        -4360.5419921875,
        1077.5
      ],
      [
        -3369.824951171875,
        -4293.52392578125,
        1093.5
      ],
      [
        -3384.574951171875,
        -4293.52392578125,
        1093.5
      ],
      [
        -3362.449951171875,
        -4280.75,
        1093.5
      ],
      [
        -3369.824951171875,
        -4293.52392578125,
        1093.5
      ],
      [
        -3317.425048828125,
        -4345.97607421875,
        1093.5
      ],
      [
        -3310.050048828125,
        -4358.75,
        1093.5
      ],
      [
        -3310.050048828125,
        -4358.75,
        1093.5
      ],
      [
        -3317.425048828125,
        -4371.52392578125,
        1093.5
      ],
      [
        -3317.425048828125,
        -4371.52392578125,
        1093.5
      ],
      [
        -3332.175048828125,
        -4371.52392578125,
        1093.5
      ],
      [
        -3322.694580078125,
        -4380.65087890625,
        1096.5
      ],
      [
        -3322.694580078125,
        -4380.65087890625,
        1093.5
      ],
      [
        -3304.952880859375,
        -4367.57861328125,
        1096.5
      ],
      [
        -3304.952880859375,
        -4367.57861328125,
        1093.5
      ],
      [
        -3675.999755859375,
        -4670.15576171875,
        1059.5228271484375
      ],
      [
        -3667.999755859375,
        -4670.15576171875,
        1059.5228271484375
      ],
      [
        -3667.999755859375,
        -4670.36865234375,
        1059.5189208984375
      ],
      [
        -3667.999755859375,
        -4670.15576171875,
        1059.5228271484375
      ],
      [
        -3667.999755859375,
        -4670.36865234375,
        1059.5189208984375
      ],
      [
        -3667.999755859375,
        -4679.7998046875,
        1059.3406982421875
      ],
      [
        -2182.125244140625,
        -4909.47314453125,
        1315.685546875
      ],
      [
        -2214.77978515625,
        -4910.2978515625,
        1302.623779296875
      ],
      [
        -1964.791748046875,
        -4903.9833984375,
        1402.623779296875
      ],
      [
        -2182.12548828125,
        -4909.47314453125,
        1315.685546875
      ],
      [
        -3556.986083984375,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3758.24658203125,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3488.941650390625,
        -4910.29736328125,
        1302.623779296875
      ],
      [
        -3556.986083984375,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3758.24658203125,
        -4909.36328125,
        1317.4210205078125
      ],
      [
        -3939.26220703125,
        -4903.9833984375,
        1402.623779296875
      ],
      [
        -3556.305419921875,
        -4069.7685546875,
        1302.623779296875
      ],
      [
        -3802.58349609375,
        -4310.9921875,
        1302.623779296875
      ],
      [
        -3900.749755859375,
        -4266.263671875,
        1353.5482177734375
      ],
      [
        -3985.582763671875,
        -4213.58984375,
        1402.623779296875
      ],
      [
        -3900.749755859375,
        -4266.263671875,
        1353.5482177734375
      ],
      [
        -3888.191162109375,
        -4333.81396484375,
        1329.1610107421875
      ],
      [
        -4007.749267578125,
        -4244.5771484375,
        1402.623779296875
      ],
      [
        -3835.11669921875,
        -4356.12060546875,
        1302.623779296875
      ],
      [
        -3888.191162109375,
        -4333.81396484375,
        1329.1610107421875
      ],
      [
        -3311.842041015625,
        -3619.7685546875,
        1402.623779296875
      ],
      [
        -3221.86962890625,
        -3820.217529296875,
        1302.623779296875
      ],
      [
        -3100.0,
        -3780.262451171875,
        1322.556640625
      ],
      [
        -3100.0,
        -3820.217529296875,
        1302.623779296875
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2654.999755859375,
      "bbox_min": [
        -3380.1875,
        -4869.7685546875,
        983.775390625
      ],
      "bbox_max": [
        -2308.018798828125,
        -4200.0,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4367.96875,
      "bbox_min": [
        -3380.1875,
        -4869.7685546875,
        983.775390625
      ],
      "bbox_max": [
        -2654.999755859375,
        -4200.0,
        1052.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3616013824939728,
        0.0,
        -0.9323328733444214
      ],
      "plane_d": 2145.7646484375,
      "bbox_min": [
        -3380.1875,
        -4367.96875,
        1003.7753295898438
      ],
      "bbox_max": [
        -2654.999755859375,
        -4200.0,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.7580097317695618,
        0.6522433161735535
      ],
      "plane_d": -3960.58642578125,
      "bbox_min": [
        -3380.1875,
        -4342.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3289.624755859375,
        -4259.51904296875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5648571848869324,
        -0.32612064480781555,
        -0.7580115795135498
      ],
      "plane_d": -2481.8486328125,
      "bbox_min": [
        -3346.71630859375,
        -4264.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3342.024658203125,
        -4259.51904296875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2766062617301941,
        -0.9063534736633301,
        -0.3193938136100769
      ],
      "plane_d": -2604.05419921875,
      "bbox_min": [
        -3344.14453125,
        -4264.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3342.024658203125,
        -4263.8017578125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6564573645591736,
        0.3790042996406555,
        0.6522418856620789
      ],
      "plane_d": 3118.83984375,
      "bbox_min": [
        -3359.10107421875,
        -4342.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3289.624755859375,
        -4336.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5648574233055115,
        -0.3261207938194275,
        -0.7580114006996155
      ],
      "plane_d": 1278.38671875,
      "bbox_min": [
        -3359.10107421875,
        -4342.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3289.624755859375,
        -4336.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6466190218925476,
        0.6927236914634705,
        -0.3194022476673126
      ],
      "plane_d": 5510.96142578125,
      "bbox_min": [
        -3357.0654296875,
        -4338.1806640625,
        1051.337158203125
      ],
      "bbox_max": [
        -3355.28369140625,
        -4336.76171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5648571848869324,
        -0.32612064480781555,
        -0.7580115795135498
      ],
      "plane_d": -2477.6875,
      "bbox_min": [
        -3294.31640625,
        -4342.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3289.624755859375,
        -4337.51904296875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2766062617301941,
        -0.9063534736633301,
        -0.3193938136100769
      ],
      "plane_d": -2689.243896484375,
      "bbox_min": [
        -3291.74462890625,
        -4342.63525390625,
        1051.337158203125
      ],
      "bbox_max": [
        -3289.624755859375,
        -4341.8017578125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3634515106678009,
        0.0,
        -0.9316132068634033
      ],
      "plane_d": -190.060791015625,
      "bbox_min": [
        -3244.62939453125,
        -4367.96875,
        1003.7753295898438
      ],
      "bbox_max": [
        -2654.999755859375,
        -4200.0,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4362.7685546875,
      "bbox_min": [
        -2679.999755859375,
        -4367.96875,
        1023.0237426757812
      ],
      "bbox_max": [
        -2654.999755859375,
        -4362.7685546875,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.29085761308670044,
        -0.0,
        0.9567664265632629
      ],
      "plane_d": -206.56787109375,
      "bbox_min": [
        -2679.999755859375,
        -4367.96875,
        1023.0237426757812
      ],
      "bbox_max": [
        -2654.999755859375,
        -4362.7685546875,
        1030.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9162545204162598,
        0.0,
        -0.400596559047699
      ],
      "plane_d": 3385.4404296875,
      "bbox_min": [
        -3244.62939453125,
        -4367.96875,
        1003.7753295898438
      ],
      "bbox_max": [
        -3180.0,
        -4200.0,
        1052.4244384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9162540435791016,
        -0.0,
        0.4005979001522064
      ],
      "plane_d": 2560.369140625,
      "bbox_min": [
        -3244.62939453125,
        -4367.96875,
        1003.7753295898438
      ],
      "bbox_max": [
        -3180.0,
        -4200.0,
        1052.4244384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.64405757188797,
        -0.0,
        0.7649770975112915
      ],
      "plane_d": 1309.6885986328125,
      "bbox_min": [
        -3244.62939453125,
        -4367.96875,
        1003.7753295898438
      ],
      "bbox_max": [
        -3180.0,
        -4200.0,
        1052.4244384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.42300987243652344,
        -0.0,
        -0.9061251878738403
      ],
      "plane_d": -407.51507568359375,
      "bbox_min": [
        -3244.62939453125,
        -4367.96875,
        1003.7753295898438
      ],
      "bbox_max": [
        -3180.0,
        -4200.0,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1013.8012084960938,
      "bbox_min": [
        -3244.62939453125,
        -4367.96875,
        1003.7753295898438
      ],
      "bbox_max": [
        -3180.0,
        -4200.0,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": -4199.99951171875,
      "bbox_min": [
        -3237.634765625,
        -4200.0,
        1003.7753295898438
      ],
      "bbox_max": [
        -3203.56298828125,
        -4200.0,
        1013.8012084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -3180.0,
      "bbox_min": [
        -3244.62939453125,
        -4367.96875,
        1013.8012084960938
      ],
      "bbox_max": [
        -3180.0,
        -4200.0,
        1052.4244384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4300.0,
      "bbox_min": [
        -3203.56298828125,
        -4300.0,
        1013.8012084960938
      ],
      "bbox_max": [
        -3180.0,
        -4300.0,
        1045.7977294921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2699.999755859375,
      "bbox_min": [
        -2799.999755859375,
        -4869.7685546875,
        1023.0237426757812
      ],
      "bbox_max": [
        -2654.999755859375,
        -4367.96875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4372.76806640625,
      "bbox_min": [
        -2679.999755859375,
        -4372.7685546875,
        1023.0237426757812
      ],
      "bbox_max": [
        -2654.999755859375,
        -4367.96875,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.29085761308670044,
        -0.0,
        0.9567664265632629
      ],
      "plane_d": -206.56787109375,
      "bbox_min": [
        -2679.999755859375,
        -4372.7685546875,
        1023.0237426757812
      ],
      "bbox_max": [
        -2654.999755859375,
        -4367.96875,
        1030.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2799.999755859375,
      "bbox_min": [
        -2799.999755859375,
        -4869.7685546875,
        1037.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4629.7685546875,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1037.623779296875,
      "bbox_min": [
        -2799.999755859375,
        -4869.7685546875,
        1037.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4629.7685546875,
        1052.623779296875
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -0.0,
        0.2873479127883911,
        0.9578263759613037
      ],
      "plane_d": 391.0870361328125,
      "bbox_min": [
        -2799.999755859375,
        -4869.7685546875,
        1037.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4629.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2749.999755859375,
      "bbox_min": [
        -2799.999755859375,
        -4869.7685546875,
        1037.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4629.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4819.7685546875,
      "bbox_min": [
        -2749.999755859375,
        -4819.7685546875,
        1037.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4629.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4629.7685546875,
      "bbox_min": [
        -2749.999755859375,
        -4799.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4629.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4715.486328125,
      "bbox_min": [
        -2739.999755859375,
        -4799.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4680.4384765625,
      "bbox_min": [
        -2739.999755859375,
        -4724.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4689.0986328125,
      "bbox_min": [
        -2739.999755859375,
        -4724.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4680.4384765625,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -13.17822265625,
      "bbox_min": [
        -2739.999755859375,
        -4689.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4680.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        -0.0
      ],
      "plane_d": 4689.326171875,
      "bbox_min": [
        -2719.999755859375,
        -4689.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4680.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 4.51806640625,
      "bbox_min": [
        -2719.999755859375,
        -4689.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4684.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -4697.986328125,
      "bbox_min": [
        -2719.999755859375,
        -4689.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2717.499755859375,
        -4684.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4706.646484375,
      "bbox_min": [
        -2739.999755859375,
        -4689.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4680.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -30.498779296875,
      "bbox_min": [
        -2739.999755859375,
        -4689.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4680.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4715.306640625,
      "bbox_min": [
        -2739.999755859375,
        -4689.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4684.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 21.838623046875,
      "bbox_min": [
        -2732.499755859375,
        -4689.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4684.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4724.0986328125,
      "bbox_min": [
        -2719.999755859375,
        -4724.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4715.4384765625,
      "bbox_min": [
        -2719.999755859375,
        -4724.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -12.982177734375,
      "bbox_min": [
        -2719.999755859375,
        -4724.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4706.826171875,
      "bbox_min": [
        -2719.999755859375,
        -4719.7685546875,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4.322021484375,
      "bbox_min": [
        -2719.999755859375,
        -4719.7685546875,
        1037.623779296875
      ],
      "bbox_max": [
        -2717.499755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4677.986328125,
      "bbox_min": [
        -2739.999755859375,
        -4649.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4649.0986328125,
      "bbox_min": [
        -2719.999755859375,
        -4649.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4640.4384765625,
      "bbox_min": [
        -2719.999755859375,
        -4649.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 24.51806640625,
      "bbox_min": [
        -2719.999755859375,
        -4649.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4669.326171875,
      "bbox_min": [
        -2719.999755859375,
        -4644.7685546875,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -33.178466796875,
      "bbox_min": [
        -2719.999755859375,
        -4644.7685546875,
        1037.623779296875
      ],
      "bbox_max": [
        -2717.499755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4649.0986328125,
      "bbox_min": [
        -2739.999755859375,
        -4649.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4640.4384765625,
      "bbox_min": [
        -2739.999755859375,
        -4649.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 41.838623046875,
      "bbox_min": [
        -2739.999755859375,
        -4649.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -4695.306640625,
      "bbox_min": [
        -2739.999755859375,
        -4649.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -50.498779296875,
      "bbox_min": [
        -2739.999755859375,
        -4644.7685546875,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        -0.0
      ],
      "plane_d": 4686.646484375,
      "bbox_min": [
        -2732.499755859375,
        -4644.7685546875,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4640.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4759.0986328125,
      "bbox_min": [
        -2739.999755859375,
        -4799.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4750.4384765625,
      "bbox_min": [
        -2739.999755859375,
        -4759.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4732.986328125,
      "bbox_min": [
        -2739.999755859375,
        -4759.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4750.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 21.822021484375,
      "bbox_min": [
        -2719.999755859375,
        -4759.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4750.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -30.482177734375,
      "bbox_min": [
        -2712.499755859375,
        -4759.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4750.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4724.326171875,
      "bbox_min": [
        -2712.499755859375,
        -4754.7685546875,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4750.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -4750.30712890625,
      "bbox_min": [
        -2739.999755859375,
        -4759.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4750.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -13.16162109375,
      "bbox_min": [
        -2739.999755859375,
        -4759.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4750.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4.50146484375,
      "bbox_min": [
        -2739.999755859375,
        -4754.7685546875,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4750.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        -0.0
      ],
      "plane_d": 4741.64697265625,
      "bbox_min": [
        -2732.499755859375,
        -4754.7685546875,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4750.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4724.0986328125,
      "bbox_min": [
        -2739.999755859375,
        -4724.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4715.4384765625,
      "bbox_min": [
        -2739.999755859375,
        -4724.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 4.33837890625,
      "bbox_min": [
        -2739.999755859375,
        -4724.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -4732.80712890625,
      "bbox_min": [
        -2739.999755859375,
        -4724.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -12.99853515625,
      "bbox_min": [
        -2739.999755859375,
        -4719.7685546875,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        -0.0
      ],
      "plane_d": 4724.14697265625,
      "bbox_min": [
        -2732.499755859375,
        -4719.7685546875,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4715.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 41.822265625,
      "bbox_min": [
        -2739.999755859375,
        -4799.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4790.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4799.0986328125,
      "bbox_min": [
        -2719.999755859375,
        -4799.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4790.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4790.4384765625,
      "bbox_min": [
        -2719.999755859375,
        -4799.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4790.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -4752.98681640625,
      "bbox_min": [
        -2719.999755859375,
        -4799.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4790.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        -0.0
      ],
      "plane_d": 4744.32666015625,
      "bbox_min": [
        -2712.499755859375,
        -4799.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4790.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -50.482421875,
      "bbox_min": [
        -2712.499755859375,
        -4799.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4794.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4799.0986328125,
      "bbox_min": [
        -2739.999755859375,
        -4799.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4790.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4790.4384765625,
      "bbox_min": [
        -2739.999755859375,
        -4799.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4790.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 24.501708984375,
      "bbox_min": [
        -2739.999755859375,
        -4799.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4790.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4770.3076171875,
      "bbox_min": [
        -2739.999755859375,
        -4799.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4790.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4761.6474609375,
      "bbox_min": [
        -2732.499755859375,
        -4799.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4790.4384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -33.161865234375,
      "bbox_min": [
        -2732.499755859375,
        -4799.0986328125,
        1037.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4794.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4629.7685546875,
      "bbox_min": [
        -2799.999755859375,
        -4629.7685546875,
        1037.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4629.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4389.7685546875,
      "bbox_min": [
        -3327.78759765625,
        -4600.2314453125,
        983.775390625
      ],
      "bbox_max": [
        -3020.999755859375,
        -4367.96875,
        1052.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.32566678524017334,
        0.0,
        0.9454846978187561
      ],
      "plane_d": -1992.87255859375,
      "bbox_min": [
        -3244.62939453125,
        -4389.7685546875,
        1003.7753295898438
      ],
      "bbox_max": [
        -3094.0,
        -4367.96875,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1038.623779296875,
      "bbox_min": [
        -3104.0,
        -4377.96875,
        1038.623779296875
      ],
      "bbox_max": [
        -3094.0,
        -4367.96875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32566747069358826,
        0.0,
        -0.9454843997955322
      ],
      "plane_d": 2004.575927734375,
      "bbox_min": [
        -3244.62939453125,
        -4389.7685546875,
        1003.7753295898438
      ],
      "bbox_max": [
        -3094.0,
        -4367.96875,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42300987243652344,
        -0.0,
        -0.9061251878738403
      ],
      "plane_d": -407.51507568359375,
      "bbox_min": [
        -3244.62939453125,
        -4389.7685546875,
        1007.5341186523438
      ],
      "bbox_max": [
        -3176.0,
        -4367.96875,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3616013526916504,
        0.0,
        -0.9323328137397766
      ],
      "plane_d": 2145.7646484375,
      "bbox_min": [
        -3244.62939453125,
        -4389.7685546875,
        1007.5341186523438
      ],
      "bbox_max": [
        -3176.0,
        -4367.96875,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3634514808654785,
        0.0,
        -0.9316131472587585
      ],
      "plane_d": -190.06072998046875,
      "bbox_min": [
        -3244.62939453125,
        -4389.7685546875,
        1007.5341186523438
      ],
      "bbox_max": [
        -3176.0,
        -4367.96875,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9162545800209045,
        0.0,
        -0.40059658885002136
      ],
      "plane_d": 3385.440673828125,
      "bbox_min": [
        -3244.62939453125,
        -4389.7685546875,
        1007.5341186523438
      ],
      "bbox_max": [
        -3176.0,
        -4367.96875,
        1045.7977294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9162539839744568,
        -0.0,
        0.40059787034988403
      ],
      "plane_d": 2560.369140625,
      "bbox_min": [
        -3244.62939453125,
        -4389.7685546875,
        1007.5341186523438
      ],
      "bbox_max": [
        -3176.0,
        -4367.96875,
        1034.7977294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6440575122833252,
        -0.0,
        0.7649770379066467
      ],
      "plane_d": 1309.6884765625,
      "bbox_min": [
        -3237.634765625,
        -4389.7685546875,
        1007.5341186523438
      ],
      "bbox_max": [
        -3176.0,
        -4367.96875,
        1034.7977294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -3180.0,
      "bbox_min": [
        -3180.0,
        -4389.7685546875,
        1024.8221435546875
      ],
      "bbox_max": [
        -3176.0,
        -4367.96875,
        1034.7977294921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1026.199951171875,
      "bbox_min": [
        -3180.0,
        -4377.96875,
        1024.8221435546875
      ],
      "bbox_max": [
        -3176.0,
        -4367.96875,
        1026.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4377.96875,
      "bbox_min": [
        -3180.0,
        -4377.96875,
        1024.8221435546875
      ],
      "bbox_max": [
        -3176.0,
        -4377.96875,
        1026.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4377.96875,
      "bbox_min": [
        -3230.191162109375,
        -4389.7685546875,
        1003.7753295898438
      ],
      "bbox_max": [
        -3094.0,
        -4367.96875,
        1051.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6440575122833252,
        -0.0,
        0.7649770379066467
      ],
      "plane_d": 1309.6884765625,
      "bbox_min": [
        -3230.191162109375,
        -4389.7685546875,
        1003.7753295898438
      ],
      "bbox_max": [
        -3225.7265625,
        -4377.96875,
        1007.5341186523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -3179.999755859375,
      "bbox_min": [
        -3180.0,
        -4389.7685546875,
        1013.8012084960938
      ],
      "bbox_max": [
        -3180.0,
        -4377.96875,
        1024.8221435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6440575122833252,
        -0.0,
        0.7649770379066467
      ],
      "plane_d": 1309.6884765625,
      "bbox_min": [
        -3230.191162109375,
        -4377.96875,
        1003.7753295898438
      ],
      "bbox_max": [
        -3225.7265625,
        -4367.96875,
        1007.5341186523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1050.9998779296875,
      "bbox_min": [
        -3180.0,
        -4377.96875,
        1013.8012084960938
      ],
      "bbox_max": [
        -3094.0,
        -4367.96875,
        1051.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.005645662546157837,
        0.0,
        0.9999841451644897
      ],
      "plane_d": -1031.7384033203125,
      "bbox_min": [
        -3180.0,
        -4377.96875,
        1013.8012084960938
      ],
      "bbox_max": [
        -3176.0,
        -4367.96875,
        1013.8237915039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3094.0,
      "bbox_min": [
        -3104.0,
        -4389.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3094.0,
        -4367.96875,
        1051.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1051.0,
      "bbox_min": [
        -3104.0,
        -4389.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3094.0,
        -4367.96875,
        1051.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1038.623779296875,
      "bbox_min": [
        -3104.0,
        -4389.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3094.0,
        -4367.96875,
        1051.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3104.0,
      "bbox_min": [
        -3104.0,
        -4389.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3104.0,
        -4377.96875,
        1051.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4409.7685546875,
      "bbox_min": [
        -3327.78759765625,
        -4600.2314453125,
        983.775390625
      ],
      "bbox_max": [
        -3020.999755859375,
        -4389.7685546875,
        1052.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4539.7685546875,
      "bbox_min": [
        -3244.62939453125,
        -4600.2314453125,
        983.775390625
      ],
      "bbox_max": [
        -3020.999755859375,
        -4409.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3618845045566559,
        0.09276022017002106,
        -0.9275965094566345
      ],
      "plane_d": 218.925048828125,
      "bbox_min": [
        -3244.62939453125,
        -4539.7685546875,
        989.8216552734375
      ],
      "bbox_max": [
        -3092.499755859375,
        -4409.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3102.499755859375,
      "bbox_min": [
        -3102.499755859375,
        -4539.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3092.499755859375,
        -4409.7685546875,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.00015022426669020206
      ],
      "plane_d": -3092.34375,
      "bbox_min": [
        -3102.499755859375,
        -4539.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3092.499755859375,
        -4409.7685546875,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        -3102.499755859375,
        -4539.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3092.499755859375,
        -4409.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": -1082.1533203125,
      "bbox_min": [
        -3102.499755859375,
        -4525.01611328125,
        1050.0
      ],
      "bbox_max": [
        -3092.50146484375,
        -4519.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1038.623779296875,
      "bbox_min": [
        -3102.499755859375,
        -4539.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3092.499755859375,
        -4409.7685546875,
        1048.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4244791865348816,
        0.905437707901001
      ],
      "plane_d": 978.1386108398438,
      "bbox_min": [
        -3102.499755859375,
        -4539.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3092.499755859375,
        -4519.7685546875,
        1048.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36003994941711426,
        0.09283125400543213,
        -0.9283068776130676
      ],
      "plane_d": 2544.97802734375,
      "bbox_min": [
        -3244.62939453125,
        -4539.7685546875,
        989.8216552734375
      ],
      "bbox_max": [
        -3220.548828125,
        -4409.7685546875,
        1051.470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9155197739601135,
        0.040027931332588196,
        -0.4002768397331238
      ],
      "plane_d": 3558.859375,
      "bbox_min": [
        -3244.62939453125,
        -4539.7685546875,
        989.8216552734375
      ],
      "bbox_max": [
        -3225.7265625,
        -4409.7685546875,
        1044.843994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9155197739601135,
        -0.04002780839800835,
        0.4002768397331238
      ],
      "plane_d": 2382.18603515625,
      "bbox_min": [
        -3244.62939453125,
        -4539.7685546875,
        989.8216552734375
      ],
      "bbox_max": [
        -3225.7265625,
        -4409.7685546875,
        1028.845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6421766877174377,
        -0.07627546787261963,
        0.7627524137496948
      ],
      "plane_d": 970.2244873046875,
      "bbox_min": [
        -3237.634765625,
        -4539.7685546875,
        989.8216552734375
      ],
      "bbox_max": [
        -3225.7265625,
        -4409.7685546875,
        1012.8474731445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1048.0,
      "bbox_min": [
        -3244.62939453125,
        -4600.2314453125,
        983.775390625
      ],
      "bbox_max": [
        -3020.999755859375,
        -4539.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36003994941711426,
        0.09283125400543213,
        -0.9283068776130676
      ],
      "plane_d": 2544.97802734375,
      "bbox_min": [
        -3244.62939453125,
        -4600.2314453125,
        983.775390625
      ],
      "bbox_max": [
        -3203.56298828125,
        -4539.7685546875,
        1038.4705810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3618845045566559,
        0.09276022017002106,
        -0.9275965094566345
      ],
      "plane_d": 218.925048828125,
      "bbox_min": [
        -3244.62939453125,
        -4600.2314453125,
        983.775390625
      ],
      "bbox_max": [
        -3203.56298828125,
        -4539.7685546875,
        1038.4705810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9155197739601135,
        -0.04002780839800835,
        0.4002768397331238
      ],
      "plane_d": 2382.18603515625,
      "bbox_min": [
        -3244.62939453125,
        -4600.2314453125,
        983.775390625
      ],
      "bbox_max": [
        -3225.7265625,
        -4539.7685546875,
        1031.8438720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9155197739601135,
        0.040027931332588196,
        -0.4002768397331238
      ],
      "plane_d": 3558.859375,
      "bbox_min": [
        -3244.62939453125,
        -4600.2314453125,
        983.775390625
      ],
      "bbox_max": [
        -3225.7265625,
        -4539.7685546875,
        1031.8438720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6421766877174377,
        -0.07627546787261963,
        0.7627524137496948
      ],
      "plane_d": 970.2244873046875,
      "bbox_min": [
        -3237.634765625,
        -4600.2314453125,
        983.775390625
      ],
      "bbox_max": [
        -3225.7265625,
        -4539.7685546875,
        999.8474731445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4589.7685546875,
      "bbox_min": [
        -3102.499755859375,
        -4589.7685546875,
        1048.0
      ],
      "bbox_max": [
        -3020.999755859375,
        -4539.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3102.499755859375,
      "bbox_min": [
        -3102.499755859375,
        -4589.7685546875,
        1048.0
      ],
      "bbox_max": [
        -3020.999755859375,
        -4539.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.00016276042151730508
      ],
      "plane_d": -3020.8291015625,
      "bbox_min": [
        -3082.0,
        -4589.7685546875,
        1048.0
      ],
      "bbox_max": [
        -3020.999755859375,
        -4539.7685546875,
        1052.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.9238940477371216,
        0.3826485574245453,
        0.0
      ],
      "plane_d": 4584.9931640625,
      "bbox_min": [
        -3082.0,
        -4570.0,
        1048.0
      ],
      "bbox_max": [
        -3045.0,
        -4560.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826485574245453,
        0.9238940477371216,
        0.0
      ],
      "plane_d": 5390.3662109375,
      "bbox_min": [
        -3082.0,
        -4570.0,
        1048.0
      ],
      "bbox_max": [
        -3072.0,
        -4560.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826485574245453,
        0.9238940477371216,
        0.0
      ],
      "plane_d": 3035.54736328125,
      "bbox_min": [
        -3082.0,
        -4570.0,
        1048.0
      ],
      "bbox_max": [
        -3072.0,
        -4560.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238940477371216,
        0.3826485574245453,
        0.0
      ],
      "plane_d": -1100.65087890625,
      "bbox_min": [
        -3082.0,
        -4570.0,
        1048.0
      ],
      "bbox_max": [
        -3072.0,
        -4561.46435546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238940477371216,
        -0.3826485574245453,
        -0.0
      ],
      "plane_d": -4594.23193359375,
      "bbox_min": [
        -3082.0,
        -4570.0,
        1048.0
      ],
      "bbox_max": [
        -3072.0,
        -4565.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826485574245453,
        -0.9238940477371216,
        -0.0
      ],
      "plane_d": -5399.60546875,
      "bbox_min": [
        -3080.53564453125,
        -4570.0,
        1048.0
      ],
      "bbox_max": [
        -3072.0,
        -4565.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826485574245453,
        -0.9238940477371216,
        0.0
      ],
      "plane_d": -3044.7861328125,
      "bbox_min": [
        -3077.0,
        -4570.0,
        1048.0
      ],
      "bbox_max": [
        -3072.0,
        -4565.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238940477371216,
        -0.3826485574245453,
        0.0
      ],
      "plane_d": 1091.411865234375,
      "bbox_min": [
        -3073.46435546875,
        -4568.53564453125,
        1048.0
      ],
      "bbox_max": [
        -3072.0,
        -4565.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238940477371216,
        0.3826485574245453,
        0.0
      ],
      "plane_d": 4560.0478515625,
      "bbox_min": [
        -3055.0,
        -4570.0,
        1048.0
      ],
      "bbox_max": [
        -3045.0,
        -4560.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826485574245453,
        0.9238940477371216,
        0.0
      ],
      "plane_d": 5380.03466796875,
      "bbox_min": [
        -3055.0,
        -4570.0,
        1048.0
      ],
      "bbox_max": [
        -3045.0,
        -4560.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826485574245453,
        0.9238940477371216,
        0.0
      ],
      "plane_d": 3045.87890625,
      "bbox_min": [
        -3055.0,
        -4570.0,
        1048.0
      ],
      "bbox_max": [
        -3045.0,
        -4560.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238940477371216,
        0.3826485574245453,
        0.0
      ],
      "plane_d": -1075.70556640625,
      "bbox_min": [
        -3055.0,
        -4570.0,
        1048.0
      ],
      "bbox_max": [
        -3045.0,
        -4561.46435546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238940477371216,
        -0.3826485574245453,
        -0.0
      ],
      "plane_d": -4569.287109375,
      "bbox_min": [
        -3055.0,
        -4570.0,
        1048.0
      ],
      "bbox_max": [
        -3045.0,
        -4565.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826485574245453,
        -0.9238940477371216,
        -0.0
      ],
      "plane_d": -5389.27392578125,
      "bbox_min": [
        -3053.53564453125,
        -4570.0,
        1048.0
      ],
      "bbox_max": [
        -3045.0,
        -4565.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826485574245453,
        -0.9238940477371216,
        0.0
      ],
      "plane_d": -3055.11767578125,
      "bbox_min": [
        -3050.0,
        -4570.0,
        1048.0
      ],
      "bbox_max": [
        -3045.0,
        -4565.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238940477371216,
        -0.3826485574245453,
        0.0
      ],
      "plane_d": 1066.466796875,
      "bbox_min": [
        -3046.46435546875,
        -4568.53564453125,
        1048.0
      ],
      "bbox_max": [
        -3045.0,
        -4565.0,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1038.623779296875,
      "bbox_min": [
        -3327.78759765625,
        -4409.7685546875,
        1002.8215942382812
      ],
      "bbox_max": [
        -3043.201904296875,
        -4389.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4400.2314453125,
      "bbox_min": [
        -3244.62939453125,
        -4409.7685546875,
        1002.8215942382812
      ],
      "bbox_max": [
        -3180.0,
        -4389.7685546875,
        1038.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9155197739601135,
        -0.04002780839800835,
        0.4002768397331238
      ],
      "plane_d": 2382.18603515625,
      "bbox_min": [
        -3244.62939453125,
        -4409.7685546875,
        1002.8215942382812
      ],
      "bbox_max": [
        -3225.7265625,
        -4400.2314453125,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6421766877174377,
        -0.07627546787261963,
        0.7627524137496948
      ],
      "plane_d": 970.2244873046875,
      "bbox_min": [
        -3244.62939453125,
        -4409.7685546875,
        1002.8215942382812
      ],
      "bbox_max": [
        -3225.7265625,
        -4400.2314453125,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9155197739601135,
        0.040027931332588196,
        -0.4002768397331238
      ],
      "plane_d": 3558.859375,
      "bbox_min": [
        -3244.62939453125,
        -4409.7685546875,
        1028.845703125
      ],
      "bbox_max": [
        -3240.354248046875,
        -4400.2314453125,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1013.8012084960938,
      "bbox_min": [
        -3244.62939453125,
        -4400.2314453125,
        1003.7753295898438
      ],
      "bbox_max": [
        -3180.0,
        -4389.7685546875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6440575122833252,
        -0.0,
        0.7649770379066467
      ],
      "plane_d": 1309.6884765625,
      "bbox_min": [
        -3237.634765625,
        -4400.2314453125,
        1003.7753295898438
      ],
      "bbox_max": [
        -3225.7265625,
        -4389.7685546875,
        1013.8012084960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -3179.999755859375,
      "bbox_min": [
        -3244.62939453125,
        -4400.2314453125,
        1013.8012084960938
      ],
      "bbox_max": [
        -3180.0,
        -4389.7685546875,
        1038.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9162539839744568,
        -0.0,
        0.40059787034988403
      ],
      "plane_d": 2560.369140625,
      "bbox_min": [
        -3244.62939453125,
        -4400.2314453125,
        1013.8012084960938
      ],
      "bbox_max": [
        -3180.0,
        -4389.7685546875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9162545800209045,
        0.0,
        -0.40059658885002136
      ],
      "plane_d": 3385.440673828125,
      "bbox_min": [
        -3244.62939453125,
        -4400.2314453125,
        1029.7994384765625
      ],
      "bbox_max": [
        -3180.0,
        -4389.7685546875,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3616013526916504,
        0.0,
        -0.9323328137397766
      ],
      "plane_d": 2145.7646484375,
      "bbox_min": [
        -3327.78759765625,
        -4409.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3188.19580078125,
        -4389.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7580097317695618,
        0.6522433161735535
      ],
      "plane_d": -4019.711181640625,
      "bbox_min": [
        -3327.78759765625,
        -4397.68701171875,
        1051.3370361328125
      ],
      "bbox_max": [
        -3321.8125,
        -4395.43408203125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9232286214828491,
        0.2136252075433731,
        -0.3193950057029724
      ],
      "plane_d": 4342.3544921875,
      "bbox_min": [
        -3322.327392578125,
        -4397.68701171875,
        1051.3370361328125
      ],
      "bbox_max": [
        -3321.8125,
        -4395.43408203125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3634514808654785,
        0.0,
        -0.9316131472587585
      ],
      "plane_d": -190.06072998046875,
      "bbox_min": [
        -3240.771240234375,
        -4409.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3188.19580078125,
        -4389.7685546875,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36003994941711426,
        0.09283125400543213,
        -0.9283068776130676
      ],
      "plane_d": 2544.97802734375,
      "bbox_min": [
        -3240.771240234375,
        -4409.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3188.19580078125,
        -4389.7685546875,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3618845045566559,
        0.09276022017002106,
        -0.9275965094566345
      ],
      "plane_d": 218.925048828125,
      "bbox_min": [
        -3240.771240234375,
        -4409.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3188.19580078125,
        -4389.7685546875,
        1052.4244384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42300987243652344,
        -0.0,
        -0.9061251878738403
      ],
      "plane_d": -407.51507568359375,
      "bbox_min": [
        -3240.771240234375,
        -4409.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3188.19580078125,
        -4389.7685546875,
        1045.7977294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9155197739601135,
        0.040027931332588196,
        -0.4002768397331238
      ],
      "plane_d": 3558.859375,
      "bbox_min": [
        -3240.771240234375,
        -4409.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3237.634765625,
        -4400.2314453125,
        1045.7977294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4616886377334595,
        0.0,
        0.8870421648025513
      ],
      "plane_d": -2338.7333984375,
      "bbox_min": [
        -3070.10009765625,
        -4409.7685546875,
        1038.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4389.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4569.7998046875,
      "bbox_min": [
        -2654.999755859375,
        -4843.06005859375,
        1014.623779296875
      ],
      "bbox_max": [
        -2308.018798828125,
        -4319.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4462694823741913,
        0.0,
        0.8948986530303955
      ],
      "plane_d": -1971.989990234375,
      "bbox_min": [
        -2551.980712890625,
        -4843.06005859375,
        1014.623779296875
      ],
      "bbox_max": [
        -2308.018798828125,
        -4676.47705078125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4462694823741913,
        -0.0,
        0.8948986530303955
      ],
      "plane_d": 196.8795166015625,
      "bbox_min": [
        -2551.980712890625,
        -4843.06005859375,
        1014.623779296875
      ],
      "bbox_max": [
        -2308.018798828125,
        -4676.47705078125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4767.7685546875,
      "bbox_min": [
        -2551.980712890625,
        -4843.06005859375,
        1020.256103515625
      ],
      "bbox_max": [
        -2308.018798828125,
        -4676.47705078125,
        1052.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.3636971414089203,
        0.8780349493026733,
        0.31109341979026794
      ],
      "plane_d": 4808.69580078125,
      "bbox_min": [
        -2488.895751953125,
        -4843.06005859375,
        1022.73291015625
      ],
      "bbox_max": [
        -2350.02197265625,
        -4767.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36369848251342773,
        0.878038227558136,
        0.3110823631286621
      ],
      "plane_d": 3041.15234375,
      "bbox_min": [
        -2484.87548828125,
        -4843.06005859375,
        1022.73291015625
      ],
      "bbox_max": [
        -2350.02197265625,
        -4767.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24316059052944183,
        0.5870414972305298,
        0.772175669670105
      ],
      "plane_d": 2630.20068359375,
      "bbox_min": [
        -2484.87548828125,
        -4837.37451171875,
        1022.73291015625
      ],
      "bbox_max": [
        -2350.02197265625,
        -4767.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2431621104478836,
        0.5870451331138611,
        0.7721723318099976
      ],
      "plane_d": 1448.457763671875,
      "bbox_min": [
        -2452.134765625,
        -4837.37451171875,
        1022.73291015625
      ],
      "bbox_max": [
        -2350.02197265625,
        -4767.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8780379891395569,
        0.36369600892066956,
        0.31108608841896057
      ],
      "plane_d": -656.8467407226562,
      "bbox_min": [
        -2452.134765625,
        -4818.66455078125,
        1022.73291015625
      ],
      "bbox_max": [
        -2350.02197265625,
        -4767.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5870425701141357,
        0.24316082894802094,
        0.7721747159957886
      ],
      "plane_d": -1023.9840698242188,
      "bbox_min": [
        -2452.134765625,
        -4814.64404296875,
        1022.73291015625
      ],
      "bbox_max": [
        -2355.70751953125,
        -4767.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070931792259216,
        0.7071203589439392,
        0.0
      ],
      "plane_d": 1662.14501953125,
      "bbox_min": [
        -2452.134765625,
        -4783.90380859375,
        1027.623779296875
      ],
      "bbox_max": [
        -2414.220458984375,
        -4767.951171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070945501327515,
        -0.7071189284324646,
        -2.4642197331559146e-06
      ],
      "plane_d": -5089.86865234375,
      "bbox_min": [
        -2423.8173828125,
        -4783.90380859375,
        1027.623779296875
      ],
      "bbox_max": [
        -2414.220458984375,
        -4774.30712890625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1644.3154296875,
      "bbox_min": [
        -2452.134765625,
        -4777.5478515625,
        1027.623779296875
      ],
      "bbox_max": [
        -2442.538330078125,
        -4767.951171875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3636971414089203,
        -0.8780349493026733,
        0.31109341979026794
      ],
      "plane_d": -5317.3583984375,
      "bbox_min": [
        -2452.134765625,
        -4751.7685546875,
        1022.73291015625
      ],
      "bbox_max": [
        -2350.02197265625,
        -4676.47705078125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8780390620231628,
        -0.36369645595550537,
        0.311082661151886
      ],
      "plane_d": -4119.0654296875,
      "bbox_min": [
        -2452.134765625,
        -4751.7685546875,
        1022.73291015625
      ],
      "bbox_max": [
        -2350.02197265625,
        -4700.87255859375,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5870413780212402,
        -0.24316103756427765,
        0.7721755504608154
      ],
      "plane_d": -3338.761474609375,
      "bbox_min": [
        -2452.134765625,
        -4751.7685546875,
        1022.73291015625
      ],
      "bbox_max": [
        -2355.70751953125,
        -4704.89306640625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071006894111633,
        0.7071129083633423,
        0.0
      ],
      "plane_d": 1641.5303955078125,
      "bbox_min": [
        -2452.134765625,
        -4751.5859375,
        1027.623779296875
      ],
      "bbox_max": [
        -2414.220703125,
        -4735.63330078125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -4.315837941248901e-06
      ],
      "plane_d": -5087.01025390625,
      "bbox_min": [
        -2452.134765625,
        -4751.5859375,
        1027.623779296875
      ],
      "bbox_max": [
        -2439.7177734375,
        -4735.6337890625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6499340534210205,
        0.6499340534210205,
        -0.3939182460308075
      ],
      "plane_d": 1902.9022216796875,
      "bbox_min": [
        -2452.134765625,
        -4748.05029296875,
        1032.623779296875
      ],
      "bbox_max": [
        -2439.7177734375,
        -4735.6337890625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2464.999755859375,
      "bbox_min": [
        -2654.999755859375,
        -4569.7998046875,
        1019.2237548828125
      ],
      "bbox_max": [
        -2464.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4404.7685546875,
      "bbox_min": [
        -2654.999755859375,
        -4529.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4382.55810546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2639.999755859375,
      "bbox_min": [
        -2654.999755859375,
        -4529.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4404.7685546875,
        1052.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.1585732400417328,
        0.9873473048210144
      ],
      "plane_d": -1724.36474609375,
      "bbox_min": [
        -2639.999755859375,
        -4419.7685546875,
        1036.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4404.7685546875,
        1039.0328369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.157990500330925,
        0.9874406456947327
      ],
      "plane_d": -1721.8858642578125,
      "bbox_min": [
        -2654.999755859375,
        -4444.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4404.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1585732400417328,
        0.9873473048210144
      ],
      "plane_d": -1724.36474609375,
      "bbox_min": [
        -2654.999755859375,
        -4444.7685546875,
        1036.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4404.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4444.7685546875,
      "bbox_min": [
        -2654.999755859375,
        -4444.7685546875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2639.999755859375,
        -4444.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1585732400417328,
        0.9873473048210144
      ],
      "plane_d": -1724.36474609375,
      "bbox_min": [
        -2654.999755859375,
        -4404.7685546875,
        1039.0328369140625
      ],
      "bbox_max": [
        -2596.999755859375,
        -4382.55810546875,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1042.5999755859375,
      "bbox_min": [
        -2639.999755859375,
        -4404.7685546875,
        1039.0382080078125
      ],
      "bbox_max": [
        -2596.999755859375,
        -4382.55810546875,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2639.999755859375,
      "bbox_min": [
        -2639.999755859375,
        -4404.7685546875,
        1039.0382080078125
      ],
      "bbox_max": [
        -2639.999755859375,
        -4382.55810546875,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1047.5999755859375,
      "bbox_min": [
        -2639.999755859375,
        -4404.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2596.999755859375,
        -4389.39990234375,
        1047.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5599077343940735,
        0.8285550475120544,
        0.0
      ],
      "plane_d": 2171.43701171875,
      "bbox_min": [
        -2639.999755859375,
        -4404.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2600.0,
        -4389.39990234375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42661547660827637,
        0.9044331312179565,
        0.0
      ],
      "plane_d": 2860.718505859375,
      "bbox_min": [
        -2628.800048828125,
        -4397.2001953125,
        1042.5999755859375
      ],
      "bbox_max": [
        -2600.0,
        -4389.39990234375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.21972408890724182,
        0.9755620956420898,
        0.0
      ],
      "plane_d": 3713.39794921875,
      "bbox_min": [
        -2628.800048828125,
        -4397.2001953125,
        1042.5999755859375
      ],
      "bbox_max": [
        -2610.60009765625,
        -4394.39990234375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0422564260661602,
        0.9991068840026855,
        0.0
      ],
      "plane_d": 4282.189453125,
      "bbox_min": [
        -2628.800048828125,
        -4397.2001953125,
        1042.5999755859375
      ],
      "bbox_max": [
        -2621.699951171875,
        -4396.89990234375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1047.5999755859375,
      "bbox_min": [
        -2596.999755859375,
        -4568.7998046875,
        1032.623779296875
      ],
      "bbox_max": [
        -2464.999755859375,
        -4382.55810546875,
        1052.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1042.5999755859375,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2464.999755859375,
        -4382.55810546875,
        1047.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4509.7685546875,
      "bbox_min": [
        -2570.999755859375,
        -4509.7685546875,
        1032.623779296875
      ],
      "bbox_max": [
        -2507.792724609375,
        -4393.0556640625,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6994220018386841,
        0.699429988861084,
        0.14699143171310425
      ],
      "plane_d": 1145.570556640625,
      "bbox_min": [
        -2559.712646484375,
        -4415.17578125,
        1032.623779296875
      ],
      "bbox_max": [
        -2507.792724609375,
        -4393.0556640625,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": 4193.55224609375,
      "bbox_min": [
        -2538.20654296875,
        -4394.5380859375,
        1032.623779296875
      ],
      "bbox_max": [
        -2507.792724609375,
        -4393.0556640625,
        1042.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4509.7685546875,
      "bbox_min": [
        -2570.999755859375,
        -4509.7685546875,
        1042.5999755859375
      ],
      "bbox_max": [
        -2508.40673828125,
        -4394.5380859375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6994220018386841,
        0.699429988861084,
        0.14699143171310425
      ],
      "plane_d": 1145.570556640625,
      "bbox_min": [
        -2558.22998046875,
        -4415.4833984375,
        1042.5999755859375
      ],
      "bbox_max": [
        -2508.40673828125,
        -4394.5380859375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": 4193.55224609375,
      "bbox_min": [
        -2537.592529296875,
        -4395.28125,
        1042.5999755859375
      ],
      "bbox_max": [
        -2508.40673828125,
        -4394.5380859375,
        1047.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4509.7685546875,
      "bbox_min": [
        -2570.999755859375,
        -4509.7685546875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2508.714599609375,
        -4395.28125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6994220018386841,
        0.699429988861084,
        0.14699143171310425
      ],
      "plane_d": 1145.570556640625,
      "bbox_min": [
        -2557.487060546875,
        -4415.79248046875,
        1047.5999755859375
      ],
      "bbox_max": [
        -2508.714599609375,
        -4395.28125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": 4193.55224609375,
      "bbox_min": [
        -2537.28466796875,
        -4396.02783203125,
        1047.5999755859375
      ],
      "bbox_max": [
        -2508.714599609375,
        -4395.28125,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1576450914144516,
        0.9874958395957947
      ],
      "plane_d": -1720.451904296875,
      "bbox_min": [
        -2654.999755859375,
        -4382.55810546875,
        1019.2237548828125
      ],
      "bbox_max": [
        -2464.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4372.76806640625,
      "bbox_min": [
        -2654.999755859375,
        -4372.7685546875,
        1019.2237548828125
      ],
      "bbox_max": [
        -2642.499755859375,
        -4362.7685546875,
        1040.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4362.7685546875,
      "bbox_min": [
        -2654.999755859375,
        -4372.7685546875,
        1019.2237548828125
      ],
      "bbox_max": [
        -2642.499755859375,
        -4362.7685546875,
        1040.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29085761308670044,
        -0.0,
        0.9567664265632629
      ],
      "plane_d": -206.56787109375,
      "bbox_min": [
        -2654.999755859375,
        -4372.7685546875,
        1019.2237548828125
      ],
      "bbox_max": [
        -2642.499755859375,
        -4362.7685546875,
        1023.0237426757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3667.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4651.576171875,
        1009.5238037109375
      ],
      "bbox_max": [
        -3667.999755859375,
        -4632.0185546875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.762873649597168,
        0.6465476155281067
      ],
      "plane_d": 2877.70703125,
      "bbox_min": [
        -3675.999755859375,
        -4647.33837890625,
        1014.5238037109375
      ],
      "bbox_max": [
        -3667.999755859375,
        -4632.0185546875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8134896159172058,
        -0.5815794467926025
      ],
      "plane_d": -3174.87939453125,
      "bbox_min": [
        -3632.999755859375,
        -4641.01611328125,
        1009.5238037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4624.5185546875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 3624.99951171875,
      "bbox_min": [
        -3624.999755859375,
        -4641.01611328125,
        1009.5238037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4624.5185546875,
        1032.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600293636322021,
        0.2798992693424225,
        -0.0
      ],
      "plane_d": 4907.18798828125,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14052800834178925,
        0.9900767803192139,
        -0.0
      ],
      "plane_d": 5148.95849609375,
      "bbox_min": [
        -3750.459716796875,
        -4675.39990234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3515.0,
        -4289.7998046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.762873649597168,
        0.6465476155281067
      ],
      "plane_d": 2877.70703125,
      "bbox_min": [
        -3675.999755859375,
        -4656.68115234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4637.44140625,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3667.999755859375,
      "bbox_min": [
        -3667.999755859375,
        -4656.68115234375,
        1032.5999755859375
      ],
      "bbox_max": [
        -3667.999755859375,
        -4647.33837890625,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8134896159172058,
        -0.5815794467926025
      ],
      "plane_d": -3174.87939453125,
      "bbox_min": [
        -3632.999755859375,
        -4645.32275390625,
        1032.5999755859375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4637.44140625,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 3624.99951171875,
      "bbox_min": [
        -3624.999755859375,
        -4645.32275390625,
        1032.5999755859375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4637.44140625,
        1038.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.762873649597168,
        0.6465476155281067
      ],
      "plane_d": 2877.70703125,
      "bbox_min": [
        -3675.999755859375,
        -4668.54638671875,
        1038.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4641.748046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3667.999755859375,
      "bbox_min": [
        -3667.999755859375,
        -4668.54638671875,
        1038.623779296875
      ],
      "bbox_max": [
        -3667.999755859375,
        -4652.44384765625,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8134896159172058,
        -0.5815794467926025
      ],
      "plane_d": -3174.87939453125,
      "bbox_min": [
        -3632.999755859375,
        -4655.33154296875,
        1038.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4641.748046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 3624.99951171875,
      "bbox_min": [
        -3624.999755859375,
        -4655.33154296875,
        1038.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4641.748046875,
        1052.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4249.7685546875,
      "bbox_min": [
        -3835.11669921875,
        -5065.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2119.999755859375,
        -3820.217529296875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000007748603821,
        -0.8660249710083008,
        1.395172148477286e-06
      ],
      "plane_d": -4776.0458984375,
      "bbox_min": [
        -2654.341064453125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2295.551025390625,
        -3984.21875,
        1226.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.743144154548645,
        -0.669131338596344,
        0.0
      ],
      "plane_d": -4530.474609375,
      "bbox_min": [
        -2369.712646484375,
        -4155.2939453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2354.909423828125,
        -4138.85302734375,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7435131669044495,
        -0.6687213778495789,
        0.0
      ],
      "plane_d": -4529.65234375,
      "bbox_min": [
        -2369.712646484375,
        -4155.27392578125,
        1052.623779296875
      ],
      "bbox_max": [
        -2354.943603515625,
        -4138.85302734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660253286361694,
        -0.5000001192092896,
        0.0
      ],
      "plane_d": 173.8419189453125,
      "bbox_min": [
        -2654.341064453125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2295.551025390625,
        -4049.25439453125,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660269379615784,
        0.49999743700027466,
        0.0
      ],
      "plane_d": -91.2567138671875,
      "bbox_min": [
        -2654.341064453125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2295.551025390625,
        -4058.77880859375,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41408902406692505,
        0.9102364182472229,
        0.0
      ],
      "plane_d": 2879.88818359375,
      "bbox_min": [
        -2484.04052734375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2295.551025390625,
        -4119.99951171875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.976732075214386,
        0.21446312963962555,
        0.0
      ],
      "plane_d": -1380.2791748046875,
      "bbox_min": [
        -2346.291259765625,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2295.551025390625,
        -4215.14111328125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.914959728717804,
        -0.4035452604293823,
        -0.0
      ],
      "plane_d": -3815.310791015625,
      "bbox_min": [
        -2310.823486328125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2295.551025390625,
        -4215.14111328125,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9162565469741821,
        -0.40059199929237366,
        -0.0
      ],
      "plane_d": -3926.45703125,
      "bbox_min": [
        -2484.04052734375,
        -4215.14111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4119.99951171875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11120469868183136,
        -0.9937976002693176,
        0.0
      ],
      "plane_d": -3879.902099609375,
      "bbox_min": [
        -2474.586181640625,
        -4215.14111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000298619270325,
        -0.8660082817077637,
        0.0
      ],
      "plane_d": -4824.04541015625,
      "bbox_min": [
        -2474.586181640625,
        -4174.6240234375,
        1052.623779296875
      ],
      "bbox_max": [
        -2344.81982421875,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.866020917892456,
        0.5000077486038208,
        0.0
      ],
      "plane_d": -17.19970703125,
      "bbox_min": [
        -2465.059814453125,
        -4169.12353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -2344.81982421875,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.743144154548645,
        -0.669131338596344,
        0.0
      ],
      "plane_d": -4530.474609375,
      "bbox_min": [
        -2366.2392578125,
        -4168.896484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2344.81982421875,
        -4155.27392578125,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.743144690990448,
        -0.669130802154541,
        0.0
      ],
      "plane_d": -4530.486328125,
      "bbox_min": [
        -2366.2392578125,
        -4168.896484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2344.835693359375,
        -4155.27392578125,
        1087.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1086575984954834,
        -0.09783578664064407,
        0.989253044128418
      ],
      "plane_d": -1738.352294921875,
      "bbox_min": [
        -2366.2392578125,
        -4168.896484375,
        1082.623779296875
      ],
      "bbox_max": [
        -2344.835693359375,
        -4156.490234375,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1082.623779296875,
      "bbox_min": [
        -2366.2392578125,
        -4168.896484375,
        1082.623779296875
      ],
      "bbox_max": [
        -2344.835693359375,
        -4156.490234375,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075810432434082,
        0.706632137298584,
        0.0
      ],
      "plane_d": 1271.5703125,
      "bbox_min": [
        -2366.2392578125,
        -4168.896484375,
        1082.623779296875
      ],
      "bbox_max": [
        -2353.849609375,
        -4156.490234375,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660209774971008,
        -0.5000078082084656,
        0.0
      ],
      "plane_d": 61.19921875,
      "bbox_min": [
        -2465.059814453125,
        -4169.12353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -2420.954833984375,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000013709068298,
        -0.8660246729850769,
        -0.0
      ],
      "plane_d": -4812.044921875,
      "bbox_min": [
        -2465.059814453125,
        -4169.12353515625,
        1052.623779296875
      ],
      "bbox_max": [
        -2420.954833984375,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44329512119293213,
        -0.7678069472312927,
        -0.46256038546562195
      ],
      "plane_d": -3709.5517578125,
      "bbox_min": [
        -2465.059814453125,
        -4169.12353515625,
        1203.623779296875
      ],
      "bbox_max": [
        -2420.954833984375,
        -4136.7314453125,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6790370345115662,
        0.7341040372848511,
        0.0
      ],
      "plane_d": 1525.21728515625,
      "bbox_min": [
        -2368.212646484375,
        -4215.14111328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4166.49951171875,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.743144154548645,
        -0.669131338596344,
        0.0
      ],
      "plane_d": -4530.474609375,
      "bbox_min": [
        -2368.212646484375,
        -4215.10009765625,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4166.49951171875,
        1185.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10966189205646515,
        -0.10024439543485641,
        0.9889010190963745
      ],
      "plane_d": -1750.394775390625,
      "bbox_min": [
        -2368.212646484375,
        -4215.10009765625,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4166.5009765625,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.738088846206665,
        -0.6747035980224609,
        0.0
      ],
      "plane_d": -4562.05419921875,
      "bbox_min": [
        -2368.212646484375,
        -4215.10009765625,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4166.5009765625,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1082.623779296875,
      "bbox_min": [
        -2368.212646484375,
        -4215.10009765625,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4166.5009765625,
        1087.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1086575984954834,
        -0.09783578664064407,
        0.989253044128418
      ],
      "plane_d": -1738.352294921875,
      "bbox_min": [
        -2368.212646484375,
        -4203.69091796875,
        1082.623779296875
      ],
      "bbox_max": [
        -2323.849609375,
        -4166.5009765625,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6949717998504639,
        -0.7190370559692383,
        0.0
      ],
      "plane_d": -1397.6177978515625,
      "bbox_min": [
        -2368.212646484375,
        -4203.69091796875,
        1082.623779296875
      ],
      "bbox_max": [
        -2323.849609375,
        -4168.896484375,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7075810432434082,
        0.706632137298584,
        0.0
      ],
      "plane_d": 1271.5703125,
      "bbox_min": [
        -2368.212646484375,
        -4170.87255859375,
        1082.623779296875
      ],
      "bbox_max": [
        -2366.2392578125,
        -4168.896484375,
        1085.0360107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.743144690990448,
        -0.669130802154541,
        0.0
      ],
      "plane_d": -4530.486328125,
      "bbox_min": [
        -2344.835693359375,
        -4215.10009765625,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4166.5009765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7428241968154907,
        -0.6694865226745605,
        -0.0
      ],
      "plane_d": -4531.232421875,
      "bbox_min": [
        -2323.849609375,
        -4210.19482421875,
        1052.623779296875
      ],
      "bbox_max": [
        -2305.47607421875,
        -4189.80859375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880243301391602,
        -0.45979657769203186,
        0.0
      ],
      "plane_d": -3990.13525390625,
      "bbox_min": [
        -2323.89990234375,
        -4215.10009765625,
        1052.623779296875
      ],
      "bbox_max": [
        -2310.800048828125,
        -4189.7998046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7570425868034363,
        -0.43707743287086487,
        0.4856437146663666
      ],
      "plane_d": -410.84649658203125,
      "bbox_min": [
        -2654.341064453125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2487.43701171875,
        -4058.77880859375,
        1124.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999934434890747,
        -0.8660258054733276,
        0.0
      ],
      "plane_d": -4828.64453125,
      "bbox_min": [
        -2654.341064453125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2513.73681640625,
        -4094.807373046875,
        1124.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -2654.341064453125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2513.73681640625,
        -4106.83154296875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745972871780396,
        -0.4472154378890991,
        0.44721055030822754
      ],
      "plane_d": -333.14947509765625,
      "bbox_min": [
        -2642.794189453125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2513.73681640625,
        -4106.83154296875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2575.0478515625,
        -4173.67724609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2513.73681640625,
        -4106.83154296875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7492330074310303,
        -0.43257012963294983,
        0.5015307664871216
      ],
      "plane_d": -428.611328125,
      "bbox_min": [
        -2575.0478515625,
        -4173.67724609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2513.73681640625,
        -4106.83154296875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660253286361694,
        0.5000002384185791,
        0.0
      ],
      "plane_d": -149.793212890625,
      "bbox_min": [
        -2575.0478515625,
        -4173.67724609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2534.73681640625,
        -4106.83154296875,
        1067.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2999916970729828,
        -0.5196143984794617,
        0.8000036478042603
      ],
      "plane_d": -3776.464599609375,
      "bbox_min": [
        -2575.0478515625,
        -4173.67724609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2534.73681640625,
        -4143.20458984375,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5252299308776855,
        -0.7097760438919067,
        0.46941617131233215
      ],
      "plane_d": -2115.96728515625,
      "bbox_min": [
        -2552.267578125,
        -4173.67724609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2534.73681640625,
        -4156.35693359375,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10802071541547775,
        -0.9941487312316895,
        0.0
      ],
      "plane_d": -3575.28662109375,
      "bbox_min": [
        -3046.499755859375,
        -3984.21875,
        1082.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3905.65966796875,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49999991059303284,
        -0.8660255670547485,
        0.0
      ],
      "plane_d": -4776.044921875,
      "bbox_min": [
        -2752.65576171875,
        -3984.21875,
        1082.623779296875
      ],
      "bbox_max": [
        -2651.219482421875,
        -3925.654541015625,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6879106163978577,
        -0.6849433779716492,
        0.24006594717502594
      ],
      "plane_d": -658.194091796875,
      "bbox_min": [
        -3600.0,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4264.18798828125,
      "bbox_min": [
        -3600.0,
        -4119.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3549.999755859375,
        -4069.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6787002682685852,
        -0.6787002682685852,
        0.2805918753147125
      ],
      "plane_d": -5190.9072265625,
      "bbox_min": [
        -3599.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3063.126220703125,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28535524010658264,
        -0.8666651844978333,
        0.40922343730926514
      ],
      "plane_d": -4820.12890625,
      "bbox_min": [
        -3224.999755859375,
        -3984.973388671875,
        1082.623779296875
      ],
      "bbox_max": [
        -3063.126220703125,
        -3857.455078125,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9778734445571899,
        -0.20647084712982178,
        0.03366447240114212
      ],
      "plane_d": 2159.6767578125,
      "bbox_min": [
        -3207.47998046875,
        -3984.973388671875,
        1082.623779296875
      ],
      "bbox_max": [
        -3063.126220703125,
        -3857.455078125,
        1165.0567626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3207.47998046875,
        -3984.973388671875,
        1082.623779296875
      ],
      "bbox_max": [
        -3064.999755859375,
        -3879.7685546875,
        1133.5926513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9415097236633301,
        -0.3369859457015991,
        0.0
      ],
      "plane_d": 1578.2994384765625,
      "bbox_min": [
        -3068.5068359375,
        -3889.566650390625,
        1082.623779296875
      ],
      "bbox_max": [
        -3064.999755859375,
        -3879.7685546875,
        1098.4541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6980487108230591,
        0.6980504989624023,
        0.15954118967056274
      ],
      "plane_d": 5042.2138671875,
      "bbox_min": [
        -3599.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3224.999755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4380.60546875,
      "bbox_min": [
        -3599.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3348.9013671875,
        -4096.39453125,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6541234850883484,
        -0.7563877701759338,
        0.0
      ],
      "plane_d": -930.5595703125,
      "bbox_min": [
        -3599.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3378.606201171875,
        -4152.08349609375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4239.7685546875,
      "bbox_min": [
        -3599.999755859375,
        -4239.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3435.49072265625,
        -4196.435546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071084380149841,
        -0.7071052193641663,
        -0.0
      ],
      "plane_d": -5400.009765625,
      "bbox_min": [
        -3440.33251953125,
        -4201.27734375,
        1052.623779296875
      ],
      "bbox_max": [
        -3435.49072265625,
        -4196.435546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071084380149841,
        -0.7071052193641663,
        -0.0
      ],
      "plane_d": -5400.009765625,
      "bbox_min": [
        -3435.49072265625,
        -4210.6396484375,
        1052.623779296875
      ],
      "bbox_max": [
        -3426.12841796875,
        -4201.27734375,
        1102.62255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6224409937858582,
        -0.7379052639007568,
        0.2608889639377594
      ],
      "plane_d": -5213.8037109375,
      "bbox_min": [
        -3301.525146484375,
        -3890.92822265625,
        1102.623779296875
      ],
      "bbox_max": [
        -3224.999755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6375481486320496,
        -0.7279708385467529,
        0.25217205286026
      ],
      "plane_d": -1145.8114013671875,
      "bbox_min": [
        -3502.938720703125,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4380.60546875,
      "bbox_min": [
        -3502.938720703125,
        -4239.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3479.999755859375,
        -4189.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28535524010658264,
        -0.8666651844978333,
        0.40922343730926514
      ],
      "plane_d": -4820.12890625,
      "bbox_min": [
        -3188.277587890625,
        -3976.673095703125,
        1098.453857421875
      ],
      "bbox_max": [
        -3059.999755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9778734445571899,
        -0.20647084712982178,
        0.03366447240114212
      ],
      "plane_d": 2159.6767578125,
      "bbox_min": [
        -3083.468505859375,
        -3931.36865234375,
        1098.453857421875
      ],
      "bbox_max": [
        -3059.999755859375,
        -3820.217529296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10802071541547775,
        -0.9941487312316895,
        0.0
      ],
      "plane_d": -3575.28662109375,
      "bbox_min": [
        -3439.048583984375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3046.499755859375,
        -3927.351806640625,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071084380149841,
        -0.7071052193641663,
        -0.0
      ],
      "plane_d": -5400.009765625,
      "bbox_min": [
        -3439.048583984375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3386.999755859375,
        -4197.71923828125,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3699.999755859375,
      "bbox_min": [
        -3699.999755859375,
        -4206.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4119.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3699.999755859375,
      "bbox_min": [
        -3699.999755859375,
        -4249.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4206.7998046875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3754.28271484375,
        -4249.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3599.999755859375,
        -4069.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7621387243270874,
        -0.6012710928916931,
        0.24003666639328003
      ],
      "plane_d": -6.656219482421875,
      "bbox_min": [
        -3754.28271484375,
        -4249.7685546875,
        1278.740234375
      ],
      "bbox_max": [
        -3744.02880859375,
        -4244.33984375,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9751271605491638,
        0.22164621949195862
      ],
      "plane_d": -4427.49267578125,
      "bbox_min": [
        -3749.999755859375,
        -4249.7685546875,
        1278.740234375
      ],
      "bbox_max": [
        -3744.02880859375,
        -4244.33984375,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -4264.18798828125,
      "bbox_min": [
        -3749.999755859375,
        -4119.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3599.999755859375,
        -4069.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        3.487878927899146e-07,
        0.0
      ],
      "plane_d": -2919.998291015625,
      "bbox_min": [
        -3835.11669921875,
        -5065.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2119.999755859375,
        -4249.7685546875,
        1302.6241455078125
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2214.77978515625,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2119.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.48899564146995544,
        0.8722862601280212,
        0.0
      ],
      "plane_d": 2783.7412109375,
      "bbox_min": [
        -2214.77978515625,
        -4432.9013671875,
        1167.623779296875
      ],
      "bbox_max": [
        -2119.999755859375,
        -4379.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4609.7685546875,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4919.7685546875,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4609.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1102.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4919.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7047529220581055,
        0.6667083501815796,
        0.24253523349761963
      ],
      "plane_d": 947.6998901367188,
      "bbox_min": [
        -2920.0,
        -4981.9541015625,
        1195.5255126953125
      ],
      "bbox_max": [
        -2908.47216796875,
        -4942.994140625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9079594016075134,
        0.0,
        0.4190582036972046
      ],
      "plane_d": 1957.648193359375,
      "bbox_min": [
        -2749.999755859375,
        -4952.2685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2664.999755859375,
        -4919.7685546875,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -2749.99951171875,
      "bbox_min": [
        -2749.999755859375,
        -4952.2685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4919.7685546875,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2749.999755859375,
      "bbox_min": [
        -2920.0,
        -4919.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.999755859375,
        -4609.7685546875,
        1255.3924560546875
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4615.7685546875,
      "bbox_min": [
        -2249.999755859375,
        -4619.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.999755859375,
        -4615.7685546875,
        1099.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2249.999755859375,
      "bbox_min": [
        -2249.999755859375,
        -4619.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.999755859375,
        -4615.7685546875,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1085.623779296875,
      "bbox_min": [
        -2245.999755859375,
        -4619.7685546875,
        1085.623779296875
      ],
      "bbox_max": [
        -2214.999755859375,
        -4615.7685546875,
        1085.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22678926587104797,
        0.8463535308837891,
        0.4819256365299225
      ],
      "plane_d": 2897.25927734375,
      "bbox_min": [
        -2380.729248046875,
        -4710.6572265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2341.902099609375,
        -4650.14208984375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6153339743614197,
        -0.6237942576408386,
        0.48191797733306885
      ],
      "plane_d": -4896.94189453125,
      "bbox_min": [
        -2380.729248046875,
        -4710.6572265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2355.126708984375,
        -4658.3115234375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8447829484939575,
        0.2325933277606964,
        0.48191502690315247
      ],
      "plane_d": -1427.938232421875,
      "bbox_min": [
        -2380.729248046875,
        -4688.59716796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2363.4580078125,
        -4658.3115234375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2548328936100006,
        0.9510114789009094,
        0.17503531277179718
      ],
      "plane_d": 3648.627685546875,
      "bbox_min": [
        -2368.411376953125,
        -4698.4013671875,
        1072.623779296875
      ],
      "bbox_max": [
        -2345.14111328125,
        -4662.39794921875,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914238333702087,
        -0.7009251713752747,
        0.1750343292951584
      ],
      "plane_d": -5109.36474609375,
      "bbox_min": [
        -2368.411376953125,
        -4698.4013671875,
        1072.623779296875
      ],
      "bbox_max": [
        -2352.77099609375,
        -4667.30615234375,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9492396712303162,
        0.26135846972465515,
        0.17503103613853455
      ],
      "plane_d": -1211.3905029296875,
      "bbox_min": [
        -2368.411376953125,
        -4685.296875,
        1072.623779296875
      ],
      "bbox_max": [
        -2356.96142578125,
        -4667.30615234375,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2495473474264145,
        0.931351900100708,
        -0.2651599645614624
      ],
      "plane_d": 4061.17236328125,
      "bbox_min": [
        -2371.770751953125,
        -4701.74365234375,
        1117.623779296875
      ],
      "bbox_max": [
        -2344.2578125,
        -4659.0556640625,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9296196699142456,
        0.25593090057373047,
        -0.265154093503952
      ],
      "plane_d": -698.5534057617188,
      "bbox_min": [
        -2371.770751953125,
        -4701.74365234375,
        1117.623779296875
      ],
      "bbox_max": [
        -2352.77099609375,
        -4664.85302734375,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6771124601364136,
        -0.6864485144615173,
        -0.2651548683643341
      ],
      "plane_d": -4515.83935546875,
      "bbox_min": [
        -2371.770751953125,
        -4701.74365234375,
        1117.623779296875
      ],
      "bbox_max": [
        -2352.77099609375,
        -4682.896484375,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23148757219314575,
        0.8639536499977112,
        -0.44721078872680664
      ],
      "plane_d": 4000.243408203125,
      "bbox_min": [
        -2382.96875,
        -4708.23046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2341.313232421875,
        -4647.9140625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8623456358909607,
        0.23740917444229126,
        -0.44721004366874695
      ],
      "plane_d": -415.03887939453125,
      "bbox_min": [
        -2382.96875,
        -4708.23046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2356.010009765625,
        -4656.67626953125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13553127646446228,
        -0.13739998638629913,
        -0.9811996221542358
      ],
      "plane_d": 170.5274658203125,
      "bbox_min": [
        -2375.614013671875,
        -4708.23046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2356.010009765625,
        -4686.197265625,
        1159.5908203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7162401676177979,
        0.6266971230506897,
        -0.3070029616355896
      ],
      "plane_d": 1593.462890625,
      "bbox_min": [
        -2382.96875,
        -4696.45263671875,
        1157.623779296875
      ],
      "bbox_max": [
        -2371.770751953125,
        -4686.197265625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13687992095947266,
        -0.13688242435455322,
        -0.9810847043991089
      ],
      "plane_d": 169.6212158203125,
      "bbox_min": [
        -2378.821533203125,
        -4696.45263671875,
        1157.623779296875
      ],
      "bbox_max": [
        -2371.770751953125,
        -4686.197265625,
        1159.596923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22646257281303406,
        0.8451343774795532,
        0.4842134118080139
      ],
      "plane_d": 3990.55517578125,
      "bbox_min": [
        -2540.4609375,
        -4702.48779296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2487.608642578125,
        -4650.14208984375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.614443838596344,
        0.622891902923584,
        0.48421511054039
      ],
      "plane_d": 839.6099853515625,
      "bbox_min": [
        -2540.4609375,
        -4702.48779296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2514.8583984375,
        -4650.14208984375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8435620069503784,
        -0.23223426938056946,
        0.48422130942344666
      ],
      "plane_d": -3737.784912109375,
      "bbox_min": [
        -2540.4609375,
        -4702.48779296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2523.17236328125,
        -4672.2021484375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9493250846862793,
        -0.261356383562088,
        0.17457012832164764
      ],
      "plane_d": -3809.228759765625,
      "bbox_min": [
        -2528.14306640625,
        -4693.4931640625,
        1072.5
      ],
      "bbox_max": [
        -2523.17236328125,
        -4675.50244140625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914816498756409,
        0.7009838223457336,
        0.17457029223442078
      ],
      "plane_d": 1342.060546875,
      "bbox_min": [
        -2528.14306640625,
        -4675.56005859375,
        1072.5
      ],
      "bbox_max": [
        -2514.8583984375,
        -4662.39794921875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9493250846862793,
        -0.261356383562088,
        0.17457012832164764
      ],
      "plane_d": -3809.228759765625,
      "bbox_min": [
        -2528.14306640625,
        -4675.56005859375,
        1072.5
      ],
      "bbox_max": [
        -2528.104248046875,
        -4675.50244140625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.254854291677475,
        0.9510912895202637,
        0.17457003891468048
      ],
      "plane_d": 4888.0625,
      "bbox_min": [
        -2514.890380859375,
        -4667.32421875,
        1072.5
      ],
      "bbox_max": [
        -2496.54150390625,
        -4662.39794921875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914816498756409,
        0.7009838223457336,
        0.17457029223442078
      ],
      "plane_d": 1342.060546875,
      "bbox_min": [
        -2514.890380859375,
        -4662.4599609375,
        1072.5
      ],
      "bbox_max": [
        -2514.85205078125,
        -4662.39794921875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.254854291677475,
        0.9510912895202637,
        0.17457003891468048
      ],
      "plane_d": 4888.0625,
      "bbox_min": [
        -2528.118408203125,
        -4693.47509765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2496.559326171875,
        -4662.42236328125,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6914816498756409,
        0.7009838223457336,
        0.17457029223442078
      ],
      "plane_d": 1342.060546875,
      "bbox_min": [
        -2528.118408203125,
        -4693.47509765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2512.502685546875,
        -4662.42236328125,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9493250846862793,
        -0.261356383562088,
        0.17457012832164764
      ],
      "plane_d": -3809.228759765625,
      "bbox_min": [
        -2528.118408203125,
        -4693.47509765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2516.693359375,
        -4675.5087890625,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24954763054847717,
        0.9313529133796692,
        -0.2651560604572296
      ],
      "plane_d": 5273.9736328125,
      "bbox_min": [
        -2531.50244140625,
        -4695.94580078125,
        1117.623779296875
      ],
      "bbox_max": [
        -2494.10498046875,
        -4659.0556640625,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6771115660667419,
        0.6864476203918457,
        -0.2651596665382385
      ],
      "plane_d": 1801.715087890625,
      "bbox_min": [
        -2531.50244140625,
        -4695.94580078125,
        1117.623779296875
      ],
      "bbox_max": [
        -2512.502685546875,
        -4659.0556640625,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9296203851699829,
        -0.25592634081840515,
        -0.2651558518409729
      ],
      "plane_d": -3242.7392578125,
      "bbox_min": [
        -2531.50244140625,
        -4695.94580078125,
        1117.623779296875
      ],
      "bbox_max": [
        -2516.693359375,
        -4674.60205078125,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2314876914024353,
        0.8639540672302246,
        -0.4472099244594574
      ],
      "plane_d": 5125.27392578125,
      "bbox_min": [
        -2542.700439453125,
        -4708.23046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2484.43994140625,
        -4647.9140625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6281108260154724,
        0.6367726922035217,
        -0.4472106397151947
      ],
      "plane_d": 1904.2965087890625,
      "bbox_min": [
        -2542.700439453125,
        -4708.23046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2484.43994140625,
        -4647.9140625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8623447418212891,
        -0.23739954829216003,
        -0.44721701741218567
      ],
      "plane_d": -2775.067138671875,
      "bbox_min": [
        -2542.700439453125,
        -4708.23046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2484.43994140625,
        -4671.6015625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1355312615633011,
        -0.13739998638629913,
        -0.9811995029449463
      ],
      "plane_d": 829.209228515625,
      "bbox_min": [
        -2503.989501953125,
        -4708.23046875,
        1157.623779296875
      ],
      "bbox_max": [
        -2484.43994140625,
        -4686.197265625,
        1159.5906982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6153347492218018,
        0.6237949728965759,
        0.4819159507751465
      ],
      "plane_d": 1041.29443359375,
      "bbox_min": [
        -2380.729248046875,
        -4861.2255859375,
        1052.623779296875
      ],
      "bbox_max": [
        -2355.126708984375,
        -4808.8798828125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8447805047035217,
        -0.2325926423072815,
        0.4819195866584778
      ],
      "plane_d": -3642.11474609375,
      "bbox_min": [
        -2380.729248046875,
        -4861.2255859375,
        1052.623779296875
      ],
      "bbox_max": [
        -2363.4580078125,
        -4830.93994140625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6144431829452515,
        0.6228911876678467,
        0.4842171370983124
      ],
      "plane_d": 4022.822265625,
      "bbox_min": [
        -2540.4609375,
        -4847.3349609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2479.270263671875,
        -4808.8798828125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2264551967382431,
        0.8451293706893921,
        0.4842255413532257
      ],
      "plane_d": 2987.91015625,
      "bbox_min": [
        -2540.4609375,
        -4847.3349609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2501.633544921875,
        -4808.8798828125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.84356290102005,
        0.23223452270030975,
        0.48421967029571533
      ],
      "plane_d": -1527.021240234375,
      "bbox_min": [
        -2540.4609375,
        -4847.3349609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2523.186767578125,
        -4817.04931640625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.949325442314148,
        0.26135650277137756,
        0.1745680719614029
      ],
      "plane_d": -1321.2349853515625,
      "bbox_min": [
        -2528.14306640625,
        -4844.03466796875,
        1072.5
      ],
      "bbox_max": [
        -2523.186767578125,
        -4826.0439453125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.254848450422287,
        0.9510927796363831,
        0.17457054555416107
      ],
      "plane_d": 3759.757568359375,
      "bbox_min": [
        -2523.190185546875,
        -4826.1142578125,
        1072.5
      ],
      "bbox_max": [
        -2504.872802734375,
        -4821.1357421875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.949325442314148,
        0.26135650277137756,
        0.1745680719614029
      ],
      "plane_d": -1321.2349853515625,
      "bbox_min": [
        -2523.190185546875,
        -4826.1142578125,
        1072.5
      ],
      "bbox_max": [
        -2523.17236328125,
        -4826.0439453125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.69148188829422,
        0.7009840607643127,
        0.17456886172294617
      ],
      "plane_d": 4924.38818359375,
      "bbox_min": [
        -2504.931640625,
        -4834.24658203125,
        1072.5
      ],
      "bbox_max": [
        -2491.588134765625,
        -4821.1357421875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.254848450422287,
        0.9510927796363831,
        0.17457054555416107
      ],
      "plane_d": 3759.757568359375,
      "bbox_min": [
        -2504.931640625,
        -4821.173828125,
        1072.5
      ],
      "bbox_max": [
        -2504.872802734375,
        -4821.1357421875,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.254848450422287,
        0.9510927796363831,
        0.17457054555416107
      ],
      "plane_d": 3759.757568359375,
      "bbox_min": [
        -2528.118408203125,
        -4844.0283203125,
        1072.623779296875
      ],
      "bbox_max": [
        -2491.61279296875,
        -4821.16015625,
        1117.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.69148188829422,
        0.7009840607643127,
        0.17456886172294617
      ],
      "plane_d": 4924.38818359375,
      "bbox_min": [
        -2528.118408203125,
        -4844.0283203125,
        1072.623779296875
      ],
      "bbox_max": [
        -2491.61279296875,
        -4821.16015625,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.949325442314148,
        0.26135650277137756,
        0.1745680719614029
      ],
      "plane_d": -1321.2349853515625,
      "bbox_min": [
        -2528.118408203125,
        -4844.0283203125,
        1072.623779296875
      ],
      "bbox_max": [
        -2516.693359375,
        -4826.06201171875,
        1117.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24956487119197845,
        0.9313494563102722,
        -0.2651519477367401
      ],
      "plane_d": 4169.087890625,
      "bbox_min": [
        -2531.50244140625,
        -4844.93505859375,
        1117.623779296875
      ],
      "bbox_max": [
        -2488.228759765625,
        -4817.79345703125,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6771124601364136,
        0.6864485144615173,
        -0.2651548683643341
      ],
      "plane_d": 5309.59912109375,
      "bbox_min": [
        -2531.50244140625,
        -4844.93505859375,
        1117.623779296875
      ],
      "bbox_max": [
        -2488.228759765625,
        -4817.79345703125,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9296206831932068,
        0.2559264004230499,
        -0.26515480875968933
      ],
      "plane_d": -806.4406127929688,
      "bbox_min": [
        -2531.50244140625,
        -4844.93505859375,
        1117.623779296875
      ],
      "bbox_max": [
        -2516.693359375,
        -4823.59130859375,
        1157.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8623470664024353,
        0.23740020394325256,
        -0.44721224904060364
      ],
      "plane_d": -515.1415405273438,
      "bbox_min": [
        -2542.700439453125,
        -4847.935546875,
        1157.623779296875
      ],
      "bbox_max": [
        -2481.17822265625,
        -4806.65185546875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23149581253528595,
        0.863949179649353,
        -0.44721511006355286
      ],
      "plane_d": 4100.373046875,
      "bbox_min": [
        -2533.74755859375,
        -4833.33984375,
        1157.623779296875
      ],
      "bbox_max": [
        -2481.17822265625,
        -4806.65185546875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13553127646446228,
        0.13739998638629913,
        -0.9811996221542358
      ],
      "plane_d": 2137.193603515625,
      "bbox_min": [
        -2503.989501953125,
        -4833.33984375,
        1157.623779296875
      ],
      "bbox_max": [
        -2481.17822265625,
        -4813.99267578125,
        1159.5968017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13687992095947266,
        0.13688242435455322,
        -0.9810847043991089
      ],
      "plane_d": 2137.914794921875,
      "bbox_min": [
        -2488.228759765625,
        -4833.33984375,
        1157.623779296875
      ],
      "bbox_max": [
        -2481.17822265625,
        -4823.03125,
        1159.5968017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.554774284362793,
        0.7588759660720825,
        -0.3410758674144745
      ],
      "plane_d": 2661.796142578125,
      "bbox_min": [
        -2503.989501953125,
        -4817.79345703125,
        1157.623779296875
      ],
      "bbox_max": [
        -2493.60302734375,
        -4806.65185546875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13553127646446228,
        0.13739998638629913,
        -0.9811996221542358
      ],
      "plane_d": 2137.193603515625,
      "bbox_min": [
        -2503.989501953125,
        -4817.79345703125,
        1157.623779296875
      ],
      "bbox_max": [
        -2493.60302734375,
        -4811.306640625,
        1159.5906982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9867103099822998,
        0.0,
        -0.16248930990695953
      ],
      "plane_d": -2236.600341796875,
      "bbox_min": [
        -2501.044921875,
        -4826.24853515625,
        1052.623779296875
      ],
      "bbox_max": [
        -2363.673828125,
        -4689.19775390625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9867106676101685,
        -0.16248691082000732
      ],
      "plane_d": 4855.64404296875,
      "bbox_min": [
        -2466.416748046875,
        -4822.27099609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2363.673828125,
        -4689.19775390625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2463.123046875,
        -4822.27099609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2369.927490234375,
        -4721.35205078125,
        1212.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.6937940120697021,
        0.7201735377311707,
        -0.0
      ],
      "plane_d": 5058.2001953125,
      "bbox_min": [
        -2389.768798828125,
        -4734.83251953125,
        1192.623779296875
      ],
      "bbox_max": [
        -2375.77587890625,
        -4721.35205078125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9781163930892944,
        0.0,
        0.20805880427360535
      ],
      "plane_d": -2573.705078125,
      "bbox_min": [
        -2452.15087890625,
        -4822.27099609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2369.927490234375,
        -4734.83251953125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4734.83251953125,
      "bbox_min": [
        -2379.927490234375,
        -4734.83251953125,
        1181.6800537109375
      ],
      "bbox_max": [
        -2369.927490234375,
        -4734.83251953125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9929671287536621,
        0.11839047819375992
      ],
      "plane_d": 4638.580078125,
      "bbox_min": [
        -2452.15087890625,
        -4822.27099609375,
        1052.623779296875
      ],
      "bbox_max": [
        -2407.8486328125,
        -4749.7685546875,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2452.15087890625,
      "bbox_min": [
        -2452.15087890625,
        -4822.27099609375,
        1181.2305908203125
      ],
      "bbox_max": [
        -2452.15087890625,
        -4812.27099609375,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2439.499755859375,
      "bbox_min": [
        -2439.499755859375,
        -4788.44921875,
        1052.623779296875
      ],
      "bbox_max": [
        -2409.6748046875,
        -4749.7685546875,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4749.7685546875,
      "bbox_min": [
        -2439.499755859375,
        -4788.44921875,
        1052.623779296875
      ],
      "bbox_max": [
        -2409.6748046875,
        -4749.7685546875,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070945501327515,
        -0.7071189284324646,
        -2.4642197331559146e-06
      ],
      "plane_d": -5089.86865234375,
      "bbox_min": [
        -2423.8173828125,
        -4788.44921875,
        1052.623779296875
      ],
      "bbox_max": [
        -2409.6748046875,
        -4765.0,
        1187.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070931792259216,
        0.7071203589439392,
        0.0
      ],
      "plane_d": 1662.14501953125,
      "bbox_min": [
        -2423.8173828125,
        -4774.30712890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2417.461181640625,
        -4765.0,
        1187.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4765.0,
      "bbox_min": [
        -2419.999755859375,
        -4765.0,
        1177.623779296875
      ],
      "bbox_max": [
        -2418.999755859375,
        -4765.0,
        1187.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7062519788742065,
        0.7062519788742065,
        -0.04915514215826988
      ],
      "plane_d": 1691.9815673828125,
      "bbox_min": [
        -2466.416748046875,
        -4745.22998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2363.673828125,
        -4689.19775390625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6954730749130249,
        0.6954730749130249,
        -0.18064959347248077
      ],
      "plane_d": 5159.07421875,
      "bbox_min": [
        -2414.499755859375,
        -4737.44384765625,
        1067.623779296875
      ],
      "bbox_max": [
        -2363.673828125,
        -4693.55908203125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6937940120697021,
        0.7201735377311707,
        -0.0
      ],
      "plane_d": 5058.2001953125,
      "bbox_min": [
        -2414.499755859375,
        -4729.091796875,
        1165.623779296875
      ],
      "bbox_max": [
        -2386.349853515625,
        -4711.40966796875,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7066429853439331,
        0.7066429853439331,
        -0.03621487691998482
      ],
      "plane_d": 1677.8031005859375,
      "bbox_min": [
        -2414.499755859375,
        -4729.091796875,
        1165.623779296875
      ],
      "bbox_max": [
        -2400.357666015625,
        -4714.94970703125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7865133881568909,
        0.5997427105903625,
        -0.14732742309570312
      ],
      "plane_d": 1111.57177734375,
      "bbox_min": [
        -2407.8486328125,
        -4721.82568359375,
        1165.623779296875
      ],
      "bbox_max": [
        -2400.357666015625,
        -4714.94970703125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13687992095947266,
        -0.13688242435455322,
        -0.9810847043991089
      ],
      "plane_d": 169.6212158203125,
      "bbox_min": [
        -2400.357666015625,
        -4728.12646484375,
        1159.5906982421875
      ],
      "bbox_max": [
        -2363.673828125,
        -4693.55908203125,
        1165.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.13553127646446228,
        -0.13739998638629913,
        -0.9811996221542358
      ],
      "plane_d": 170.5274658203125,
      "bbox_min": [
        -2387.1806640625,
        -4728.12646484375,
        1159.5906982421875
      ],
      "bbox_max": [
        -2363.673828125,
        -4696.50634765625,
        1165.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7062459588050842,
        0.7062581181526184,
        -0.04915497079491615
      ],
      "plane_d": 5124.3798828125,
      "bbox_min": [
        -2466.416748046875,
        -4745.22998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2378.547607421875,
        -4689.19775390625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6937940120697021,
        0.7201735377311707,
        0.0
      ],
      "plane_d": 1686.3616943359375,
      "bbox_min": [
        -2466.416748046875,
        -4729.091796875,
        1165.623779296875
      ],
      "bbox_max": [
        -2445.499755859375,
        -4711.41015625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7066429853439331,
        0.7066429853439331,
        -0.03621487691998482
      ],
      "plane_d": 5112.087890625,
      "bbox_min": [
        -2463.123046875,
        -4729.091796875,
        1165.623779296875
      ],
      "bbox_max": [
        -2445.499755859375,
        -4712.0927734375,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2463.123046875,
        -4724.64599609375,
        1192.623779296875
      ],
      "bbox_max": [
        -2448.56201171875,
        -4712.3359375,
        1192.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2460.871826171875,
        -4729.091796875,
        1165.623779296875
      ],
      "bbox_max": [
        -2445.499755859375,
        -4712.0927734375,
        1192.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7865133881568909,
        0.5997427105903625,
        -0.14732742309570312
      ],
      "plane_d": 4934.0263671875,
      "bbox_min": [
        -2458.89453125,
        -4721.82568359375,
        1166.846923828125
      ],
      "bbox_max": [
        -2452.15087890625,
        -4715.60546875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2460.653076171875,
        -4729.091796875,
        1165.623779296875
      ],
      "bbox_max": [
        -2394.729248046875,
        -4703.9345703125,
        1212.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6937940120697021,
        0.7201735377311707,
        -0.0
      ],
      "plane_d": 5058.2001953125,
      "bbox_min": [
        -2407.8486328125,
        -4712.0927734375,
        1192.623779296875
      ],
      "bbox_max": [
        -2399.380126953125,
        -4703.9345703125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9199437499046326,
        -0.0,
        -0.392050564289093
      ],
      "plane_d": -1792.73876953125,
      "bbox_min": [
        -2460.653076171875,
        -4729.091796875,
        1165.623779296875
      ],
      "bbox_max": [
        -2394.729248046875,
        -4703.9345703125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2452.15087890625,
      "bbox_min": [
        -2452.15087890625,
        -4707.26611328125,
        1181.2305908203125
      ],
      "bbox_max": [
        -2452.15087890625,
        -4703.9345703125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.830085039138794,
        0.13408897817134857,
        -0.5412752628326416
      ],
      "plane_d": -764.9303588867188,
      "bbox_min": [
        -2460.653076171875,
        -4729.091796875,
        1165.623779296875
      ],
      "bbox_max": [
        -2445.499755859375,
        -4707.26611328125,
        1181.2305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7865133881568909,
        0.5997427105903625,
        -0.14732742309570312
      ],
      "plane_d": 4934.0263671875,
      "bbox_min": [
        -2460.653076171875,
        -4720.89697265625,
        1171.2025146484375
      ],
      "bbox_max": [
        -2452.859130859375,
        -4710.67578125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8630385398864746,
        0.5051382780075073
      ],
      "plane_d": 3457.23681640625,
      "bbox_min": [
        -2452.15087890625,
        -4703.9345703125,
        1177.96044921875
      ],
      "bbox_max": [
        -2407.8486328125,
        -4697.26611328125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2452.15087890625,
      "bbox_min": [
        -2452.15087890625,
        -4703.9345703125,
        1177.96044921875
      ],
      "bbox_max": [
        -2450.75732421875,
        -4697.26611328125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9199437499046326,
        -0.0,
        -0.392050564289093
      ],
      "plane_d": -1792.73876953125,
      "bbox_min": [
        -2452.15087890625,
        -4703.9345703125,
        1177.96044921875
      ],
      "bbox_max": [
        -2450.75732421875,
        -4697.26611328125,
        1181.2305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7162401676177979,
        0.6266971230506897,
        -0.3070029616355896
      ],
      "plane_d": 1593.462890625,
      "bbox_min": [
        -2460.02099609375,
        -4745.22998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2378.547607421875,
        -4689.19775390625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7865133881568909,
        0.5997427105903625,
        -0.14732742309570312
      ],
      "plane_d": 1111.57177734375,
      "bbox_min": [
        -2403.511474609375,
        -4717.71484375,
        1165.623779296875
      ],
      "bbox_max": [
        -2382.96875,
        -4689.19775390625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071006894111633,
        0.7071129083633423,
        0.0
      ],
      "plane_d": 1641.5303955078125,
      "bbox_min": [
        -2460.02099609375,
        -4745.22998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2409.675048828125,
        -4712.447265625,
        1173.7857666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7865133881568909,
        0.5997427105903625,
        -0.14732742309570312
      ],
      "plane_d": 4934.0263671875,
      "bbox_min": [
        -2460.02099609375,
        -4717.71533203125,
        1166.9442138671875
      ],
      "bbox_max": [
        -2456.488037109375,
        -4712.447265625,
        1173.7857666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.706821858882904,
        0.706821858882904,
        0.028386786580085754
      ],
      "plane_d": 1605.7431640625,
      "bbox_min": [
        -2472.81884765625,
        -4791.41064453125,
        1165.623779296875
      ],
      "bbox_max": [
        -2458.6767578125,
        -4777.2685546875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5202022194862366,
        0.8393972516059875,
        -0.15748634934425354
      ],
      "plane_d": 2919.10107421875,
      "bbox_min": [
        -2472.81884765625,
        -4791.41064453125,
        1165.623779296875
      ],
      "bbox_max": [
        -2465.630859375,
        -4784.70458984375,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13553127646446228,
        0.13739998638629913,
        -0.9811996221542358
      ],
      "plane_d": 2137.193603515625,
      "bbox_min": [
        -2494.296630859375,
        -4823.03125,
        1159.5906982421875
      ],
      "bbox_max": [
        -2472.81884765625,
        -4791.41064453125,
        1165.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7062459588050842,
        0.7062581181526184,
        -0.04915497079491615
      ],
      "plane_d": 5124.3798828125,
      "bbox_min": [
        -2501.044921875,
        -4813.30810546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2442.538330078125,
        -4689.19775390625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7062519192695618,
        -0.7062519192695618,
        -0.04915689304471016
      ],
      "plane_d": -5028.38330078125,
      "bbox_min": [
        -2501.044921875,
        -4813.30810546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2442.538330078125,
        -4696.50634765625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6954664587974548,
        0.6954793930053711,
        -0.18065086007118225
      ],
      "plane_d": 1779.1229248046875,
      "bbox_min": [
        -2494.296875,
        -4742.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2446.300537109375,
        -4696.50634765625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6937940120697021,
        0.7201735377311707,
        0.0
      ],
      "plane_d": 1686.3616943359375,
      "bbox_min": [
        -2476.665771484375,
        -4742.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2446.300537109375,
        -4714.5048828125,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2475.95654296875,
        -4742.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2446.300537109375,
        -4714.5048828125,
        1192.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.16481725871562958,
        0.7927932739257812,
        -0.5867829322814941
      ],
      "plane_d": 4038.37451171875,
      "bbox_min": [
        -2466.974365234375,
        -4742.2685546875,
        1165.623779296875
      ],
      "bbox_max": [
        -2458.6767578125,
        -4714.94970703125,
        1178.0010986328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7865133881568909,
        0.5997427105903625,
        -0.14732742309570312
      ],
      "plane_d": 4934.0263671875,
      "bbox_min": [
        -2459.641845703125,
        -4715.650390625,
        1165.623779296875
      ],
      "bbox_max": [
        -2458.87841796875,
        -4714.94970703125,
        1166.9442138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1355312615633011,
        -0.13739998638629913,
        -0.9811995029449463
      ],
      "plane_d": 829.209228515625,
      "bbox_min": [
        -2494.296875,
        -4728.12646484375,
        1159.5906982421875
      ],
      "bbox_max": [
        -2472.81884765625,
        -4696.50634765625,
        1165.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45533156394958496,
        0.0,
        -0.8903219699859619
      ],
      "plane_d": -81.732666015625,
      "bbox_min": [
        -2501.044921875,
        -4813.30810546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2442.538330078125,
        -4706.22900390625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2484.2236328125,
      "bbox_min": [
        -2490.072021484375,
        -4794.93603515625,
        1165.623779296875
      ],
      "bbox_max": [
        -2458.6767578125,
        -4726.8681640625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1192.623779296875,
      "bbox_min": [
        -2484.2236328125,
        -4794.93603515625,
        1165.623779296875
      ],
      "bbox_max": [
        -2458.6767578125,
        -4726.8681640625,
        1212.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6937940120697021,
        0.7201735377311707,
        0.0
      ],
      "plane_d": 1686.3616943359375,
      "bbox_min": [
        -2484.2236328125,
        -4734.83251953125,
        1192.623779296875
      ],
      "bbox_max": [
        -2475.95654296875,
        -4726.8681640625,
        1212.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9074113965034485,
        -0.42024338245391846
      ],
      "plane_d": 4793.0341796875,
      "bbox_min": [
        -2484.2236328125,
        -4794.93603515625,
        1165.623779296875
      ],
      "bbox_max": [
        -2458.6767578125,
        -4734.83251953125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8819599747657776,
        0.0,
        0.4713243842124939
      ],
      "plane_d": -2753.0986328125,
      "bbox_min": [
        -2490.072021484375,
        -4784.70458984375,
        1178.6890869140625
      ],
      "bbox_max": [
        -2484.2236328125,
        -4734.83251953125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4734.83251953125,
      "bbox_min": [
        -2490.072021484375,
        -4736.2177734375,
        1178.6890869140625
      ],
      "bbox_max": [
        -2484.2236328125,
        -4734.83251953125,
        1192.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9074113965034485,
        -0.42024338245391846
      ],
      "plane_d": 4793.0341796875,
      "bbox_min": [
        -2490.072021484375,
        -4736.2177734375,
        1178.6890869140625
      ],
      "bbox_max": [
        -2484.2236328125,
        -4734.83251953125,
        1181.6800537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.554774284362793,
        0.7588759660720825,
        -0.3410758674144745
      ],
      "plane_d": 2661.796142578125,
      "bbox_min": [
        -2501.044921875,
        -4813.30810546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2442.538330078125,
        -4706.22900390625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5202022194862366,
        0.8393972516059875,
        -0.15748634934425354
      ],
      "plane_d": 2919.10107421875,
      "bbox_min": [
        -2501.044921875,
        -4806.65185546875,
        1165.623779296875
      ],
      "bbox_max": [
        -2470.88134765625,
        -4789.03857421875,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1355312615633011,
        -0.13739998638629913,
        -0.9811995029449463
      ],
      "plane_d": 829.209228515625,
      "bbox_min": [
        -2496.32568359375,
        -4782.09326171875,
        1052.623779296875
      ],
      "bbox_max": [
        -2442.538330078125,
        -4706.22900390625,
        1165.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -4.315837941248901e-06
      ],
      "plane_d": -5087.01025390625,
      "bbox_min": [
        -2456.680419921875,
        -4782.09326171875,
        1052.623779296875
      ],
      "bbox_max": [
        -2442.538330078125,
        -4737.44384765625,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6499340534210205,
        0.6499340534210205,
        -0.3939182460308075
      ],
      "plane_d": 1902.9022216796875,
      "bbox_min": [
        -2456.680419921875,
        -4741.9892578125,
        1052.623779296875
      ],
      "bbox_max": [
        -2451.613037109375,
        -4737.44384765625,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1644.3154296875,
      "bbox_min": [
        -2456.680419921875,
        -4782.09326171875,
        1052.623779296875
      ],
      "bbox_max": [
        -2442.538330078125,
        -4767.951171875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7865133881568909,
        0.5997427105903625,
        -0.14732742309570312
      ],
      "plane_d": 4934.0263671875,
      "bbox_min": [
        -2477.03076171875,
        -4736.1552734375,
        1052.623779296875
      ],
      "bbox_max": [
        -2445.77880859375,
        -4689.19775390625,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6499340534210205,
        0.6499340534210205,
        -0.3939182460308075
      ],
      "plane_d": 1902.9022216796875,
      "bbox_min": [
        -2450.324462890625,
        -4736.1552734375,
        1052.623779296875
      ],
      "bbox_max": [
        -2445.77880859375,
        -4731.087890625,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4819.7685546875,
      "bbox_min": [
        -2649.999755859375,
        -4879.83837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2599.999755859375,
        -4609.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4869.7685546875,
      "bbox_min": [
        -2649.999755859375,
        -4879.83837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2599.999755859375,
        -4819.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6507914066314697,
        -0.0,
        0.7592566609382629
      ],
      "plane_d": 892.8458862304688,
      "bbox_min": [
        -2649.999755859375,
        -4879.83837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2599.999755859375,
        -4869.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2649.999755859375,
        -4879.83837890625,
        1082.623779296875
      ],
      "bbox_max": [
        -2634.999755859375,
        -4869.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650791347026825,
        -0.0,
        0.7592566013336182
      ],
      "plane_d": 892.8458251953125,
      "bbox_min": [
        -2649.999755859375,
        -4829.83837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2599.999755859375,
        -4819.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2649.999755859375,
        -4829.83837890625,
        1082.623779296875
      ],
      "bbox_max": [
        -2634.999755859375,
        -4819.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4669.7685546875,
      "bbox_min": [
        -2649.999755859375,
        -4679.837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2599.999755859375,
        -4609.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650791347026825,
        -0.0,
        0.7592566013336182
      ],
      "plane_d": 892.8458251953125,
      "bbox_min": [
        -2649.999755859375,
        -4679.837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2599.999755859375,
        -4669.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2649.999755859375,
        -4679.837890625,
        1082.623779296875
      ],
      "bbox_max": [
        -2634.999755859375,
        -4669.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650791347026825,
        -0.0,
        0.7592566013336182
      ],
      "plane_d": 892.8458251953125,
      "bbox_min": [
        -2649.999755859375,
        -4619.837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2599.999755859375,
        -4609.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2649.999755859375,
        -4619.837890625,
        1082.623779296875
      ],
      "bbox_max": [
        -2634.999755859375,
        -4609.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9079594016075134,
        0.0,
        0.4190582036972046
      ],
      "plane_d": 1957.648193359375,
      "bbox_min": [
        -2750.0,
        -4919.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2649.999755859375,
        -4609.7685546875,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2699.999755859375,
      "bbox_min": [
        -2750.0,
        -4909.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4629.837890625,
        1102.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1072.623779296875,
      "bbox_min": [
        -2750.0,
        -4909.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4629.837890625,
        1102.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1102.623779296875,
      "bbox_min": [
        -2750.0,
        -4909.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4799.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 4244.33251953125,
      "bbox_min": [
        -2750.0,
        -4909.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4799.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4909.7685546875,
      "bbox_min": [
        -2750.0,
        -4909.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4799.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2750.0,
        -4909.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4799.7685546875,
        1102.623779296875
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2729.999755859375,
      "bbox_min": [
        -2746.999755859375,
        -4899.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4811.7685546875,
        1082.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4879.7685546875,
      "bbox_min": [
        -2714.999755859375,
        -4899.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4879.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4899.7685546875,
      "bbox_min": [
        -2714.999755859375,
        -4899.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4899.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4869.7685546875,
      "bbox_min": [
        -2729.999755859375,
        -4869.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4869.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1078.623779296875,
      "bbox_min": [
        -2746.999755859375,
        -4877.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4811.7685546875,
        1082.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2732.999755859375,
      "bbox_min": [
        -2732.999755859375,
        -4877.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4869.7685546875,
        1078.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4877.7685546875,
      "bbox_min": [
        -2732.999755859375,
        -4877.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4877.7685546875,
        1078.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2732.999755859375,
      "bbox_min": [
        -2732.999755859375,
        -4877.7685546875,
        1078.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4869.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4869.7685546875,
      "bbox_min": [
        -2732.999755859375,
        -4877.7685546875,
        1078.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4869.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4877.7685546875,
      "bbox_min": [
        -2732.999755859375,
        -4877.7685546875,
        1078.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4877.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2746.999755859375,
      "bbox_min": [
        -2746.999755859375,
        -4864.7685546875,
        1078.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4811.7685546875,
        1082.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 1796.8585205078125,
      "bbox_min": [
        -2746.999755859375,
        -4864.7685546875,
        1078.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4811.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2733.999755859375,
      "bbox_min": [
        -2742.999755859375,
        -4864.7685546875,
        1078.623779296875
      ],
      "bbox_max": [
        -2733.999755859375,
        -4857.2685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2742.999755859375,
      "bbox_min": [
        -2742.999755859375,
        -4864.7685546875,
        1078.623779296875
      ],
      "bbox_max": [
        -2742.999755859375,
        -4857.2685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2739.499755859375,
      "bbox_min": [
        -2746.999755859375,
        -4846.7685546875,
        1078.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4811.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -3570.71826171875,
      "bbox_min": [
        -2739.499755859375,
        -4819.2685546875,
        1078.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4813.2685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.800000011920929,
        0.0,
        0.6000000238418579
      ],
      "plane_d": 1546.425537109375,
      "bbox_min": [
        -2746.999755859375,
        -4846.7685546875,
        1078.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4811.7685546875,
        1082.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4831.7685546875,
      "bbox_min": [
        -2746.999755859375,
        -4846.7685546875,
        1078.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4816.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4816.7685546875,
      "bbox_min": [
        -2746.999755859375,
        -4826.7685546875,
        1078.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4816.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4826.7685546875,
      "bbox_min": [
        -2746.999755859375,
        -4826.7685546875,
        1078.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4826.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4841.7685546875,
      "bbox_min": [
        -2746.999755859375,
        -4846.7685546875,
        1078.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4841.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4846.7685546875,
      "bbox_min": [
        -2746.999755859375,
        -4846.7685546875,
        1078.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4846.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -2670.8447265625,
      "bbox_min": [
        -2750.0,
        -4909.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4799.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2729.999755859375,
      "bbox_min": [
        -2749.999755859375,
        -4869.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4799.7685546875,
        1097.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -2749.999755859375,
        -4869.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4799.7685546875,
        1097.623779296875
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.40613850951194763,
        -0.0,
        -0.9138116240501404
      ],
      "plane_d": -113.35174560546875,
      "bbox_min": [
        -2746.999755859375,
        -4864.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4799.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4809.7685546875,
      "bbox_min": [
        -2746.999755859375,
        -4864.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4799.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1094.623779296875,
      "bbox_min": [
        -2741.999755859375,
        -4864.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4811.7685546875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4856.7685546875,
      "bbox_min": [
        -2741.999755859375,
        -4864.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4811.7685546875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4811.7685546875,
      "bbox_min": [
        -2741.999755859375,
        -4811.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4811.7685546875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4864.7685546875,
      "bbox_min": [
        -2741.999755859375,
        -4864.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4864.7685546875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2746.999755859375,
      "bbox_min": [
        -2746.999755859375,
        -4809.7685546875,
        1096.845947265625
      ],
      "bbox_max": [
        -2746.999755859375,
        -4799.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3713906705379486,
        0.0,
        -0.9284766912460327
      ],
      "plane_d": 2034.685791015625,
      "bbox_min": [
        -2746.999755859375,
        -4864.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2737.499755859375,
        -4799.7685546875,
        1096.845947265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2746.999755859375,
      "bbox_min": [
        -2746.999755859375,
        -4809.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4799.7685546875,
        1096.845947265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4799.7685546875,
      "bbox_min": [
        -2746.999755859375,
        -4809.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4799.7685546875,
        1096.845947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4809.7685546875,
      "bbox_min": [
        -2746.999755859375,
        -4809.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4809.7685546875,
        1096.845947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4799.7685546875,
      "bbox_min": [
        -2746.999755859375,
        -4864.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2737.499755859375,
        -4799.7685546875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4811.7685546875,
      "bbox_min": [
        -2746.999755859375,
        -4864.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2737.499755859375,
        -4809.7685546875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4809.7685546875,
      "bbox_min": [
        -2746.999755859375,
        -4809.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2737.499755859375,
        -4809.7685546875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4864.7685546875,
      "bbox_min": [
        -2746.999755859375,
        -4864.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2737.499755859375,
        -4864.7685546875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2731.499755859375,
      "bbox_min": [
        -2749.999755859375,
        -4811.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2731.499755859375,
        -4799.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4809.7685546875,
      "bbox_min": [
        -2749.999755859375,
        -4811.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2738.499755859375,
        -4799.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2738.499755859375,
      "bbox_min": [
        -2738.499755859375,
        -4811.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2738.499755859375,
        -4809.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4801.7685546875,
      "bbox_min": [
        -2749.999755859375,
        -4809.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2746.999755859375,
        -4799.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2746.999755859375,
      "bbox_min": [
        -2746.999755859375,
        -4801.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2746.999755859375,
        -4799.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4807.7685546875,
      "bbox_min": [
        -2749.999755859375,
        -4809.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2746.999755859375,
        -4807.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2746.999755859375,
      "bbox_min": [
        -2746.999755859375,
        -4809.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2746.999755859375,
        -4807.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2746.999755859375,
      "bbox_min": [
        -2749.999755859375,
        -4869.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4811.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4831.7685546875,
      "bbox_min": [
        -2749.999755859375,
        -4856.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2746.999755859375,
        -4816.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4816.7685546875,
      "bbox_min": [
        -2749.999755859375,
        -4826.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2746.999755859375,
        -4816.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4826.7685546875,
      "bbox_min": [
        -2749.999755859375,
        -4826.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2746.999755859375,
        -4826.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4846.7685546875,
      "bbox_min": [
        -2749.999755859375,
        -4856.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2746.999755859375,
        -4841.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4841.7685546875,
      "bbox_min": [
        -2749.999755859375,
        -4841.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2746.999755859375,
        -4841.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4856.7685546875,
      "bbox_min": [
        -2749.999755859375,
        -4856.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2746.999755859375,
        -4856.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4846.7685546875,
      "bbox_min": [
        -2746.999755859375,
        -4869.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4811.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805806875228882,
        0.0,
        0.1961161345243454
      ],
      "plane_d": 2479.373779296875,
      "bbox_min": [
        -2746.999755859375,
        -4846.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4811.7685546875,
        1092.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4831.7685546875,
      "bbox_min": [
        -2746.999755859375,
        -4841.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2744.999755859375,
        -4816.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4816.7685546875,
      "bbox_min": [
        -2746.999755859375,
        -4826.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2744.999755859375,
        -4816.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4826.7685546875,
      "bbox_min": [
        -2746.999755859375,
        -4826.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2744.999755859375,
        -4826.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4841.7685546875,
      "bbox_min": [
        -2746.999755859375,
        -4841.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2744.999755859375,
        -4841.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2738.499755859375,
      "bbox_min": [
        -2739.499755859375,
        -4813.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4811.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -2739.499755859375,
      "bbox_min": [
        -2739.499755859375,
        -4813.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2738.499755859375,
        -4811.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4813.2685546875,
      "bbox_min": [
        -2739.499755859375,
        -4813.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2738.499755859375,
        -4811.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": -4792.4130859375,
      "bbox_min": [
        -2739.499755859375,
        -4813.2685546875,
        1089.623779296875
      ],
      "bbox_max": [
        -2738.499755859375,
        -4811.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -2731.499755859375,
      "bbox_min": [
        -2731.499755859375,
        -4813.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4811.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4813.2685546875,
      "bbox_min": [
        -2731.499755859375,
        -4813.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4811.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": -4792.4130859375,
      "bbox_min": [
        -2731.499755859375,
        -4813.2685546875,
        1089.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4811.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2741.999755859375,
      "bbox_min": [
        -2746.999755859375,
        -4869.7685546875,
        1086.1239013671875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4863.2685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2742.999755859375,
      "bbox_min": [
        -2742.999755859375,
        -4864.7685546875,
        1086.1239013671875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4863.2685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4863.2685546875,
      "bbox_min": [
        -2742.999755859375,
        -4864.7685546875,
        1086.1239013671875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4863.2685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 3862.545654296875,
      "bbox_min": [
        -2742.999755859375,
        -4864.7685546875,
        1089.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4863.2685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4864.7685546875,
      "bbox_min": [
        -2734.999755859375,
        -4869.7685546875,
        1086.1239013671875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4863.2685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2734.999755859375,
      "bbox_min": [
        -2734.999755859375,
        -4869.7685546875,
        1087.6239013671875
      ],
      "bbox_max": [
        -2734.999755859375,
        -4864.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4863.2685546875,
      "bbox_min": [
        -2734.999755859375,
        -4864.7685546875,
        1086.1239013671875
      ],
      "bbox_max": [
        -2733.999755859375,
        -4863.2685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 3862.545654296875,
      "bbox_min": [
        -2734.999755859375,
        -4864.7685546875,
        1089.623779296875
      ],
      "bbox_max": [
        -2733.999755859375,
        -4863.2685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4869.7685546875,
      "bbox_min": [
        -2750.0,
        -4909.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4859.76806640625,
        1102.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2741.999755859375,
      "bbox_min": [
        -2746.999755859375,
        -4869.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4859.76806640625,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4864.7685546875,
      "bbox_min": [
        -2746.999755859375,
        -4864.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4863.2685546875,
        1087.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2742.999755859375,
      "bbox_min": [
        -2742.999755859375,
        -4864.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4863.2685546875,
        1087.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4863.2685546875,
      "bbox_min": [
        -2742.999755859375,
        -4863.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4863.2685546875,
        1086.1239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2734.999755859375,
      "bbox_min": [
        -2734.999755859375,
        -4869.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4859.76806640625,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4864.7685546875,
      "bbox_min": [
        -2734.999755859375,
        -4864.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4863.2685546875,
        1087.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2733.999755859375,
      "bbox_min": [
        -2734.999755859375,
        -4864.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2733.999755859375,
        -4863.2685546875,
        1087.6239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4863.2685546875,
      "bbox_min": [
        -2734.999755859375,
        -4863.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2733.999755859375,
        -4863.2685546875,
        1086.1239013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -2734.99951171875,
      "bbox_min": [
        -2750.0,
        -4909.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4869.7685546875,
        1102.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2721.999755859375,
      "bbox_min": [
        -2734.999755859375,
        -4909.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4869.7685546875,
        1102.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2731.999755859375,
      "bbox_min": [
        -2734.999755859375,
        -4909.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2721.999755859375,
        -4869.7685546875,
        1102.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1097.623779296875,
      "bbox_min": [
        -2734.999755859375,
        -4899.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2731.999755859375,
        -4869.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4899.7685546875,
      "bbox_min": [
        -2734.999755859375,
        -4899.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2731.999755859375,
        -4869.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -2877.575927734375,
      "bbox_min": [
        -2734.999755859375,
        -4899.7685546875,
        1085.123779296875
      ],
      "bbox_max": [
        -2731.999755859375,
        -4869.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2732.999755859375,
      "bbox_min": [
        -2734.999755859375,
        -4879.7685546875,
        1085.123779296875
      ],
      "bbox_max": [
        -2731.999755859375,
        -4869.7685546875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1085.123779296875,
      "bbox_min": [
        -2734.999755859375,
        -4879.7685546875,
        1085.123779296875
      ],
      "bbox_max": [
        -2732.999755859375,
        -4869.7685546875,
        1086.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1086.623779296875,
      "bbox_min": [
        -2734.999755859375,
        -4879.7685546875,
        1085.123779296875
      ],
      "bbox_max": [
        -2732.999755859375,
        -4869.7685546875,
        1086.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6396021246910095,
        -0.6396021246910095,
        0.42640140652656555
      ],
      "plane_d": -5331.8408203125,
      "bbox_min": [
        -2734.999755859375,
        -4879.7685546875,
        1085.123779296875
      ],
      "bbox_max": [
        -2732.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1085.123779296875,
      "bbox_min": [
        -2732.999755859375,
        -4879.7685546875,
        1085.123779296875
      ],
      "bbox_max": [
        -2731.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": -4662.13134765625,
      "bbox_min": [
        -2732.999755859375,
        -4879.7685546875,
        1085.123779296875
      ],
      "bbox_max": [
        -2731.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4877.7685546875,
      "bbox_min": [
        -2732.999755859375,
        -4878.7685546875,
        1085.123779296875
      ],
      "bbox_max": [
        -2731.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1086.623779296875,
      "bbox_min": [
        -2732.999755859375,
        -4878.7685546875,
        1086.623779296875
      ],
      "bbox_max": [
        -2731.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -2674.38037109375,
      "bbox_min": [
        -2734.999755859375,
        -4899.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2731.999755859375,
        -4869.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -2734.999755859375,
        -4874.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2731.999755859375,
        -4869.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 4237.26171875,
      "bbox_min": [
        -2734.999755859375,
        -4899.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2731.999755859375,
        -4894.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -2724.99951171875,
      "bbox_min": [
        -2731.999755859375,
        -4909.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2721.999755859375,
        -4869.7685546875,
        1102.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1097.623779296875,
      "bbox_min": [
        -2724.999755859375,
        -4899.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2721.999755859375,
        -4869.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4899.7685546875,
      "bbox_min": [
        -2724.999755859375,
        -4899.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2721.999755859375,
        -4869.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -2674.38037109375,
      "bbox_min": [
        -2724.999755859375,
        -4899.7685546875,
        1085.123779296875
      ],
      "bbox_max": [
        -2721.999755859375,
        -4869.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -2724.999755859375,
        -4874.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2721.999755859375,
        -4869.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 4237.26171875,
      "bbox_min": [
        -2724.999755859375,
        -4899.7685546875,
        1085.123779296875
      ],
      "bbox_max": [
        -2721.999755859375,
        -4877.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1085.123779296875,
      "bbox_min": [
        -2724.999755859375,
        -4879.7685546875,
        1085.123779296875
      ],
      "bbox_max": [
        -2721.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": -4662.13134765625,
      "bbox_min": [
        -2724.999755859375,
        -4879.7685546875,
        1085.123779296875
      ],
      "bbox_max": [
        -2721.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4877.7685546875,
      "bbox_min": [
        -2724.999755859375,
        -4878.7685546875,
        1085.123779296875
      ],
      "bbox_max": [
        -2721.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1086.623779296875,
      "bbox_min": [
        -2724.999755859375,
        -4878.7685546875,
        1086.623779296875
      ],
      "bbox_max": [
        -2721.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1085.123779296875,
      "bbox_min": [
        -2731.999755859375,
        -4879.7685546875,
        1085.123779296875
      ],
      "bbox_max": [
        -2724.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": -4662.13134765625,
      "bbox_min": [
        -2731.999755859375,
        -4879.7685546875,
        1085.123779296875
      ],
      "bbox_max": [
        -2724.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4877.7685546875,
      "bbox_min": [
        -2731.999755859375,
        -4878.7685546875,
        1085.123779296875
      ],
      "bbox_max": [
        -2724.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1086.623779296875,
      "bbox_min": [
        -2731.999755859375,
        -4878.7685546875,
        1086.623779296875
      ],
      "bbox_max": [
        -2724.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": -4662.13134765625,
      "bbox_min": [
        -2721.999755859375,
        -4909.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4869.7685546875,
        1102.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4877.7685546875,
      "bbox_min": [
        -2721.999755859375,
        -4879.7685546875,
        1085.123779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4869.7685546875,
        1095.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1085.123779296875,
      "bbox_min": [
        -2721.999755859375,
        -4879.7685546875,
        1085.123779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1086.623779296875,
      "bbox_min": [
        -2721.999755859375,
        -4878.7685546875,
        1086.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4877.7685546875,
        1086.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -2714.999755859375,
        -4874.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2711.999755859375,
        -4869.7685546875,
        1095.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 2711.99951171875,
      "bbox_min": [
        -2714.999755859375,
        -4874.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2711.999755859375,
        -4869.7685546875,
        1095.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -2714.99951171875,
      "bbox_min": [
        -2714.999755859375,
        -4874.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2714.999755859375,
        -4869.7685546875,
        1095.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -2714.99951171875,
      "bbox_min": [
        -2714.999755859375,
        -4909.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2711.999755859375,
        -4872.7685546875,
        1102.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2711.999755859375,
      "bbox_min": [
        -2714.999755859375,
        -4909.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2711.999755859375,
        -4872.7685546875,
        1102.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4899.7685546875,
      "bbox_min": [
        -2714.999755859375,
        -4899.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2711.999755859375,
        -4874.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -2674.38037109375,
      "bbox_min": [
        -2714.999755859375,
        -4899.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2711.999755859375,
        -4874.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 4237.26171875,
      "bbox_min": [
        -2714.999755859375,
        -4899.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2711.999755859375,
        -4894.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -2744.99951171875,
      "bbox_min": [
        -2750.0,
        -4909.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4869.7685546875,
        1102.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2741.999755859375,
      "bbox_min": [
        -2744.999755859375,
        -4909.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4869.7685546875,
        1102.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1097.623779296875,
      "bbox_min": [
        -2744.999755859375,
        -4899.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4869.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4899.7685546875,
      "bbox_min": [
        -2744.999755859375,
        -4899.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4869.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -2674.38037109375,
      "bbox_min": [
        -2744.999755859375,
        -4899.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4869.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -2744.999755859375,
        -4874.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4869.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 4237.26171875,
      "bbox_min": [
        -2744.999755859375,
        -4899.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2741.999755859375,
        -4894.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2749.39990234375,
      "bbox_min": [
        -2750.0,
        -4888.0,
        1086.0
      ],
      "bbox_max": [
        -2749.39990234375,
        -4885.0,
        1088.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1088.0030517578125,
      "bbox_min": [
        -2750.0,
        -4888.0,
        1086.0
      ],
      "bbox_max": [
        -2749.39990234375,
        -4885.0,
        1088.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4888.0,
      "bbox_min": [
        -2750.0,
        -4888.0,
        1086.0
      ],
      "bbox_max": [
        -2749.39990234375,
        -4885.0,
        1088.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4885.0,
      "bbox_min": [
        -2750.0,
        -4885.0,
        1086.0
      ],
      "bbox_max": [
        -2749.39990234375,
        -4885.0,
        1088.0030517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4909.7685546875,
      "bbox_min": [
        -2749.999755859375,
        -4909.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4629.837890625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        9.765624781721272e-06,
        -1.0,
        0.0
      ],
      "plane_d": -4629.8115234375,
      "bbox_min": [
        -2749.999755859375,
        -4894.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4629.837890625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.79471755027771,
        0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -418.2768249511719,
      "bbox_min": [
        -2739.999755859375,
        -4894.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9176645874977112,
        0.39735594391822815
      ],
      "plane_d": -4789.49609375,
      "bbox_min": [
        -2739.999755859375,
        -4894.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4715.4384765625,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9176645874977112,
        0.39735594391822815
      ],
      "plane_d": 3937.0693359375,
      "bbox_min": [
        -2739.999755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4715.4384765625,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7947176098823547,
        -0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": -4765.5322265625,
      "bbox_min": [
        -2739.999755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4750.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.79471755027771,
        0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -402.2177429199219,
      "bbox_min": [
        -2719.999755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4750.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7947176098823547,
        0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": 3913.098876953125,
      "bbox_min": [
        -2719.999755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4750.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.79471755027771,
        -0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -450.2153015136719,
      "bbox_min": [
        -2719.999755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4750.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4759.0986328125,
      "bbox_min": [
        -2719.999755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4750.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4750.4384765625,
      "bbox_min": [
        -2719.999755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4750.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4732.986328125,
      "bbox_min": [
        -2719.999755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4750.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 21.822021484375,
      "bbox_min": [
        -2719.999755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4750.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -30.482177734375,
      "bbox_min": [
        -2712.499755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4750.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4724.326171875,
      "bbox_min": [
        -2712.499755859375,
        -4754.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4750.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7947176098823547,
        0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": 3928.992919921875,
      "bbox_min": [
        -2739.999755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4750.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.79471755027771,
        -0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -434.3210144042969,
      "bbox_min": [
        -2739.999755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4750.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947176098823547,
        -0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": -4781.42578125,
      "bbox_min": [
        -2739.999755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4750.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.79471755027771,
        0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -418.1120300292969,
      "bbox_min": [
        -2739.999755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4750.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4759.0986328125,
      "bbox_min": [
        -2739.999755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4750.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4750.4384765625,
      "bbox_min": [
        -2739.999755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4750.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -4750.30712890625,
      "bbox_min": [
        -2739.999755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4750.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -13.16162109375,
      "bbox_min": [
        -2739.999755859375,
        -4759.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4750.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4.50146484375,
      "bbox_min": [
        -2739.999755859375,
        -4754.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4750.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        -0.0
      ],
      "plane_d": 4741.64697265625,
      "bbox_min": [
        -2732.499755859375,
        -4754.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4750.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947176098823547,
        -0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": -4749.47265625,
      "bbox_min": [
        -2719.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4715.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9176645874977112,
        0.39735594391822815
      ],
      "plane_d": 3904.951171875,
      "bbox_min": [
        -2719.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4715.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7947176098823547,
        0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": 3897.039306640625,
      "bbox_min": [
        -2719.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4715.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.79471755027771,
        -0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -434.1562194824219,
      "bbox_min": [
        -2719.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4715.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9176645874977112,
        0.39735594391822815
      ],
      "plane_d": -4757.3779296875,
      "bbox_min": [
        -2719.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4715.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4724.0986328125,
      "bbox_min": [
        -2719.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4715.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4715.4384765625,
      "bbox_min": [
        -2719.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4715.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4715.486328125,
      "bbox_min": [
        -2719.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4715.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -12.982177734375,
      "bbox_min": [
        -2719.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4715.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4706.826171875,
      "bbox_min": [
        -2719.999755859375,
        -4719.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4715.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4.322021484375,
      "bbox_min": [
        -2719.999755859375,
        -4719.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2717.499755859375,
        -4715.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.79471755027771,
        0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -383.8642272949219,
      "bbox_min": [
        -2739.999755859375,
        -4894.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4790.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947176098823547,
        -0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": -4783.884765625,
      "bbox_min": [
        -2719.999755859375,
        -4894.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4790.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9176645874977112,
        0.39735594391822815
      ],
      "plane_d": -4826.20263671875,
      "bbox_min": [
        -2719.999755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4790.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9176645874977112,
        0.39735594391822815
      ],
      "plane_d": 3973.77587890625,
      "bbox_min": [
        -2719.999755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4790.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7947176098823547,
        0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": 3931.452392578125,
      "bbox_min": [
        -2719.999755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4790.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.79471755027771,
        -0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -468.5688171386719,
      "bbox_min": [
        -2719.999755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4790.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4799.0986328125,
      "bbox_min": [
        -2719.999755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4790.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4790.4384765625,
      "bbox_min": [
        -2719.999755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4790.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 41.822265625,
      "bbox_min": [
        -2719.999755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4790.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -4752.98681640625,
      "bbox_min": [
        -2719.999755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4790.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        -0.0
      ],
      "plane_d": 4744.32666015625,
      "bbox_min": [
        -2712.499755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4790.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -50.482421875,
      "bbox_min": [
        -2712.499755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4794.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2716.2998046875,
      "bbox_min": [
        -2716.2998046875,
        -4894.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2715.2998046875,
        -4891.568359375,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805669188499451,
        0.0,
        0.19618520140647888
      ],
      "plane_d": -2870.8076171875,
      "bbox_min": [
        -2716.2998046875,
        -4894.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2715.2998046875,
        -4891.568359375,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1056.623779296875,
      "bbox_min": [
        -2716.2998046875,
        -4894.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2715.2998046875,
        -4891.568359375,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805898666381836,
        0.0,
        -0.1960700899362564
      ],
      "plane_d": 2870.159912109375,
      "bbox_min": [
        -2716.2998046875,
        -4894.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -2715.2998046875,
        -4891.568359375,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1058.623779296875,
      "bbox_min": [
        -2716.2998046875,
        -4894.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -2715.2998046875,
        -4891.568359375,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4891.568359375,
      "bbox_min": [
        -2716.2998046875,
        -4894.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -2715.2998046875,
        -4891.568359375,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4894.7685546875,
      "bbox_min": [
        -2716.2998046875,
        -4894.7685546875,
        1056.623779296875
      ],
      "bbox_max": [
        -2715.2998046875,
        -4894.7685546875,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2715.69970703125,
      "bbox_min": [
        -2716.2998046875,
        -4894.16845703125,
        1052.623779296875
      ],
      "bbox_max": [
        -2715.69970703125,
        -4892.16845703125,
        1056.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4894.16845703125,
      "bbox_min": [
        -2716.2998046875,
        -4894.16845703125,
        1052.623779296875
      ],
      "bbox_max": [
        -2715.69970703125,
        -4892.16845703125,
        1056.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4892.16845703125,
      "bbox_min": [
        -2716.2998046875,
        -4892.16845703125,
        1052.623779296875
      ],
      "bbox_max": [
        -2715.69970703125,
        -4892.16845703125,
        1056.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9176645874977112,
        0.39735594391822815
      ],
      "plane_d": -4826.20263671875,
      "bbox_min": [
        -2739.999755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4790.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947176098823547,
        -0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": -4799.779296875,
      "bbox_min": [
        -2739.999755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4790.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.79471755027771,
        0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -399.7585144042969,
      "bbox_min": [
        -2739.999755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4790.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7947176098823547,
        0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": 3947.346435546875,
      "bbox_min": [
        -2739.999755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4790.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.79471755027771,
        -0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -452.6745300292969,
      "bbox_min": [
        -2739.999755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4790.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9176645874977112,
        0.39735594391822815
      ],
      "plane_d": 3973.77587890625,
      "bbox_min": [
        -2739.999755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4790.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4799.0986328125,
      "bbox_min": [
        -2739.999755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4790.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4790.4384765625,
      "bbox_min": [
        -2739.999755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4790.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 24.501708984375,
      "bbox_min": [
        -2739.999755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4790.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4770.3076171875,
      "bbox_min": [
        -2739.999755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4790.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4761.6474609375,
      "bbox_min": [
        -2732.499755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4790.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -33.161865234375,
      "bbox_min": [
        -2732.499755859375,
        -4799.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4794.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9176645874977112,
        0.39735594391822815
      ],
      "plane_d": 3872.8330078125,
      "bbox_min": [
        -2739.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9176645874977112,
        0.39735594391822815
      ],
      "plane_d": -4725.25927734375,
      "bbox_min": [
        -2739.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4680.4384765625,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7947176098823547,
        -0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": -4733.4130859375,
      "bbox_min": [
        -2739.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4680.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.79471755027771,
        0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -434.3361511230469,
      "bbox_min": [
        -2719.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4680.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7947176098823547,
        0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": 3880.980224609375,
      "bbox_min": [
        -2719.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4680.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.79471755027771,
        -0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -418.0968933105469,
      "bbox_min": [
        -2719.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4680.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4680.4384765625,
      "bbox_min": [
        -2719.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4680.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4689.0986328125,
      "bbox_min": [
        -2719.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4680.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -13.17822265625,
      "bbox_min": [
        -2719.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4680.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        -0.0
      ],
      "plane_d": 4689.326171875,
      "bbox_min": [
        -2719.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4680.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 4.51806640625,
      "bbox_min": [
        -2719.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4684.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -4697.986328125,
      "bbox_min": [
        -2719.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2717.499755859375,
        -4684.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7947176098823547,
        0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": 3896.874267578125,
      "bbox_min": [
        -2739.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4680.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.79471755027771,
        -0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -402.2026062011719,
      "bbox_min": [
        -2739.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4680.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947176098823547,
        -0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": -4749.3076171875,
      "bbox_min": [
        -2739.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4680.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.79471755027771,
        0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -450.2304382324219,
      "bbox_min": [
        -2739.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4680.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4680.4384765625,
      "bbox_min": [
        -2739.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4680.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4689.0986328125,
      "bbox_min": [
        -2739.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4680.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4706.646484375,
      "bbox_min": [
        -2739.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4680.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -30.498779296875,
      "bbox_min": [
        -2739.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4680.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4715.306640625,
      "bbox_min": [
        -2739.999755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4684.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 21.838623046875,
      "bbox_min": [
        -2732.499755859375,
        -4689.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4684.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7947176098823547,
        0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": 3912.933837890625,
      "bbox_min": [
        -2739.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4715.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.79471755027771,
        -0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -418.2619323730469,
      "bbox_min": [
        -2739.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4715.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9176645874977112,
        0.39735594391822815
      ],
      "plane_d": -4757.3779296875,
      "bbox_min": [
        -2739.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4715.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947176098823547,
        -0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": -4765.3671875,
      "bbox_min": [
        -2739.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4715.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.79471755027771,
        0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -434.1711120605469,
      "bbox_min": [
        -2739.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4715.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9176645874977112,
        0.39735594391822815
      ],
      "plane_d": 3904.951171875,
      "bbox_min": [
        -2739.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4715.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4724.0986328125,
      "bbox_min": [
        -2739.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4715.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4715.4384765625,
      "bbox_min": [
        -2739.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4715.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 4.33837890625,
      "bbox_min": [
        -2739.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4715.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -4732.80712890625,
      "bbox_min": [
        -2739.999755859375,
        -4724.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4715.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -12.99853515625,
      "bbox_min": [
        -2739.999755859375,
        -4719.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4715.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        -0.0
      ],
      "plane_d": 4724.14697265625,
      "bbox_min": [
        -2732.499755859375,
        -4719.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4715.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947176098823547,
        -0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": -4715.0595703125,
      "bbox_min": [
        -2739.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.79471755027771,
        0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -452.6896667480469,
      "bbox_min": [
        -2719.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9176645874977112,
        0.39735594391822815
      ],
      "plane_d": 3836.12646484375,
      "bbox_min": [
        -2719.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7947176098823547,
        0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": 3862.626708984375,
      "bbox_min": [
        -2719.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.79471755027771,
        -0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -399.7433776855469,
      "bbox_min": [
        -2719.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9176645874977112,
        0.39735594391822815
      ],
      "plane_d": -4688.552734375,
      "bbox_min": [
        -2719.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4649.0986328125,
      "bbox_min": [
        -2719.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4640.4384765625,
      "bbox_min": [
        -2719.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4677.986328125,
      "bbox_min": [
        -2719.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 24.51806640625,
      "bbox_min": [
        -2719.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4669.326171875,
      "bbox_min": [
        -2719.999755859375,
        -4644.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2709.999755859375,
        -4640.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -33.178466796875,
      "bbox_min": [
        -2719.999755859375,
        -4644.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2717.499755859375,
        -4640.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7947176098823547,
        0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": 3878.520751953125,
      "bbox_min": [
        -2739.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4640.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.79471755027771,
        -0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -383.8490905761719,
      "bbox_min": [
        -2739.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4640.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9176645874977112,
        0.39735594391822815
      ],
      "plane_d": -4688.552734375,
      "bbox_min": [
        -2739.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4640.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947176098823547,
        -0.45883557200431824,
        0.39735880494117737
      ],
      "plane_d": -4730.9541015625,
      "bbox_min": [
        -2739.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4640.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.79471755027771,
        0.45883554220199585,
        0.397358775138855
      ],
      "plane_d": -468.5839538574219,
      "bbox_min": [
        -2739.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4640.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9176645874977112,
        0.39735594391822815
      ],
      "plane_d": 3836.12646484375,
      "bbox_min": [
        -2739.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4640.4384765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4649.0986328125,
      "bbox_min": [
        -2739.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4640.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4640.4384765625,
      "bbox_min": [
        -2739.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4640.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 41.838623046875,
      "bbox_min": [
        -2739.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4640.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": -4695.306640625,
      "bbox_min": [
        -2739.999755859375,
        -4649.0986328125,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4640.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -50.498779296875,
      "bbox_min": [
        -2739.999755859375,
        -4644.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4640.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        -0.0
      ],
      "plane_d": 4686.646484375,
      "bbox_min": [
        -2732.499755859375,
        -4644.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2729.999755859375,
        -4640.4384765625,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8000000715255737,
        -0.0,
        0.6000000238418579
      ],
      "plane_d": 1470.42578125,
      "bbox_min": [
        -2664.999755859375,
        -4919.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2649.999755859375,
        -4609.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2839.999755859375,
      "bbox_min": [
        -2920.0,
        -4919.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4609.7685546875,
        1231.90625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2799.999755859375,
      "bbox_min": [
        -2839.999755859375,
        -4919.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4609.7685546875,
        1231.90625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8064050674438477,
        0.5913636684417725
      ],
      "plane_d": 3077.1162109375,
      "bbox_min": [
        -2839.999755859375,
        -4919.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4609.7685546875,
        1231.90625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4869.7685546875,
      "bbox_min": [
        -2839.999755859375,
        -4919.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4869.7685546875,
        1231.90625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4909.7685546875,
      "bbox_min": [
        -2839.999755859375,
        -4919.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4909.7685546875,
        1082.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        0.0,
        0.44721364974975586
      ],
      "plane_d": -3010.921142578125,
      "bbox_min": [
        -2839.999755859375,
        -4919.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4909.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2824.999755859375,
        -4919.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4909.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4909.7685546875,
      "bbox_min": [
        -2799.999755859375,
        -4919.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4609.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2799.999755859375,
        -4919.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4909.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4629.7685546875,
      "bbox_min": [
        -2799.999755859375,
        -4819.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4629.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4819.7685546875,
      "bbox_min": [
        -2799.999755859375,
        -4819.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4629.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -47.639404296875,
      "bbox_min": [
        -2789.999755859375,
        -4799.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4640.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4759.0986328125,
      "bbox_min": [
        -2789.999755859375,
        -4799.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4715.4384765625,
        1082.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4796.2880859375,
      "bbox_min": [
        -2789.999755859375,
        -4799.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4790.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4799.0986328125,
      "bbox_min": [
        -2789.999755859375,
        -4799.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4790.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4790.4384765625,
      "bbox_min": [
        -2789.999755859375,
        -4799.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4790.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -10.13916015625,
      "bbox_min": [
        -2789.999755859375,
        -4799.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4790.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4813.6083984375,
      "bbox_min": [
        -2789.999755859375,
        -4799.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4790.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 18.79931640625,
      "bbox_min": [
        -2789.999755859375,
        -4794.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4790.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4804.9482421875,
      "bbox_min": [
        -2782.499755859375,
        -4794.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4790.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4799.0986328125,
      "bbox_min": [
        -2769.999755859375,
        -4799.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4790.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4790.4384765625,
      "bbox_min": [
        -2769.999755859375,
        -4799.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4790.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 7.18115234375,
      "bbox_min": [
        -2769.999755859375,
        -4799.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4790.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4787.6279296875,
      "bbox_min": [
        -2769.999755859375,
        -4794.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4790.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 1.47900390625,
      "bbox_min": [
        -2769.999755859375,
        -4794.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2767.499755859375,
        -4790.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4750.4384765625,
      "bbox_min": [
        -2789.999755859375,
        -4759.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4715.4384765625,
        1082.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4724.0986328125,
      "bbox_min": [
        -2769.999755859375,
        -4724.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4715.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4715.4384765625,
      "bbox_min": [
        -2769.999755859375,
        -4724.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4715.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -30.319091796875,
      "bbox_min": [
        -2769.999755859375,
        -4724.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4715.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4758.7880859375,
      "bbox_min": [
        -2769.999755859375,
        -4724.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4715.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 38.979248046875,
      "bbox_min": [
        -2769.999755859375,
        -4719.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4715.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4750.1279296875,
      "bbox_min": [
        -2762.499755859375,
        -4719.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4715.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -30.139404296875,
      "bbox_min": [
        -2789.999755859375,
        -4759.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4750.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4776.2880859375,
      "bbox_min": [
        -2769.999755859375,
        -4759.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4750.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -12.819091796875,
      "bbox_min": [
        -2769.999755859375,
        -4759.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4750.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4767.6279296875,
      "bbox_min": [
        -2769.999755859375,
        -4754.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4750.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 21.479248046875,
      "bbox_min": [
        -2769.999755859375,
        -4754.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2767.499755859375,
        -4750.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4793.6083984375,
      "bbox_min": [
        -2789.999755859375,
        -4759.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4750.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 38.799560546875,
      "bbox_min": [
        -2789.999755859375,
        -4754.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4750.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4784.9482421875,
      "bbox_min": [
        -2782.499755859375,
        -4754.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4750.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4680.4384765625,
      "bbox_min": [
        -2789.999755859375,
        -4724.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4640.4384765625,
        1082.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4729.947265625,
      "bbox_min": [
        -2789.999755859375,
        -4649.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4640.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4649.0986328125,
      "bbox_min": [
        -2769.999755859375,
        -4649.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4640.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4640.4384765625,
      "bbox_min": [
        -2769.999755859375,
        -4649.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4640.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 76.4794921875,
      "bbox_min": [
        -2769.999755859375,
        -4649.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4640.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4712.626953125,
      "bbox_min": [
        -2769.999755859375,
        -4649.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4640.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -67.8193359375,
      "bbox_min": [
        -2769.999755859375,
        -4649.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4644.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4721.28759765625,
      "bbox_min": [
        -2769.999755859375,
        -4649.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2767.499755859375,
        -4644.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4649.0986328125,
      "bbox_min": [
        -2789.999755859375,
        -4649.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4640.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4640.4384765625,
      "bbox_min": [
        -2789.999755859375,
        -4649.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4640.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 93.7998046875,
      "bbox_min": [
        -2789.999755859375,
        -4649.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4640.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4738.60791015625,
      "bbox_min": [
        -2789.999755859375,
        -4649.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4644.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -85.1396484375,
      "bbox_min": [
        -2782.499755859375,
        -4649.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4644.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4689.0986328125,
      "bbox_min": [
        -2789.999755859375,
        -4724.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4680.4384765625,
        1082.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4724.0986328125,
      "bbox_min": [
        -2789.999755859375,
        -4724.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4715.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4715.4384765625,
      "bbox_min": [
        -2789.999755859375,
        -4724.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4715.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4776.1083984375,
      "bbox_min": [
        -2789.999755859375,
        -4724.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4715.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4767.4482421875,
      "bbox_min": [
        -2789.999755859375,
        -4719.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4715.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 56.299560546875,
      "bbox_min": [
        -2789.999755859375,
        -4719.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2787.499755859375,
        -4715.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -65.1396484375,
      "bbox_min": [
        -2789.999755859375,
        -4689.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4680.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4741.28759765625,
      "bbox_min": [
        -2769.999755859375,
        -4689.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4680.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": -47.8193359375,
      "bbox_min": [
        -2769.999755859375,
        -4689.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4680.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4732.62744140625,
      "bbox_min": [
        -2769.999755859375,
        -4684.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4680.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 56.4794921875,
      "bbox_min": [
        -2769.999755859375,
        -4684.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2767.499755859375,
        -4680.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.500004231929779,
        0.0
      ],
      "plane_d": 4758.60791015625,
      "bbox_min": [
        -2789.999755859375,
        -4689.0986328125,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4680.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 73.7998046875,
      "bbox_min": [
        -2789.999755859375,
        -4684.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4680.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660230040550232,
        -0.500004231929779,
        -0.0
      ],
      "plane_d": -4749.94775390625,
      "bbox_min": [
        -2782.499755859375,
        -4684.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2779.999755859375,
        -4680.4384765625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4631.7685546875,
      "bbox_min": [
        -2799.999755859375,
        -4631.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4629.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4629.7685546875,
      "bbox_min": [
        -2799.999755859375,
        -4631.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4629.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7808688282966614,
        0.6246950626373291
      ],
      "plane_d": 2934.2470703125,
      "bbox_min": [
        -2799.999755859375,
        -4631.7685546875,
        1090.123779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4629.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2879.999755859375,
      "bbox_min": [
        -2920.0,
        -4919.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4609.7685546875,
        1228.0782470703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9607518315315247,
        0.0,
        0.27740928530693054
      ],
      "plane_d": 2447.21630859375,
      "bbox_min": [
        -2920.0,
        -4919.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4609.7685546875,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4850.7685546875,
      "bbox_min": [
        -2920.0,
        -4856.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4609.7685546875,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968532919883728,
        0.07926793396472931
      ],
      "plane_d": 4744.13818359375,
      "bbox_min": [
        -2920.0,
        -4856.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4850.7685546875,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4811.14599609375,
      "bbox_min": [
        -2920.0,
        -4856.7685546875,
        1179.3675537109375
      ],
      "bbox_max": [
        -2901.78662109375,
        -4852.89501953125,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": -4629.76806640625,
      "bbox_min": [
        -2920.0,
        -4850.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4609.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": 2096.258544921875,
      "bbox_min": [
        -2899.999755859375,
        -4629.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4609.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10610295832157135,
        0.9943552017211914,
        0.0
      ],
      "plane_d": 4492.951171875,
      "bbox_min": [
        -2920.0,
        -4850.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4821.984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2920.0,
        -4850.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4825.7685546875,
        1082.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9138801693916321,
        0.4059842526912689,
        -0.0
      ],
      "plane_d": 4626.1796875,
      "bbox_min": [
        -2920.0,
        -4830.03662109375,
        1052.623779296875
      ],
      "bbox_max": [
        -2916.584716796875,
        -4821.984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2920.0,
        -4830.03662109375,
        1082.623779296875
      ],
      "bbox_max": [
        -2916.584716796875,
        -4821.984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2839.999755859375,
      "bbox_min": [
        -2920.0,
        -4910.19970703125,
        1227.393310546875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4639.62060546875,
        1255.3924560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2799.999755859375,
      "bbox_min": [
        -2839.999755859375,
        -4869.7685546875,
        1230.4019775390625
      ],
      "bbox_max": [
        -2799.999755859375,
        -4718.13916015625,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8064050674438477,
        0.5913636684417725
      ],
      "plane_d": 3077.1162109375,
      "bbox_min": [
        -2839.999755859375,
        -4869.7685546875,
        1230.4019775390625
      ],
      "bbox_max": [
        -2799.999755859375,
        -4718.13916015625,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4869.7685546875,
      "bbox_min": [
        -2839.999755859375,
        -4869.7685546875,
        1230.4019775390625
      ],
      "bbox_max": [
        -2799.999755859375,
        -4869.7685546875,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8319953680038452,
        0.0,
        0.5547826290130615
      ],
      "plane_d": 1732.95654296875,
      "bbox_min": [
        -2920.0,
        -4910.19970703125,
        1227.393310546875
      ],
      "bbox_max": [
        -2901.78662109375,
        -4856.3642578125,
        1255.3924560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": 4836.0390625,
      "bbox_min": [
        -2920.0,
        -4857.9619140625,
        1227.393310546875
      ],
      "bbox_max": [
        -2901.78662109375,
        -4856.3642578125,
        1255.3924560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4605.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4609.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2749.999755859375,
      "bbox_min": [
        -2899.999755859375,
        -4609.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2299.999755859375,
        -4605.7685546875,
        1127.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1085.623779296875,
      "bbox_min": [
        -2749.999755859375,
        -4609.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2299.999755859375,
        -4605.7685546875,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2303.999755859375,
      "bbox_min": [
        -2303.999755859375,
        -4609.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2303.999755859375,
        -4605.7685546875,
        1085.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2303.999755859375,
      "bbox_min": [
        -2303.999755859375,
        -4609.7685546875,
        1085.623779296875
      ],
      "bbox_max": [
        -2299.999755859375,
        -4605.7685546875,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1099.623779296875,
      "bbox_min": [
        -2303.999755859375,
        -4609.7685546875,
        1099.623779296875
      ],
      "bbox_max": [
        -2299.999755859375,
        -4605.7685546875,
        1099.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": 2096.258544921875,
      "bbox_min": [
        -2899.999755859375,
        -4609.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4605.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2879.999755859375,
      "bbox_min": [
        -2879.999755859375,
        -4609.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4605.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3090860843658447,
        -0.9510340690612793
      ],
      "plane_d": 2445.8681640625,
      "bbox_min": [
        -2780.999755859375,
        -4609.7685546875,
        1073.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4605.7685546875,
        1079.423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9987523555755615,
        0.049937617033720016,
        0.0
      ],
      "plane_d": 3002.7373046875,
      "bbox_min": [
        -2780.999755859375,
        -4609.7685546875,
        1073.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4605.7685546875,
        1079.423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9987523555755615,
        0.049937617033720016,
        0.0
      ],
      "plane_d": -2547.3291015625,
      "bbox_min": [
        -2780.999755859375,
        -4609.7685546875,
        1073.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4605.7685546875,
        1079.423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1961161494255066,
        0.980580747127533
      ],
      "plane_d": -1961.727783203125,
      "bbox_min": [
        -2780.999755859375,
        -4609.7685546875,
        1078.623779296875
      ],
      "bbox_max": [
        -2775.999755859375,
        -4605.7685546875,
        1079.423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2654.999755859375,
      "bbox_min": [
        -2919.999755859375,
        -4605.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2399.999755859375,
      "bbox_min": [
        -2654.999755859375,
        -4605.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4569.7998046875,
      "bbox_min": [
        -2399.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4319.7685546875,
      "bbox_min": [
        -2399.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4559.7685546875,
      "bbox_min": [
        -2389.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4319.7685546875,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1077.623779296875,
      "bbox_min": [
        -2389.999755859375,
        -4569.7998046875,
        1077.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4559.7685546875,
        1077.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1077.6236572265625,
      "bbox_min": [
        -2224.77978515625,
        -4559.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2214.77978515625,
        -4410.228515625,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.914959728717804,
        -0.4035452604293823,
        -0.0
      ],
      "plane_d": -3815.310791015625,
      "bbox_min": [
        -2271.1962890625,
        -4435.0087890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1077.6236572265625,
      "bbox_min": [
        -2271.1962890625,
        -4435.0087890625,
        1077.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5756958723068237,
        0.8176640272140503
      ],
      "plane_d": -3502.085693359375,
      "bbox_min": [
        -2389.999755859375,
        -4559.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1301383674144745,
        -0.47995108366012573,
        0.8675891160964966
      ],
      "plane_d": -3424.8876953125,
      "bbox_min": [
        -2389.999755859375,
        -4559.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12173735350370407,
        -0.5714139938354492,
        0.8115823864936829
      ],
      "plane_d": -3194.82470703125,
      "bbox_min": [
        -2389.999755859375,
        -4559.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4819210171699524,
        0.0,
        0.8762146830558777
      ],
      "plane_d": -2091.639892578125,
      "bbox_min": [
        -2389.999755859375,
        -4559.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43366071581840515,
        -0.4361818730831146,
        0.7884691953659058
      ],
      "plane_d": -3853.72216796875,
      "bbox_min": [
        -2389.999755859375,
        -4559.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17092366516590118,
        0.19323012232780457,
        0.9661506414413452
      ],
      "plane_d": -558.6419677734375,
      "bbox_min": [
        -2389.999755859375,
        -4548.52197265625,
        1064.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -2279.999755859375,
        -4548.52197265625,
        1064.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4440.0,
        1072.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.18815985321998596,
        0.19261319935321808,
        0.963066041469574
      ],
      "plane_d": -597.2233276367188,
      "bbox_min": [
        -2279.999755859375,
        -4480.0,
        1064.623779296875
      ],
      "bbox_max": [
        -2270.0,
        -4440.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13031168282032013,
        0.47780948877334595,
        0.8687445521354675
      ],
      "plane_d": 1504.557861328125,
      "bbox_min": [
        -2389.999755859375,
        -4520.0,
        1064.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4329.7685546875,
        1100.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.32461899518966675,
        0.18549543619155884,
        0.927477240562439
      ],
      "plane_d": -939.6539306640625,
      "bbox_min": [
        -2389.999755859375,
        -4520.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2310.0,
        -4447.27294921875,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1455213725566864,
        0.19402849674224854,
        0.9701425433158875
      ],
      "plane_d": -526.9075317382812,
      "bbox_min": [
        -2350.0,
        -4520.0,
        1087.7666015625
      ],
      "bbox_max": [
        -2310.0,
        -4485.71435546875,
        1100.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14400461316108704,
        -0.2400076985359192,
        0.9600307941436768
      ],
      "plane_d": -2433.796875,
      "bbox_min": [
        -2389.999755859375,
        -4450.29052734375,
        1064.623779296875
      ],
      "bbox_max": [
        -2238.910400390625,
        -4329.7685546875,
        1088.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24253705143928528,
        0.0,
        0.9701422452926636
      ],
      "plane_d": -1620.26123046875,
      "bbox_min": [
        -2389.999755859375,
        -4440.0,
        1064.623779296875
      ],
      "bbox_max": [
        -2238.910400390625,
        -4329.7685546875,
        1088.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.23570361733436584,
        -0.23570217192173004,
        0.9428086876869202
      ],
      "plane_d": -2611.7001953125,
      "bbox_min": [
        -2389.999755859375,
        -4440.0,
        1064.623779296875
      ],
      "bbox_max": [
        -2238.910400390625,
        -4329.7685546875,
        1088.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09950372576713562,
        0.0,
        0.9950372576713562
      ],
      "plane_d": -1311.084716796875,
      "bbox_min": [
        -2389.999755859375,
        -4440.0,
        1064.623779296875
      ],
      "bbox_max": [
        -2238.910400390625,
        -4329.7685546875,
        1088.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4202214479446411,
        0.9074215888977051
      ],
      "plane_d": 846.1397094726562,
      "bbox_min": [
        -2389.999755859375,
        -4440.0,
        1064.623779296875
      ],
      "bbox_max": [
        -2238.910400390625,
        -4329.7685546875,
        1086.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.1961161345243454,
        0.9805806875228882
      ],
      "plane_d": -1914.7052001953125,
      "bbox_min": [
        -2389.999755859375,
        -4440.0,
        1064.623779296875
      ],
      "bbox_max": [
        -2238.910400390625,
        -4329.7685546875,
        1086.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2309373915195465,
        0.3055573105812073,
        0.9237438440322876
      ],
      "plane_d": -210.5400390625,
      "bbox_min": [
        -2389.999755859375,
        -4360.0,
        1072.623779296875
      ],
      "bbox_max": [
        -2321.97216796875,
        -4329.7685546875,
        1082.4334716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09451575577259064,
        0.31264054775238037,
        0.945157527923584
      ],
      "plane_d": 117.750732421875,
      "bbox_min": [
        -2350.0,
        -4356.23193359375,
        1072.623779296875
      ],
      "bbox_max": [
        -2321.97216796875,
        -4329.7685546875,
        1082.4334716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09451575577259064,
        0.31264054775238037,
        0.945157527923584
      ],
      "plane_d": 117.750732421875,
      "bbox_min": [
        -2357.999755859375,
        -4408.14013671875,
        1070.9957275390625
      ],
      "bbox_max": [
        -2238.910400390625,
        -4350.95166015625,
        1086.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16590309143066406,
        -0.07317177951335907,
        0.9834237098693848
      ],
      "plane_d": -1748.458984375,
      "bbox_min": [
        -2357.999755859375,
        -4408.14013671875,
        1070.9957275390625
      ],
      "bbox_max": [
        -2238.910400390625,
        -4356.23193359375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2309373915195465,
        0.3055573105812073,
        0.9237438440322876
      ],
      "plane_d": -210.5400390625,
      "bbox_min": [
        -2357.999755859375,
        -4360.0,
        1080.6239013671875
      ],
      "bbox_max": [
        -2350.0,
        -4356.23193359375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1481594443321228,
        0.04938647896051407,
        0.9877296090126038
      ],
      "plane_d": -1200.2138671875,
      "bbox_min": [
        -2350.0,
        -4400.0,
        1082.623779296875
      ],
      "bbox_max": [
        -2310.0,
        -4360.0,
        1088.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.33035042881965637,
        0.9438584446907043
      ],
      "plane_d": 454.350830078125,
      "bbox_min": [
        -2389.999755859375,
        -4450.29052734375,
        1072.623779296875
      ],
      "bbox_max": [
        -2350.0,
        -4440.0,
        1075.05859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16590309143066406,
        -0.07317177951335907,
        0.9834237098693848
      ],
      "plane_d": -1748.458984375,
      "bbox_min": [
        -2386.6806640625,
        -4485.71435546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4402.97021484375,
        1087.7666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.33035042881965637,
        0.9438584446907043
      ],
      "plane_d": 454.350830078125,
      "bbox_min": [
        -2386.6806640625,
        -4485.71435546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4408.14013671875,
        1087.7666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33035221695899963,
        0.0,
        0.943857729434967
      ],
      "plane_d": -1801.946044921875,
      "bbox_min": [
        -2386.6806640625,
        -4485.71435546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4425.45458984375,
        1087.7666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17420688271522522,
        0.0,
        0.9847091436386108
      ],
      "plane_d": -1443.7943115234375,
      "bbox_min": [
        -2310.0,
        -4440.0,
        1064.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4425.45458984375,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1961161345243454,
        0.9805806875228882
      ],
      "plane_d": -1914.7052001953125,
      "bbox_min": [
        -2310.0,
        -4440.0,
        1064.623779296875
      ],
      "bbox_max": [
        -2259.171142578125,
        -4425.45458984375,
        1067.532958984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.32461899518966675,
        0.18549543619155884,
        0.927477240562439
      ],
      "plane_d": -939.6539306640625,
      "bbox_min": [
        -2354.0,
        -4485.71435546875,
        1085.2237548828125
      ],
      "bbox_max": [
        -2350.0,
        -4480.0,
        1087.7666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1961161345243454,
        0.9805806875228882
      ],
      "plane_d": -1914.705078125,
      "bbox_min": [
        -2280.90869140625,
        -4440.0,
        1067.5328369140625
      ],
      "bbox_max": [
        -2224.77978515625,
        -4408.14013671875,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -2270.0,
        -4559.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2224.77978515625,
        -4541.6123046875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9135422706604004,
        -0.4067438244819641,
        -0.0
      ],
      "plane_d": -3873.526123046875,
      "bbox_min": [
        -2399.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7610056400299072,
        -0.6487452983856201,
        -0.0
      ],
      "plane_d": -4560.17578125,
      "bbox_min": [
        -2346.841796875,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.976732075214386,
        0.21446312963962555,
        0.0
      ],
      "plane_d": -1380.2791748046875,
      "bbox_min": [
        -2346.841796875,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4067424237728119,
        -0.9135428071022034,
        0.0
      ],
      "plane_d": -2941.075927734375,
      "bbox_min": [
        -2342.36767578125,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4067084789276123,
        0.9135580062866211,
        0.0
      ],
      "plane_d": 2985.219970703125,
      "bbox_min": [
        -2342.36767578125,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4307.7685546875,
      "bbox_min": [
        -2319.997314453125,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4283.1005859375,
        1226.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.914959728717804,
        -0.4035452604293823,
        -0.0
      ],
      "plane_d": -3815.310791015625,
      "bbox_min": [
        -2307.839599609375,
        -4307.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2269.969970703125,
        -4283.1005859375,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9079594612121582,
        -0.419058233499527,
        0.0
      ],
      "plane_d": -3888.06494140625,
      "bbox_min": [
        -2307.839599609375,
        -4307.7685546875,
        1104.3970947265625
      ],
      "bbox_max": [
        -2294.0,
        -4292.16162109375,
        1123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3896400034427643,
        -0.9209672212600708
      ],
      "plane_d": -644.232666015625,
      "bbox_min": [
        -2307.839599609375,
        -4307.7685546875,
        1116.3970947265625
      ],
      "bbox_max": [
        -2294.0,
        -4292.16162109375,
        1123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.914959728717804,
        -0.4035452604293823,
        -0.0
      ],
      "plane_d": -3815.310791015625,
      "bbox_min": [
        -2269.969970703125,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2264.67724609375,
        -4307.7685546875,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9135460257530212,
        -0.4067356288433075,
        -0.0
      ],
      "plane_d": -3861.5,
      "bbox_min": [
        -2342.36767578125,
        -4302.5205078125,
        1052.623779296875
      ],
      "bbox_max": [
        -2280.849853515625,
        -4249.7685546875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.914959728717804,
        -0.4035452604293823,
        -0.0
      ],
      "plane_d": -3815.310791015625,
      "bbox_min": [
        -2314.0,
        -4295.1162109375,
        1052.623779296875
      ],
      "bbox_max": [
        -2280.849853515625,
        -4249.7685546875,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9079594612121582,
        -0.419058233499527,
        0.0
      ],
      "plane_d": -3888.06494140625,
      "bbox_min": [
        -2314.0,
        -4295.1162109375,
        1100.0
      ],
      "bbox_max": [
        -2301.203125,
        -4281.7685546875,
        1117.6470947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3896400034427643,
        -0.9209672212600708
      ],
      "plane_d": -644.232666015625,
      "bbox_min": [
        -2314.0,
        -4295.1162109375,
        1112.0
      ],
      "bbox_max": [
        -2301.203125,
        -4281.7685546875,
        1117.6470947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8099361658096313,
        -0.3606100380420685,
        -0.4625622630119324
      ],
      "plane_d": -2866.8154296875,
      "bbox_min": [
        -2342.36767578125,
        -4302.5205078125,
        1203.623779296875
      ],
      "bbox_max": [
        -2313.5087890625,
        -4257.44384765625,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3511234521865845,
        0.0,
        0.9363292455673218
      ],
      "plane_d": -1828.298583984375,
      "bbox_min": [
        -2399.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2339.999755859375,
        -4279.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4299.7685546875,
      "bbox_min": [
        -2399.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2339.999755859375,
        -4279.7685546875,
        1075.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2359.999755859375,
        -4299.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -2339.999755859375,
        -4279.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 968.0032348632812,
      "bbox_min": [
        -2359.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2339.999755859375,
        -4299.7685546875,
        1075.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -2359.99951171875,
      "bbox_min": [
        -2359.999755859375,
        -4319.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -2359.999755859375,
        -4299.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4569.7998046875,
      "bbox_min": [
        -2654.999755859375,
        -4605.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2465.999755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660253286361694,
        -0.5000001192092896,
        0.0
      ],
      "plane_d": 173.8419189453125,
      "bbox_min": [
        -2654.999755859375,
        -4260.69189453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2631.2470703125,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071089148521423,
        -0.7071046829223633,
        0.0
      ],
      "plane_d": -1128.3988037109375,
      "bbox_min": [
        -2654.999755859375,
        -4250.8173828125,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.874267578125,
        -4250.69189453125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500004231929779,
        -0.8660230040550232,
        -0.0
      ],
      "plane_d": -5008.6455078125,
      "bbox_min": [
        -2654.874267578125,
        -4260.69189453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2631.2470703125,
        -4249.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7745972871780396,
        -0.4472154378890991,
        0.44721055030822754
      ],
      "plane_d": -333.14947509765625,
      "bbox_min": [
        -2654.874267578125,
        -4260.69189453125,
        1052.623779296875
      ],
      "bbox_max": [
        -2631.2470703125,
        -4249.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -2654.874267578125,
        -4255.69189453125,
        1072.623779296875
      ],
      "bbox_max": [
        -2642.794189453125,
        -4249.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2639.999755859375,
      "bbox_min": [
        -2654.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4395.837890625,
        1117.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4529.7685546875,
      "bbox_min": [
        -2639.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4404.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1092.623779296875,
      "bbox_min": [
        -2639.999755859375,
        -4529.7685546875,
        1058.552734375
      ],
      "bbox_max": [
        -2596.999755859375,
        -4404.7685546875,
        1104.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2615.0,
      "bbox_min": [
        -2625.0,
        -4439.7685546875,
        1058.552734375
      ],
      "bbox_max": [
        -2615.0,
        -4429.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4429.7685546875,
      "bbox_min": [
        -2625.0,
        -4429.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2615.0,
        -4429.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1104.623779296875,
      "bbox_min": [
        -2629.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4419.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2629.999755859375,
      "bbox_min": [
        -2629.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4419.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7864406108856201,
        0.6176660060882568
      ],
      "plane_d": 2798.974365234375,
      "bbox_min": [
        -2629.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4419.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.42383554577827454,
        0.9057391881942749
      ],
      "plane_d": 876.9922485351562,
      "bbox_min": [
        -2629.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4419.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.96592116355896,
        0.25883668661117554
      ],
      "plane_d": 3986.3369140625,
      "bbox_min": [
        -2629.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4419.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4498.7685546875,
      "bbox_min": [
        -2629.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4429.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2625.999755859375,
      "bbox_min": [
        -2625.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2613.999755859375,
        -4498.7685546875,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4510.7685546875,
      "bbox_min": [
        -2625.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2613.999755859375,
        -4498.7685546875,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1098.6236572265625,
      "bbox_min": [
        -2625.999755859375,
        -4510.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2613.999755859375,
        -4498.7685546875,
        1098.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2614.999755859375,
      "bbox_min": [
        -2624.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4499.7685546875,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4509.7685546875,
      "bbox_min": [
        -2624.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4499.7685546875,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4499.7685546875,
      "bbox_min": [
        -2624.999755859375,
        -4499.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2614.999755859375,
        -4499.7685546875,
        1098.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2615.0,
      "bbox_min": [
        -2629.999755859375,
        -4449.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4429.7685546875,
        1104.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4449.7685546875,
      "bbox_min": [
        -2615.0,
        -4449.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2609.999755859375,
        -4449.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4429.7685546875,
      "bbox_min": [
        -2629.999755859375,
        -4449.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2615.0,
        -4429.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1102.0,
      "bbox_min": [
        -2629.999755859375,
        -4449.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2615.0,
        -4429.7685546875,
        1104.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4449.7685546875,
      "bbox_min": [
        -2629.999755859375,
        -4449.7685546875,
        1102.0
      ],
      "bbox_max": [
        -2615.0,
        -4449.7685546875,
        1104.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4449.7685546875,
      "bbox_min": [
        -2629.999755859375,
        -4449.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2625.0,
        -4449.7685546875,
        1102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1064.623779296875,
      "bbox_min": [
        -2639.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4529.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4566.7685546875,
      "bbox_min": [
        -2600.0,
        -4566.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4566.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8872451782226562,
        -0.4612981677055359
      ],
      "plane_d": 4553.91748046875,
      "bbox_min": [
        -2619.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "bbox_max": [
        -2616.999755859375,
        -4569.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2619.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "bbox_max": [
        -2616.999755859375,
        -4569.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2619.999755859375,
      "bbox_min": [
        -2619.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "bbox_max": [
        -2619.999755859375,
        -4569.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1080.123779296875,
      "bbox_min": [
        -2639.999755859375,
        -4404.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4395.837890625,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2639.999755859375,
        -4404.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4397.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4397.7685546875,
      "bbox_min": [
        -2639.999755859375,
        -4397.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4397.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.630307137966156,
        0.7763458490371704,
        0.0
      ],
      "plane_d": 1775.782958984375,
      "bbox_min": [
        -2607.999755859375,
        -4404.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4395.837890625,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1055.6236572265625,
      "bbox_min": [
        -2607.999755859375,
        -4404.7685546875,
        1055.623779296875
      ],
      "bbox_max": [
        -2596.999755859375,
        -4395.837890625,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1064.623779296875,
      "bbox_min": [
        -2654.999755859375,
        -4569.7998046875,
        1064.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4509.7685546875,
        1064.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6823182702064514,
        0.0,
        -0.7310552597045898
      ],
      "plane_d": -1014.9796142578125,
      "bbox_min": [
        -2654.999755859375,
        -4529.7685546875,
        1075.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1092.623779296875,
      "bbox_min": [
        -2654.999755859375,
        -4529.7685546875,
        1075.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4529.7685546875,
      "bbox_min": [
        -2654.999755859375,
        -4529.7685546875,
        1075.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4529.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 1080.1236572265625,
      "bbox_min": [
        -2654.999755859375,
        -4509.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4397.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2646.999755859375,
        -4499.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4397.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2646.999755859375,
      "bbox_min": [
        -2646.999755859375,
        -4499.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4397.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1242.9302978515625,
      "bbox_min": [
        -2646.999755859375,
        -4499.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4397.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5812382102012634,
        -0.8137334585189819,
        0.0
      ],
      "plane_d": -5196.0810546875,
      "bbox_min": [
        -2646.999755859375,
        -4499.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4494.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1064.623779296875,
      "bbox_min": [
        -2654.999755859375,
        -4509.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4446.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2654.999755859375,
        -4509.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4446.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4446.7685546875,
      "bbox_min": [
        -2654.999755859375,
        -4446.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2639.999755859375,
        -4446.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4509.7685546875,
      "bbox_min": [
        -2596.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2467.999755859375,
        -4387.04248046875,
        1103.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1060.623779296875,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2482.638427734375,
        -4387.04248046875,
        1094.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5003462433815002,
        0.8658254146575928,
        0.0
      ],
      "plane_d": 2523.86083984375,
      "bbox_min": [
        -2596.999755859375,
        -4416.28515625,
        1052.623779296875
      ],
      "bbox_max": [
        -2509.02392578125,
        -4387.04248046875,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6994220018386841,
        0.699429988861084,
        0.14699143171310425
      ],
      "plane_d": 1145.570556640625,
      "bbox_min": [
        -2578.01416015625,
        -4416.28515625,
        1052.623779296875
      ],
      "bbox_max": [
        -2509.02392578125,
        -4387.04248046875,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": 4193.55224609375,
      "bbox_min": [
        -2536.975341796875,
        -4397.216796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2509.02392578125,
        -4396.02783203125,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18456201255321503,
        0.9828208684921265,
        0.0
      ],
      "plane_d": 3843.395751953125,
      "bbox_min": [
        -2578.01416015625,
        -4404.7685546875,
        1055.623779296875
      ],
      "bbox_max": [
        -2537.255859375,
        -4387.04248046875,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1055.6236572265625,
      "bbox_min": [
        -2578.01416015625,
        -4404.7685546875,
        1055.623779296875
      ],
      "bbox_max": [
        -2570.999755859375,
        -4401.677734375,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1055.6236572265625,
      "bbox_min": [
        -2596.999755859375,
        -4404.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2572.66552734375,
        -4389.7685546875,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.630307137966156,
        0.7763458490371704,
        0.0
      ],
      "plane_d": 1775.782958984375,
      "bbox_min": [
        -2596.999755859375,
        -4395.837890625,
        1052.623779296875
      ],
      "bbox_max": [
        -2591.999755859375,
        -4391.7783203125,
        1055.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.001743542612530291,
        0.9999985694885254,
        0.0
      ],
      "plane_d": 4400.234375,
      "bbox_min": [
        -2596.999755859375,
        -4404.7685546875,
        1055.623779296875
      ],
      "bbox_max": [
        -2577.956298828125,
        -4404.7353515625,
        1060.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2559.999755859375,
      "bbox_min": [
        -2563.361083984375,
        -4509.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2482.638427734375,
        -4389.4072265625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.5,
      "bbox_min": [
        -2559.999755859375,
        -4509.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2482.638427734375,
        -4389.4072265625,
        1072.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.36142003536224365,
        -0.9324031472206116
      ],
      "plane_d": 2586.422119140625,
      "bbox_min": [
        -2559.999755859375,
        -4509.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2506.281494140625,
        -4389.4072265625,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2555570602416992,
        0.2555605471134186,
        -0.9324051737785339
      ],
      "plane_d": 1472.720947265625,
      "bbox_min": [
        -2559.999755859375,
        -4509.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2510.03125,
        -4389.4072265625,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6994220018386841,
        0.699429988861084,
        0.14699143171310425
      ],
      "plane_d": 1145.570556640625,
      "bbox_min": [
        -2554.30810546875,
        -4509.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2510.03125,
        -4398.4599609375,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": 4193.55224609375,
      "bbox_min": [
        -2535.968017578125,
        -4509.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2510.03125,
        -4398.4599609375,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2519.999755859375,
      "bbox_min": [
        -2519.999755859375,
        -4509.7685546875,
        1060.623779296875
      ],
      "bbox_max": [
        -2519.999755859375,
        -4506.7685546875,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6994220018386841,
        0.699429988861084,
        0.14699143171310425
      ],
      "plane_d": 1145.570556640625,
      "bbox_min": [
        -2555.33984375,
        -4416.80029296875,
        1062.0474853515625
      ],
      "bbox_max": [
        -2535.968017578125,
        -4398.4599609375,
        1068.990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9891379475593567,
        0.14699022471904755
      ],
      "plane_d": 4193.55224609375,
      "bbox_min": [
        -2536.48291015625,
        -4398.4599609375,
        1060.623779296875
      ],
      "bbox_max": [
        -2509.516357421875,
        -4397.216796875,
        1068.990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9894623160362244,
        0.0,
        0.14479120075702667
      ],
      "plane_d": -2682.164306640625,
      "bbox_min": [
        -2553.78662109375,
        -4460.5556640625,
        1072.5
      ],
      "bbox_max": [
        -2510.247314453125,
        -4398.9814453125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6996562480926514,
        0.6996562480926514,
        0.14478379487991333
      ],
      "plane_d": 1148.3394775390625,
      "bbox_min": [
        -2553.78662109375,
        -4460.5556640625,
        1072.5
      ],
      "bbox_max": [
        -2510.247314453125,
        -4398.9814453125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6996592283248901,
        -0.6996497511863708,
        0.14480072259902954
      ],
      "plane_d": -5050.2880859375,
      "bbox_min": [
        -2553.78662109375,
        -4460.5556640625,
        1072.5
      ],
      "bbox_max": [
        -2510.247314453125,
        -4398.9814453125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9894623160362244,
        0.14479120075702667
      ],
      "plane_d": 4197.337890625,
      "bbox_min": [
        -2535.752197265625,
        -4460.5556640625,
        1072.5
      ],
      "bbox_max": [
        -2510.247314453125,
        -4398.9814453125,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -2518.0,
      "bbox_min": [
        -2535.752197265625,
        -4460.5556640625,
        1072.5
      ],
      "bbox_max": [
        -2510.247314453125,
        -4450.0,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.989462673664093,
        0.1447882503271103
      ],
      "plane_d": -4568.8388671875,
      "bbox_min": [
        -2518.0,
        -4460.5556640625,
        1072.5
      ],
      "bbox_max": [
        -2510.247314453125,
        -4460.53759765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9894623160362244,
        0.14479120075702667
      ],
      "plane_d": -4568.84033203125,
      "bbox_min": [
        -2535.752197265625,
        -4460.5556640625,
        1072.5
      ],
      "bbox_max": [
        -2526.199951171875,
        -4460.53759765625,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2555570602416992,
        0.2555605471134186,
        -0.9324051737785339
      ],
      "plane_d": 1472.720947265625,
      "bbox_min": [
        -2563.361083984375,
        -4414.4423828125,
        1071.197021484375
      ],
      "bbox_max": [
        -2559.999755859375,
        -4409.68896484375,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.5,
      "bbox_min": [
        -2563.361083984375,
        -4414.4423828125,
        1072.5
      ],
      "bbox_max": [
        -2559.999755859375,
        -4409.68896484375,
        1072.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1080.123779296875,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1075.623779296875
      ],
      "bbox_max": [
        -2589.999755859375,
        -4397.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1082.6236572265625,
      "bbox_min": [
        -2596.999755859375,
        -4499.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2589.999755859375,
        -4397.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1075.623779296875,
      "bbox_min": [
        -2596.999755859375,
        -4509.7685546875,
        1075.623779296875
      ],
      "bbox_max": [
        -2589.999755859375,
        -4506.7685546875,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -2538.794921875,
        -4429.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2507.20458984375,
        -4391.6357421875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5066525340080261,
        0.8621503710746765
      ],
      "plane_d": 1291.64892578125,
      "bbox_min": [
        -2538.794921875,
        -4422.5,
        1072.623779296875
      ],
      "bbox_max": [
        -2507.20458984375,
        -4391.6357421875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1082.623779296875,
      "bbox_min": [
        -2538.794921875,
        -4422.5,
        1072.623779296875
      ],
      "bbox_max": [
        -2507.20458984375,
        -4391.6357421875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4422.5,
      "bbox_min": [
        -2526.0107421875,
        -4422.5,
        1086.623779296875
      ],
      "bbox_max": [
        -2519.989013671875,
        -4422.5,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9894623160362244,
        0.14479120075702667
      ],
      "plane_d": 4197.337890625,
      "bbox_min": [
        -2535.744384765625,
        -4400.462890625,
        1072.623779296875
      ],
      "bbox_max": [
        -2510.2548828125,
        -4398.99951171875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -2522.999755859375,
        -4429.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2484.8671875,
        -4391.6357421875,
        1094.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4422.5,
      "bbox_min": [
        -2519.989013671875,
        -4422.5,
        1086.623779296875
      ],
      "bbox_max": [
        -2516.0,
        -4422.5,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -2522.999755859375,
        -4437.10546875,
        1086.623779296875
      ],
      "bbox_max": [
        -2505.286865234375,
        -4422.431640625,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2516.0,
      "bbox_min": [
        -2516.0,
        -4432.66796875,
        1086.623779296875
      ],
      "bbox_max": [
        -2516.0,
        -4426.869140625,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -2561.13232421875,
        -4429.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2522.999755859375,
        -4391.6357421875,
        1094.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4422.5,
      "bbox_min": [
        -2528.5,
        -4422.5,
        1086.623779296875
      ],
      "bbox_max": [
        -2526.0107421875,
        -4422.5,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6996562480926514,
        0.6996562480926514,
        0.14478379487991333
      ],
      "plane_d": 1148.3394775390625,
      "bbox_min": [
        -2553.7685546875,
        -4417.6298828125,
        1072.623779296875
      ],
      "bbox_max": [
        -2535.138427734375,
        -4398.99951171875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -2522.99951171875,
        -4467.9013671875,
        1082.623779296875
      ],
      "bbox_max": [
        -2484.8671875,
        -4429.7685546875,
        1094.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2516.0,
      "bbox_min": [
        -2516.0,
        -4435.0,
        1086.623779296875
      ],
      "bbox_max": [
        -2516.0,
        -4432.66796875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -2561.13232421875,
        -4445.5634765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2522.99951171875,
        -4413.9736328125,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5066569447517395,
        0.0,
        0.8621476888656616
      ],
      "plane_d": -2230.9970703125,
      "bbox_min": [
        -2561.13232421875,
        -4445.5634765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2540.712646484375,
        -4413.9736328125,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9894623160362244,
        0.0,
        0.14479120075702667
      ],
      "plane_d": -2682.164306640625,
      "bbox_min": [
        -2553.7685546875,
        -4442.513671875,
        1072.623779296875
      ],
      "bbox_max": [
        -2552.30517578125,
        -4417.0234375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -2589.999755859375,
        -4509.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2522.99951171875,
        -4429.7685546875,
        1094.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2559.999755859375,
      "bbox_min": [
        -2559.999755859375,
        -4506.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2535.562744140625,
        -4442.33154296875,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6996592283248901,
        -0.6996497511863708,
        0.14480072259902954
      ],
      "plane_d": -5050.2880859375,
      "bbox_min": [
        -2553.7685546875,
        -4460.53759765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2535.562744140625,
        -4442.33154296875,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35826417803764343,
        -0.35825634002685547,
        0.8621479272842407
      ],
      "plane_d": -3443.594970703125,
      "bbox_min": [
        -2561.13232421875,
        -4467.9013671875,
        1075.623779296875
      ],
      "bbox_max": [
        -2525.16650390625,
        -4435.0,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6996592283248901,
        -0.6996497511863708,
        0.14480072259902954
      ],
      "plane_d": -5050.2880859375,
      "bbox_min": [
        -2553.32958984375,
        -4460.0986328125,
        1075.623779296875
      ],
      "bbox_max": [
        -2525.16650390625,
        -4435.0,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4435.0,
      "bbox_min": [
        -2528.5,
        -4435.0,
        1086.623779296875
      ],
      "bbox_max": [
        -2525.16650390625,
        -4435.0,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1094.623779296875,
      "bbox_min": [
        -2556.13671875,
        -4509.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2507.20458984375,
        -4429.7685546875,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1075.623779296875,
      "bbox_min": [
        -2556.13671875,
        -4509.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2507.20458984375,
        -4435.0,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -2518.0,
      "bbox_min": [
        -2535.74462890625,
        -4460.53759765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2510.2548828125,
        -4450.0,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.989462673664093,
        0.1447882503271103
      ],
      "plane_d": -4568.8388671875,
      "bbox_min": [
        -2518.0,
        -4460.53759765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2510.2548828125,
        -4460.0986328125,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9894623160362244,
        0.14479120075702667
      ],
      "plane_d": -4568.84033203125,
      "bbox_min": [
        -2535.74462890625,
        -4460.53759765625,
        1072.623779296875
      ],
      "bbox_max": [
        -2526.199951171875,
        -4460.0986328125,
        1075.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5066525340080261,
        0.8621503710746765
      ],
      "plane_d": -3197.05810546875,
      "bbox_min": [
        -2538.794921875,
        -4467.9013671875,
        1075.623779296875
      ],
      "bbox_max": [
        -2507.20458984375,
        -4435.0,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -2518.0,
      "bbox_min": [
        -2535.562744140625,
        -4460.0986328125,
        1075.623779296875
      ],
      "bbox_max": [
        -2510.436767578125,
        -4435.0,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.989462673664093,
        0.1447882503271103
      ],
      "plane_d": -4568.8388671875,
      "bbox_min": [
        -2518.0,
        -4460.0986328125,
        1075.623779296875
      ],
      "bbox_max": [
        -2510.436767578125,
        -4459.07421875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9894623160362244,
        0.14479120075702667
      ],
      "plane_d": -4568.84033203125,
      "bbox_min": [
        -2535.562744140625,
        -4460.0986328125,
        1075.623779296875
      ],
      "bbox_max": [
        -2520.832763671875,
        -4435.0,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4435.0,
      "bbox_min": [
        -2525.16650390625,
        -4435.0,
        1086.623779296875
      ],
      "bbox_max": [
        -2520.832763671875,
        -4435.0,
        1094.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1064.623779296875,
      "bbox_min": [
        -2596.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2516.999755859375,
        -4509.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2596.999755859375,
        -4569.7998046875,
        1067.623779296875
      ],
      "bbox_max": [
        -2516.999755859375,
        -4509.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2519.999755859375,
      "bbox_min": [
        -2519.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2516.999755859375,
        -4566.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4566.7685546875,
      "bbox_min": [
        -2519.999755859375,
        -4566.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2516.999755859375,
        -4566.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2619.999755859375,
        -4589.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2616.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2619.999755859375,
      "bbox_min": [
        -2619.999755859375,
        -4589.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2616.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1080.123779296875,
      "bbox_min": [
        -2619.999755859375,
        -4589.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2616.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8872451782226562,
        -0.4612981677055359
      ],
      "plane_d": 4553.91748046875,
      "bbox_min": [
        -2619.999755859375,
        -4571.068359375,
        1080.123779296875
      ],
      "bbox_max": [
        -2616.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3090834319591522,
        -0.9510349035263062
      ],
      "plane_d": 2445.85693359375,
      "bbox_min": [
        -2620.7998046875,
        -4605.7685546875,
        1074.923828125
      ],
      "bbox_max": [
        -2616.19970703125,
        -4589.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9987521767616272,
        0.04994065687060356,
        0.0
      ],
      "plane_d": -2387.514404296875,
      "bbox_min": [
        -2620.7998046875,
        -4605.7685546875,
        1074.923828125
      ],
      "bbox_max": [
        -2616.19970703125,
        -4589.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.19611327350139618,
        0.9805813431739807
      ],
      "plane_d": -1961.7152099609375,
      "bbox_min": [
        -2620.7998046875,
        -4605.7685546875,
        1079.423828125
      ],
      "bbox_max": [
        -2616.19970703125,
        -4589.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4372.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4605.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4250.8173828125,
        1152.623779296875
      ],
      "face_count": 18
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4319.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4250.8173828125,
        1152.623779296875
      ],
      "face_count": 18
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2869.999755859375,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1122.623779296875,
      "bbox_min": [
        -2869.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2799.999755859375,
      "bbox_min": [
        -2869.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3387194871902466,
        0.0,
        0.940887451171875
      ],
      "plane_d": -1976.450439453125,
      "bbox_min": [
        -2869.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4344.7998046875,
      "bbox_min": [
        -2833.39990234375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4344.7998046875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.39349955320358276,
        0.0,
        -0.9193248152732849
      ],
      "plane_d": 2106.27490234375,
      "bbox_min": [
        -2833.39990234375,
        -4372.7685546875,
        1063.0
      ],
      "bbox_max": [
        -2799.999755859375,
        -4344.7998046875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8674445152282715,
        0.0,
        -0.4975341260433197
      ],
      "plane_d": 2987.75244140625,
      "bbox_min": [
        -2833.39990234375,
        -4372.7685546875,
        1063.0
      ],
      "bbox_max": [
        -2799.999755859375,
        -4344.7998046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4355.0,
      "bbox_min": [
        -2833.39990234375,
        -4372.7685546875,
        1063.0
      ],
      "bbox_max": [
        -2799.999755859375,
        -4344.7998046875,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1063.0,
      "bbox_min": [
        -2833.39990234375,
        -4355.0,
        1063.0
      ],
      "bbox_max": [
        -2799.999755859375,
        -4344.7998046875,
        1065.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1065.123779296875,
      "bbox_min": [
        -2833.39990234375,
        -4355.0,
        1065.123779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4344.7998046875,
        1065.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1065.123779296875,
      "bbox_min": [
        -2833.39990234375,
        -4372.7685546875,
        1063.0
      ],
      "bbox_max": [
        -2823.39990234375,
        -4355.0,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1104.623779296875,
      "bbox_min": [
        -2867.999755859375,
        -4372.7685546875,
        1098.1436767578125
      ],
      "bbox_max": [
        -2849.999755859375,
        -4319.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2867.999755859375,
      "bbox_min": [
        -2867.999755859375,
        -4372.7685546875,
        1098.1436767578125
      ],
      "bbox_max": [
        -2867.999755859375,
        -4319.7685546875,
        1104.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1074.623779296875,
      "bbox_min": [
        -2869.999755859375,
        -4372.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2849.999755859375,
        -4319.7685546875,
        1098.1436767578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2867.999755859375,
      "bbox_min": [
        -2869.999755859375,
        -4372.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2867.999755859375,
        -4319.7685546875,
        1098.1436767578125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1087.623779296875,
      "bbox_min": [
        -2869.999755859375,
        -4361.83251953125,
        1074.623779296875
      ],
      "bbox_max": [
        -2867.999755859375,
        -4332.83251953125,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4361.83251953125,
      "bbox_min": [
        -2869.999755859375,
        -4361.83251953125,
        1074.623779296875
      ],
      "bbox_max": [
        -2867.999755859375,
        -4332.83251953125,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4332.83251953125,
      "bbox_min": [
        -2869.999755859375,
        -4332.83251953125,
        1074.623779296875
      ],
      "bbox_max": [
        -2867.999755859375,
        -4332.83251953125,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2739.999755859375,
      "bbox_min": [
        -2799.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1092.623779296875,
      "bbox_min": [
        -2799.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4344.7998046875,
      "bbox_min": [
        -2799.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1092.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4329.99951171875,
      "bbox_min": [
        -2795.0,
        -4344.7998046875,
        1065.123779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.3200697898864746,
        0.947394073009491
      ],
      "plane_d": -2399.731201171875,
      "bbox_min": [
        -2795.0,
        -4344.7998046875,
        1065.123779296875
      ],
      "bbox_max": [
        -2785.0,
        -4330.0,
        1080.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -2785.0,
      "bbox_min": [
        -2795.0,
        -4344.7998046875,
        1065.123779296875
      ],
      "bbox_max": [
        -2785.0,
        -4330.0,
        1080.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3200697898864746,
        -0.947394073009491
      ],
      "plane_d": 2409.205078125,
      "bbox_min": [
        -2795.0,
        -4344.7998046875,
        1065.123779296875
      ],
      "bbox_max": [
        -2785.0,
        -4330.0,
        1080.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2795.0,
      "bbox_min": [
        -2795.0,
        -4344.7998046875,
        1065.123779296875
      ],
      "bbox_max": [
        -2795.0,
        -4330.0,
        1080.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3872325122356415,
        0.0,
        -0.9219821691513062
      ],
      "plane_d": 2074.29736328125,
      "bbox_min": [
        -2795.0,
        -4330.0,
        1070.123779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1080.123779296875,
      "bbox_min": [
        -2795.0,
        -4330.0,
        1075.9237060546875
      ],
      "bbox_max": [
        -2760.0,
        -4319.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2760.0,
      "bbox_min": [
        -2760.0,
        -4330.0,
        1090.623779296875
      ],
      "bbox_max": [
        -2760.0,
        -4319.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2795.0,
      "bbox_min": [
        -2795.0,
        -4330.0,
        1075.9237060546875
      ],
      "bbox_max": [
        -2795.0,
        -4319.7685546875,
        1080.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3872325122356415,
        0.0,
        0.9219821691513062
      ],
      "plane_d": -2065.07763671875,
      "bbox_min": [
        -2795.0,
        -4330.0,
        1070.123779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6246950626373291,
        0.0,
        0.7808688879013062
      ],
      "plane_d": -2564.8603515625,
      "bbox_min": [
        -2760.0,
        -4330.0,
        1080.623779296875
      ],
      "bbox_max": [
        -2749.472900390625,
        -4319.7685546875,
        1085.0452880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1080.623779296875,
      "bbox_min": [
        -2760.0,
        -4330.0,
        1080.623779296875
      ],
      "bbox_max": [
        -2754.999755859375,
        -4319.7685546875,
        1080.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6246950626373291,
        0.0,
        0.7808688879013062
      ],
      "plane_d": -2564.8603515625,
      "bbox_min": [
        -2795.0,
        -4330.0,
        1070.123779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1070.123779296875,
      "bbox_min": [
        -2795.0,
        -4330.0,
        1070.123779296875
      ],
      "bbox_max": [
        -2785.0,
        -4319.7685546875,
        1075.9237060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2795.0,
      "bbox_min": [
        -2795.0,
        -4330.0,
        1070.123779296875
      ],
      "bbox_max": [
        -2795.0,
        -4319.7685546875,
        1075.9237060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2747.39990234375,
      "bbox_min": [
        -2799.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2747.39990234375,
        -4344.7998046875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        -0.0,
        -0.8944272398948669
      ],
      "plane_d": -264.80194091796875,
      "bbox_min": [
        -2799.999755859375,
        -4372.7685546875,
        1056.5999755859375
      ],
      "bbox_max": [
        -2747.39990234375,
        -4344.7998046875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8690410852432251,
        -0.0,
        -0.49473994970321655
      ],
      "plane_d": -1860.64404296875,
      "bbox_min": [
        -2799.999755859375,
        -4372.7685546875,
        1056.5999755859375
      ],
      "bbox_max": [
        -2747.39990234375,
        -4344.7998046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4355.0,
      "bbox_min": [
        -2799.999755859375,
        -4372.7685546875,
        1056.5999755859375
      ],
      "bbox_max": [
        -2747.39990234375,
        -4344.7998046875,
        1065.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1063.0,
      "bbox_min": [
        -2799.999755859375,
        -4355.0,
        1063.0
      ],
      "bbox_max": [
        -2747.39990234375,
        -4344.7998046875,
        1065.123779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1065.123779296875,
      "bbox_min": [
        -2799.999755859375,
        -4355.0,
        1065.123779296875
      ],
      "bbox_max": [
        -2747.39990234375,
        -4344.7998046875,
        1065.123779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1062.9998779296875,
      "bbox_min": [
        -2757.362548828125,
        -4372.7685546875,
        1063.0
      ],
      "bbox_max": [
        -2747.39990234375,
        -4355.0,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -2794.999755859375,
      "bbox_min": [
        -2795.0,
        -4372.7685546875,
        1056.5999755859375
      ],
      "bbox_max": [
        -2785.0,
        -4355.0,
        1065.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.3923766613006592,
        0.9198046922683716
      ],
      "plane_d": -2688.50634765625,
      "bbox_min": [
        -2795.0,
        -4372.7685546875,
        1056.5999755859375
      ],
      "bbox_max": [
        -2785.0,
        -4355.0,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2785.0,
      "bbox_min": [
        -2795.0,
        -4372.7685546875,
        1056.5999755859375
      ],
      "bbox_max": [
        -2785.0,
        -4355.0,
        1065.123779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1056.5999755859375,
      "bbox_min": [
        -2795.0,
        -4372.7685546875,
        1056.5999755859375
      ],
      "bbox_max": [
        -2785.0,
        -4370.0,
        1056.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1058.7249755859375,
      "bbox_min": [
        -2795.0,
        -4372.7685546875,
        1057.5440673828125
      ],
      "bbox_max": [
        -2785.0,
        -4370.0,
        1058.7249755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2785.0,
      "bbox_min": [
        -2785.0,
        -4372.7685546875,
        1057.5440673828125
      ],
      "bbox_max": [
        -2785.0,
        -4370.0,
        1058.7249755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4370.7685546875,
      "bbox_min": [
        -2799.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1102.623779296875,
      "bbox_min": [
        -2785.0,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2774.999755859375,
        -4370.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2774.999755859375,
      "bbox_min": [
        -2785.0,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2774.999755859375,
        -4370.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2785.0,
      "bbox_min": [
        -2785.0,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2784.999755859375,
        -4370.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4333.0,
      "bbox_min": [
        -2786.999755859375,
        -4370.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1097.623779296875,
      "bbox_min": [
        -2763.0,
        -4333.0,
        1092.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1097.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4330.0,
      "bbox_min": [
        -2763.0,
        -4333.0,
        1092.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4319.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.857492983341217,
        0.0,
        0.5144957900047302
      ],
      "plane_d": 1787.380126953125,
      "bbox_min": [
        -2763.0,
        -4333.0,
        1092.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4330.0,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2763.0,
      "bbox_min": [
        -2763.0,
        -4333.0,
        1092.623779296875
      ],
      "bbox_max": [
        -2763.0,
        -4330.0,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2763.0,
      "bbox_min": [
        -2763.0,
        -4330.0,
        1092.623779296875
      ],
      "bbox_max": [
        -2760.0,
        -4319.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2760.0,
      "bbox_min": [
        -2760.0,
        -4330.0,
        1092.623779296875
      ],
      "bbox_max": [
        -2760.0,
        -4319.7685546875,
        1097.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2774.999755859375,
      "bbox_min": [
        -2786.999755859375,
        -4370.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2772.999755859375,
        -4369.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2772.999755859375,
      "bbox_min": [
        -2774.999755859375,
        -4370.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2772.999755859375,
        -4369.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4369.7685546875,
      "bbox_min": [
        -2774.999755859375,
        -4370.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2772.999755859375,
        -4369.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": 3797.795166015625,
      "bbox_min": [
        -2774.999755859375,
        -4370.7685546875,
        1099.623779296875
      ],
      "bbox_max": [
        -2772.999755859375,
        -4369.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2786.999755859375,
      "bbox_min": [
        -2786.999755859375,
        -4370.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2784.999755859375,
        -4369.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2785.0,
      "bbox_min": [
        -2786.999755859375,
        -4370.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2784.999755859375,
        -4369.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4369.7685546875,
      "bbox_min": [
        -2786.999755859375,
        -4370.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2784.999755859375,
        -4369.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": 3797.795166015625,
      "bbox_min": [
        -2786.999755859375,
        -4370.7685546875,
        1099.623779296875
      ],
      "bbox_max": [
        -2784.999755859375,
        -4369.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1092.623779296875,
      "bbox_min": [
        -2739.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2684.999755859375,
      "bbox_min": [
        -2739.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4319.7685546875,
        1092.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1072.623779296875,
      "bbox_min": [
        -2684.999755859375,
        -4369.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4319.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1074.623779296875,
      "bbox_min": [
        -2684.999755859375,
        -4346.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4334.7685546875,
        1077.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4343.7685546875,
      "bbox_min": [
        -2657.999755859375,
        -4343.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4337.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4337.76806640625,
      "bbox_min": [
        -2657.999755859375,
        -4337.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4337.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4337.7685546875,
      "bbox_min": [
        -2684.999755859375,
        -4343.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2681.999755859375,
        -4337.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": -4343.76806640625,
      "bbox_min": [
        -2684.999755859375,
        -4343.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2681.999755859375,
        -4343.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4343.7685546875,
      "bbox_min": [
        -2681.999755859375,
        -4346.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2657.999755859375,
        -4334.7685546875,
        1074.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4337.7685546875,
      "bbox_min": [
        -2681.999755859375,
        -4337.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2657.999755859375,
        -4334.7685546875,
        1074.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071461081504822,
        0.7070674896240234,
        0.0
      ],
      "plane_d": 1175.3408203125,
      "bbox_min": [
        -2675.19580078125,
        -4337.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2666.999755859375,
        -4334.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25877800583839417,
        0.9659368991851807,
        0.0
      ],
      "plane_d": 4878.0498046875,
      "bbox_min": [
        -2672.999755859375,
        -4335.572265625,
        1072.623779296875
      ],
      "bbox_max": [
        -2666.999755859375,
        -4334.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25877800583839417,
        0.9659368991851807,
        0.0
      ],
      "plane_d": 3496.175537109375,
      "bbox_min": [
        -2672.999755859375,
        -4335.572265625,
        1072.623779296875
      ],
      "bbox_max": [
        -2669.999755859375,
        -4334.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071461081504822,
        -0.7070674896240234,
        -0.0
      ],
      "plane_d": -4963.091796875,
      "bbox_min": [
        -2675.19580078125,
        -4346.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2664.8037109375,
        -4343.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071461081504822,
        -0.7070674896240234,
        0.0
      ],
      "plane_d": -1186.931884765625,
      "bbox_min": [
        -2672.999755859375,
        -4346.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2664.8037109375,
        -4343.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25877800583839417,
        -0.9659368991851807,
        -0.0
      ],
      "plane_d": -4889.64111328125,
      "bbox_min": [
        -2672.999755859375,
        -4346.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2666.999755859375,
        -4345.96484375,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25877800583839417,
        -0.9659368991851807,
        0.0
      ],
      "plane_d": -3507.766845703125,
      "bbox_min": [
        -2669.999755859375,
        -4346.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2666.999755859375,
        -4345.96484375,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.0,
        0.7071068286895752
      ],
      "plane_d": 1136.58642578125,
      "bbox_min": [
        -2684.999755859375,
        -4343.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4337.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4337.7685546875,
      "bbox_min": [
        -2684.999755859375,
        -4343.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2681.999755859375,
        -4337.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": -4343.76806640625,
      "bbox_min": [
        -2684.999755859375,
        -4343.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2681.999755859375,
        -4343.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071355581283569,
        0.0,
        0.7070780396461487
      ],
      "plane_d": -2639.4091796875,
      "bbox_min": [
        -2657.999755859375,
        -4343.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4337.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4343.7685546875,
      "bbox_min": [
        -2657.999755859375,
        -4343.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4337.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4337.76806640625,
      "bbox_min": [
        -2657.999755859375,
        -4337.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4337.7685546875,
        1077.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2683.999755859375,
      "bbox_min": [
        -2684.999755859375,
        -4369.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4351.7685546875,
      "bbox_min": [
        -2684.999755859375,
        -4351.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2683.999755859375,
        -4325.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4334.7685546875,
      "bbox_min": [
        -2684.999755859375,
        -4334.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2683.999755859375,
        -4325.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4325.7685546875,
      "bbox_min": [
        -2684.999755859375,
        -4334.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2683.999755859375,
        -4325.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1062.623779296875,
      "bbox_min": [
        -2684.999755859375,
        -4334.7685546875,
        1062.623779296875
      ],
      "bbox_max": [
        -2683.999755859375,
        -4325.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4353.7685546875,
      "bbox_min": [
        -2679.999755859375,
        -4359.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4359.7685546875,
      "bbox_min": [
        -2679.999755859375,
        -4359.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4353.7685546875,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1058.623779296875,
      "bbox_min": [
        -2679.999755859375,
        -4359.7685546875,
        1055.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4353.7685546875,
        1058.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 2332.140625,
      "bbox_min": [
        -2679.999755859375,
        -4356.7685546875,
        1055.623779296875
      ],
      "bbox_max": [
        -2657.999755859375,
        -4353.7685546875,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5773502588272095,
        0.5773502588272095,
        0.5773502588272095
      ],
      "plane_d": 367.85589599609375,
      "bbox_min": [
        -2660.999755859375,
        -4356.7685546875,
        1055.623779296875
      ],
      "bbox_max": [
        -2657.999755859375,
        -4353.7685546875,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -2628.0498046875,
      "bbox_min": [
        -2679.999755859375,
        -4353.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2660.999755859375,
      "bbox_min": [
        -2660.999755859375,
        -4353.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4319.7685546875,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1058.623779296875,
      "bbox_min": [
        -2657.999755859375,
        -4353.7685546875,
        1058.623779296875
      ],
      "bbox_max": [
        -2655.0,
        -4319.7685546875,
        1058.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1164.794921875,
      "bbox_min": [
        -2679.999755859375,
        -4321.7685546875,
        1057.623779296875
      ],
      "bbox_max": [
        -2659.999755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -4949.58349609375,
      "bbox_min": [
        -2679.999755859375,
        -4321.7685546875,
        1057.623779296875
      ],
      "bbox_max": [
        -2672.499755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4321.7685546875,
      "bbox_min": [
        -2679.999755859375,
        -4321.7685546875,
        1057.623779296875
      ],
      "bbox_max": [
        -2672.499755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -2306.6845703125,
      "bbox_min": [
        -2679.999755859375,
        -4321.7685546875,
        1057.623779296875
      ],
      "bbox_max": [
        -2672.499755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -3812.9970703125,
      "bbox_min": [
        -2679.999755859375,
        -4321.7685546875,
        1070.623779296875
      ],
      "bbox_max": [
        -2672.499755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1173.6337890625,
      "bbox_min": [
        -2667.499755859375,
        -4321.7685546875,
        1057.623779296875
      ],
      "bbox_max": [
        -2659.999755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -4940.74462890625,
      "bbox_min": [
        -2667.499755859375,
        -4321.7685546875,
        1057.623779296875
      ],
      "bbox_max": [
        -2659.999755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4321.7685546875,
      "bbox_min": [
        -2667.499755859375,
        -4321.7685546875,
        1059.623779296875
      ],
      "bbox_max": [
        -2659.999755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -3812.9970703125,
      "bbox_min": [
        -2667.499755859375,
        -4321.7685546875,
        1070.623779296875
      ],
      "bbox_max": [
        -2659.999755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -1136.58642578125,
      "bbox_min": [
        -2739.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4319.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4325.7685546875,
      "bbox_min": [
        -2739.999755859375,
        -4336.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4319.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4323.7685546875,
      "bbox_min": [
        -2739.999755859375,
        -4325.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4319.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2685.999755859375,
      "bbox_min": [
        -2685.999755859375,
        -4325.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4323.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833810806274,
        0.0,
        0.3162277936935425
      ],
      "plane_d": -2883.245849609375,
      "bbox_min": [
        -2685.999755859375,
        -4325.7685546875,
        1059.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4323.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4321.0,
      "bbox_min": [
        -2739.999755859375,
        -4321.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2736.0,
        -4319.7685546875,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1056.0,
      "bbox_min": [
        -2739.999755859375,
        -4321.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2736.0,
        -4319.7685546875,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2736.0,
      "bbox_min": [
        -2736.0,
        -4321.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2736.0,
        -4319.7685546875,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4334.7685546875,
      "bbox_min": [
        -2685.999755859375,
        -4336.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4334.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4336.7685546875,
      "bbox_min": [
        -2685.999755859375,
        -4336.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4334.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2685.999755859375,
      "bbox_min": [
        -2685.999755859375,
        -4336.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4334.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833810806274,
        0.0,
        0.3162277936935425
      ],
      "plane_d": -2883.245849609375,
      "bbox_min": [
        -2685.999755859375,
        -4336.7685546875,
        1059.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4334.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659289717674255,
        -0.0,
        -0.25880733132362366
      ],
      "plane_d": -2281.762451171875,
      "bbox_min": [
        -2723.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2588219940662384,
        -0.0,
        -0.9659250378608704
      ],
      "plane_d": 389.433349609375,
      "bbox_min": [
        -2723.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2659.01904296875,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.0,
        -0.7071068286895752
      ],
      "plane_d": -1097.002197265625,
      "bbox_min": [
        -2723.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2659.01904296875,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2686.999755859375,
      "bbox_min": [
        -2723.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2684.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1097.0238037109375,
      "bbox_min": [
        -2686.999755859375,
        -4372.7685546875,
        1097.0238037109375
      ],
      "bbox_max": [
        -2684.999755859375,
        -4319.7685546875,
        1098.0238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1098.0238037109375,
      "bbox_min": [
        -2686.999755859375,
        -4372.7685546875,
        1097.0238037109375
      ],
      "bbox_max": [
        -2684.999755859375,
        -4319.7685546875,
        1098.0238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2684.999755859375,
      "bbox_min": [
        -2684.999755859375,
        -4372.7685546875,
        1097.0238037109375
      ],
      "bbox_max": [
        -2684.999755859375,
        -4319.7685546875,
        1098.0238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2699.999755859375,
      "bbox_min": [
        -2723.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2695.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2695.999755859375,
      "bbox_min": [
        -2699.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2695.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1118.623779296875,
      "bbox_min": [
        -2699.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2695.999755859375,
        -4322.7685546875,
        1118.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4369.7685546875,
      "bbox_min": [
        -2699.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2695.999755859375,
        -4322.7685546875,
        1118.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4322.7685546875,
      "bbox_min": [
        -2699.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2695.999755859375,
        -4322.7685546875,
        1118.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -2269.915283203125,
      "bbox_min": [
        -2699.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2695.999755859375,
        -4322.7685546875,
        1118.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 3876.636962890625,
      "bbox_min": [
        -2699.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2695.999755859375,
        -4322.7685546875,
        1118.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 1511.4652099609375,
      "bbox_min": [
        -2699.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2695.999755859375,
        -4322.7685546875,
        1096.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -3310.28662109375,
      "bbox_min": [
        -2699.999755859375,
        -4328.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2695.999755859375,
        -4322.7685546875,
        1096.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2719.999755859375,
      "bbox_min": [
        -2723.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2723.999755859375,
      "bbox_min": [
        -2723.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2719.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1118.623779296875,
      "bbox_min": [
        -2723.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2719.999755859375,
        -4322.7685546875,
        1118.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4322.7685546875,
      "bbox_min": [
        -2723.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2719.999755859375,
        -4322.7685546875,
        1118.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4369.7685546875,
      "bbox_min": [
        -2723.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2719.999755859375,
        -4322.7685546875,
        1118.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -2269.915283203125,
      "bbox_min": [
        -2723.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2719.999755859375,
        -4322.7685546875,
        1118.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 3876.636962890625,
      "bbox_min": [
        -2723.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2719.999755859375,
        -4322.7685546875,
        1118.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 1511.4652099609375,
      "bbox_min": [
        -2723.999755859375,
        -4369.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2719.999755859375,
        -4322.7685546875,
        1096.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -3310.28662109375,
      "bbox_min": [
        -2723.999755859375,
        -4328.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2719.999755859375,
        -4322.7685546875,
        1096.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -2269.915283203125,
      "bbox_min": [
        -2719.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4328.7685546875,
      "bbox_min": [
        -2719.999755859375,
        -4328.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2719.999755859375,
        -4322.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4319.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 3876.636962890625,
      "bbox_min": [
        -2719.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4363.7685546875,
      "bbox_min": [
        -2719.999755859375,
        -4372.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4363.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2719.999755859375,
        -4372.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4369.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 1511.4652099609375,
      "bbox_min": [
        -2719.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4319.7685546875,
        1096.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1096.623779296875,
      "bbox_min": [
        -2719.999755859375,
        -4372.7685546875,
        1096.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4369.7685546875,
        1096.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": -3310.28662109375,
      "bbox_min": [
        -2719.999755859375,
        -4328.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4319.7685546875,
        1096.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1096.623779296875,
      "bbox_min": [
        -2719.999755859375,
        -4322.7685546875,
        1096.623779296875
      ],
      "bbox_max": [
        -2699.999755859375,
        -4319.7685546875,
        1096.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -4441.3623046875,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2908.16259765625,
        -4319.7685546875,
        1061.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9498211145401001,
        0.3127937316894531
      ],
      "plane_d": 3773.75341796875,
      "bbox_min": [
        -2919.999755859375,
        -4330.732421875,
        1052.623779296875
      ],
      "bbox_max": [
        -2908.16259765625,
        -4319.7685546875,
        1061.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486832618713379,
        0.0,
        0.3162277340888977
      ],
      "plane_d": 2426.056396484375,
      "bbox_min": [
        -2919.999755859375,
        -4330.732421875,
        1052.623779296875
      ],
      "bbox_max": [
        -2908.16259765625,
        -4319.7685546875,
        1061.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9537330865859985,
        0.0,
        0.30065464973449707
      ],
      "plane_d": -3101.376708984375,
      "bbox_min": [
        -2919.999755859375,
        -4330.732421875,
        1052.623779296875
      ],
      "bbox_max": [
        -2917.16259765625,
        -4319.7685546875,
        1061.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9475358724594116,
        0.31964942812919617
      ],
      "plane_d": -4479.82568359375,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2908.16259765625,
        -4361.732421875,
        1061.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486833214759827,
        0.3162277936935425
      ],
      "plane_d": 3805.0341796875,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2908.16259765625,
        -4361.732421875,
        1061.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 2426.056640625,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2908.16259765625,
        -4361.732421875,
        1061.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9537331461906433,
        0.0,
        0.3006546199321747
      ],
      "plane_d": -3101.376708984375,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2917.16259765625,
        -4361.732421875,
        1061.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4327.732421875,
      "bbox_min": [
        -2917.16259765625,
        -4369.732421875,
        1061.623779296875
      ],
      "bbox_max": [
        -2911.16259765625,
        -4322.732421875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4322.732421875,
      "bbox_min": [
        -2917.16259765625,
        -4327.732421875,
        1061.623779296875
      ],
      "bbox_max": [
        -2911.16259765625,
        -4322.732421875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2917.16259765625,
      "bbox_min": [
        -2917.16259765625,
        -4327.732421875,
        1061.623779296875
      ],
      "bbox_max": [
        -2911.16259765625,
        -4322.732421875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2911.16259765625,
      "bbox_min": [
        -2911.16259765625,
        -4327.732421875,
        1061.623779296875
      ],
      "bbox_max": [
        -2911.16259765625,
        -4322.732421875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4369.732421875,
      "bbox_min": [
        -2917.16259765625,
        -4369.732421875,
        1061.623779296875
      ],
      "bbox_max": [
        -2911.16259765625,
        -4364.732421875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4364.732421875,
      "bbox_min": [
        -2917.16259765625,
        -4369.732421875,
        1061.623779296875
      ],
      "bbox_max": [
        -2911.16259765625,
        -4364.732421875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2917.16259765625,
      "bbox_min": [
        -2917.16259765625,
        -4369.732421875,
        1061.623779296875
      ],
      "bbox_max": [
        -2911.16259765625,
        -4364.732421875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2911.16259765625,
      "bbox_min": [
        -2911.16259765625,
        -4369.732421875,
        1061.623779296875
      ],
      "bbox_max": [
        -2911.16259765625,
        -4364.732421875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1074.623779296875,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1062.623779296875
      ],
      "bbox_max": [
        -2869.999755859375,
        -4319.7685546875,
        1079.623779296875
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1072.623779296875,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1062.623779296875
      ],
      "bbox_max": [
        -2869.999755859375,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9578263163566589,
        -0.2873478829860687
      ],
      "plane_d": -3839.873046875,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1062.623779296875
      ],
      "bbox_max": [
        -2908.16259765625,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9587745070457458,
        -0.2841680347919464
      ],
      "plane_d": 4446.4892578125,
      "bbox_min": [
        -2919.999755859375,
        -4330.732421875,
        1062.623779296875
      ],
      "bbox_max": [
        -2908.16259765625,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9578262567520142,
        0.0,
        -0.2873478829860687
      ],
      "plane_d": 3093.73046875,
      "bbox_min": [
        -2919.999755859375,
        -4330.732421875,
        1062.623779296875
      ],
      "bbox_max": [
        -2908.16259765625,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9620302319526672,
        0.0,
        -0.2729431986808777
      ],
      "plane_d": -2516.362548828125,
      "bbox_min": [
        -2919.999755859375,
        -4330.732421875,
        1062.623779296875
      ],
      "bbox_max": [
        -2917.16259765625,
        -4319.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9568694233894348,
        -0.29051825404167175
      ],
      "plane_d": -3872.5517578125,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1062.623779296875
      ],
      "bbox_max": [
        -2908.16259765625,
        -4361.732421875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9578263163566589,
        -0.2873478829860687
      ],
      "plane_d": 4485.99853515625,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1062.623779296875
      ],
      "bbox_max": [
        -2908.16259765625,
        -4361.732421875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9578263163566589,
        0.0,
        -0.2873478829860687
      ],
      "plane_d": 3093.73095703125,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1062.623779296875
      ],
      "bbox_max": [
        -2908.16259765625,
        -4361.732421875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9620301723480225,
        0.0,
        -0.2729431688785553
      ],
      "plane_d": -2516.362548828125,
      "bbox_min": [
        -2919.999755859375,
        -4372.7685546875,
        1062.623779296875
      ],
      "bbox_max": [
        -2917.16259765625,
        -4361.732421875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1079.623779296875,
      "bbox_min": [
        -2889.999755859375,
        -4372.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2869.999755859375,
        -4367.7685546875,
        1079.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4367.7685546875,
      "bbox_min": [
        -2889.999755859375,
        -4372.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2869.999755859375,
        -4367.7685546875,
        1079.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1048.475830078125,
      "bbox_min": [
        -2889.999755859375,
        -4372.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4367.7685546875,
        1079.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4306.16796875,
      "bbox_min": [
        -2919.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4250.8173828125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 970.6865844726562,
      "bbox_min": [
        -2869.999755859375,
        -4306.16796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4250.8173828125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588197588920593,
        -0.9659256935119629,
        0.0
      ],
      "plane_d": -3447.43505859375,
      "bbox_min": [
        -2869.999755859375,
        -4306.16796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2679.95068359375,
        -4275.7685546875,
        1067.823486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071089148521423,
        -0.7071046829223633,
        0.0
      ],
      "plane_d": -1128.3988037109375,
      "bbox_min": [
        -2869.999755859375,
        -4306.16796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2679.95068359375,
        -4275.7685546875,
        1067.823486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2869.999755859375,
      "bbox_min": [
        -2869.999755859375,
        -4306.16796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4299.7685546875,
        1067.823486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 2739.99951171875,
      "bbox_min": [
        -2739.999755859375,
        -4303.23046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4299.7685546875,
        1066.3548583984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 2739.99951171875,
      "bbox_min": [
        -2739.999755859375,
        -4306.16796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2739.999755859375,
        -4303.23046875,
        1067.823486328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071089148521423,
        -0.7071046829223633,
        0.0
      ],
      "plane_d": -1128.3988037109375,
      "bbox_min": [
        -2750.961181640625,
        -4306.16796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4250.8173828125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588197588920593,
        -0.9659256935119629,
        0.0
      ],
      "plane_d": -3447.43505859375,
      "bbox_min": [
        -2750.961181640625,
        -4306.16796875,
        1060.39111328125
      ],
      "bbox_max": [
        -2695.4853515625,
        -4291.30322265625,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 970.6865844726562,
      "bbox_min": [
        -2869.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2733.050048828125,
        -4306.16796875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 2739.99951171875,
      "bbox_min": [
        -2869.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2733.050048828125,
        -4306.16796875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2869.999755859375,
      "bbox_min": [
        -2869.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2869.999755859375,
        -4306.16796875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1058.0234375,
      "bbox_min": [
        -2739.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2733.050048828125,
        -4308.0,
        1058.0234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2733.050048828125,
      "bbox_min": [
        -2739.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2733.050048828125,
        -4308.0,
        1058.0234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4316.0,
      "bbox_min": [
        -2739.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2733.050048828125,
        -4308.0,
        1058.0234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4308.0,
      "bbox_min": [
        -2739.999755859375,
        -4308.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2733.050048828125,
        -4308.0,
        1058.0234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1056.0,
      "bbox_min": [
        -2739.999755859375,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2736.0,
        -4316.0,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2736.0,
      "bbox_min": [
        -2736.0,
        -4319.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2736.0,
        -4316.0,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4569.7998046875,
      "bbox_min": [
        -2919.999755859375,
        -4605.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4372.7685546875,
        1128.623779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1092.623779296875,
      "bbox_min": [
        -2919.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4372.7685546875,
        1127.623779296875
      ],
      "face_count": 17
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4559.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4449.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4449.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2909.999755859375,
        -4444.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4444.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4444.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2909.999755859375,
        -4444.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4479.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4454.7998046875,
      "bbox_min": [
        -2909.999755859375,
        -4479.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2739.999755859375,
      "bbox_min": [
        -2884.999755859375,
        -4479.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4454.7998046875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2869.999755859375,
      "bbox_min": [
        -2884.999755859375,
        -4479.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2869.999755859375,
        -4454.7998046875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2884.999755859375,
      "bbox_min": [
        -2884.999755859375,
        -4479.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2869.999755859375,
        -4454.7998046875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1074.623779296875,
      "bbox_min": [
        -2884.999755859375,
        -4479.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2869.999755859375,
        -4454.7998046875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1064.623779296875,
      "bbox_min": [
        -2660.0,
        -4479.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4454.7998046875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2660.0,
        -4479.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4454.7998046875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2660.0,
      "bbox_min": [
        -2660.0,
        -4479.7685546875,
        1064.623779296875
      ],
      "bbox_max": [
        -2660.0,
        -4454.7998046875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2833.39990234375,
      "bbox_min": [
        -2909.999755859375,
        -4454.80029296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2884.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4454.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2833.39990234375,
        -4372.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1074.623779296875,
      "bbox_min": [
        -2884.999755859375,
        -4454.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2833.39990234375,
        -4372.7685546875,
        1074.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2869.999755859375,
      "bbox_min": [
        -2869.999755859375,
        -4454.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2833.39990234375,
        -4372.7685546875,
        1074.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1065.123779296875,
      "bbox_min": [
        -2869.999755859375,
        -4454.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2833.39990234375,
        -4384.83251953125,
        1065.123779296875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2850.362548828125,
      "bbox_min": [
        -2869.999755859375,
        -4454.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2833.39990234375,
        -4384.83251953125,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2855.362548828125,
      "bbox_min": [
        -2869.999755859375,
        -4454.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2850.362548828125,
        -4384.83251953125,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4399.83251953125,
      "bbox_min": [
        -2855.362548828125,
        -4439.83251953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2850.362548828125,
        -4384.83251953125,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4439.83251953125,
      "bbox_min": [
        -2855.362548828125,
        -4439.83251953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2850.362548828125,
        -4439.83251953125,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4384.83251953125,
      "bbox_min": [
        -2855.362548828125,
        -4384.83251953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2850.362548828125,
        -4384.83251953125,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2868.362548828125,
      "bbox_min": [
        -2869.999755859375,
        -4454.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2855.362548828125,
        -4384.83251953125,
        1065.123779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4417.83251953125,
      "bbox_min": [
        -2869.999755859375,
        -4439.83251953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2868.362548828125,
        -4399.83251953125,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4439.83251953125,
      "bbox_min": [
        -2869.999755859375,
        -4439.83251953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2868.362548828125,
        -4421.83251953125,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4421.83251953125,
      "bbox_min": [
        -2869.999755859375,
        -4421.83251953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2868.362548828125,
        -4421.83251953125,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4399.83251953125,
      "bbox_min": [
        -2869.999755859375,
        -4399.83251953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2868.362548828125,
        -4399.83251953125,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4384.83251953125,
      "bbox_min": [
        -2868.362548828125,
        -4384.83251953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2855.362548828125,
        -4384.83251953125,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4384.83251953125,
      "bbox_min": [
        -2850.362548828125,
        -4384.83251953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2833.39990234375,
        -4384.83251953125,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2889.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4449.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4372.7685546875,
        1079.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1074.623779296875,
      "bbox_min": [
        -2889.999755859375,
        -4449.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4372.7685546875,
        1079.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1079.623779296875,
      "bbox_min": [
        -2889.999755859375,
        -4449.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4372.7685546875,
        1079.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4449.7685546875,
      "bbox_min": [
        -2889.999755859375,
        -4449.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4449.7685546875,
        1079.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4444.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4449.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2889.999755859375,
        -4444.7685546875,
        1079.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09950372576713562,
        0.0,
        -0.9950372576713562
      ],
      "plane_d": 1356.8564453125,
      "bbox_min": [
        -2909.999755859375,
        -4449.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2889.999755859375,
        -4444.7685546875,
        1079.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4449.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4449.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2889.999755859375,
        -4444.7685546875,
        1079.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09950372576713562,
        0.0,
        0.9950372576713562
      ],
      "plane_d": -1361.83154296875,
      "bbox_min": [
        -2909.999755859375,
        -4449.7685546875,
        1077.623779296875
      ],
      "bbox_max": [
        -2889.999755859375,
        -4444.7685546875,
        1079.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2747.39990234375,
      "bbox_min": [
        -2833.39990234375,
        -4454.80029296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2739.999755859375,
      "bbox_min": [
        -2739.999755859375,
        -4454.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4372.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4446.7685546875,
      "bbox_min": [
        -2660.0,
        -4454.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4446.7685546875,
        1067.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -2.0345052689663135e-05
      ],
      "plane_d": -2659.978271484375,
      "bbox_min": [
        -2660.0,
        -4454.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4446.7685546875,
        1067.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2660.0,
        -4454.7998046875,
        1067.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4446.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4449.7685546875,
      "bbox_min": [
        -2659.999755859375,
        -4449.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2656.999755859375,
        -4446.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2656.999755859375,
      "bbox_min": [
        -2656.999755859375,
        -4449.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2656.999755859375,
        -4446.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8690410852432251,
        -0.0,
        -0.49473994970321655
      ],
      "plane_d": -1860.64404296875,
      "bbox_min": [
        -2833.39990234375,
        -4454.80029296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2747.39990234375,
        -4372.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        -0.0,
        -0.8944272398948669
      ],
      "plane_d": -264.80194091796875,
      "bbox_min": [
        -2833.39990234375,
        -4454.80029296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2747.39990234375,
        -4372.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39349955320358276,
        0.0,
        -0.9193248152732849
      ],
      "plane_d": 2106.27490234375,
      "bbox_min": [
        -2833.39990234375,
        -4454.80029296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2747.39990234375,
        -4372.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8674445152282715,
        0.0,
        -0.4975341260433197
      ],
      "plane_d": 2987.75244140625,
      "bbox_min": [
        -2833.39990234375,
        -4454.80029296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2747.39990234375,
        -4372.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4444.60009765625,
      "bbox_min": [
        -2833.39990234375,
        -4454.80029296875,
        1052.623779296875
      ],
      "bbox_max": [
        -2747.39990234375,
        -4372.7685546875,
        1074.625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1065.123779296875,
      "bbox_min": [
        -2833.39990234375,
        -4454.80029296875,
        1063.0
      ],
      "bbox_max": [
        -2747.39990234375,
        -4444.60009765625,
        1065.123779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1062.9998779296875,
      "bbox_min": [
        -2833.39990234375,
        -4454.80029296875,
        1063.0
      ],
      "bbox_max": [
        -2747.39990234375,
        -4444.60009765625,
        1063.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1065.123779296875,
      "bbox_min": [
        -2833.39990234375,
        -4444.60009765625,
        1063.0
      ],
      "bbox_max": [
        -2823.39990234375,
        -4372.7685546875,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1063.0,
      "bbox_min": [
        -2833.39990234375,
        -4444.60009765625,
        1063.0
      ],
      "bbox_max": [
        -2823.39990234375,
        -4372.7685546875,
        1063.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4430.0,
      "bbox_min": [
        -2815.0,
        -4444.60009765625,
        1052.623779296875
      ],
      "bbox_max": [
        -2765.0,
        -4372.7685546875,
        1074.625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2775.0,
      "bbox_min": [
        -2815.0,
        -4430.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2765.0,
        -4372.7685546875,
        1074.625
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4380.0,
      "bbox_min": [
        -2775.0,
        -4430.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2765.0,
        -4380.0,
        1074.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2765.0,
      "bbox_min": [
        -2775.0,
        -4430.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2765.0,
        -4380.0,
        1074.625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1074.625,
      "bbox_min": [
        -2775.0,
        -4430.0,
        1053.625
      ],
      "bbox_max": [
        -2765.0,
        -4380.0,
        1074.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1073.625,
      "bbox_min": [
        -2775.0,
        -4429.0,
        1053.625
      ],
      "bbox_max": [
        -2765.0,
        -4381.0,
        1073.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1053.625,
      "bbox_min": [
        -2775.0,
        -4429.0,
        1053.625
      ],
      "bbox_max": [
        -2765.0,
        -4381.0,
        1073.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4429.0,
      "bbox_min": [
        -2775.0,
        -4429.0,
        1053.625
      ],
      "bbox_max": [
        -2765.0,
        -4381.0,
        1073.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4381.0,
      "bbox_min": [
        -2775.0,
        -4429.0,
        1053.625
      ],
      "bbox_max": [
        -2765.0,
        -4381.0,
        1073.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1058.625,
      "bbox_min": [
        -2775.0,
        -4429.0,
        1053.625
      ],
      "bbox_max": [
        -2765.0,
        -4390.0,
        1068.625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2770.0,
      "bbox_min": [
        -2775.0,
        -4429.0,
        1053.625
      ],
      "bbox_max": [
        -2765.0,
        -4390.0,
        1058.625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4390.0,
      "bbox_min": [
        -2775.0,
        -4390.0,
        1053.625
      ],
      "bbox_max": [
        -2770.0,
        -4390.0,
        1058.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4400.0,
      "bbox_min": [
        -2770.0,
        -4410.0,
        1053.625
      ],
      "bbox_max": [
        -2765.0,
        -4400.0,
        1058.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4410.0,
      "bbox_min": [
        -2770.0,
        -4410.0,
        1053.625
      ],
      "bbox_max": [
        -2765.0,
        -4410.0,
        1058.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2770.0,
      "bbox_min": [
        -2775.0,
        -4415.0,
        1058.625
      ],
      "bbox_max": [
        -2770.0,
        -4395.0,
        1068.625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1068.625,
      "bbox_min": [
        -2775.0,
        -4415.0,
        1058.625
      ],
      "bbox_max": [
        -2770.0,
        -4395.0,
        1068.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1063.625,
      "bbox_min": [
        -2775.0,
        -4415.0,
        1058.625
      ],
      "bbox_max": [
        -2770.0,
        -4395.0,
        1068.625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4395.0,
      "bbox_min": [
        -2775.0,
        -4415.0,
        1058.625
      ],
      "bbox_max": [
        -2770.0,
        -4395.0,
        1063.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4415.0,
      "bbox_min": [
        -2775.0,
        -4415.0,
        1058.625
      ],
      "bbox_max": [
        -2770.0,
        -4415.0,
        1063.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4400.0,
      "bbox_min": [
        -2775.0,
        -4410.0,
        1063.625
      ],
      "bbox_max": [
        -2770.0,
        -4400.0,
        1068.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4410.0,
      "bbox_min": [
        -2775.0,
        -4410.0,
        1063.625
      ],
      "bbox_max": [
        -2770.0,
        -4410.0,
        1068.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2805.0,
      "bbox_min": [
        -2815.0,
        -4430.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2785.0,
        -4372.7685546875,
        1074.625
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4380.0,
      "bbox_min": [
        -2815.0,
        -4430.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2805.0,
        -4380.0,
        1074.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2815.0,
      "bbox_min": [
        -2815.0,
        -4430.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2805.0,
        -4380.0,
        1074.625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1074.625,
      "bbox_min": [
        -2815.0,
        -4430.0,
        1053.625
      ],
      "bbox_max": [
        -2805.0,
        -4380.0,
        1074.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1053.625,
      "bbox_min": [
        -2815.0,
        -4429.0,
        1053.625
      ],
      "bbox_max": [
        -2805.0,
        -4381.0,
        1073.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1073.625,
      "bbox_min": [
        -2815.0,
        -4429.0,
        1053.625
      ],
      "bbox_max": [
        -2805.0,
        -4381.0,
        1073.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4429.0,
      "bbox_min": [
        -2815.0,
        -4429.0,
        1053.625
      ],
      "bbox_max": [
        -2805.0,
        -4381.0,
        1073.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4381.0,
      "bbox_min": [
        -2815.0,
        -4420.0,
        1053.625
      ],
      "bbox_max": [
        -2805.0,
        -4381.0,
        1073.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4415.0,
      "bbox_min": [
        -2815.0,
        -4420.0,
        1053.625
      ],
      "bbox_max": [
        -2805.0,
        -4390.0,
        1068.625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2810.0,
      "bbox_min": [
        -2815.0,
        -4415.0,
        1053.625
      ],
      "bbox_max": [
        -2805.0,
        -4390.0,
        1068.625
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1058.625,
      "bbox_min": [
        -2815.0,
        -4415.0,
        1053.625
      ],
      "bbox_max": [
        -2810.0,
        -4390.0,
        1068.625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4395.0,
      "bbox_min": [
        -2815.0,
        -4400.0,
        1053.625
      ],
      "bbox_max": [
        -2810.0,
        -4390.0,
        1058.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4390.0,
      "bbox_min": [
        -2815.0,
        -4390.0,
        1053.625
      ],
      "bbox_max": [
        -2810.0,
        -4390.0,
        1058.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4400.0,
      "bbox_min": [
        -2815.0,
        -4400.0,
        1053.625
      ],
      "bbox_max": [
        -2810.0,
        -4400.0,
        1058.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4410.0,
      "bbox_min": [
        -2815.0,
        -4415.0,
        1058.625
      ],
      "bbox_max": [
        -2810.0,
        -4405.0,
        1068.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1068.625,
      "bbox_min": [
        -2815.0,
        -4415.0,
        1068.625
      ],
      "bbox_max": [
        -2810.0,
        -4410.0,
        1068.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4405.0,
      "bbox_min": [
        -2815.0,
        -4410.0,
        1058.625
      ],
      "bbox_max": [
        -2810.0,
        -4405.0,
        1063.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1063.625,
      "bbox_min": [
        -2815.0,
        -4410.0,
        1063.625
      ],
      "bbox_max": [
        -2810.0,
        -4405.0,
        1063.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4390.0,
      "bbox_min": [
        -2810.0,
        -4410.0,
        1053.625
      ],
      "bbox_max": [
        -2805.0,
        -4390.0,
        1068.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1063.625,
      "bbox_min": [
        -2810.0,
        -4410.0,
        1053.625
      ],
      "bbox_max": [
        -2805.0,
        -4390.0,
        1068.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1058.625,
      "bbox_min": [
        -2810.0,
        -4410.0,
        1053.625
      ],
      "bbox_max": [
        -2805.0,
        -4405.0,
        1063.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4410.0,
      "bbox_min": [
        -2810.0,
        -4410.0,
        1053.625
      ],
      "bbox_max": [
        -2805.0,
        -4410.0,
        1058.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4405.0,
      "bbox_min": [
        -2810.0,
        -4405.0,
        1058.625
      ],
      "bbox_max": [
        -2805.0,
        -4405.0,
        1063.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4395.0,
      "bbox_min": [
        -2810.0,
        -4395.0,
        1063.625
      ],
      "bbox_max": [
        -2805.0,
        -4390.0,
        1068.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1068.625,
      "bbox_min": [
        -2810.0,
        -4395.0,
        1068.625
      ],
      "bbox_max": [
        -2805.0,
        -4390.0,
        1068.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4420.0,
      "bbox_min": [
        -2815.0,
        -4420.0,
        1053.625
      ],
      "bbox_max": [
        -2805.0,
        -4415.0,
        1058.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1058.625,
      "bbox_min": [
        -2815.0,
        -4420.0,
        1058.625
      ],
      "bbox_max": [
        -2805.0,
        -4415.0,
        1058.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1056.5999755859375,
      "bbox_min": [
        -2795.0,
        -4430.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2785.0,
        -4372.7685546875,
        1058.7249755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1058.7249755859375,
      "bbox_min": [
        -2795.0,
        -4430.0,
        1056.5999755859375
      ],
      "bbox_max": [
        -2785.0,
        -4372.7685546875,
        1058.7249755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2795.0,
      "bbox_min": [
        -2795.0,
        -4430.0,
        1056.5999755859375
      ],
      "bbox_max": [
        -2785.0,
        -4372.7685546875,
        1058.7249755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2785.0,
      "bbox_min": [
        -2785.0,
        -4430.0,
        1056.5999755859375
      ],
      "bbox_max": [
        -2785.0,
        -4372.7685546875,
        1058.7249755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4417.0,
      "bbox_min": [
        -2795.0,
        -4420.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2785.0,
        -4380.0,
        1056.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4420.0,
      "bbox_min": [
        -2795.0,
        -4420.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2785.0,
        -4417.0,
        1056.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2795.0,
      "bbox_min": [
        -2795.0,
        -4420.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2785.0,
        -4417.0,
        1056.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2785.0,
      "bbox_min": [
        -2785.0,
        -4420.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2785.0,
        -4417.0,
        1056.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4380.0,
      "bbox_min": [
        -2795.0,
        -4383.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2785.0,
        -4380.0,
        1056.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4383.0,
      "bbox_min": [
        -2795.0,
        -4383.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2785.0,
        -4380.0,
        1056.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2795.0,
      "bbox_min": [
        -2795.0,
        -4383.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2785.0,
        -4380.0,
        1056.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2785.0,
      "bbox_min": [
        -2785.0,
        -4383.0,
        1052.623779296875
      ],
      "bbox_max": [
        -2785.0,
        -4380.0,
        1056.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.4014759659767151,
        -0.9158696532249451
      ],
      "plane_d": -810.8306884765625,
      "bbox_min": [
        -2795.0,
        -4444.60009765625,
        1056.5999755859375
      ],
      "bbox_max": [
        -2785.0,
        -4430.0,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4014117419719696,
        0.9158978462219238
      ],
      "plane_d": 808.570068359375,
      "bbox_min": [
        -2795.0,
        -4444.60009765625,
        1056.5999755859375
      ],
      "bbox_max": [
        -2785.0,
        -4430.0,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2795.0,
      "bbox_min": [
        -2795.0,
        -4444.60009765625,
        1056.5999755859375
      ],
      "bbox_max": [
        -2785.0,
        -4430.0,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2785.0,
      "bbox_min": [
        -2785.0,
        -4444.60009765625,
        1056.5999755859375
      ],
      "bbox_max": [
        -2785.0,
        -4430.0,
        1065.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2839.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4499.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4524.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2839.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4524.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4524.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4499.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37528127431869507,
        0.0,
        -0.9269109964370728
      ],
      "plane_d": -83.93792724609375,
      "bbox_min": [
        -2909.999755859375,
        -4524.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4499.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4500.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4524.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4499.7685546875,
        1087.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2879.999755859375,
      "bbox_min": [
        -2886.999755859375,
        -4500.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4499.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2886.999755859375,
      "bbox_min": [
        -2886.999755859375,
        -4500.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4499.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1062.623779296875,
      "bbox_min": [
        -2886.999755859375,
        -4500.7685546875,
        1062.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4499.7685546875,
        1062.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2897.499755859375,
      "bbox_min": [
        -2909.999755859375,
        -4524.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4500.7685546875,
        1083.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4509.7685546875,
      "bbox_min": [
        -2897.499755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4500.7685546875,
        1072.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4299336075782776,
        0.0,
        -0.9028605818748474
      ],
      "plane_d": -277.30279541015625,
      "bbox_min": [
        -2897.499755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4500.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2879.999755859375,
      "bbox_min": [
        -2886.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4500.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1062.623779296875,
      "bbox_min": [
        -2886.999755859375,
        -4509.7685546875,
        1062.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4500.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2886.999755859375,
      "bbox_min": [
        -2886.999755859375,
        -4509.7685546875,
        1062.623779296875
      ],
      "bbox_max": [
        -2886.999755859375,
        -4500.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1071.623779296875,
      "bbox_min": [
        -2909.999755859375,
        -4524.7685546875,
        1056.0
      ],
      "bbox_max": [
        -2901.900146484375,
        -4508.7685546875,
        1083.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4520.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4520.7685546875,
        1071.623779296875
      ],
      "bbox_max": [
        -2908.999755859375,
        -4508.7685546875,
        1083.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4508.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4520.7685546875,
        1071.623779296875
      ],
      "bbox_max": [
        -2908.999755859375,
        -4508.7685546875,
        1083.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 2908.99951171875,
      "bbox_min": [
        -2909.999755859375,
        -4520.7685546875,
        1071.623779296875
      ],
      "bbox_max": [
        -2908.999755859375,
        -4508.7685546875,
        1083.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4519.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4519.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2908.999755859375,
        -4509.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1082.623779296875,
      "bbox_min": [
        -2909.999755859375,
        -4519.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2908.999755859375,
        -4509.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4509.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4519.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2908.999755859375,
        -4509.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -2909.999755859375,
        -4519.7685546875,
        1072.623779296875
      ],
      "bbox_max": [
        -2908.999755859375,
        -4509.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4524.2685546875,
      "bbox_min": [
        -2904.900146484375,
        -4524.7685546875,
        1056.0
      ],
      "bbox_max": [
        -2901.900146484375,
        -4524.2685546875,
        1058.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1058.0,
      "bbox_min": [
        -2904.900146484375,
        -4524.7685546875,
        1056.0
      ],
      "bbox_max": [
        -2901.900146484375,
        -4524.2685546875,
        1058.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1056.0,
      "bbox_min": [
        -2904.900146484375,
        -4524.7685546875,
        1056.0
      ],
      "bbox_max": [
        -2901.900146484375,
        -4524.2685546875,
        1058.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2904.900146484375,
      "bbox_min": [
        -2904.900146484375,
        -4524.7685546875,
        1056.0
      ],
      "bbox_max": [
        -2901.900146484375,
        -4524.2685546875,
        1058.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2901.900146484375,
      "bbox_min": [
        -2901.900146484375,
        -4524.7685546875,
        1056.0
      ],
      "bbox_max": [
        -2901.900146484375,
        -4524.2685546875,
        1058.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -2407.801025390625,
      "bbox_min": [
        -2884.999755859375,
        -4499.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2864.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -2884.99951171875,
      "bbox_min": [
        -2884.999755859375,
        -4497.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2864.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2864.999755859375,
      "bbox_min": [
        -2864.999755859375,
        -4497.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2864.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2864.999755859375,
      "bbox_min": [
        -2864.999755859375,
        -4499.7685546875,
        1089.623779296875
      ],
      "bbox_max": [
        -2864.999755859375,
        -4494.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4529.7685546875,
      "bbox_min": [
        -2839.999755859375,
        -4551.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2819.999755859375,
      "bbox_min": [
        -2839.999755859375,
        -4529.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4509.7685546875,
      "bbox_min": [
        -2819.999755859375,
        -4529.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2764.999755859375,
      "bbox_min": [
        -2764.999755859375,
        -4509.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2764.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1074.623779296875,
      "bbox_min": [
        -2819.999755859375,
        -4529.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 2715.02392578125,
      "bbox_min": [
        -2764.999755859375,
        -4529.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2764.999755859375,
      "bbox_min": [
        -2764.999755859375,
        -4529.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2764.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4509.7685546875,
      "bbox_min": [
        -2839.999755859375,
        -4529.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2819.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -1234.167236328125,
      "bbox_min": [
        -2839.999755859375,
        -4529.7685546875,
        1074.623779296875
      ],
      "bbox_max": [
        -2819.999755859375,
        -4509.7685546875,
        1089.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1089.623779296875,
      "bbox_min": [
        -2839.999755859375,
        -4529.7685546875,
        1089.623779296875
      ],
      "bbox_max": [
        -2834.999755859375,
        -4509.7685546875,
        1089.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1089.623779296875,
      "bbox_min": [
        -2749.999755859375,
        -4559.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4479.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4509.7685546875,
      "bbox_min": [
        -2749.999755859375,
        -4529.7685546875,
        1089.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4529.7685546875,
      "bbox_min": [
        -2749.999755859375,
        -4529.7685546875,
        1089.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4529.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2660.0,
      "bbox_min": [
        -2660.0,
        -4559.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4479.7685546875,
        1067.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2660.0,
        -4559.7685546875,
        1067.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4479.7685546875,
        1067.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4529.7685546875,
      "bbox_min": [
        -2660.0,
        -4529.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2656.999755859375,
        -4526.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4526.7685546875,
      "bbox_min": [
        -2659.999755859375,
        -4529.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2656.999755859375,
        -4526.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2656.999755859375,
      "bbox_min": [
        -2656.999755859375,
        -4529.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2656.999755859375,
        -4526.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1072.623779296875,
      "bbox_min": [
        -2919.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7082090973854065,
        -0.7060028314590454,
        0.0
      ],
      "plane_d": -1271.634521484375,
      "bbox_min": [
        -2759.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4559.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2659.999755859375,
      "bbox_min": [
        -2660.0,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4559.7685546875,
        1067.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1067.623779296875,
      "bbox_min": [
        -2660.0,
        -4569.7998046875,
        1067.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4559.7685546875,
        1067.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2656.999755859375,
      "bbox_min": [
        -2659.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2656.999755859375,
        -4566.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4566.7685546875,
      "bbox_min": [
        -2659.999755859375,
        -4566.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2656.999755859375,
        -4566.7685546875,
        1064.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7082090973854065,
        -0.7060028314590454,
        0.0
      ],
      "plane_d": -1271.634521484375,
      "bbox_min": [
        -2779.999755859375,
        -4569.7998046875,
        1072.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8872451782226562,
        -0.4612981677055359
      ],
      "plane_d": 4553.91748046875,
      "bbox_min": [
        -2779.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "bbox_max": [
        -2776.999755859375,
        -4569.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2779.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "bbox_max": [
        -2776.999755859375,
        -4569.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2776.999755859375,
      "bbox_min": [
        -2779.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "bbox_max": [
        -2776.999755859375,
        -4569.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2779.999755859375,
      "bbox_min": [
        -2779.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "bbox_max": [
        -2779.999755859375,
        -4569.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1112.623779296875,
      "bbox_min": [
        -2919.999755859375,
        -4569.7998046875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4372.7685546875,
        1127.623779296875
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1122.623779296875,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4372.7685546875,
        1127.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": 1971.038330078125,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4372.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2799.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4372.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -4575.96142578125,
      "bbox_min": [
        -2799.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4554.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -4575.96142578125,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4444.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4444.76806640625,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4444.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        0.44721361994743347
      ],
      "plane_d": -3100.363525390625,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4444.7685546875,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2839.999755859375,
      "bbox_min": [
        -2839.999755859375,
        -4499.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4449.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4449.7685546875,
      "bbox_min": [
        -2839.999755859375,
        -4499.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4449.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4499.7685546875,
      "bbox_min": [
        -2839.999755859375,
        -4499.7685546875,
        1112.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4499.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 2388.001953125,
      "bbox_min": [
        -2904.999755859375,
        -4554.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -2839.999755859375,
        -4499.7685546875,
        1127.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -4014.522705078125,
      "bbox_min": [
        -2904.999755859375,
        -4554.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -2839.999755859375,
        -4499.7685546875,
        1127.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -2847.9599609375,
      "bbox_min": [
        -2904.999755859375,
        -4554.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -2839.999755859375,
        -4499.7685546875,
        1127.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": 1214.3681640625,
      "bbox_min": [
        -2844.999755859375,
        -4554.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -2839.999755859375,
        -4499.7685546875,
        1127.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4559.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4569.7998046875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4372.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7082090973854065,
        -0.7060028314590454,
        0.0
      ],
      "plane_d": -1271.634521484375,
      "bbox_min": [
        -2759.999755859375,
        -4569.7998046875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2909.999755859375,
      "bbox_min": [
        -2919.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4372.7685546875,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4444.7685546875,
      "bbox_min": [
        -2919.999755859375,
        -4444.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2909.999755859375,
        -4444.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4529.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4372.7685546875,
        1112.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2759.999755859375,
      "bbox_min": [
        -2839.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4529.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2749.999755859375,
      "bbox_min": [
        -2749.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4529.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2839.999755859375,
      "bbox_min": [
        -2839.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2839.999755859375,
        -4529.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2759.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4529.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4372.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2749.999755859375,
      "bbox_min": [
        -2759.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4469.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4469.7685546875,
      "bbox_min": [
        -2759.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4469.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4509.7685546875,
      "bbox_min": [
        -2759.999755859375,
        -4509.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4509.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2884.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4529.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2772.999755859375,
        -4372.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4499.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4499.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4499.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2774.999755859375,
      "bbox_min": [
        -2786.999755859375,
        -4373.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2772.999755859375,
        -4372.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2772.999755859375,
      "bbox_min": [
        -2774.999755859375,
        -4373.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2772.999755859375,
        -4372.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4373.7685546875,
      "bbox_min": [
        -2774.999755859375,
        -4373.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2772.999755859375,
        -4372.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": -4497.05322265625,
      "bbox_min": [
        -2774.999755859375,
        -4373.7685546875,
        1099.623779296875
      ],
      "bbox_max": [
        -2772.999755859375,
        -4372.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2786.999755859375,
      "bbox_min": [
        -2786.999755859375,
        -4373.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2785.0,
        -4372.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2785.0,
      "bbox_min": [
        -2786.999755859375,
        -4373.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2785.0,
        -4372.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4373.7685546875,
      "bbox_min": [
        -2786.999755859375,
        -4373.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2785.0,
        -4372.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": -4497.05322265625,
      "bbox_min": [
        -2786.999755859375,
        -4373.7685546875,
        1099.623779296875
      ],
      "bbox_max": [
        -2785.0,
        -4372.7685546875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": 2096.258544921875,
      "bbox_min": [
        -2899.999755859375,
        -4589.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2776.999755859375,
        -4569.7998046875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2879.999755859375,
      "bbox_min": [
        -2879.999755859375,
        -4589.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4569.7998046875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2779.999755859375,
        -4589.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2776.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2776.999755859375,
      "bbox_min": [
        -2779.999755859375,
        -4589.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2776.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -2779.999755859375,
      "bbox_min": [
        -2779.999755859375,
        -4589.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2776.999755859375,
        -4569.7998046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1080.123779296875,
      "bbox_min": [
        -2779.999755859375,
        -4589.7685546875,
        1080.123779296875
      ],
      "bbox_max": [
        -2776.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8872451782226562,
        -0.4612981677055359
      ],
      "plane_d": 4553.91748046875,
      "bbox_min": [
        -2779.999755859375,
        -4571.068359375,
        1080.123779296875
      ],
      "bbox_max": [
        -2776.999755859375,
        -4569.7998046875,
        1082.563720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.0,
        0.44721364974975586
      ],
      "plane_d": 2096.258544921875,
      "bbox_min": [
        -2899.999755859375,
        -4605.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2776.19970703125,
        -4589.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2879.999755859375,
      "bbox_min": [
        -2879.999755859375,
        -4605.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4589.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3090860843658447,
        -0.9510340690612793
      ],
      "plane_d": 2445.8681640625,
      "bbox_min": [
        -2780.7998046875,
        -4605.7685546875,
        1074.923828125
      ],
      "bbox_max": [
        -2776.19970703125,
        -4589.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9987523555755615,
        0.049937617033720016,
        0.0
      ],
      "plane_d": 3002.7373046875,
      "bbox_min": [
        -2780.7998046875,
        -4605.7685546875,
        1074.923828125
      ],
      "bbox_max": [
        -2776.19970703125,
        -4589.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9987523555755615,
        0.049937617033720016,
        0.0
      ],
      "plane_d": -2547.3291015625,
      "bbox_min": [
        -2780.7998046875,
        -4605.7685546875,
        1074.923828125
      ],
      "bbox_max": [
        -2776.19970703125,
        -4589.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1961161494255066,
        0.980580747127533
      ],
      "plane_d": -1961.727783203125,
      "bbox_min": [
        -2780.7998046875,
        -4605.7685546875,
        1079.423828125
      ],
      "bbox_max": [
        -2776.19970703125,
        -4589.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3699.999755859375,
      "bbox_min": [
        -3835.11669921875,
        -5065.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4249.7685546875,
        1302.6241455078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3784.999755859375,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4289.7998046875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600293636322021,
        0.2798992693424225,
        -0.0
      ],
      "plane_d": 4907.18798828125,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4289.7998046875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.789697527885437,
        -0.6134963631629944,
        0.0
      ],
      "plane_d": 308.167724609375,
      "bbox_min": [
        -3784.999755859375,
        -4675.39990234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4289.7998046875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14052800834178925,
        0.9900767803192139,
        -0.0
      ],
      "plane_d": 5148.95849609375,
      "bbox_min": [
        -3750.459716796875,
        -4675.39990234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4289.7998046875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4289.7998046875,
      "bbox_min": [
        -3722.8740234375,
        -4289.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4289.7998046875,
        1102.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9700089693069458,
        -0.0,
        0.24306941032409668
      ],
      "plane_d": 3403.469482421875,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.932385265827179,
        0.26299288868904114,
        0.24797670543193817
      ],
      "plane_d": 4451.162109375,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.931310772895813,
        0.2715262770652771,
        0.24276229739189148
      ],
      "plane_d": 4492.71728515625,
      "bbox_min": [
        -3835.11669921875,
        -4668.23779296875,
        1102.623779296875
      ],
      "bbox_max": [
        -3750.459716796875,
        -4549.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9732754826545715,
        0.0,
        0.22964049875736237
      ],
      "plane_d": 3347.911865234375,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7658141851425171,
        -0.594942033290863,
        0.2440749555826187
      ],
      "plane_d": 29.72479248046875,
      "bbox_min": [
        -3835.11669921875,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3729.92431640625,
        -4260.35546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1222.32177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7621387243270874,
        -0.6012710928916931,
        0.24003666639328003
      ],
      "plane_d": -6.656219482421875,
      "bbox_min": [
        -3835.11669921875,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 3322.101318359375,
      "bbox_min": [
        -3733.5146484375,
        -4260.80517578125,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1236.6832275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1356099247932434,
        0.955426812171936,
        0.26223912835121155
      ],
      "plane_d": 4679.6083984375,
      "bbox_min": [
        -3789.732666015625,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1350298374891281,
        0.9555009007453918,
        0.2622690796852112
      ],
      "plane_d": 4677.7451171875,
      "bbox_min": [
        -3789.732666015625,
        -4723.5966796875,
        1102.623779296875
      ],
      "bbox_max": [
        -3747.18896484375,
        -4668.23779296875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9751271605491638,
        0.22164621949195862
      ],
      "plane_d": -4427.49267578125,
      "bbox_min": [
        -3746.760498046875,
        -4289.7998046875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4249.7685546875,
        1278.7403564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783878922462463,
        0.06522687524557114,
        0.1962204873561859
      ],
      "plane_d": 3718.708251953125,
      "bbox_min": [
        -3747.18896484375,
        -4879.7685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3699.999755859375,
        -4723.5966796875,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4679.7998046875,
      "bbox_min": [
        -3699.999755859375,
        -5065.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4249.7685546875,
        1302.6241455078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3319.999755859375,
      "bbox_min": [
        -3599.999755859375,
        -4741.14697265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2955.91162109375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4719.7685546875,
      "bbox_min": [
        -3599.999755859375,
        -4740.5244140625,
        1052.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4719.7685546875,
        1181.713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3599.999755859375,
        -4740.5244140625,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4719.7685546875,
        1181.713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3339.772216796875,
        -4740.5244140625,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4719.7685546875,
        1181.713134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8292540311813354,
        0.5588719248771667,
        0.0
      ],
      "plane_d": 13.907958984375,
      "bbox_min": [
        -3240.07275390625,
        -4741.14697265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2955.91162109375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8292540311813354,
        0.5588719248771667,
        0.0
      ],
      "plane_d": 5155.2822265625,
      "bbox_min": [
        -3170.900634765625,
        -4741.14697265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2955.91162109375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3079.999755859375,
      "bbox_min": [
        -3170.900634765625,
        -4740.6494140625,
        1052.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4484086036682129,
        0.8938286900520325,
        0.0
      ],
      "plane_d": 5564.03759765625,
      "bbox_min": [
        -3079.999755859375,
        -4739.90283203125,
        1052.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9838698506355286,
        0.0,
        0.17888544499874115
      ],
      "plane_d": -3236.50634765625,
      "bbox_min": [
        -3079.999755859375,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7978267073631287,
        0.537691593170166,
        0.272691011428833
      ],
      "plane_d": 4645.59619140625,
      "bbox_min": [
        -3079.999755859375,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4239882528781891,
        0.8451507687568665,
        0.3255058228969574
      ],
      "plane_d": 4885.83447265625,
      "bbox_min": [
        -3079.999755859375,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3727562129497528,
        -0.9278368353843689,
        0.013100594282150269
      ],
      "plane_d": -3274.530029296875,
      "bbox_min": [
        -3054.30859375,
        -4739.90283203125,
        1152.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4729.86767578125,
        1207.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3170.900634765625,
        -4740.6494140625,
        1052.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4484086036682129,
        0.8938286900520325,
        0.0
      ],
      "plane_d": 2783.90478515625,
      "bbox_min": [
        -3170.900634765625,
        -4735.19970703125,
        1052.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9838699102401733,
        -0.0,
        0.17888544499874115
      ],
      "plane_d": 2863.486328125,
      "bbox_min": [
        -3170.900634765625,
        -4735.19970703125,
        1152.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7978267073631287,
        0.537691593170166,
        0.272691011428833
      ],
      "plane_d": -300.9292297363281,
      "bbox_min": [
        -3170.900634765625,
        -4735.19970703125,
        1152.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4239882528781891,
        0.8451507687568665,
        0.3255058228969574
      ],
      "plane_d": 2257.107666015625,
      "bbox_min": [
        -3145.921875,
        -4710.5654296875,
        1152.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1207.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -3116.6005859375,
        -4740.6494140625,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8741673827171326,
        0.0,
        -0.48562484979629517
      ],
      "plane_d": -2189.454833984375,
      "bbox_min": [
        -3116.6005859375,
        -4740.6494140625,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.874157190322876,
        0.0,
        -0.4856429100036621
      ],
      "plane_d": 3229.236083984375,
      "bbox_min": [
        -3116.6005859375,
        -4740.6494140625,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3116.6005859375,
        -4740.6494140625,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.4909895062446594,
        -0.87116539478302
      ],
      "plane_d": 3257.42919921875,
      "bbox_min": [
        -3116.6005859375,
        -4695.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3082.100341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36590203642845154,
        0.9306533932685852,
        0.0
      ],
      "plane_d": 5510.220703125,
      "bbox_min": [
        -3029.098876953125,
        -4741.14697265625,
        1052.623779296875
      ],
      "bbox_max": [
        -2955.91162109375,
        -4729.86767578125,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7291637659072876,
        0.6843392848968506,
        0.0
      ],
      "plane_d": 1080.096435546875,
      "bbox_min": [
        -2968.409423828125,
        -4741.146484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2955.91162109375,
        -4732.1083984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9138801693916321,
        0.4059842526912689,
        -0.0
      ],
      "plane_d": 4626.1796875,
      "bbox_min": [
        -2968.059326171875,
        -4741.146484375,
        1052.623779296875
      ],
      "bbox_max": [
        -2955.91162109375,
        -4732.1083984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2968.059326171875,
        -4740.7734375,
        1082.623779296875
      ],
      "bbox_max": [
        -2956.077392578125,
        -4732.1083984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36590203642845154,
        0.9306533932685852,
        0.0
      ],
      "plane_d": 3241.628173828125,
      "bbox_min": [
        -3240.07275390625,
        -4741.14697265625,
        1052.623779296875
      ],
      "bbox_max": [
        -3170.900634765625,
        -4729.86767578125,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7291637659072876,
        0.6843392848968506,
        -0.0
      ],
      "plane_d": 5600.9111328125,
      "bbox_min": [
        -3240.07275390625,
        -4741.146484375,
        1052.623779296875
      ],
      "bbox_max": [
        -3231.590087890625,
        -4732.1083984375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3624.999755859375,
      "bbox_min": [
        -3667.999755859375,
        -4741.1396484375,
        1053.1822509765625
      ],
      "bbox_max": [
        -3624.999755859375,
        -4679.7998046875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3667.999755859375,
      "bbox_min": [
        -3667.999755859375,
        -4741.1201171875,
        1054.7738037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4679.7998046875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.01888239197432995,
        0.9998217225074768
      ],
      "plane_d": -1147.5177001953125,
      "bbox_min": [
        -3632.999755859375,
        -4741.07763671875,
        1058.1834716796875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4679.7998046875,
        1059.3406982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3319.999755859375,
      "bbox_min": [
        -3580.227294921875,
        -5045.98291015625,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.541015625,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3580.227294921875,
        -4947.19970703125,
        1102.5999755859375
      ],
      "bbox_max": [
        -3319.999755859375,
        -4739.541015625,
        1212.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3347.17578125,
        -4947.19970703125,
        1102.5999755859375
      ],
      "bbox_max": [
        -3319.999755859375,
        -4739.541015625,
        1212.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4850.7685546875,
      "bbox_min": [
        -3335.999755859375,
        -4850.7685546875,
        1102.5999755859375
      ],
      "bbox_max": [
        -3319.999755859375,
        -4850.7685546875,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3347.175537109375,
        -4947.19970703125,
        1102.623779296875
      ],
      "bbox_max": [
        -3319.999755859375,
        -4850.7685546875,
        1212.34912109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4850.7685546875,
      "bbox_min": [
        -3332.493896484375,
        -4850.7685546875,
        1102.6241455078125
      ],
      "bbox_max": [
        -3319.999755859375,
        -4850.7685546875,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8741573691368103,
        0.0,
        -0.4856429696083069
      ],
      "plane_d": 3229.236572265625,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3053.76708984375,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8741573691368103,
        1.5244095266098157e-06,
        -0.4856429696083069
      ],
      "plane_d": -2189.39599609375,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3053.76708984375,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.9701427221298218,
        0.2425345927476883
      ],
      "plane_d": 4598.58740234375,
      "bbox_min": [
        -3144.93408203125,
        -5028.2685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3053.76708984375,
        -4929.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3144.93408203125,
        -4965.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3053.76708984375,
        -4929.7685546875,
        1152.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4939.7685546875,
      "bbox_min": [
        -3133.822998046875,
        -4965.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3053.76708984375,
        -4929.7685546875,
        1152.623779296875
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.6122634410858154,
        0.7906539440155029,
        0.0
      ],
      "plane_d": 2056.304443359375,
      "bbox_min": [
        -3054.07763671875,
        -4965.7685546875,
        1152.064697265625
      ],
      "bbox_max": [
        -3053.76708984375,
        -4965.52783203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        0.38267579674720764,
        0.0
      ],
      "plane_d": -955.22900390625,
      "bbox_min": [
        -3133.822998046875,
        -4939.7685546875,
        1105.4046630859375
      ],
      "bbox_max": [
        -3064.878173828125,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": 3379.79541015625,
      "bbox_min": [
        -3077.07080078125,
        -4932.697265625,
        1110.6771240234375
      ],
      "bbox_max": [
        -3064.878173828125,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        0.9238893389701843,
        -0.0
      ],
      "plane_d": 5729.326171875,
      "bbox_min": [
        -3069.999755859375,
        -4931.8896484375,
        1123.4049072265625
      ],
      "bbox_max": [
        -3064.878173828125,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923882782459259,
        0.38267579674720764,
        -0.0
      ],
      "plane_d": 4772.84375,
      "bbox_min": [
        -3133.822998046875,
        -4939.7685546875,
        1107.742431640625
      ],
      "bbox_max": [
        -3119.999755859375,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        0.9238893389701843,
        -0.0
      ],
      "plane_d": 5752.28564453125,
      "bbox_min": [
        -3133.822998046875,
        -4932.697265625,
        1113.014404296875
      ],
      "bbox_max": [
        -3122.9287109375,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": 3356.835693359375,
      "bbox_min": [
        -3133.822998046875,
        -4931.35205078125,
        1125.7420654296875
      ],
      "bbox_max": [
        -3129.999755859375,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6037309765815735,
        0.7593981027603149,
        0.24253521859645844
      ],
      "plane_d": 5452.6083984375,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3290.5458984375,
        -4932.2685546875,
        1102.623779296875
      ],
      "bbox_max": [
        -3269.999755859375,
        -4919.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122634410858154,
        0.7906539440155029,
        0.0
      ],
      "plane_d": 5852.33740234375,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": 4850.76806640625,
      "bbox_min": [
        -3319.999755859375,
        -5028.2685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3137.9208984375,
        -4850.7685546875,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9701427221298218,
        0.2425345927476883
      ],
      "plane_d": 4598.58740234375,
      "bbox_min": [
        -3169.794189453125,
        -5028.2685546875,
        1140.0
      ],
      "bbox_max": [
        -3137.9208984375,
        -5025.11279296875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": 4850.76806640625,
      "bbox_min": [
        -3294.4287109375,
        -4850.7685546875,
        1098.123779296875
      ],
      "bbox_max": [
        -3269.999755859375,
        -4850.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": 0.334716796875,
      "bbox_min": [
        -3264.823974609375,
        -4965.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36590203642845154,
        0.9306533932685852,
        0.0
      ],
      "plane_d": 3241.628173828125,
      "bbox_min": [
        -3264.823974609375,
        -4817.24169921875,
        1092.623779296875
      ],
      "bbox_max": [
        -3196.425048828125,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4787.7001953125,
      "bbox_min": [
        -3264.823974609375,
        -4787.7001953125,
        1095.0
      ],
      "bbox_max": [
        -3240.564208984375,
        -4787.7001953125,
        1098.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4992690682411194,
        0.8664470314979553,
        0.0
      ],
      "plane_d": 5781.10546875,
      "bbox_min": [
        -3264.823974609375,
        -4817.24169921875,
        1092.623779296875
      ],
      "bbox_max": [
        -3219.147216796875,
        -4786.7001953125,
        1095.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4787.7001953125,
      "bbox_min": [
        -3264.823974609375,
        -4787.7001953125,
        1092.623779296875
      ],
      "bbox_max": [
        -3246.999755859375,
        -4786.7001953125,
        1095.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4786.7001953125,
      "bbox_min": [
        -3253.999755859375,
        -4786.7001953125,
        1092.623779296875
      ],
      "bbox_max": [
        -3246.999755859375,
        -4786.7001953125,
        1094.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9807850122451782,
        0.19509224593639374,
        0.0
      ],
      "plane_d": 4104.474609375,
      "bbox_min": [
        -3219.999755859375,
        -4965.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807848930358887,
        -0.19509220123291016,
        -9.289935292144946e-07
      ],
      "plane_d": 2211.781005859375,
      "bbox_min": [
        -3219.999755859375,
        -4965.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1152.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1094.9998779296875,
      "bbox_min": [
        -3219.147216796875,
        -4820.24853515625,
        1092.623779296875
      ],
      "bbox_max": [
        -3211.66259765625,
        -4808.0712890625,
        1095.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4992690682411194,
        0.8664470314979553,
        0.0
      ],
      "plane_d": 5781.10546875,
      "bbox_min": [
        -3219.147216796875,
        -4820.24853515625,
        1092.623779296875
      ],
      "bbox_max": [
        -3213.928955078125,
        -4817.24169921875,
        1095.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": 4965.76806640625,
      "bbox_min": [
        -3164.42626953125,
        -4965.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1152.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": 3356.835693359375,
      "bbox_min": [
        -3137.07080078125,
        -4939.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4929.7685546875,
        1132.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        0.9238893389701843,
        -0.0
      ],
      "plane_d": 5752.28564453125,
      "bbox_min": [
        -3129.999755859375,
        -4939.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4929.7685546875,
        1125.7420654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923882782459259,
        0.38267579674720764,
        -0.0
      ],
      "plane_d": 4772.84375,
      "bbox_min": [
        -3122.9287109375,
        -4939.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4932.697265625,
        1113.014404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4939.7685546875,
      "bbox_min": [
        -3119.999755859375,
        -4939.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4939.7685546875,
        1107.7423095703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.19509725272655487,
        0.9807839393615723,
        0.0
      ],
      "plane_d": 4078.82666015625,
      "bbox_min": [
        -3164.42626953125,
        -4797.34228515625,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4779.7685546875,
      "bbox_min": [
        -3121.999755859375,
        -4779.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3111.6005859375,
        -4779.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 5390.181640625,
      "bbox_min": [
        -3319.999755859375,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3087.100341796875,
        -4740.6494140625,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4850.76806640625,
      "bbox_min": [
        -3319.999755859375,
        -4850.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3314.499755859375,
        -4850.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": 0.334716796875,
      "bbox_min": [
        -3264.823974609375,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3087.100341796875,
        -4740.6494140625,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36590203642845154,
        0.9306533932685852,
        0.0
      ],
      "plane_d": 3241.62841796875,
      "bbox_min": [
        -3264.823974609375,
        -4817.24169921875,
        1052.623779296875
      ],
      "bbox_max": [
        -3198.3232421875,
        -4740.6494140625,
        1092.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4786.7001953125,
      "bbox_min": [
        -3253.999755859375,
        -4786.7001953125,
        1082.623779296875
      ],
      "bbox_max": [
        -3253.0908203125,
        -4786.7001953125,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7291637659072876,
        0.6843392848968506,
        -0.0
      ],
      "plane_d": 5600.9111328125,
      "bbox_min": [
        -3231.940185546875,
        -4750.33740234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3222.96435546875,
        -4740.7734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807850122451782,
        0.19509224593639374,
        0.0
      ],
      "plane_d": 4104.474609375,
      "bbox_min": [
        -3219.999755859375,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3087.100341796875,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122634410858154,
        0.7906539440155029,
        0.0
      ],
      "plane_d": 5852.33740234375,
      "bbox_min": [
        -3219.999755859375,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3087.100341796875,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3219.999755859375,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3087.100341796875,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9807846546173096,
        -0.1950935274362564,
        3.671312470032717e-06
      ],
      "plane_d": 2211.76904296875,
      "bbox_min": [
        -3219.999755859375,
        -4939.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3087.100341796875,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.4992690682411194,
        0.8664470314979553,
        0.0
      ],
      "plane_d": 5781.10546875,
      "bbox_min": [
        -3219.147216796875,
        -4820.24853515625,
        1082.623779296875
      ],
      "bbox_max": [
        -3213.928955078125,
        -4817.24169921875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        0.38267579674720764,
        0.0
      ],
      "plane_d": -1010.661865234375,
      "bbox_min": [
        -3139.999755859375,
        -4939.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3122.9287109375,
        -4929.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        0.9238893389701843,
        -0.0
      ],
      "plane_d": 5752.28564453125,
      "bbox_min": [
        -3129.999755859375,
        -4932.697265625,
        1052.623779296875
      ],
      "bbox_max": [
        -3122.9287109375,
        -4929.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33401647210121155,
        0.13982084393501282,
        0.932138979434967
      ],
      "plane_d": -1349.8382568359375,
      "bbox_min": [
        -3213.928955078125,
        -4899.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3087.100341796875,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2501220405101776,
        0.0,
        -0.9682143926620483
      ],
      "plane_d": 1804.04833984375,
      "bbox_min": [
        -3137.999755859375,
        -4899.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3100.572265625,
        -4859.7685546875,
        1070.3240966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3137.999755859375,
        -4899.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3100.572265625,
        -4859.7685546875,
        1070.3240966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23462752997875214,
        -0.04854360595345497,
        -0.9708725214004517
      ],
      "plane_d": 66.652587890625,
      "bbox_min": [
        -3115.8916015625,
        -4899.7685546875,
        1062.7064208984375
      ],
      "bbox_max": [
        -3100.572265625,
        -4879.7685546875,
        1070.3240966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33401644229888916,
        0.13982084393501282,
        0.932138979434967
      ],
      "plane_d": 723.85986328125,
      "bbox_min": [
        -3112.388427734375,
        -4899.7685546875,
        1062.7064208984375
      ],
      "bbox_max": [
        -3100.572265625,
        -4879.7685546875,
        1070.3240966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3112.388427734375,
        -4899.7685546875,
        1062.7064208984375
      ],
      "bbox_max": [
        -3100.572265625,
        -4879.7685546875,
        1070.3240966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3780319392681122,
        0.0,
        0.9257925748825073
      ],
      "plane_d": 183.02239990234375,
      "bbox_min": [
        -3105.34765625,
        -4899.7685546875,
        1068.3741455078125
      ],
      "bbox_max": [
        -3100.572265625,
        -4892.6259765625,
        1070.3240966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2501220405101776,
        0.0,
        -0.9682143330574036
      ],
      "plane_d": 253.29180908203125,
      "bbox_min": [
        -3115.8916015625,
        -4899.7685546875,
        1063.314453125
      ],
      "bbox_max": [
        -3103.38330078125,
        -4893.56298828125,
        1066.5457763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3137.999755859375,
        -4859.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3104.516845703125,
        -4859.7685546875,
        1061.2734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701396822929382,
        0.0,
        -0.24254676699638367
      ],
      "plane_d": -2753.6748046875,
      "bbox_min": [
        -3213.928955078125,
        -4899.7685546875,
        1057.5238037109375
      ],
      "bbox_max": [
        -3087.100341796875,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 4745.90283203125,
      "bbox_min": [
        -3111.6005859375,
        -4899.7685546875,
        1062.2100830078125
      ],
      "bbox_max": [
        -3087.100341796875,
        -4759.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3780319392681122,
        0.0,
        0.9257925748825073
      ],
      "plane_d": 183.02239990234375,
      "bbox_min": [
        -3106.102294921875,
        -4899.7685546875,
        1067.3477783203125
      ],
      "bbox_max": [
        -3104.185791015625,
        -4879.7685546875,
        1070.63232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3105.496826171875,
        -4879.7685546875,
        1067.3477783203125
      ],
      "bbox_max": [
        -3104.185791015625,
        -4879.7685546875,
        1068.210205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17693176865577698,
        -0.033184535801410675,
        -0.9836634993553162
      ],
      "plane_d": 334.79840087890625,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1064.801025390625
      ],
      "bbox_max": [
        -3105.28125,
        -4769.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14150792360305786,
        -0.04840825870633125,
        -0.9887527823448181
      ],
      "plane_d": 377.13336181640625,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1064.804931640625
      ],
      "bbox_max": [
        -3105.28125,
        -4769.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17616158723831177,
        0.03705311939120293,
        -0.9836636781692505
      ],
      "plane_d": 680.149658203125,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1065.4927978515625
      ],
      "bbox_max": [
        -3105.28125,
        -4769.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14644506573677063,
        0.15934692323207855,
        -0.9763004183769226
      ],
      "plane_d": 1359.9833984375,
      "bbox_min": [
        -3181.999755859375,
        -4899.7685546875,
        1065.4927978515625
      ],
      "bbox_max": [
        -3105.28125,
        -4769.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15917500853538513,
        0.14545495808124542,
        0.9764764308929443
      ],
      "plane_d": 157.85400390625,
      "bbox_min": [
        -3177.4326171875,
        -4899.7685546875,
        1065.4927978515625
      ],
      "bbox_max": [
        -3105.28125,
        -4779.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16064220666885376,
        0.1464139223098755,
        0.9760926961898804
      ],
      "plane_d": 167.546630859375,
      "bbox_min": [
        -3177.4326171875,
        -4899.7685546875,
        1065.4927978515625
      ],
      "bbox_max": [
        -3105.28125,
        -4848.3837890625,
        1077.311279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1758042424917221,
        0.038869597017765045,
        -0.9836574792861938
      ],
      "plane_d": 690.1115112304688,
      "bbox_min": [
        -3177.4326171875,
        -4899.7685546875,
        1065.4927978515625
      ],
      "bbox_max": [
        -3105.28125,
        -4848.3837890625,
        1077.311279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33401644229888916,
        0.13982084393501282,
        0.932138979434967
      ],
      "plane_d": 723.85986328125,
      "bbox_min": [
        -3160.285888671875,
        -4899.7685546875,
        1065.4927978515625
      ],
      "bbox_max": [
        -3105.28125,
        -4848.3837890625,
        1077.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3780319392681122,
        0.0,
        0.9257925748825073
      ],
      "plane_d": 183.02239990234375,
      "bbox_min": [
        -3160.285888671875,
        -4899.7685546875,
        1065.4927978515625
      ],
      "bbox_max": [
        -3105.28125,
        -4848.3837890625,
        1077.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555734634399414,
        0.8314674496650696,
        -0.0
      ],
      "plane_d": 5797.841796875,
      "bbox_min": [
        -3160.285888671875,
        -4879.7685546875,
        1065.4927978515625
      ],
      "bbox_max": [
        -3105.28125,
        -4848.3837890625,
        1077.010009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3160.285888671875,
        -4879.7685546875,
        1065.4927978515625
      ],
      "bbox_max": [
        -3105.28125,
        -4848.3837890625,
        1077.010009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        0.5555662512779236,
        -0.0
      ],
      "plane_d": 5323.8994140625,
      "bbox_min": [
        -3160.285888671875,
        -4879.7685546875,
        1067.14453125
      ],
      "bbox_max": [
        -3121.999755859375,
        -4848.3837890625,
        1077.010009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        0.19509923458099365,
        -0.0
      ],
      "plane_d": 4045.47216796875,
      "bbox_min": [
        -3160.285888671875,
        -4855.07568359375,
        1074.4185791015625
      ],
      "bbox_max": [
        -3158.954833984375,
        -4848.3837890625,
        1076.4903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555734634399414,
        0.8314674496650696,
        -0.0
      ],
      "plane_d": 5797.841796875,
      "bbox_min": [
        -3162.8212890625,
        -4876.7236328125,
        1075.7105712890625
      ],
      "bbox_max": [
        -3137.30712890625,
        -4838.54638671875,
        1078.74072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        0.19509923458099365,
        -0.0
      ],
      "plane_d": 4045.47216796875,
      "bbox_min": [
        -3162.8212890625,
        -4855.07568359375,
        1075.7105712890625
      ],
      "bbox_max": [
        -3158.954833984375,
        -4838.54638671875,
        1078.74072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07161380350589752,
        0.2093566656112671,
        -0.9752134084701538
      ],
      "plane_d": 1837.46435546875,
      "bbox_min": [
        -3162.8212890625,
        -4839.7685546875,
        1077.373779296875
      ],
      "bbox_max": [
        -3161.999755859375,
        -4838.54638671875,
        1077.6964111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07161380350589752,
        0.2093566656112671,
        -0.9752134084701538
      ],
      "plane_d": 1837.46435546875,
      "bbox_min": [
        -3162.180419921875,
        -4839.7685546875,
        1077.373779296875
      ],
      "bbox_max": [
        -3161.85107421875,
        -4838.8603515625,
        1077.64697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": 2157.001953125,
      "bbox_min": [
        -3161.999755859375,
        -4839.7685546875,
        1077.373779296875
      ],
      "bbox_max": [
        -3161.85107421875,
        -4839.021484375,
        1077.64697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1221439465880394,
        0.05059312283992767,
        -0.991222083568573
      ],
      "plane_d": 1706.1895751953125,
      "bbox_min": [
        -3177.4326171875,
        -4882.19482421875,
        1076.186279296875
      ],
      "bbox_max": [
        -3121.999755859375,
        -4779.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19617928564548492,
        0.0,
        -0.9805680513381958
      ],
      "plane_d": 1683.86376953125,
      "bbox_min": [
        -3177.4326171875,
        -4882.19482421875,
        1082.5341796875
      ],
      "bbox_max": [
        -3121.999755859375,
        -4779.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555662512779236,
        0.8314722776412964,
        0.0
      ],
      "plane_d": 2230.80859375,
      "bbox_min": [
        -3177.4326171875,
        -4879.146484375,
        1083.564453125
      ],
      "bbox_max": [
        -3121.999755859375,
        -4779.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509725272655487,
        0.9807839393615723,
        0.0
      ],
      "plane_d": 4078.82666015625,
      "bbox_min": [
        -3177.4326171875,
        -4879.146484375,
        1083.564453125
      ],
      "bbox_max": [
        -3121.999755859375,
        -4779.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": 2157.001953125,
      "bbox_min": [
        -3177.4326171875,
        -4864.76513671875,
        1083.564453125
      ],
      "bbox_max": [
        -3158.954833984375,
        -4824.46142578125,
        1087.436279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25476783514022827,
        0.01656128093600273,
        0.9668603539466858
      ],
      "plane_d": -160.2706298828125,
      "bbox_min": [
        -3177.4326171875,
        -4864.76513671875,
        1083.564453125
      ],
      "bbox_max": [
        -3167.051025390625,
        -4858.52490234375,
        1086.311279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25508740544319153,
        0.018345549702644348,
        0.9667438864707947
      ],
      "plane_d": -150.4522705078125,
      "bbox_min": [
        -3167.28173828125,
        -4882.19482421875,
        1082.5341796875
      ],
      "bbox_max": [
        -3161.68212890625,
        -4857.9853515625,
        1083.7283935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25476783514022827,
        0.01656128093600273,
        0.9668603539466858
      ],
      "plane_d": -160.2706298828125,
      "bbox_min": [
        -3167.28173828125,
        -4882.19482421875,
        1082.5341796875
      ],
      "bbox_max": [
        -3161.68212890625,
        -4857.9853515625,
        1083.610595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24678322672843933,
        0.027199994772672653,
        0.9686889052391052
      ],
      "plane_d": -135.60809326171875,
      "bbox_min": [
        -3164.42626953125,
        -4882.19482421875,
        1082.5341796875
      ],
      "bbox_max": [
        -3161.68212890625,
        -4879.830078125,
        1083.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0005590629298239946,
        0.36375975608825684,
        -0.9314926862716675
      ],
      "plane_d": 2759.59716796875,
      "bbox_min": [
        -3177.4326171875,
        -4881.64111328125,
        1076.186279296875
      ],
      "bbox_max": [
        -3137.30712890625,
        -4784.3359375,
        1089.561279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07161380350589752,
        0.2093566656112671,
        -0.9752134084701538
      ],
      "plane_d": 1837.46435546875,
      "bbox_min": [
        -3177.4326171875,
        -4881.64111328125,
        1076.186279296875
      ],
      "bbox_max": [
        -3137.30712890625,
        -4801.0615234375,
        1089.561279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24678322672843933,
        0.027199994772672653,
        0.9686889052391052
      ],
      "plane_d": -135.60809326171875,
      "bbox_min": [
        -3165.979248046875,
        -4881.64111328125,
        1076.186279296875
      ],
      "bbox_max": [
        -3137.30712890625,
        -4801.0615234375,
        1089.561279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        0.19509923458099365,
        -0.0
      ],
      "plane_d": 4045.47216796875,
      "bbox_min": [
        -3161.999755859375,
        -4876.7236328125,
        1076.186279296875
      ],
      "bbox_max": [
        -3137.30712890625,
        -4825.1875,
        1081.439208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555734634399414,
        0.8314674496650696,
        -0.0
      ],
      "plane_d": 5797.841796875,
      "bbox_min": [
        -3161.999755859375,
        -4876.7236328125,
        1076.186279296875
      ],
      "bbox_max": [
        -3137.30712890625,
        -4825.1875,
        1081.439208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        0.5555662512779236,
        -0.0
      ],
      "plane_d": 5323.8994140625,
      "bbox_min": [
        -3161.999755859375,
        -4868.052734375,
        1077.5233154296875
      ],
      "bbox_max": [
        -3150.283935546875,
        -4825.1875,
        1081.439208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": 2157.001953125,
      "bbox_min": [
        -3161.999755859375,
        -4839.7685546875,
        1077.5233154296875
      ],
      "bbox_max": [
        -3159.099365234375,
        -4825.1875,
        1081.439208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        0.5555662512779236,
        -0.0
      ],
      "plane_d": 5323.8994140625,
      "bbox_min": [
        -3165.979248046875,
        -4879.830078125,
        1079.248779296875
      ],
      "bbox_max": [
        -3137.30712890625,
        -4801.0615234375,
        1089.561279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25476783514022827,
        0.01656128093600273,
        0.9668603539466858
      ],
      "plane_d": -160.2706298828125,
      "bbox_min": [
        -3165.979248046875,
        -4868.052734375,
        1079.248779296875
      ],
      "bbox_max": [
        -3150.283935546875,
        -4855.07568359375,
        1083.2120361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        0.19509923458099365,
        -0.0
      ],
      "plane_d": 4045.47216796875,
      "bbox_min": [
        -3161.999755859375,
        -4855.07568359375,
        1080.291015625
      ],
      "bbox_max": [
        -3137.30712890625,
        -4801.0615234375,
        1089.561279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": 2157.001953125,
      "bbox_min": [
        -3161.999755859375,
        -4839.7685546875,
        1080.291015625
      ],
      "bbox_max": [
        -3137.30712890625,
        -4801.0615234375,
        1089.561279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23699171841144562,
        0.09816411882638931,
        -0.9665395617485046
      ],
      "plane_d": 2268.083740234375,
      "bbox_min": [
        -3150.283935546875,
        -4811.484375,
        1085.498779296875
      ],
      "bbox_max": [
        -3137.30712890625,
        -4801.0615234375,
        1089.561279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.051469944417476654,
        0.1215628981590271,
        -0.9912483096122742
      ],
      "plane_d": 1823.041748046875,
      "bbox_min": [
        -3177.4326171875,
        -4816.8076171875,
        1083.436279296875
      ],
      "bbox_max": [
        -3138.03271484375,
        -4784.3359375,
        1089.561279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14628201723098755,
        0.16601243615150452,
        -0.9752134680747986
      ],
      "plane_d": 1391.5875244140625,
      "bbox_min": [
        -3181.999755859375,
        -4856.10205078125,
        1069.885009765625
      ],
      "bbox_max": [
        -3106.37109375,
        -4769.7685546875,
        1080.373779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807834625244141,
        0.19509923458099365,
        -0.0
      ],
      "plane_d": 4045.47216796875,
      "bbox_min": [
        -3161.999755859375,
        -4856.10205078125,
        1074.1480712890625
      ],
      "bbox_max": [
        -3158.268798828125,
        -4839.7685546875,
        1077.373779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1758042424917221,
        0.038869597017765045,
        -0.9836574792861938
      ],
      "plane_d": 690.1115112304688,
      "bbox_min": [
        -3160.296630859375,
        -4855.98486328125,
        1074.2430419921875
      ],
      "bbox_max": [
        -3158.77392578125,
        -4855.07568359375,
        1074.5291748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        0.5555662512779236,
        -0.0
      ],
      "plane_d": 5323.8994140625,
      "bbox_min": [
        -3158.954833984375,
        -4856.10205078125,
        1074.1480712890625
      ],
      "bbox_max": [
        -3158.268798828125,
        -4855.07568359375,
        1074.4185791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1758042424917221,
        0.038869597017765045,
        -0.9836574792861938
      ],
      "plane_d": 690.1115112304688,
      "bbox_min": [
        -3158.954833984375,
        -4856.10205078125,
        1074.1480712890625
      ],
      "bbox_max": [
        -3158.268798828125,
        -4855.07568359375,
        1074.311279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3106.600341796875,
      "bbox_min": [
        -3106.600341796875,
        -4789.7685546875,
        1069.885009765625
      ],
      "bbox_max": [
        -3106.37109375,
        -4769.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4769.7685546875,
      "bbox_min": [
        -3106.600341796875,
        -4769.7685546875,
        1071.7066650390625
      ],
      "bbox_max": [
        -3106.37109375,
        -4769.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1940375715494156,
        0.0555294007062912,
        -0.9794212579727173
      ],
      "plane_d": 709.2298583984375,
      "bbox_min": [
        -3164.42626953125,
        -4882.19482421875,
        1068.1536865234375
      ],
      "bbox_max": [
        -3129.5654296875,
        -4868.052734375,
        1074.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555734634399414,
        0.8314674496650696,
        -0.0
      ],
      "plane_d": 5797.841796875,
      "bbox_min": [
        -3150.283935546875,
        -4878.263671875,
        1068.1536865234375
      ],
      "bbox_max": [
        -3129.5654296875,
        -4868.052734375,
        1072.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509625434875488,
        0.9807841777801514,
        -0.0
      ],
      "plane_d": 5395.08984375,
      "bbox_min": [
        -3137.30712890625,
        -4878.263671875,
        1068.1536865234375
      ],
      "bbox_max": [
        -3129.5654296875,
        -4876.7236328125,
        1069.59814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.143018901348114,
        -0.04942425712943077,
        -0.9884851574897766
      ],
      "plane_d": 367.152099609375,
      "bbox_min": [
        -3137.30712890625,
        -4899.7685546875,
        1064.804931640625
      ],
      "bbox_max": [
        -3110.458251953125,
        -4876.7236328125,
        1069.186279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2501220405101776,
        0.0,
        -0.9682143330574036
      ],
      "plane_d": 253.29180908203125,
      "bbox_min": [
        -3121.999755859375,
        -4899.7685546875,
        1066.4066162109375
      ],
      "bbox_max": [
        -3115.3525390625,
        -4897.552734375,
        1068.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23462752997875214,
        -0.04854360595345497,
        -0.9708725214004517
      ],
      "plane_d": 66.652587890625,
      "bbox_min": [
        -3112.48291015625,
        -4879.98828125,
        1064.801025390625
      ],
      "bbox_max": [
        -3112.377685546875,
        -4879.7685546875,
        1064.8238525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3112.48291015625,
        -4879.7685546875,
        1064.801025390625
      ],
      "bbox_max": [
        -3112.377685546875,
        -4879.7685546875,
        1064.8238525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3106.600341796875,
      "bbox_min": [
        -3213.928955078125,
        -4823.02880859375,
        1057.5238037109375
      ],
      "bbox_max": [
        -3103.996826171875,
        -4769.7685546875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4769.7685546875,
      "bbox_min": [
        -3106.600341796875,
        -4769.7685546875,
        1057.5238037109375
      ],
      "bbox_max": [
        -3103.996826171875,
        -4769.7685546875,
        1071.7528076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1081.1998291015625,
      "bbox_min": [
        -3213.928955078125,
        -4823.02880859375,
        1081.199951171875
      ],
      "bbox_max": [
        -3206.739501953125,
        -4808.85498046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807847142219543,
        -0.1950935274362564,
        0.0
      ],
      "plane_d": 2206.40234375,
      "bbox_min": [
        -3211.66259765625,
        -4823.02880859375,
        1081.199951171875
      ],
      "bbox_max": [
        -3206.739501953125,
        -4808.85498046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4917427897453308,
        0.870740532875061,
        -0.0
      ],
      "plane_d": 5766.5771484375,
      "bbox_min": [
        -3211.66259765625,
        -4811.63525390625,
        1081.199951171875
      ],
      "bbox_max": [
        -3206.739501953125,
        -4808.85498046875,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9056034088134766,
        0.4241255521774292,
        -0.0
      ],
      "plane_d": 4710.7529296875,
      "bbox_min": [
        -3109.32275390625,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 235.0537109375,
      "bbox_min": [
        -3109.32275390625,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4739.90283203125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6037311553955078,
        0.759398341178894,
        0.24253442883491516
      ],
      "plane_d": 1709.478515625,
      "bbox_min": [
        -3060.780029296875,
        -5028.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4919.7685546875,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7047529220581055,
        0.6667083501815796,
        0.24253523349761963
      ],
      "plane_d": 947.6998901367188,
      "bbox_min": [
        -3060.780029296875,
        -5028.2685546875,
        1062.337158203125
      ],
      "bbox_max": [
        -2920.0,
        -4919.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701427221298218,
        0.2425345927476883
      ],
      "plane_d": 4598.58740234375,
      "bbox_min": [
        -3060.780029296875,
        -5028.2685546875,
        1140.0
      ],
      "bbox_max": [
        -3030.205322265625,
        -5025.11279296875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36590203642845154,
        0.9306533932685852,
        0.0
      ],
      "plane_d": 5510.220703125,
      "bbox_min": [
        -3001.92333984375,
        -4750.33740234375,
        1052.623779296875
      ],
      "bbox_max": [
        -2977.03515625,
        -4740.5517578125,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38265982270240784,
        0.9238893389701843,
        -0.0
      ],
      "plane_d": 5729.326171875,
      "bbox_min": [
        -3109.32275390625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3054.07763671875,
        -4859.7685546875,
        1152.0648193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3109.32275390625,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3054.07763671875,
        -4929.7685546875,
        1152.0648193359375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": 3379.79541015625,
      "bbox_min": [
        -3087.1005859375,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3069.999755859375,
        -4929.7685546875,
        1123.4049072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923882782459259,
        0.38267579674720764,
        0.0
      ],
      "plane_d": -955.22900390625,
      "bbox_min": [
        -3087.1005859375,
        -4965.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3077.07080078125,
        -4932.697265625,
        1110.6771240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3087.1005859375,
        -4965.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3077.07080078125,
        -4939.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1092.623779296875,
      "bbox_min": [
        -3087.1005859375,
        -4956.91162109375,
        1092.623779296875
      ],
      "bbox_max": [
        -3079.999755859375,
        -4939.7685546875,
        1105.4046630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4939.7685546875,
      "bbox_min": [
        -3087.100341796875,
        -4939.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3079.999755859375,
        -4939.7685546875,
        1105.4046630859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2501220405101776,
        0.0,
        -0.9682143330574036
      ],
      "plane_d": 253.29180908203125,
      "bbox_min": [
        -3104.875,
        -4899.7685546875,
        1056.38720703125
      ],
      "bbox_max": [
        -3076.568115234375,
        -4859.7685546875,
        1073.87744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3780319392681122,
        0.0,
        0.9257925748825073
      ],
      "plane_d": 183.02239990234375,
      "bbox_min": [
        -3103.383056640625,
        -4899.7685546875,
        1058.52734375
      ],
      "bbox_max": [
        -3076.568115234375,
        -4859.7685546875,
        1073.87744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33401644229888916,
        0.13982084393501282,
        0.932138979434967
      ],
      "plane_d": 723.85986328125,
      "bbox_min": [
        -3103.383056640625,
        -4892.6259765625,
        1058.52734375
      ],
      "bbox_max": [
        -3082.07958984375,
        -4859.7685546875,
        1068.3741455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3103.383056640625,
        -4879.7685546875,
        1058.52734375
      ],
      "bbox_max": [
        -3084.85205078125,
        -4859.7685546875,
        1066.7657470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2501220405101776,
        0.0,
        -0.9682143926620483
      ],
      "plane_d": 1804.04833984375,
      "bbox_min": [
        -3103.383056640625,
        -4879.7685546875,
        1062.11328125
      ],
      "bbox_max": [
        -3093.83740234375,
        -4859.7685546875,
        1064.263916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3103.383056640625,
        -4859.7685546875,
        1062.4404296875
      ],
      "bbox_max": [
        -3098.7021484375,
        -4859.7685546875,
        1064.263916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3099.999755859375,
        -4859.7685546875,
        1062.11328125
      ],
      "bbox_max": [
        -3097.61083984375,
        -4859.7685546875,
        1062.775634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33401647210121155,
        0.13982084393501282,
        0.932138979434967
      ],
      "plane_d": -1349.8382568359375,
      "bbox_min": [
        -3102.855712890625,
        -4879.7685546875,
        1062.384521484375
      ],
      "bbox_max": [
        -3091.44970703125,
        -4859.7685546875,
        1068.1405029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3102.855712890625,
        -4879.7685546875,
        1062.384521484375
      ],
      "bbox_max": [
        -3091.44970703125,
        -4859.7685546875,
        1067.1285400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2501220405101776,
        0.0,
        -0.9682143926620483
      ],
      "plane_d": 1804.04833984375,
      "bbox_min": [
        -3095.234619140625,
        -4879.7685546875,
        1063.67138671875
      ],
      "bbox_max": [
        -3091.44970703125,
        -4874.02392578125,
        1064.649169921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33401647210121155,
        0.13982084393501282,
        0.932138979434967
      ],
      "plane_d": -1349.8382568359375,
      "bbox_min": [
        -3099.99951171875,
        -4879.7685546875,
        1064.649169921875
      ],
      "bbox_max": [
        -3084.852294921875,
        -4859.7685546875,
        1073.87744140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2501220405101776,
        0.0,
        -0.9682143926620483
      ],
      "plane_d": 1804.04833984375,
      "bbox_min": [
        -3097.521484375,
        -4879.7685546875,
        1064.649169921875
      ],
      "bbox_max": [
        -3084.852294921875,
        -4859.7685546875,
        1068.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3097.521484375,
        -4859.7685546875,
        1065.337890625
      ],
      "bbox_max": [
        -3093.135986328125,
        -4859.7685546875,
        1068.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3104.210693359375,
        -4879.7685546875,
        1058.146484375
      ],
      "bbox_max": [
        -3084.85205078125,
        -4859.7685546875,
        1063.314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3104.210693359375,
        -4879.7685546875,
        1061.30712890625
      ],
      "bbox_max": [
        -3098.733154296875,
        -4859.7685546875,
        1063.314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2501220405101776,
        0.0,
        -0.9682143926620483
      ],
      "plane_d": 1804.04833984375,
      "bbox_min": [
        -3102.068603515625,
        -4879.7685546875,
        1061.906005859375
      ],
      "bbox_max": [
        -3099.999755859375,
        -4871.74609375,
        1062.4404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2501220405101776,
        0.0,
        -0.9682143926620483
      ],
      "plane_d": 1804.04833984375,
      "bbox_min": [
        -3104.875,
        -4879.7685546875,
        1060.62890625
      ],
      "bbox_max": [
        -3101.266357421875,
        -4859.7685546875,
        1062.11328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3104.51708984375,
        -4859.7685546875,
        1061.2734375
      ],
      "bbox_max": [
        -3103.26611328125,
        -4859.7685546875,
        1061.8248291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701425433158875,
        0.0,
        -0.24253563582897186
      ],
      "plane_d": 3259.927734375,
      "bbox_min": [
        -3106.600341796875,
        -4899.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3017.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3093.135986328125,
        -4859.9287109375,
        1068.482421875
      ],
      "bbox_max": [
        -3093.069580078125,
        -4859.7685546875,
        1068.7476806640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -3106.600341796875,
      "bbox_min": [
        -3106.600341796875,
        -4779.76904296875,
        1052.623779296875
      ],
      "bbox_max": [
        -3106.600341796875,
        -4769.7685546875,
        1057.5238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.15917502343654633,
        0.14545495808124542,
        0.9764764308929443
      ],
      "plane_d": -831.9400634765625,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1063.4658203125
      ],
      "bbox_max": [
        -3022.56689453125,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17616155743598938,
        0.03705311194062233,
        -0.9836636185646057
      ],
      "plane_d": 1771.610107421875,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1063.4658203125
      ],
      "bbox_max": [
        -3022.56689453125,
        -4828.38427734375,
        1077.311279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16064220666885376,
        0.1464138925075531,
        0.9760926961898804
      ],
      "plane_d": -831.3634643554688,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1064.03125
      ],
      "bbox_max": [
        -3022.56689453125,
        -4828.38427734375,
        1077.311279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1758042573928833,
        0.03886957839131355,
        -0.9836574792861938
      ],
      "plane_d": 1779.3203125,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1064.03125
      ],
      "bbox_max": [
        -3022.56689453125,
        -4828.38427734375,
        1077.311279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33401647210121155,
        0.13982084393501282,
        0.932138979434967
      ],
      "plane_d": -1349.8382568359375,
      "bbox_min": [
        -3093.13623046875,
        -4879.7685546875,
        1064.03125
      ],
      "bbox_max": [
        -3039.713623046875,
        -4828.38427734375,
        1077.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2501220405101776,
        0.0,
        -0.9682143926620483
      ],
      "plane_d": 1804.04833984375,
      "bbox_min": [
        -3085.949951171875,
        -4879.7685546875,
        1066.0699462890625
      ],
      "bbox_max": [
        -3077.999755859375,
        -4877.11865234375,
        1068.123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 157.660400390625,
      "bbox_min": [
        -3093.13623046875,
        -4859.7685546875,
        1064.03125
      ],
      "bbox_max": [
        -3039.713623046875,
        -4828.38427734375,
        1077.010009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509625434875488,
        0.9807841777801514,
        0.0
      ],
      "plane_d": 4165.87744140625,
      "bbox_min": [
        -3093.13623046875,
        -4859.7685546875,
        1064.03125
      ],
      "bbox_max": [
        -3039.713623046875,
        -4828.38427734375,
        1076.4903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3093.13623046875,
        -4859.7685546875,
        1064.03125
      ],
      "bbox_max": [
        -3039.713623046875,
        -4828.38427734375,
        1076.4903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        0.19509923458099365,
        0.0
      ],
      "plane_d": -2039.2867431640625,
      "bbox_min": [
        -3041.044677734375,
        -4835.07568359375,
        1074.4188232421875
      ],
      "bbox_max": [
        -3039.713623046875,
        -4828.38427734375,
        1076.4903564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555734634399414,
        0.8314674496650696,
        0.0
      ],
      "plane_d": 2336.656982421875,
      "bbox_min": [
        -3093.13623046875,
        -4859.7685546875,
        1063.4658203125
      ],
      "bbox_max": [
        -3049.715576171875,
        -4848.052734375,
        1072.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4859.76806640625,
      "bbox_min": [
        -3093.13623046875,
        -4859.7685546875,
        1063.4658203125
      ],
      "bbox_max": [
        -3062.6923828125,
        -4856.7236328125,
        1069.59814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509625434875488,
        0.9807841777801514,
        0.0
      ],
      "plane_d": 4165.87744140625,
      "bbox_min": [
        -3070.636962890625,
        -4858.3037109375,
        1068.1158447265625
      ],
      "bbox_max": [
        -3062.6923828125,
        -4856.7236328125,
        1069.59814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2286498099565506,
        0.11457086354494095,
        0.9667434096336365
      ],
      "plane_d": -1184.240966796875,
      "bbox_min": [
        -3087.100341796875,
        -4875.201171875,
        1075.7105712890625
      ],
      "bbox_max": [
        -3022.56689453125,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 157.660400390625,
      "bbox_min": [
        -3062.6923828125,
        -4856.7236328125,
        1075.7105712890625
      ],
      "bbox_max": [
        -3037.178955078125,
        -4818.54736328125,
        1078.74072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555734634399414,
        0.8314674496650696,
        0.0
      ],
      "plane_d": 2336.656982421875,
      "bbox_min": [
        -3062.6923828125,
        -4856.7236328125,
        1075.7105712890625
      ],
      "bbox_max": [
        -3037.178955078125,
        -4818.54736328125,
        1078.74072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        0.19509923458099365,
        0.0
      ],
      "plane_d": -2039.2867431640625,
      "bbox_min": [
        -3041.044677734375,
        -4835.07568359375,
        1075.7105712890625
      ],
      "bbox_max": [
        -3037.178955078125,
        -4818.54736328125,
        1078.74072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07161381840705872,
        0.20935668051242828,
        -0.9752134680747986
      ],
      "plane_d": 2277.282958984375,
      "bbox_min": [
        -3037.999755859375,
        -4819.7685546875,
        1077.373779296875
      ],
      "bbox_max": [
        -3037.178955078125,
        -4818.54736328125,
        1077.6961669921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07161381840705872,
        0.20935668051242828,
        -0.9752134680747986
      ],
      "plane_d": 2277.282958984375,
      "bbox_min": [
        -3038.148193359375,
        -4819.7685546875,
        1077.373779296875
      ],
      "bbox_max": [
        -3037.819091796875,
        -4818.86083984375,
        1077.646728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": -3919.953125,
      "bbox_min": [
        -3038.148193359375,
        -4819.7685546875,
        1077.373779296875
      ],
      "bbox_max": [
        -3037.999755859375,
        -4819.02197265625,
        1077.646728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555662512779236,
        0.8314722776412964,
        0.0
      ],
      "plane_d": 5658.68994140625,
      "bbox_min": [
        -3087.100341796875,
        -4862.19482421875,
        1076.186279296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509725272655487,
        0.9807839393615723,
        0.0
      ],
      "plane_d": 5268.81396484375,
      "bbox_min": [
        -3087.100341796875,
        -4862.19482421875,
        1076.186279296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12214395403862,
        0.05059313401579857,
        -0.991222083568573
      ],
      "plane_d": 947.8853759765625,
      "bbox_min": [
        -3087.100341796875,
        -4862.19482421875,
        1076.186279296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19617927074432373,
        -0.0,
        -0.980567991733551
      ],
      "plane_d": 467.55218505859375,
      "bbox_min": [
        -3086.517333984375,
        -4862.19482421875,
        1082.5341796875
      ],
      "bbox_max": [
        -3035.5732421875,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": -5197.7412109375,
      "bbox_min": [
        -3086.18994140625,
        -4817.6923828125,
        1084.7890625
      ],
      "bbox_max": [
        -3038.41259765625,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": -3919.953125,
      "bbox_min": [
        -3086.18994140625,
        -4817.6923828125,
        1084.7890625
      ],
      "bbox_max": [
        -3038.41259765625,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4759.7685546875,
      "bbox_min": [
        -3086.18994140625,
        -4759.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3077.999755859375,
        -4759.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4759.7685546875,
      "bbox_min": [
        -3086.517333984375,
        -4759.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3077.999755859375,
        -4759.7685546875,
        1094.262451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24678324162960052,
        0.02719999849796295,
        0.9686889052391052
      ],
      "plane_d": -1666.2080078125,
      "bbox_min": [
        -3038.317138671875,
        -4862.19482421875,
        1082.5341796875
      ],
      "bbox_max": [
        -3035.5732421875,
        -4859.830078125,
        1083.248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0005590711371041834,
        0.3637598156929016,
        -0.9314926862716675
      ],
      "plane_d": 2755.78857421875,
      "bbox_min": [
        -3087.100341796875,
        -4861.64111328125,
        1076.186279296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4759.7685546875,
        1093.67333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07161381840705872,
        0.20935668051242828,
        -0.9752134680747986
      ],
      "plane_d": 2277.282958984375,
      "bbox_min": [
        -3087.100341796875,
        -4861.64111328125,
        1076.186279296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4773.181640625,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24678324162960052,
        0.02719999849796295,
        0.9686889052391052
      ],
      "plane_d": -1666.2080078125,
      "bbox_min": [
        -3087.100341796875,
        -4861.64111328125,
        1076.186279296875
      ],
      "bbox_max": [
        -3037.93798828125,
        -4773.181640625,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        0.19509923458099365,
        0.0
      ],
      "plane_d": -2039.2867431640625,
      "bbox_min": [
        -3062.6923828125,
        -4856.7236328125,
        1076.186279296875
      ],
      "bbox_max": [
        -3037.999755859375,
        -4805.18798828125,
        1081.4393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555734634399414,
        0.8314674496650696,
        0.0
      ],
      "plane_d": 2336.656982421875,
      "bbox_min": [
        -3062.6923828125,
        -4856.7236328125,
        1076.186279296875
      ],
      "bbox_max": [
        -3037.999755859375,
        -4805.18798828125,
        1081.4393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 157.660400390625,
      "bbox_min": [
        -3049.715576171875,
        -4848.052734375,
        1077.523193359375
      ],
      "bbox_max": [
        -3037.999755859375,
        -4805.18798828125,
        1081.4393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        -0.19509923458099365,
        0.0
      ],
      "plane_d": -3919.953125,
      "bbox_min": [
        -3040.900146484375,
        -4819.7685546875,
        1077.523193359375
      ],
      "bbox_max": [
        -3037.999755859375,
        -4805.18798828125,
        1081.4393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": -5197.7412109375,
      "bbox_min": [
        -3087.100341796875,
        -4848.052734375,
        1079.248779296875
      ],
      "bbox_max": [
        -3037.999755859375,
        -4773.181640625,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        0.19509923458099365,
        0.0
      ],
      "plane_d": -2039.2867431640625,
      "bbox_min": [
        -3087.100341796875,
        -4848.052734375,
        1079.248779296875
      ],
      "bbox_max": [
        -3037.999755859375,
        -4773.181640625,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 157.660400390625,
      "bbox_min": [
        -3087.100341796875,
        -4848.052734375,
        1079.248779296875
      ],
      "bbox_max": [
        -3037.999755859375,
        -4773.181640625,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2369917780160904,
        0.0981641411781311,
        -0.9665396213531494
      ],
      "plane_d": 796.7720947265625,
      "bbox_min": [
        -3087.100341796875,
        -4791.484375,
        1085.498779296875
      ],
      "bbox_max": [
        -3049.715576171875,
        -4773.181640625,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.051469940692186356,
        0.1215628907084465,
        -0.9912483096122742
      ],
      "plane_d": 1501.496826171875,
      "bbox_min": [
        -3087.100341796875,
        -4796.8076171875,
        1083.436279296875
      ],
      "bbox_max": [
        -3022.56689453125,
        -4759.7685546875,
        1093.67333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2369917780160904,
        0.0981641411781311,
        -0.9665396213531494
      ],
      "plane_d": 796.7720947265625,
      "bbox_min": [
        -3087.100341796875,
        -4791.484375,
        1085.498779296875
      ],
      "bbox_max": [
        -3049.715576171875,
        -4759.7685546875,
        1093.67333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14628201723098755,
        0.1660124659538269,
        -0.9752135276794434
      ],
      "plane_d": 2295.2158203125,
      "bbox_min": [
        -3092.752685546875,
        -4836.1044921875,
        1068.2783203125
      ],
      "bbox_max": [
        -3017.999755859375,
        -4769.7685546875,
        1080.373779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807834625244141,
        0.19509923458099365,
        0.0
      ],
      "plane_d": -2039.2867431640625,
      "bbox_min": [
        -3041.732177734375,
        -4836.1044921875,
        1074.147705078125
      ],
      "bbox_max": [
        -3037.999755859375,
        -4819.7685546875,
        1077.373779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1758042573928833,
        0.03886957839131355,
        -0.9836574792861938
      ],
      "plane_d": 1779.3203125,
      "bbox_min": [
        -3041.22607421875,
        -4835.98681640625,
        1074.2427978515625
      ],
      "bbox_max": [
        -3039.69970703125,
        -4835.07568359375,
        1074.5296630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8314722776412964,
        0.5555662512779236,
        0.0
      ],
      "plane_d": 157.660400390625,
      "bbox_min": [
        -3041.732177734375,
        -4836.1044921875,
        1074.147705078125
      ],
      "bbox_max": [
        -3041.044677734375,
        -4835.07568359375,
        1074.4188232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1758042573928833,
        0.03886957839131355,
        -0.9836574792861938
      ],
      "plane_d": 1779.3203125,
      "bbox_min": [
        -3041.732177734375,
        -4836.1044921875,
        1074.147705078125
      ],
      "bbox_max": [
        -3041.044677734375,
        -4835.07568359375,
        1074.311279296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3092.100341796875,
      "bbox_min": [
        -3092.752685546875,
        -4789.7685546875,
        1068.2783203125
      ],
      "bbox_max": [
        -3092.100341796875,
        -4769.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4769.7685546875,
      "bbox_min": [
        -3092.752685546875,
        -4769.7685546875,
        1070.0147705078125
      ],
      "bbox_max": [
        -3092.100341796875,
        -4769.7685546875,
        1072.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3092.100341796875,
      "bbox_min": [
        -3097.100341796875,
        -4899.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3061.999755859375,
        -4769.7685546875,
        1070.1458740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4769.7685546875,
      "bbox_min": [
        -3097.100341796875,
        -4769.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3092.100341796875,
        -4769.7685546875,
        1070.1458740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33401644229888916,
        0.13982084393501282,
        0.932138979434967
      ],
      "plane_d": 723.85986328125,
      "bbox_min": [
        -3084.85205078125,
        -4886.4619140625,
        1052.623779296875
      ],
      "bbox_max": [
        -3061.999755859375,
        -4879.7685546875,
        1060.822998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3084.85205078125,
        -4879.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3061.999755859375,
        -4879.7685546875,
        1060.8125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4879.7685546875,
      "bbox_min": [
        -3084.85205078125,
        -4886.4619140625,
        1052.623779296875
      ],
      "bbox_max": [
        -3061.999755859375,
        -4879.7685546875,
        1058.52734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23462752997875214,
        -0.04854360595345497,
        -0.9708725214004517
      ],
      "plane_d": 66.652587890625,
      "bbox_min": [
        -3084.85205078125,
        -4886.4619140625,
        1052.623779296875
      ],
      "bbox_max": [
        -3061.999755859375,
        -4879.7685546875,
        1058.146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1082.623779296875,
      "bbox_min": [
        -2977.03515625,
        -4850.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4740.7734375,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9138801693916321,
        0.4059842526912689,
        -0.0
      ],
      "plane_d": 4626.1796875,
      "bbox_min": [
        -2977.03515625,
        -4821.984375,
        1052.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4740.7734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7291637659072876,
        0.6843392848968506,
        0.0
      ],
      "plane_d": 1080.096435546875,
      "bbox_min": [
        -2977.03515625,
        -4750.33740234375,
        1052.623779296875
      ],
      "bbox_max": [
        -2968.059326171875,
        -4740.7734375,
        1082.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4850.7685546875,
      "bbox_min": [
        -2929.999755859375,
        -4850.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4850.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701427221298218,
        0.2425345927476883
      ],
      "plane_d": 4598.58740234375,
      "bbox_min": [
        -3319.999755859375,
        -5045.98291015625,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6037311553955078,
        0.759398341178894,
        0.24253442883491516
      ],
      "plane_d": 1709.478515625,
      "bbox_min": [
        -3319.999755859375,
        -5045.98291015625,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6037326455116272,
        0.7593971490859985,
        0.24253419041633606
      ],
      "plane_d": 5452.61083984375,
      "bbox_min": [
        -3319.999755859375,
        -5044.55859375,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3319.999755859375,
        -4947.42724609375,
        1152.623779296875
      ],
      "bbox_max": [
        -3290.547119140625,
        -4932.2685546875,
        1213.2578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3295.838623046875,
        -4994.4453125,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3295.838623046875,
        -4947.5576171875,
        1152.623779296875
      ],
      "bbox_max": [
        -3275.381591796875,
        -4932.2685546875,
        1213.7796630859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -2924.617919921875,
        -4942.994140625,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4932.2685546875,
        1195.5255126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7808688282966614,
        0.6246950626373291
      ],
      "plane_d": 3157.575439453125,
      "bbox_min": [
        -3184.8525390625,
        -4985.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -2979.098876953125,
        -4935.62158203125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5839508175849915,
        0.5839548110961914,
        0.5639132261276245
      ],
      "plane_d": 3992.897705078125,
      "bbox_min": [
        -2987.251708984375,
        -4976.64208984375,
        1152.623779296875
      ],
      "bbox_max": [
        -2979.098876953125,
        -4965.7685546875,
        1166.2159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49775373935699463,
        0.6427803635597229,
        0.582301139831543
      ],
      "plane_d": 1000.5457153320312,
      "bbox_min": [
        -3184.8525390625,
        -4985.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -2985.0,
        -4935.62158203125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5839508175849915,
        0.5839548110961914,
        0.5639132261276245
      ],
      "plane_d": 3992.897705078125,
      "bbox_min": [
        -3015.989013671875,
        -4980.81591796875,
        1152.623779296875
      ],
      "bbox_max": [
        -2985.0,
        -4935.62158203125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.497753769159317,
        0.6427804827690125,
        0.5823009610176086
      ],
      "plane_d": 4086.61962890625,
      "bbox_min": [
        -3184.8525390625,
        -4985.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -3145.921875,
        -4935.62158203125,
        1177.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9749282002449036,
        0.0,
        -0.22251980006694794
      ],
      "plane_d": -2600.0576171875,
      "bbox_min": [
        -2946.8349609375,
        -4919.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4850.7685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4811.14599609375,
      "bbox_min": [
        -2946.8349609375,
        -4856.3642578125,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4850.7685546875,
        1227.393310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968532919883728,
        0.07926793396472931
      ],
      "plane_d": 4744.13818359375,
      "bbox_min": [
        -2929.999755859375,
        -4852.89501953125,
        1152.623779296875
      ],
      "bbox_max": [
        -2920.0,
        -4850.7685546875,
        1179.3675537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9749281406402588,
        0.0,
        -0.22251978516578674
      ],
      "plane_d": 3444.49658203125,
      "bbox_min": [
        -3319.999755859375,
        -4919.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -3255.81689453125,
        -4850.7685546875,
        1214.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2525814163666382e-08,
        0.9968532919883728,
        0.07926793396472931
      ],
      "plane_d": 4744.13818359375,
      "bbox_min": [
        -3319.999755859375,
        -4855.599609375,
        1152.623779296875
      ],
      "bbox_max": [
        -3255.81689453125,
        -4850.7685546875,
        1214.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4690.69580078125,
      "bbox_min": [
        -3292.71533203125,
        -4855.599609375,
        1152.623779296875
      ],
      "bbox_max": [
        -3255.81689453125,
        -4850.7685546875,
        1214.7630615234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3667.999755859375,
      "bbox_min": [
        -3667.999755859375,
        -4762.7685546875,
        1052.7738037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4741.05810546875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.01888239197432995,
        0.9998217225074768
      ],
      "plane_d": -1147.5177001953125,
      "bbox_min": [
        -3632.999755859375,
        -4762.7685546875,
        1052.7738037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4741.07763671875,
        1058.1834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3624.999755859375,
      "bbox_min": [
        -3624.999755859375,
        -4762.7685546875,
        1052.7738037109375
      ],
      "bbox_max": [
        -3624.999755859375,
        -4741.07763671875,
        1058.1834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9701427221298218,
        0.2425345927476883
      ],
      "plane_d": 4598.58740234375,
      "bbox_min": [
        -3369.999755859375,
        -5065.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6037326455116272,
        0.7593971490859985,
        0.24253419041633606
      ],
      "plane_d": 5452.61083984375,
      "bbox_min": [
        -3369.999755859375,
        -5065.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9701425433158875,
        0.24253563582897186
      ],
      "plane_d": 4505.451171875,
      "bbox_min": [
        -3369.999755859375,
        -4969.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -3295.838623046875,
        -4912.603515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3369.999755859375,
        -4969.7685546875,
        1211.3270263671875
      ],
      "bbox_max": [
        -3347.175537109375,
        -4912.603515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6037326455116272,
        0.7593972086906433,
        0.24253425002098083
      ],
      "plane_d": 1709.4686279296875,
      "bbox_min": [
        -3369.999755859375,
        -5065.7685546875,
        1213.2578125
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.704753041267395,
        0.6667084693908691,
        0.24253448843955994
      ],
      "plane_d": 5317.16943359375,
      "bbox_min": [
        -3369.999755859375,
        -5008.603515625,
        1213.2578125
      ],
      "bbox_max": [
        -2920.0,
        -4910.2978515625,
        1302.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8356147408485413,
        0.0,
        -0.5493159294128418
      ],
      "plane_d": -1788.7464599609375,
      "bbox_min": [
        -2989.006591796875,
        -4911.19970703125,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4820.59423828125,
      "bbox_min": [
        -2989.006591796875,
        -4909.00634765625,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8319953680038452,
        0.0,
        0.5547826290130615
      ],
      "plane_d": 1732.95654296875,
      "bbox_min": [
        -2959.9150390625,
        -4909.00634765625,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": 4836.0390625,
      "bbox_min": [
        -2959.9150390625,
        -4860.02587890625,
        1226.384033203125
      ],
      "bbox_max": [
        -2920.0,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42975062131881714,
        0.0,
        -0.9029476046562195
      ],
      "plane_d": -119.2418212890625,
      "bbox_min": [
        -3014.40673828125,
        -4907.19970703125,
        1290.53515625
      ],
      "bbox_max": [
        -2978.129638671875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011412267573177814,
        0.998230516910553,
        0.05835885927081108
      ],
      "plane_d": 4808.96826171875,
      "bbox_min": [
        -3014.40673828125,
        -4859.599609375,
        1290.53515625
      ],
      "bbox_max": [
        -2978.129638671875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.018744194880127907,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4778.7138671875,
      "bbox_min": [
        -3014.40673828125,
        -4859.455078125,
        1290.53515625
      ],
      "bbox_max": [
        -2989.006591796875,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3574.965576171875,
        -4916.06201171875,
        1202.759765625
      ],
      "bbox_max": [
        -3253.16455078125,
        -4744.802734375,
        1238.15380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3351.867919921875,
        -4916.06201171875,
        1211.3270263671875
      ],
      "bbox_max": [
        -3253.16455078125,
        -4746.9443359375,
        1230.0960693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9749281406402588,
        0.0,
        -0.22251978516578674
      ],
      "plane_d": 3444.49658203125,
      "bbox_min": [
        -3302.565185546875,
        -4912.5498046875,
        1213.0048828125
      ],
      "bbox_max": [
        -3253.16455078125,
        -4854.98095703125,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.019427457824349403,
        0.9972130656242371,
        0.07203244417905807
      ],
      "plane_d": 4690.69580078125,
      "bbox_min": [
        -3302.565185546875,
        -4856.7685546875,
        1213.0048828125
      ],
      "bbox_max": [
        -3253.16455078125,
        -4854.98095703125,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2525814163666382e-08,
        0.9968532919883728,
        0.07926793396472931
      ],
      "plane_d": 4744.13818359375,
      "bbox_min": [
        -3302.565185546875,
        -4856.7685546875,
        1213.0048828125
      ],
      "bbox_max": [
        -3292.71533203125,
        -4855.56982421875,
        1228.0782470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 4311.4228515625,
      "bbox_min": [
        -3566.1171875,
        -4914.876953125,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4751.63671875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": 2953.447265625,
      "bbox_min": [
        -3369.999755859375,
        -4914.876953125,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4751.63671875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.020015697926282883,
        0.9981757998466492,
        0.05695966258645058
      ],
      "plane_d": 4711.94189453125,
      "bbox_min": [
        -3298.212890625,
        -4860.02587890625,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4733.2060546875,
      "bbox_min": [
        -3253.16455078125,
        -4859.85693359375,
        1226.384033203125
      ],
      "bbox_max": [
        -3210.992919921875,
        -4855.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3221.869873046875,
        -4907.19970703125,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.011412300169467926,
        0.9982304573059082,
        0.05835884064435959
      ],
      "plane_d": 4738.2119140625,
      "bbox_min": [
        -3221.869873046875,
        -4859.599609375,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.018744278699159622,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4894.92822265625,
      "bbox_min": [
        -3210.992919921875,
        -4859.455078125,
        1290.53515625
      ],
      "bbox_max": [
        -3185.5927734375,
        -4858.7685546875,
        1302.6241455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -2.5699014258862007e-06
      ],
      "plane_d": -3128.597412109375,
      "bbox_min": [
        -3170.00048828125,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4249.7685546875,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3070.100341796875,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4306.16796875,
        1152.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4629.7685546875,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3070.10009765625,
        -4525.01611328125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        -3102.499755859375,
        -4589.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3070.100341796875,
        -4525.01611328125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3102.499755859375,
      "bbox_min": [
        -3102.499755859375,
        -4589.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3070.100341796875,
        -4525.01611328125,
        1060.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4589.7685546875,
      "bbox_min": [
        -3102.499755859375,
        -4589.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3070.100341796875,
        -4525.01611328125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -7.511212606914341e-05,
        -0.00015022425213828683
      ],
      "plane_d": -3092.68310546875,
      "bbox_min": [
        -3092.50146484375,
        -4539.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3092.50048828125,
        -4525.01611328125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238940477371216,
        0.3826485574245453,
        0.0
      ],
      "plane_d": 4584.9931640625,
      "bbox_min": [
        -3082.0,
        -4570.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3072.0,
        -4560.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826485574245453,
        0.9238940477371216,
        0.0
      ],
      "plane_d": 5390.3662109375,
      "bbox_min": [
        -3082.0,
        -4570.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3072.0,
        -4560.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826485574245453,
        0.9238940477371216,
        0.0
      ],
      "plane_d": 3035.54736328125,
      "bbox_min": [
        -3082.0,
        -4570.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3072.0,
        -4560.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238940477371216,
        0.3826485574245453,
        0.0
      ],
      "plane_d": -1100.65087890625,
      "bbox_min": [
        -3082.0,
        -4570.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3072.0,
        -4561.46435546875,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238940477371216,
        -0.3826485574245453,
        -0.0
      ],
      "plane_d": -4594.23193359375,
      "bbox_min": [
        -3082.0,
        -4570.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3072.0,
        -4565.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826485574245453,
        -0.9238940477371216,
        -0.0
      ],
      "plane_d": -5399.60546875,
      "bbox_min": [
        -3080.53564453125,
        -4570.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3072.0,
        -4565.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826485574245453,
        -0.9238940477371216,
        0.0
      ],
      "plane_d": -3044.7861328125,
      "bbox_min": [
        -3077.0,
        -4570.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3072.0,
        -4565.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238940477371216,
        -0.3826485574245453,
        0.0
      ],
      "plane_d": 1091.411865234375,
      "bbox_min": [
        -3073.46435546875,
        -4568.53564453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3072.0,
        -4565.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.980980634689331,
        -0.19410614669322968,
        0.0
      ],
      "plane_d": 2113.042236328125,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.10009765625,
        -4629.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9855440855026245,
        -0.16941924393177032,
        4.717869614978554e-06
      ],
      "plane_d": -3867.750732421875,
      "bbox_min": [
        -3128.600341796875,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.10009765625,
        -4629.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1101.6236572265625,
      "bbox_min": [
        -3128.60009765625,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.10009765625,
        -4629.7685546875,
        1121.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9950372576713562,
        0.0,
        -0.09950372576713562
      ],
      "plane_d": 3210.749267578125,
      "bbox_min": [
        -3116.6005859375,
        -4679.7998046875,
        1101.623779296875
      ],
      "bbox_max": [
        -3114.6005859375,
        -4629.7685546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -3.650367943919264e-05
      ],
      "plane_d": 3020.13916015625,
      "bbox_min": [
        -3070.100341796875,
        -4629.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4306.16796875,
        1152.623779296875
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4529.7685546875,
      "bbox_min": [
        -3070.100341796875,
        -4629.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.09716796875,
        -4306.16796875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4629.7685546875,
      "bbox_min": [
        -3070.100341796875,
        -4629.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.10009765625,
        -4529.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        -3070.100341796875,
        -4589.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.100341796875,
        -4539.7685546875,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4589.7685546875,
      "bbox_min": [
        -3070.100341796875,
        -4589.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.100341796875,
        -4539.7685546875,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4539.7685546875,
      "bbox_min": [
        -3070.100341796875,
        -4589.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.100341796875,
        -4539.7685546875,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0001220703125
      ],
      "plane_d": -3020.8720703125,
      "bbox_min": [
        -3055.0,
        -4589.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.100341796875,
        -4539.7685546875,
        1060.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1056.0,
      "bbox_min": [
        -3021.0009765625,
        -4585.0,
        1054.0
      ],
      "bbox_max": [
        -3020.100341796875,
        -4545.0,
        1056.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1054.0,
      "bbox_min": [
        -3021.0009765625,
        -4585.0,
        1054.0
      ],
      "bbox_max": [
        -3020.100341796875,
        -4545.0,
        1056.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4560.0,
      "bbox_min": [
        -3021.0009765625,
        -4585.0,
        1054.0
      ],
      "bbox_max": [
        -3020.100341796875,
        -4545.0,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4545.0,
      "bbox_min": [
        -3021.0009765625,
        -4555.0,
        1054.0
      ],
      "bbox_max": [
        -3020.100341796875,
        -4545.0,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4555.0,
      "bbox_min": [
        -3021.0009765625,
        -4555.0,
        1054.0
      ],
      "bbox_max": [
        -3020.100341796875,
        -4555.0,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4575.0,
      "bbox_min": [
        -3021.0009765625,
        -4585.0,
        1054.0
      ],
      "bbox_max": [
        -3020.100341796875,
        -4570.0,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4570.0,
      "bbox_min": [
        -3021.0009765625,
        -4570.0,
        1054.0
      ],
      "bbox_max": [
        -3020.100341796875,
        -4570.0,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4585.0,
      "bbox_min": [
        -3021.0009765625,
        -4585.0,
        1054.0
      ],
      "bbox_max": [
        -3020.100341796875,
        -4585.0,
        1056.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238940477371216,
        0.3826485574245453,
        0.0
      ],
      "plane_d": 4560.0478515625,
      "bbox_min": [
        -3055.0,
        -4570.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3045.0,
        -4560.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826485574245453,
        0.9238940477371216,
        0.0
      ],
      "plane_d": 5380.03466796875,
      "bbox_min": [
        -3055.0,
        -4570.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3045.0,
        -4560.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826485574245453,
        0.9238940477371216,
        0.0
      ],
      "plane_d": 3045.87890625,
      "bbox_min": [
        -3055.0,
        -4570.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3045.0,
        -4560.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238940477371216,
        0.3826485574245453,
        0.0
      ],
      "plane_d": -1075.70556640625,
      "bbox_min": [
        -3055.0,
        -4570.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3045.0,
        -4561.46435546875,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238940477371216,
        -0.3826485574245453,
        -0.0
      ],
      "plane_d": -4569.287109375,
      "bbox_min": [
        -3055.0,
        -4570.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3045.0,
        -4565.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826485574245453,
        -0.9238940477371216,
        -0.0
      ],
      "plane_d": -5389.27392578125,
      "bbox_min": [
        -3053.53564453125,
        -4570.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3045.0,
        -4565.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826485574245453,
        -0.9238940477371216,
        0.0
      ],
      "plane_d": -3055.11767578125,
      "bbox_min": [
        -3050.0,
        -4570.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3045.0,
        -4565.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238940477371216,
        -0.3826485574245453,
        0.0
      ],
      "plane_d": 1066.466796875,
      "bbox_min": [
        -3046.46435546875,
        -4568.53564453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3045.0,
        -4565.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4379.7685546875,
      "bbox_min": [
        -3070.100341796875,
        -4429.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.09716796875,
        -4306.16796875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4419.7685546875,
      "bbox_min": [
        -3070.10009765625,
        -4429.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4379.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4389.7685546875,
      "bbox_min": [
        -3070.10009765625,
        -4419.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4379.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.682324230670929,
        0.0,
        0.7310497760772705
      ],
      "plane_d": 1306.93017578125,
      "bbox_min": [
        -3070.10009765625,
        -4389.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4379.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1066.623779296875,
      "bbox_min": [
        -3070.10009765625,
        -4389.7685546875,
        1066.623779296875
      ],
      "bbox_max": [
        -3058.201904296875,
        -4379.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 4409.76806640625,
      "bbox_min": [
        -3070.10009765625,
        -4419.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4409.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6823182702064514,
        0.0,
        0.7310552597045898
      ],
      "plane_d": 1306.906005859375,
      "bbox_min": [
        -3070.10009765625,
        -4419.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4409.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1066.623779296875,
      "bbox_min": [
        -3070.10009765625,
        -4419.7685546875,
        1066.623779296875
      ],
      "bbox_max": [
        -3058.201904296875,
        -4409.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4429.7685546875,
      "bbox_min": [
        -3070.10009765625,
        -4429.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4419.7685546875,
        1056.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1056.623779296875,
      "bbox_min": [
        -3070.10009765625,
        -4429.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4419.7685546875,
        1056.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.682324230670929,
        -0.0,
        0.7310497760772705
      ],
      "plane_d": 1306.9300537109375,
      "bbox_min": [
        -3047.487548828125,
        -4429.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4419.7685546875,
        1056.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4306.16796875,
      "bbox_min": [
        -3070.100341796875,
        -4379.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3020.09716796875,
        -4306.16796875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238842129707336,
        -0.38267210125923157,
        0.0
      ],
      "plane_d": 1179.53564453125,
      "bbox_min": [
        -3070.100341796875,
        -4379.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4306.16796875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38266539573669434,
        -0.9238870739936829,
        0.0
      ],
      "plane_d": -2812.622802734375,
      "bbox_min": [
        -3070.10009765625,
        -4379.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4306.16796875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4369.7685546875,
      "bbox_min": [
        -3070.10009765625,
        -4379.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4369.7685546875,
        1056.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1056.623779296875,
      "bbox_min": [
        -3070.10009765625,
        -4379.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4369.7685546875,
        1056.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.682324230670929,
        -0.0,
        0.7310497760772705
      ],
      "plane_d": 1306.9300537109375,
      "bbox_min": [
        -3047.487548828125,
        -4379.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3043.201904296875,
        -4369.7685546875,
        1056.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4306.16796875,
      "bbox_min": [
        -3020.100830078125,
        -4306.16796875,
        1052.623779296875
      ],
      "bbox_max": [
        -2919.999755859375,
        -4306.16796875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4629.7685546875,
      "bbox_min": [
        -3170.00048828125,
        -4629.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4389.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4409.7685546875,
      "bbox_min": [
        -3155.499755859375,
        -4409.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3128.60009765625,
        -4409.7685546875,
        1066.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7580097317695618,
        0.6522433161735535
      ],
      "plane_d": -3960.58642578125,
      "bbox_min": [
        -3386.176513671875,
        -4397.2314453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3289.980224609375,
        -4260.1806640625,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2766062617301941,
        -0.9063534736633301,
        -0.3193938136100769
      ],
      "plane_d": -2604.05419921875,
      "bbox_min": [
        -3386.176513671875,
        -4293.52392578125,
        1052.623779296875
      ],
      "bbox_max": [
        -3342.380126953125,
        -4260.1806640625,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5648571848869324,
        -0.32612064480781555,
        -0.7580115795135498
      ],
      "plane_d": -2481.8486328125,
      "bbox_min": [
        -3386.176513671875,
        -4285.408203125,
        1052.623779296875
      ],
      "bbox_max": [
        -3344.14453125,
        -4260.1806640625,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3386.176513671875,
        -4285.408203125,
        1077.5
      ],
      "bbox_max": [
        -3368.223388671875,
        -4272.97607421875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3383.487060546875,
        -4293.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4280.75,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123758554458618,
        -0.3535555601119995,
        -0.7071027159690857
      ],
      "plane_d": 1311.0390625,
      "bbox_min": [
        -3372.711669921875,
        -4293.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4280.75,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7580097317695618,
        0.6522433161735535
      ],
      "plane_d": -4019.711181640625,
      "bbox_min": [
        -3357.855712890625,
        -4397.2314453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3289.980224609375,
        -4336.92236328125,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6564573645591736,
        0.3790042996406555,
        0.6522418856620789
      ],
      "plane_d": 3118.83984375,
      "bbox_min": [
        -3357.855712890625,
        -4397.2314453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3289.980224609375,
        -4336.92236328125,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5648574233055115,
        -0.3261207938194275,
        -0.7580114006996155
      ],
      "plane_d": 1278.38671875,
      "bbox_min": [
        -3357.855712890625,
        -4397.2314453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3289.980224609375,
        -4336.92236328125,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6466190218925476,
        0.6927236914634705,
        -0.3194022476673126
      ],
      "plane_d": 5510.96142578125,
      "bbox_min": [
        -3356.632080078125,
        -4350.97607421875,
        1052.623779296875
      ],
      "bbox_max": [
        -3329.288330078125,
        -4336.92236328125,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2766062617301941,
        -0.9063534736633301,
        -0.3193938136100769
      ],
      "plane_d": -2689.243896484375,
      "bbox_min": [
        -3333.776611328125,
        -4397.2314453125,
        1052.623779296875
      ],
      "bbox_max": [
        -3289.980224609375,
        -4338.1806640625,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5648571848869324,
        -0.32612064480781555,
        -0.7580115795135498
      ],
      "plane_d": -2477.6875,
      "bbox_min": [
        -3333.776611328125,
        -4363.408203125,
        1052.623779296875
      ],
      "bbox_max": [
        -3291.74462890625,
        -4338.1806640625,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3333.776611328125,
        -4363.408203125,
        1077.5
      ],
      "bbox_max": [
        -3315.823486328125,
        -4350.97607421875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3331.087158203125,
        -4366.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3320.311767578125,
        -4360.5419921875,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123761534690857,
        -0.3535540997982025,
        -0.7071031332015991
      ],
      "plane_d": 1251.380859375,
      "bbox_min": [
        -3321.69580078125,
        -4371.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4358.75,
        1082.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1077.5,
      "bbox_min": [
        -3321.69580078125,
        -4366.52392578125,
        1077.5
      ],
      "bbox_max": [
        -3315.823486328125,
        -4358.75,
        1077.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1093.5,
      "bbox_min": [
        -3402.0,
        -4380.65087890625,
        1082.5
      ],
      "bbox_max": [
        -3287.5,
        -4259.34912109375,
        1117.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4293.52392578125,
      "bbox_min": [
        -3389.5,
        -4380.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3287.5,
        -4280.75,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        -0.4999985098838806,
        0.0
      ],
      "plane_d": 771.6015625,
      "bbox_min": [
        -3369.824951171875,
        -4293.52392578125,
        1093.5
      ],
      "bbox_max": [
        -3362.449951171875,
        -4280.75,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4330458641052246,
        -0.9013720154762268,
        0.0
      ],
      "plane_d": -2454.65087890625,
      "bbox_min": [
        -3389.5,
        -4380.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3287.5,
        -4302.65087890625,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4302.65087890625,
      "bbox_min": [
        -3389.5,
        -4302.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3364.5,
        -4302.65087890625,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        0.4999985098838806,
        0.0
      ],
      "plane_d": 5045.958984375,
      "bbox_min": [
        -3337.5,
        -4380.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3300.0,
        -4314.66162109375,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        -0.4999985098838806,
        0.0
      ],
      "plane_d": 687.22216796875,
      "bbox_min": [
        -3337.5,
        -4380.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3304.952880859375,
        -4358.75,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4371.52392578125,
      "bbox_min": [
        -3337.5,
        -4380.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3317.425048828125,
        -4371.52392578125,
        1117.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4380.65087890625,
      "bbox_min": [
        -3337.5,
        -4380.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3322.694580078125,
        -4380.65087890625,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660278916358948,
        -0.49999579787254333,
        0.0
      ],
      "plane_d": 678.41015625,
      "bbox_min": [
        -3322.694580078125,
        -4380.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3304.952880859375,
        -4367.57861328125,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4380.65087890625,
      "bbox_min": [
        -3322.694580078125,
        -4380.65087890625,
        1093.5
      ],
      "bbox_max": [
        -3312.5,
        -4380.65087890625,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660278916358948,
        0.49999579787254333,
        0.0
      ],
      "plane_d": 5037.3740234375,
      "bbox_min": [
        -3312.5,
        -4367.57861328125,
        1093.5
      ],
      "bbox_max": [
        -3300.0,
        -4314.66162109375,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660278916358948,
        -0.49999579787254333,
        0.0
      ],
      "plane_d": 678.41015625,
      "bbox_min": [
        -3304.952880859375,
        -4367.57861328125,
        1093.5
      ],
      "bbox_max": [
        -3300.0,
        -4359.0,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3312.5,
      "bbox_min": [
        -3312.5,
        -4337.34912109375,
        1093.5
      ],
      "bbox_max": [
        -3312.5,
        -4314.66162109375,
        1096.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        -0.4999985098838806,
        0.0
      ],
      "plane_d": 771.6015625,
      "bbox_min": [
        -3384.574951171875,
        -4371.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4280.75,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4293.52392578125,
      "bbox_min": [
        -3384.574951171875,
        -4293.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3369.824951171875,
        -4293.52392578125,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        0.4999985098838806,
        0.0
      ],
      "plane_d": 5045.958984375,
      "bbox_min": [
        -3332.175048828125,
        -4371.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4345.97607421875,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660263419151306,
        -0.4999985098838806,
        0.0
      ],
      "plane_d": 687.22216796875,
      "bbox_min": [
        -3332.175048828125,
        -4371.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3310.050048828125,
        -4358.75,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4371.52392578125,
      "bbox_min": [
        -3332.175048828125,
        -4371.52392578125,
        1082.5
      ],
      "bbox_max": [
        -3317.425048828125,
        -4371.52392578125,
        1093.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4647.2685546875,
      "bbox_min": [
        -3337.999755859375,
        -4653.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4589.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4653.2685546875,
      "bbox_min": [
        -3337.999755859375,
        -4653.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4647.2685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3331.999755859375,
      "bbox_min": [
        -3331.999755859375,
        -4653.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4647.2685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4595.7685546875,
      "bbox_min": [
        -3337.999755859375,
        -4647.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4589.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3331.999755859375,
      "bbox_min": [
        -3331.999755859375,
        -4595.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4589.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3332.999755859375,
      "bbox_min": [
        -3334.999755859375,
        -4647.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4595.7685546875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1591.25634765625,
      "bbox_min": [
        -3334.999755859375,
        -4647.2685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4595.7685546875,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3554.599609375,
      "bbox_min": [
        -3560.599853515625,
        -4653.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3337.999755859375,
        -4647.2685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -4653.2685546875,
      "bbox_min": [
        -3560.599853515625,
        -4653.2685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3554.599609375,
        -4653.2685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4652.36865234375,
      "bbox_min": [
        -3554.599853515625,
        -4652.36865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3337.999755859375,
        -4650.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -4055.252197265625,
      "bbox_min": [
        -3554.599853515625,
        -4652.36865234375,
        1082.623779296875
      ],
      "bbox_max": [
        -3337.999755859375,
        -4650.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3331.999755859375,
      "bbox_min": [
        -3337.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4563.7685546875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4569.7998046875,
      "bbox_min": [
        -3337.999755859375,
        -4569.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3331.999755859375,
        -4569.7998046875,
        1087.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3332.999755859375,
      "bbox_min": [
        -3336.999755859375,
        -4563.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4404.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 1591.25634765625,
      "bbox_min": [
        -3336.999755859375,
        -4563.7685546875,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4404.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4404.36865234375,
      "bbox_min": [
        -3336.999755859375,
        -4404.36865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3332.999755859375,
        -4404.36865234375,
        1084.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4413.39990234375,
      "bbox_min": [
        -3508.06005859375,
        -4580.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3367.056640625,
        -4379.39990234375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -4546.0,
      "bbox_min": [
        -3508.06005859375,
        -4580.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3367.056640625,
        -4413.39990234375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38344883918762207,
        -0.0,
        0.9235621094703674
      ],
      "plane_d": 292.119384765625,
      "bbox_min": [
        -3417.0,
        -4546.0,
        1081.6539306640625
      ],
      "bbox_max": [
        -3367.056640625,
        -4413.39990234375,
        1102.3896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15500178933143616,
        -0.0,
        0.9879142045974731
      ],
      "plane_d": -566.6591796875,
      "bbox_min": [
        -3450.0,
        -4546.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4413.39990234375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6748446226119995,
        -0.0,
        0.7379598617553711
      ],
      "plane_d": 1492.4248046875,
      "bbox_min": [
        -3426.66552734375,
        -4546.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4413.39990234375,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9278242588043213,
        -0.3730178475379944,
        0.0
      ],
      "plane_d": 1474.636474609375,
      "bbox_min": [
        -3450.0,
        -4580.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3417.0,
        -4546.0,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3925205171108246,
        -0.9197432398796082,
        0.0
      ],
      "plane_d": -2858.22802734375,
      "bbox_min": [
        -3450.0,
        -4580.0,
        1052.623779296875
      ],
      "bbox_max": [
        -3417.0,
        -4546.0,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06411544978618622,
        -0.150238499045372,
        0.9865686893463135
      ],
      "plane_d": -1561.7010498046875,
      "bbox_min": [
        -3450.0,
        -4580.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4546.0,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15470170974731445,
        -0.06219439208507538,
        0.9860016703605652
      ],
      "plane_d": -848.2979125976562,
      "bbox_min": [
        -3450.0,
        -4580.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4546.0,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6513059735298157,
        -0.26184308528900146,
        0.7122068405151367
      ],
      "plane_d": 250.04437255859375,
      "bbox_min": [
        -3450.0,
        -4580.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4546.0,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27256160974502563,
        -0.6386798024177551,
        0.7195821404457092
      ],
      "plane_d": -2778.075927734375,
      "bbox_min": [
        -3450.0,
        -4580.0,
        1102.3896484375
      ],
      "bbox_max": [
        -3426.66552734375,
        -4563.0,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9278242588043213,
        0.3730178475379944,
        -0.0
      ],
      "plane_d": 4816.65234375,
      "bbox_min": [
        -3450.0,
        -4413.39990234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3417.0,
        -4379.39990234375,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3925205171108246,
        0.9197432398796082,
        -0.0
      ],
      "plane_d": 5382.119140625,
      "bbox_min": [
        -3450.0,
        -4413.39990234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3417.0,
        -4379.39990234375,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6512991786003113,
        0.26184508204460144,
        0.712212324142456
      ],
      "plane_d": 2595.980712890625,
      "bbox_min": [
        -3450.0,
        -4413.39990234375,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4379.39990234375,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27257317304611206,
        0.638685941696167,
        0.7195721864700317
      ],
      "plane_d": 2944.189453125,
      "bbox_min": [
        -3450.0,
        -4396.39990234375,
        1102.3896484375
      ],
      "bbox_max": [
        -3426.66552734375,
        -4379.39990234375,
        1111.228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 3624.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4651.7568359375,
        1059.7738037109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.01888239197432995,
        0.9998217225074768
      ],
      "plane_d": -1147.5177001953125,
      "bbox_min": [
        -3675.999755859375,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4655.33154296875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.762873649597168,
        0.6465476155281067
      ],
      "plane_d": 2877.70703125,
      "bbox_min": [
        -3675.999755859375,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4655.33154296875,
        1059.5228271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3667.999755859375,
      "bbox_min": [
        -3667.999755859375,
        -4679.7998046875,
        1052.623779296875
      ],
      "bbox_max": [
        -3667.999755859375,
        -4664.30908203125,
        1059.5228271484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.8134896159172058,
        -0.5815794467926025
      ],
      "plane_d": -3174.87939453125,
      "bbox_min": [
        -3632.999755859375,
        -4656.86865234375,
        1052.623779296875
      ],
      "bbox_max": [
        -3624.999755859375,
        -4655.33154296875,
        1054.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3667.999755859375,
      "bbox_min": [
        -3675.999755859375,
        -4679.7998046875,
        1059.3406982421875
      ],
      "bbox_max": [
        -3667.999755859375,
        -4670.15576171875,
        1059.7738037109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.762873649597168,
        0.6465476155281067
      ],
      "plane_d": 2877.70703125,
      "bbox_min": [
        -3675.999755859375,
        -4670.36865234375,
        1059.5228271484375
      ],
      "bbox_max": [
        -3667.999755859375,
        -4670.15576171875,
        1059.7738037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 1057.446044921875,
      "bbox_min": [
        -3939.26220703125,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.791748046875,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1100.3785400390625,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2712554931640625,
        0.3530268669128418,
        0.8954285979270935
      ],
      "plane_d": 1485.3206787109375,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2750813663005829,
        0.35142311453819275,
        0.894892156124115
      ],
      "plane_d": -215.431884765625,
      "bbox_min": [
        -3377.63818359375,
        -5265.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2754322588443756,
        0.3464488685131073,
        0.8967219591140747
      ],
      "plane_d": 1463.6072998046875,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27700290083885193,
        0.3484245240688324,
        0.8954717516899109
      ],
      "plane_d": -237.17449951171875,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3248736560344696,
        0.30733799934387207,
        0.894427478313446
      ],
      "plane_d": 1431.6265869140625,
      "bbox_min": [
        -3377.63818359375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3270551264286041,
        0.3094017207622528,
        0.892919659614563
      ],
      "plane_d": -576.7142333984375,
      "bbox_min": [
        -2945.2109375,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3714085817337036,
        1.1238243132538628e-05,
        0.9284694790840149
      ],
      "plane_d": -2031.978759765625,
      "bbox_min": [
        -3939.26220703125,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.791748046875,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1017.1966552734375,
      "bbox_min": [
        -3939.26220703125,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3369.999755859375,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19999998807907104,
        0.3999999761581421,
        0.8944271802902222
      ],
      "plane_d": 1496.8050537109375,
      "bbox_min": [
        -3597.21337890625,
        -5169.7685546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3369.999755859375,
        -4909.36328125,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4251258969306946,
        0.1388094276189804,
        0.8944271206855774
      ],
      "plane_d": 1100.856689453125,
      "bbox_min": [
        -3939.26220703125,
        -5079.7685546875,
        1317.4210205078125
      ],
      "bbox_max": [
        -3758.24658203125,
        -4903.9833984375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3159162104129791,
        -0.32253599166870117,
        0.892282247543335
      ],
      "plane_d": -1351.46044921875,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -2985.158203125,
      "bbox_min": [
        -3985.582763671875,
        -4310.9921875,
        1302.623779296875
      ],
      "bbox_max": [
        -3556.305419921875,
        -3869.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3431975841522217,
        -0.2707574963569641,
        0.8993920087814331
      ],
      "plane_d": -1033.765380859375,
      "bbox_min": [
        -3985.582763671875,
        -4310.9921875,
        1302.623779296875
      ],
      "bbox_max": [
        -3749.999755859375,
        -4183.41845703125,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3593549430370331,
        -0.25706222653388977,
        0.8970969915390015
      ],
      "plane_d": -909.20556640625,
      "bbox_min": [
        -3985.582763671875,
        -4266.263671875,
        1353.5482177734375
      ],
      "bbox_max": [
        -3900.749755859375,
        -4183.41845703125,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.315602570772171,
        -0.3142412602901459,
        0.8953476548194885
      ],
      "plane_d": -1324.80126953125,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -2985.158203125,
      "bbox_min": [
        -4007.749267578125,
        -4356.12060546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3549.999755859375,
        -3869.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3431975841522217,
        -0.2707574963569641,
        0.8993920087814331
      ],
      "plane_d": -1033.765380859375,
      "bbox_min": [
        -3900.749755859375,
        -4356.12060546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3802.58349609375,
        -4266.263671875,
        1353.5482177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.0,
        0.8944271802902222
      ],
      "plane_d": 550.01416015625,
      "bbox_min": [
        -3888.191162109375,
        -4356.12060546875,
        1302.623779296875
      ],
      "bbox_max": [
        -3835.11669921875,
        -4333.81396484375,
        1329.1610107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.0,
        0.8944271802902222
      ],
      "plane_d": 550.01416015625,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43041878938674927,
        0.12140591442584991,
        0.8944273591041565
      ],
      "plane_d": 1038.8125,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4251258969306946,
        0.1388094276189804,
        0.8944271206855774
      ],
      "plane_d": 1100.856689453125,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44641169905662537,
        0.894827663898468
      ],
      "plane_d": -2871.013671875,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.86962890625,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 1017.1966552734375,
      "bbox_min": [
        -4035.11669921875,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3221.869873046875,
        -4244.5771484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19999998807907104,
        0.3999999761581421,
        0.8944271802902222
      ],
      "plane_d": 1496.8050537109375,
      "bbox_min": [
        -3556.986083984375,
        -4910.29736328125,
        1302.623779296875
      ],
      "bbox_max": [
        -3488.941650390625,
        -4879.7685546875,
        1317.4210205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3593549430370331,
        -0.25706222653388977,
        0.8970969915390015
      ],
      "plane_d": -909.20556640625,
      "bbox_min": [
        -4035.11669921875,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3221.869873046875,
        -4244.5771484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4733.2060546875,
      "bbox_min": [
        -3248.5048828125,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3221.869873046875,
        -4859.599609375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.020015697926282883,
        0.9981757998466492,
        0.05695966258645058
      ],
      "plane_d": 4711.94189453125,
      "bbox_min": [
        -3248.5048828125,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3237.16748046875,
        -4859.85693359375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3713906705379486,
        0.0,
        0.9284766912460327
      ],
      "plane_d": -2032.00439453125,
      "bbox_min": [
        -2978.129638671875,
        -4910.2978515625,
        1302.623779296875
      ],
      "bbox_max": [
        -1964.77978515625,
        -4432.9013671875,
        1402.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8319953680038452,
        0.0,
        0.5547826290130615
      ],
      "plane_d": 1732.95654296875,
      "bbox_min": [
        -2978.129638671875,
        -4906.9423828125,
        1302.6241455078125
      ],
      "bbox_max": [
        -2951.49462890625,
        -4859.599609375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.014094876125454903,
        0.9983338713645935,
        0.05595234036445618
      ],
      "plane_d": 4820.59423828125,
      "bbox_min": [
        -2978.129638671875,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -2951.49462890625,
        -4859.599609375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.020015697926282883,
        0.9981757998466492,
        0.056959666311740875
      ],
      "plane_d": 4836.0390625,
      "bbox_min": [
        -2962.83203125,
        -4860.7685546875,
        1302.6241455078125
      ],
      "bbox_max": [
        -2951.49462890625,
        -4859.85693359375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011412267573177814,
        0.998230516910553,
        0.05835885927081108
      ],
      "plane_d": 4808.96826171875,
      "bbox_min": [
        -3100.0,
        -4906.7421875,
        1302.623779296875
      ],
      "bbox_max": [
        -2962.83203125,
        -3780.262451171875,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.018744194880127907,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4778.7138671875,
      "bbox_min": [
        -3100.0,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3005.45556640625,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42975062131881714,
        0.0,
        -0.9029476046562195
      ],
      "plane_d": -119.2418212890625,
      "bbox_min": [
        -3100.0,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3014.40673828125,
        -4859.455078125,
        1343.361572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44641169905662537,
        0.894827663898468
      ],
      "plane_d": -2871.013671875,
      "bbox_min": [
        -3100.0,
        -3820.217529296875,
        1302.623779296875
      ],
      "bbox_max": [
        -3059.999755859375,
        -3780.262451171875,
        1322.556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44641169905662537,
        0.894827663898468
      ],
      "plane_d": -2871.013671875,
      "bbox_min": [
        -3311.842041015625,
        -4906.7421875,
        1302.623779296875
      ],
      "bbox_max": [
        -3100.0,
        -3619.7685546875,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.011412300169467926,
        0.9982304573059082,
        0.05835884064435959
      ],
      "plane_d": 4738.2119140625,
      "bbox_min": [
        -3237.16748046875,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.018744278699159622,
        0.9996730089187622,
        0.017387831583619118
      ],
      "plane_d": 4894.92822265625,
      "bbox_min": [
        -3194.5439453125,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.287109375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3185.5927734375,
        -4906.7421875,
        1302.6241455078125
      ],
      "bbox_max": [
        -3100.0,
        -4859.455078125,
        1343.361572265625
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: door12",
      "entity_class": "CSlidingDoor",
      "piece_name": "door12",
      "offset": 34670,
      "centroid": [
        -2868.999755859375,
        -4419.83251953125,
        1058.873779296875
      ],
      "bbox_min": [
        -2869.499755859375,
        -4439.83251953125,
        1052.623779296875
      ],
      "bbox_max": [
        -2868.499755859375,
        -4399.83251953125,
        1065.123779296875
      ],
      "dimensions_source": {
        "span_x": 1.0,
        "span_y": 40.0,
        "height_z": 12.5,
        "door_width": 40.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          -2869.499755859375,
          -4439.83251953125,
          1065.123779296875
        ],
        [
          -2869.499755859375,
          -4439.83251953125,
          1052.623779296875
        ],
        [
          -2869.499755859375,
          -4399.83251953125,
          1052.623779296875
        ],
        [
          -2869.499755859375,
          -4399.83251953125,
          1065.123779296875
        ],
        [
          -2868.499755859375,
          -4439.83251953125,
          1065.123779296875
        ],
        [
          -2868.499755859375,
          -4439.83251953125,
          1052.623779296875
        ],
        [
          -2868.499755859375,
          -4399.83251953125,
          1052.623779296875
        ],
        [
          -2868.499755859375,
          -4399.83251953125,
          1065.123779296875
        ]
      ],
      "plane_distance": 1052.6238,
      "authentic_texture": "doorjam"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 36868,
      "centroid": [
        -2748.499755859375,
        -4836.7685546875,
        1087.623779296875
      ],
      "bbox_min": [
        -2748.499755859375,
        -4856.7685546875,
        1082.623779296875
      ],
      "bbox_max": [
        -2748.499755859375,
        -4816.7685546875,
        1092.623779296875
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 40.0,
        "height_z": 10.0,
        "door_width": 40.0,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -2748.499755859375,
          -4816.7685546875,
          1092.623779296875
        ],
        [
          -2748.499755859375,
          -4816.7685546875,
          1092.623779296875
        ],
        [
          -2748.499755859375,
          -4816.7685546875,
          1082.623779296875
        ],
        [
          -2748.499755859375,
          -4816.7685546875,
          1082.623779296875
        ],
        [
          -2748.499755859375,
          -4826.7685546875,
          1082.623779296875
        ],
        [
          -2748.499755859375,
          -4826.7685546875,
          1082.623779296875
        ],
        [
          -2748.499755859375,
          -4826.7685546875,
          1092.623779296875
        ],
        [
          -2748.499755859375,
          -4826.7685546875,
          1092.623779296875
        ],
        [
          -2748.499755859375,
          -4856.7685546875,
          1092.623779296875
        ],
        [
          -2748.499755859375,
          -4856.7685546875,
          1092.623779296875
        ],
        [
          -2748.499755859375,
          -4846.7685546875,
          1092.623779296875
        ],
        [
          -2748.499755859375,
          -4846.7685546875,
          1092.623779296875
        ],
        [
          -2748.499755859375,
          -4846.7685546875,
          1082.623779296875
        ],
        [
          -2748.499755859375,
          -4846.7685546875,
          1082.623779296875
        ],
        [
          -2748.499755859375,
          -4856.7685546875,
          1082.623779296875
        ],
        [
          -2748.499755859375,
          -4856.7685546875,
          1082.623779296875
        ],
        [
          -2748.499755859375,
          -4841.7685546875,
          1092.623779296875
        ],
        [
          -2748.499755859375,
          -4841.7685546875,
          1092.623779296875
        ],
        [
          -2748.499755859375,
          -4831.7685546875,
          1092.623779296875
        ],
        [
          -2748.499755859375,
          -4831.7685546875,
          1092.623779296875
        ],
        [
          -2748.499755859375,
          -4831.7685546875,
          1082.623779296875
        ],
        [
          -2748.499755859375,
          -4831.7685546875,
          1082.623779296875
        ],
        [
          -2748.499755859375,
          -4841.7685546875,
          1082.623779296875
        ],
        [
          -2748.499755859375,
          -4841.7685546875,
          1082.623779296875
        ]
      ],
      "plane_distance": 2748.4998,
      "authentic_texture": "warehouswin-m"
    }
  ],
  "tutorial_messages": []
}